angular
    .module('sodCommon', [
        'ngLodash',
        'ngRoute',
        'ngSanitize',
        'ngAnimate',
        'uiGmapgoogle-maps',
        'FormBuilder',
        'LayoutBuilder',
        'AsyncPanel',
        'kendo.directives',
        'Controllers',
        'vcRecaptcha',
        'angularModalService',
        'angular-ladda',
        'SodCustomAction',
        'SodTemplates',
        'sod.helper',
        'ngResource',
        'ResourceGenerator',
        'angular-md5',
        '720kb.tooltips',
        'sod-logger',
        'dialog-manager',
        'ActionManager',
        'sodCustomActionsLib',
        'ui.carousel',
        'fauzanKhanQueryBuilder',
    ], ['$interpolateProvider', function ($interpolateProvider) {
        $interpolateProvider.startSymbol('<%');
        $interpolateProvider.endSymbol('%>');
    }]);

angular.module('Controllers', []);
$(document).foundation();
$('.has-tip').foundation();

angular.module('ActionManager', ['ResourceGenerator', 'ngLodash', 'sod-logger']);
angular.module('SodCustomAction', []);
angular.module('AsyncPanel',[
    'ngLodash',
    'ResourceGenerator',
    'ActionManager',
    'sod-logger'
]);

angular.module('sodCustomActionsLib', ['sodDocumentLibrary', 'sodAppointmentSelector', 'sodNotificationCenter', 'sod.helper']);
angular.module('dialog-manager',[
    'ngLodash',
    'angularModalService',
    'sod-logger'
]);
angular.module('FormBuilder', ['ngLodash', 'selectize', 'llNotifier', 'ui.tinymce', 'sod.helper']);

angular.module('sod.helper', ['ngLodash']);
angular.module('LayoutBuilder',[]);

angular.module('fauzanKhanQueryBuilder', [
    'ui.tinymce', // for custom bracketing
    'angularModalService' // for custom bracketing
]);
angular.module('ResourceGenerator', [
    'ngResource',
    'ngLodash'
]);
angular.module('sod-logger', ['ngLodash', 'ResourceGenerator']);
angular.module('SodTemplates', []);
(function () {
    'use strict';

    runFunc.$inject = ['$http', '$templateCache', '$q', '$rootScope', '$location', 'lodash'];
    angular
        .module('SodTemplates')
        .run(runFunc);

    function runFunc($http, $templateCache, $q, $rootScope, $location, lodash) {
        $rootScope.templateLoader = $q.defer();

        var lang = angular.element('html').attr('lang');

        var types = angular.element('body').attr('data-app-type');
        if (lodash.isEmpty(types)) {
            types = '';
        }
        types = types.split('|');


        // $http.get('/api/admin/shared/templates-type').then(function (res) {
        //     var types = res.data.types;
        var promises = [];
        angular.forEach(types, function (val) {
            var templateUrl = '/api/admin/shared/templates/' + val;
            if (!!lang) {
                templateUrl += '?locale=' + lang;
            }
            var promise = $http.get(templateUrl);
            promises.push(promise);
            promise.then(function (res) {
                angular.forEach(res.data, function(_tpl, key) {
                    $templateCache.put(key, _tpl);
                });
            });
        });
        $q.all(promises).then(function () {
            $rootScope.templateLoader.resolve();
        });
        // }, function () {
        //     // redirect to 404
        //     $location.path('/500');
        // });
    }
})();

(function() {
    'use strict';

    runFunc.$inject = ['$templateCache', '$q', '$rootScope', 'Carousel', '$location', '$route'];
    laddaConfig.$inject = ['laddaProvider'];
    angular
        .module('sodCommon')
        .run(runFunc)
        .config(laddaConfig);

    function runFunc($templateCache, $q, $rootScope, Carousel, $location, $route) {
        $rootScope.initLoader = $q.defer();
        $rootScope.templateLoader.promise.then(function() {
            // Override angular-notifier template
            $templateCache.put('src/notification.html', $templateCache.get('common/components/notifier/notification'));

            $rootScope.initLoader.resolve();
        });

        Carousel.setOptions({
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            cssEase: 'ease-in-out',
            dots: false,

            easing: 'linear',
            fade: false,
            infinite: true,
            initialSlide: 1,

            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
        });

        if (window.self != window.top) {
            angular.element(document.body).addClass('is-iframe');
        }
    }

    function laddaConfig(laddaProvider) {
        laddaProvider.setOption({
            style: 'expand-left',
            spinnerSize: 25,
            spinnerColor: "#ffffff"
        });
    }
})();


(function() {
    'use strict';

    ttGridDirective.$inject = ['lodash'];
    ttGridDirectiveCtrl.$inject = ['$scope', '$element', 'DatasourceRegistry', 'lodash'];
    angular
        .module('Controllers')
        .directive('ttGrid', ttGridDirective);

    function ttGridDirective(lodash) {
        return {
            restrict: 'EA',
            scope: {
                grid: '=?',
                panelType:'=',
                gridObj: "=?ttGrid"
            },
            replace:true,
            templateUrl: "common/components/grid",
            controller: ttGridDirectiveCtrl,
            link: ttGridDirectiveLink
        };

        function ttGridDirectiveLink(scope, elem) {
            //var grid =elem.find('.k-grid');
            //scope.tempclick = function() {
            //    console.log('testclick','model value',scope.tempval);
            //    var filterHeight = lodash.get(scope,'tempval',50);
            //
            //    grid.css('height','calc(100% - '+filterHeight+'px)');
            //    grid.data('kendoGrid').refresh();
            //};
            if (lodash.has(scope,'grid.datasource.transport.read.url')) elem.data('kendoGrid').dataSource.page(1);

            //console.log('gridObj: ', scope.gridObj);
            if (!lodash.get(scope, 'options.showHeader', false)) {
                elem.find('.k-grid-header').hide();
            }
        }
    }

    function ttGridDirectiveCtrl($scope, $element, DatasourceRegistry, lodash) {
        var gridOption = {};
        this.$onInit = function() {
            gridOption = lodash.get($scope,'grid.options',{});
            gridOption = lodash.merge({
                autoBind:false,
                selectable: 'row',
                sortable: true,
                pageable: {
                    refresh: true
                },
                height: '100%',
                columnMenu: true,
                columns: []
            }, gridOption);

            var datasource = lodash.get($scope,'grid.datasource',{});

            var schema = angular.copy(lodash.get(datasource,'schema',{}));
            datasource.schema = {
                data: function(response) {
                    var dataIndex = lodash.get(schema, 'data', 'data');
                    lodash.forEach(response[dataIndex], function (element) {
                        lodash.forEach(gridOption.columns, function (column) {
                            if (!lodash.has(element, column.field)) {
                                lodash.set(element, column.field, '');
                            }
                        });

                    });
                    //return response.content;
                    return response[dataIndex];
                },

                total: function (response) {
                    return response[lodash.get(schema, 'total', 'total')];
                }
            };

            if (lodash.has(schema, 'groups')) {
                datasource.schema.groups = function(response) {
                    return response[lodash.get(schema,'groups','groups')];
                };
            }

            if (!lodash.has(datasource,'transport')) {
                datasource.transport = {};
            }

            // Reference:
            // http://docs.telerik.com/kendo-ui/api/javascript/data/datasource#configuration-transport.parameterMap
            var pageStartIndex = lodash.get($scope.grid, 'pageStartIndex',1);

            if (!lodash.has(datasource,'transport.parameterMap')) {
                datasource.transport.parameterMap = function (data, type) {
                    if (type == 'read') {
                        return {
                            page: data.page + pageStartIndex - 1 || pageStartIndex,
                            pageSize: data.pageSize || 10,
                            sort: data.sort,
                            filter: data.filter,
                            take: data.take,
                            skip: data.skip
                        };
                    }
                };
            }

            $scope.datasource = new kendo.data.DataSource(datasource);
            DatasourceRegistry.add($scope.panelType.panel_id, $scope.datasource);
            $scope.$on('$destroy', function() {
                DatasourceRegistry.remove($scope.panelType.panel_id);
            });

            gridOption.dataSource = $scope.datasource;

            if (lodash.has(gridOption, 'rowTemlate')) {
                gridOption.rowTemplate = $.proxy(kendo.template(gridOption.rowTemplate), gridOption.datasource);
            }
            $scope.options = gridOption;

            datasource.requestStart = dsRequestStart;
            datasource.requestEnd = dsRequestEnd;
            gridOption.change = dsChange;
            gridOption.dataBound = dsDatabound;
        }

        //var dataValueField = lodash.get($scope, 'grid.datasource.schema')
        function createEventData(event) {
            return {
                targetScope: $scope.grid,
                target: $element,
                event: event
            };
        }

        function dsRequestStart(e) {
            $scope.$emit('action.grid.ds.' + $scope.description + '.requestStart', createEventData(e));
        }

        function dsRequestEnd(e) {
            $scope.$emit('action.grid.ds.' + $scope.description + '.requestEnd', createEventData(e));
        }

        function dsChange(e) {
            $scope.$emit('action.grid.' + $scope.description + '.change', createEventData(e));
        }

        function dsDatabound (e) {
            $scope.$emit('action.grid.' + $scope.description + '.dataBound', createEventData(e));
            var gridElement = e.sender.element;
            if (!(lodash.get(gridOption, 'height', '100%') == '100%')) {
                var dataArea = gridElement.find(".k-grid-content");
                dataArea.css('height','auto');
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodStatusLabel', sodStatusLabel);

    function sodStatusLabel() {
        return {
            restrict: 'E',
            controller: sodStatusLabelCtrl,
            scope: {
                statusText:'=',
                statusKey: '=?'
            },
            controllerAs: 'vm',
            bindToController: true,
            template: '<span class="sod-label" ng-bind="vm.statusText" ng-class="vm.statusKey"></span>'
        };
    }

    function sodStatusLabelCtrl() {}
})();
(function () {
    'use strict';

    actionFunc.$inject = ['lodash', '$q', '$injector'];
    angular
        .module('sodCommon')
        .factory('action-append-model', actionFunc);

    function actionFunc(lodash, $q, $injector) {
        /**
         * Action have 2 main functionality.
         *  1. Allow you to select the type of model (eventData, actionResponse),
         *  2. Allow you to append the model,
         *         to append the model. "target" field is required.
         *         if value is provided, value will be append to the return data.
         *         value takes precedent over source. Both cannot be used together for now.
         */
        return function(options, eventData, actionResponse) {
            return $q.when(run());
            function run() {
                let returnModel = getInitialModel();

                if (lodash.has(options, 'rules')) {
                    returnModel = options.rules.reduce(function(model, rule) {

                        const action = lodash.get(rule, 'action', 'append');
                        if (lodash.has(rule, 'target')) {
                            if (action === 'append') {

                                if (rule !== null) {
                                    lodash.set(model, rule.target, getValue(rule));
                                }
                            }
                            if (action === 'delete') {
                                delete model[rule.target];
                            }
                        }
                        if (action === 'merge') {
                            model = lodash.merge({}, model, getValue(rule));
                        }
                        return model;

                        // if (lodash.has(rule, 'target')) {
                        //     const action = lodash.get(rule, 'action', 'append');
                        //     if (action === 'append') {
                        //         const value = getValue(rule);
                        //         if (rule !== null) {
                        //             lodash.set(model, rule.target, value);
                        //         }
                        //     }
                        //
                        //     if (action === 'merge') {
                        //         model = lodash.merge({}, model, value);
                        //     }
                        //
                        //     if (action === 'delete') {
                        //         delete model[rule.target];
                        //     }
                        // }
                        // return model;
                    }, returnModel);
                }

                return returnModel;
            }

            function getInitialModel() {
                // actionResponse is defaultValue;
                const modelType = lodash.get(options, 'type', 'actionResponse');
                const isCopy = lodash.get(options, 'copy', false);
                let result = null;
                switch (modelType) {
                    case 'actionResponse':
                        result = actionResponse;
                        break;
                    case 'eventData':
                        result = eventData;
                        break;
                    case 'newModel':
                    default:
                        result = {};
                        break;
                }

                return (isCopy) ? angular.copy(result) : result;
            }

            function getValue(rule) {
                if (lodash.has(rule, 'value')) {
                    return mutateValue(rule, rule.value)
                } else {
                    const sourceType = lodash.get(rule, 'source_type', 'actionResponse');
                    let sourceModel = actionResponse;
                    switch (sourceType) {
                        case 'formData':
                            const formId = lodash.get(rule, 'form_id', null);
                            if (!formId) {
                                break;
                            }
                            var FormBuilderService = $injector.get('FormBuilderService');
                            sourceModel =  FormBuilderService.getModel(formId);
                            break;
                        case 'eventData':
                            sourceModel = eventData;
                            break;
                        case 'actionResponse':
                        default:
                            sourceModel = actionResponse;
                            break;
                    }
                    if (lodash.has(rule, 'source')) {
                        return mutateValue(rule, lodash.get(sourceModel, rule.source, null));
                    }
                    if (lodash.has(rule, 'useSourceType') && rule.useSourceType === true) {
                        return mutateValue(rule, sourceModel);
                    }
                }
                return null;
            }

            function mutateValue(rule, value) {
                let mutateType = lodash.get(rule, 'mutate', null);
                switch (mutateType) {
                    case 'fromKendoArray':
                        return lodash.values(value).slice(0, -4);
                    default: {
                        return value;
                    }
                }
            }
        };
    }
})();

(function () {
    'use strict';
    actionFunc.$inject = ['ModalService', 'ButtonRegistry', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-show-confirmation', actionFunc);

    function actionFunc(ModalService, ButtonRegistry, lodash) {
        return function (options, eventData, actionResponse) {
            return ModalService.showModal({
                template: options.dialogTemplate,
                controller: 'ConfirmationDialogCtrl',
                controllerAs: 'vm',
                appendElement: angular.element('.modal-wrapper'),
                inputs: {
                    dialogOptions: angular.extend(options.dialogOptions || {}, {response_data: actionResponse})
                }
            }).then(function (modal) {
                modal.element.show();
                return modal.close.then(function (result) {
                    if (!lodash.has(options, 'dontClearLoading') || result === false) {
                        ButtonRegistry.clearAllLoading();
                    }
                    if (!result) {
                        return result;
                    }
                    if (lodash.has(options, 'useEventData') && options.useEventData) {
                        return eventData;
                    }
                    if (lodash.has(options, 'useActionResponse') && options.useActionResponse) {
                        return actionResponse;
                    }
                    return result;
                });
                // return modal.close;
            });
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['lodash', '$q', '$injector'];
    angular
        .module('sodCommon')
        .factory('action-console-log', actionFunc);

    function actionFunc(lodash, $q, $injector) {
        /**
         * Action have 2 main functionality.
         *  1. Allow you to select the type of model (eventData, actionResponse),
         *  2. Allow you to append the model,
         *         to append the model. "target" field is required.
         *         if value is provided, value will be append to the return data.
         *         value takes precedent over source. Both cannot be used together for now.
         */
        return function (options, eventData, actionResponse) {
            return $q.when(run());

            function run() {
                console.log(actionResponse, eventData);
            }
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['ButtonRegistry', 'lodash', '$q'];
    angular
        .module('sodCommon')
        .factory('action-disable-button', actionFunc);

    function actionFunc(ButtonRegistry, lodash, $q) {
        return function(options) {
            return $q.when(run());

            function run() {
                if (lodash.has(options, 'button_names')) {
                    let button_names = options.button_names;
                    if (!(button_names instanceof Array)) {
                        if (button_names === null || button_names.length === 0) {
                            button_names = [];
                        } else {
                            button_names = [button_names];
                        }
                    }

                    if (lodash.isEmpty(button_names)) {
                        ButtonRegistry.disableAllButtons();
                        if (lodash.get(options,'set_loading', false) == true) {
                            ButtonRegistry.setAllLoading();
                        }
                    }

                    if (!lodash.isEmpty(button_names)) {
                        // for (const name of button_names) {
                        ButtonRegistry.disableButtons(button_names);
                        // }
                        if (lodash.get(options,'set_loading', false) == true) {
                            ButtonRegistry.setLoading(button_names);
                        }
                    }
                }
                if (!lodash.has(options, 'button_names')) {
                    ButtonRegistry.disableAllButtons();
                    if (lodash.get(options,'set_loading', false) == true) {
                        ButtonRegistry.setAllLoading();
                    }
                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['ButtonRegistry', 'lodash', '$q'];
    angular
        .module('sodCommon')
        .factory('action-enable-button', actionFunc);

    function actionFunc(ButtonRegistry, lodash, $q) {
        return function(options) {
            return $q.when(run());

            function run() {
                if (lodash.has(options, 'button_names')) {
                    let button_names = options.button_names;
                    if (!(button_names instanceof Array)) {
                        if (button_names === null || button_names.length === 0) {
                            button_names = [];
                        } else {
                            button_names = [button_names];
                        }
                    }

                    if (lodash.isEmpty(button_names)) {
                        ButtonRegistry.clearAllLoading();
                    }

                    if (!lodash.isEmpty(button_names)) {
                        for (const name of button_names) {
                            ButtonRegistry.clearLoading(name);
                        }
                    }
                }
                if (!lodash.has(options, 'button_names')) {
                    ButtonRegistry.clearAllLoading();
                    if (lodash.get(options, 'enable_all_disabled', false) === true) {
                        ButtonRegistry.enableAllButtons();
                    }

                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['AccessMainCtrl', 'Path'];
    angular
        .module('sodCommon')
        .factory('action-full-structural-refresh', actionFunc);

    function actionFunc(AccessMainCtrl, Path) {
        return function() {
            const mainService = AccessMainCtrl.get('mainService');
            const currentPath = Path.getPathInfo();
            mainService.getStructure(currentPath);
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['RmsEnum', 'lodash'];
    angular
        .module('sodCommon')
        .factory('action-load-enums', actionFunc);

    function actionFunc(RmsEnum, lodash) {
        return function(options) {
            var enum_names = lodash.get(options, 'names', null);
            if (enum_names === null) return true;
            if (!(enum_names instanceof Array)) {
                enum_names = [enum_names];
            }

            enum_names.map(function(enum_name) {
               RmsEnum.load(enum_name);
            });

            return true;
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['AccessMainCtrl', 'lodash'];
    angular
        .module('sodCommon')
        .factory('action-mutate-content', actionFunc);

    function actionFunc(AccessMainCtrl, lodash) {
        return function(options, actionData, eventResponse) {
            const mainScope = AccessMainCtrl.get('mainScope');
            if (lodash.has(options, 'contentKey')) {
                let _replacement;
                if (lodash.has(options, 'modelKey')) {
                    _replacement = lodash.get(eventResponse, options.modelKey, '');
                }
                if (!lodash.has(options, 'modelKey')) {
                    _replacement = angular.copy(eventResponse);
                }
                lodash.set(mainScope, ['content', options.contentKey].join('.'), _replacement);
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['lodash', 'CommonHelper', 'notifier'];
    angular
        .module('sodCommon')
        .factory(
            'action-notify', actionFunc);

    function actionFunc(lodash, CommonHelper, notifier) {
        return function(options, eventData, actionResponse) {
            const appliedOptions = angular.copy(options);
            if (lodash.get(options, 'remote_message', true)) {
                var msg_field_name = lodash.get(options, 'msg_field_name', 'display_msg');
                const remote_message = lodash.get(actionResponse, msg_field_name, '');
                if (!CommonHelper.isEmpty(remote_message)) {
                    appliedOptions.template = remote_message;
                }
            }

            notifier.notify(
                angular.merge(
                    {},
                    {
                        template: '&nbsp;',
                        hasDelay: true,
                        delay: 3000,
                        type: '', // default success warning info error
                        position: 'top center',
                        // classes: 'test'
                    },
                    appliedOptions
                ));
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-print-element', actionFunc);

    function actionFunc() {
        return function(options) {
            var ifr = document.createElement('iframe');
            ifr.find('head').append($("<link/>",
                { rel: "stylesheet", href: options.css_link, type: "text/css" }
            ));
            ifr.style='height: 0px; width: 0px; position: absolute';
            document.body.appendChild(ifr);
            ifr.find('body').addClass('rms-common');


            $(options.selector).clone().appendTo(ifr.contentDocument.body);
            ifr.contentWindow.print();

            ifr.parentElement.removeChild(ifr);
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['Path', 'lodash', '$q', '$location'];
    angular
        .module('sodCommon')
        .factory('action-redirect', actionFunc);

    function actionFunc(Path, lodash, $q, $location) {

        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
        return function (options, eventData, actionData) {
            // Todo: Need to confirm if eventData is exactly eventData (as in arguments[1], or arguments[2]);
            return $q.when(run());
            function run() {
                if (!lodash.has(options, 'destination')) {
                    return false;
                }

                let postData = eventData;
                if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                    postData = actionData;
                }

                let endpoint = decodeURI(options.destination).replace(urlReplacerRegex, (match, submatch) => {
                    return lodash.get(postData, submatch, '');
                });


	        	var searchData = lodash.get(options, 'searchData', {});
                if ((!!lodash.get(options, 'setFieldsAsParams', false)) === true) {
                    searchData = lodash.merge(searchData, postData);
                }

                if ((!!lodash.get(options, 'paramsExclude', false)) === true) {
                    searchData = lodash.omit(searchData, options.paramsExclude)
                }

                switch (options.target) {
                    case 'newTab': {
                        Path.newTab(endpoint);
                        break;
                    }
                    case 'newWindow': {
                        var title = lodash.get(options, 'title', null);
                        var config = lodash.get(options, 'config', null);
                        if (options.centre === true) {
                            var w = parseInt(lodash.get(config, 'width', 480));
                            var h = parseInt(lodash.get(config, 'height', 600));
                            var y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
                            var x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
                            config.top = y;
                            config.left = x;
                        }
                        var config_str = lodash.map(config, function(value, key) {
                            return key + '=' + value;
                        }).join(',');
                        Path.newWindow(endpoint, title, config_str);
                        break;
                    }
                    case 'reload': {
                        Path.reload(endpoint);
                        break;
                    }
                    default: {
                        Path.redirect(endpoint, searchData);
                        break;
                    }
                }

                return true;
            }
        };
    }
})();


(function () {
    'use strict';

    actionFunc.$inject = ['lodash', 'DatasourceRegistry', '$q'];
    angular
        .module('sodCommon')
        .factory('action-refresh-datasource', actionFunc);

    function actionFunc(lodash, DatasourceRegistry, $q) {
        return function(options) {
            return $q.when(run());
            function run() {
                if (lodash.get(options, 'panel_id', null) !== null) {
                    DatasourceRegistry.refresh(options.panel_id);
                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';
    actionFunc.$inject = ['lodash', '$timeout'];
    angular
        .module('ActionManager')
        .factory('action-scroll-to', actionFunc);

    function actionFunc(lodash, $timeout) {
        return function (options) {
            return $timeout(function() {
                var container = lodash.get(options, 'container', 'body');
                var scrollToClass = lodash.get(options, 'scrollTo', '.error, .sub-form-row-error');;
                var animateOffset = lodash.get(options, 'offset', 50);
                angular.element(container).animate({
                    scrollTop: angular.element(scrollToClass).offset().top - animateOffset
                }, 500);
            });
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['CommonHelper', 'lodash', '$timeout', 'ActionModel', '$rootScope'];
    angular
        .module('sodCommon')
        .factory('action-static-notification', actionFunc);

    function actionFunc(CommonHelper, lodash, $timeout, ActionModel, $rootScope) {
        return function(options, eventData, actionResponse) {
            const appliedOptions = angular.copy(options);
            if (lodash.get(options, 'remote_message', true)) {
                const remote_message = lodash.get(actionResponse, 'display_msg', '');
                if (!CommonHelper.isEmpty(remote_message)) {
                    appliedOptions.message = remote_message;
                }
            }

            ActionModel.set('static-notifier', appliedOptions.name, appliedOptions);
            const delay = lodash.get(appliedOptions, 'delay', null);
            if (!CommonHelper.isEmpty(delay)) {
                $timeout(function() {
                    ActionModel.set('static-notifier', appliedOptions.name, {});
                    $rootScope.$apply();
                }, delay);
            }
        };
    }
})();
(function() {
	'use strict';

	DateRangePickerCtrl.$inject = ['close', '$timeout', 'options', '$element', 'lodash', 'model'];
	angular
		.module('sodCommon')
		.controller('DateRangePickerCtrl', DateRangePickerCtrl);

	function DateRangePickerCtrl(close, $timeout, options, $element, lodash, model) {
		var drpVm = this;
		var date_picker_dom = $element.find('.date');

		var formatDisplay = lodash.get(options, 'datepicker.format_display', 'D MMM YYYY');
		var formatValue = lodash.get(options, 'datepicker.format_value', 'YYYY-M-D');

		$timeout( function () {
			drpVm.show = true;
		} );

		drpVm.model = model || {};

		drpVm.dismiss = dismiss;
		drpVm.confirm = confirm;

		init();

		function dismiss() {
			close(false, 250);
		}

		function confirm() {
			close(drpVm.model, 250);
		}

		function init() {
			date_picker_dom.datepicker(angular.merge(
				{
					// 'autoclose': true,
					'orientation': 'auto bottom',
					// 'toggle'
				},
				lodash.get(options, 'datepicker', {}),
				{
					'format': {
						toDisplay: function(date, format, language) {
							return moment(date, formatValue).format(formatDisplay);
						},
						toValue: function(date, format, language) {
							return moment(date, formatValue).format(formatDisplay);
						}
					},
					changeDate: function() {
						var currentDateObj = this;
						console.log('changeDate', currentDateObj);
					}
				}
			));
		}
	}
})();
(function() {
    'use strict';

    MainController.$inject = ['$scope', 'lodash', '$http', '$q', 'Path', 'Action', 'Request', 'Notifier', 'MasterLayoutService', 'ButtonRegistry', '$injector', 'MainService', 'PageDirtyChecker', '$window', 'FormBuilderService', '$location', 'AccessMainCtrl', '$route'];
    angular
        .module('Controllers')
        .controller('MainController', MainController);

    function MainController($scope, lodash, $http, $q, Path, Action, Request, Notifier, MasterLayoutService, ButtonRegistry, $injector, MainService, PageDirtyChecker, $window, FormBuilderService, $location, AccessMainCtrl, $route) {
        var stopWatchingLocation = null;
        $scope.allowLocationChange = false;
        $scope.currentLocation = $location.url();

        $scope.success = false;
        $scope.mainService = MainService($scope);

        AccessMainCtrl.setMainControllerScope($scope);
        AccessMainCtrl.set('mainService', $scope.mainService);

        FormBuilderService.initApp($scope);
        // Defer and init
        $q.all([
            $scope.templateLoader.promise,
            $scope.initLoader.promise,
            $scope.initPortalLoader.promise
        ]).then(function () {
            init();
        });

        $scope.$watch(watchRequestService, watchRequestServiceFunc);
        $scope.$watch(pageDataWatchRequest, pageDataWatchRequestFunc);
        $window.addEventListener('beforeunload', beforeUnloadEvent);

        //https://www.bennadel.com/blog/2808-asking-the-user-to-confirm-location-or-route-changes-in-angularjs.htm


        // initialization
        $scope.getUserProfile = getUserProfile;

        /**
         * Function to initialise App in Portal
         */
        function init() {
            //$scope.mainIndexData = MasterLayoutService.get();

            var currentPath = Path.getPathInfo();
            $scope.mainService.getStructure(currentPath);
            $scope.$on('$locationChangeSuccess', locationChangeSuccess);
            stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
        }


        /**
         * Function to get user profile information
         */
        function getUserProfile() {
            var path = Path.getApiPath('/account/user/getProfile');
            $http.get(path).then(function (res) {
                if (res.data.success) {
                    $scope.user = res.data;
                } else {
                    $scope.user = false;
                }
            }, function () {
                $scope.user = false;
            });
        }

        /*
         * REQUEST HANDLING PORTION
         * Currently, What i understand is that data manipulation should happen in controller.
         * So the snippet below is meant to attempt to follow that.
         */
        function sendRequest(request) {
            // TODO: SODO: Need to handle actions from the modal
            var defer = $q.defer();
            // TODO: SODO: make sure Id are replaced at webserver
            var path = Path.getApiPath(request.getRoute());

            $scope.content.validation = {};
            $http[request.getMethod()](path, request.getData())
                .then(function (res) {
                    var eventData = request.getEventData();
                    if (eventData.fbService && eventData.fbService.eventsService) {
                        eventData.fbService.eventsService.setPristine();
                    }

                    Action.run('', res.data.actions, $scope.content, request.getEventData(), $scope);
                    defer.resolve();

                    // if actions contains redirect, don't clear loading.
                    var redirectActions = lodash.filter(res.data.actions, function(action, index) {
                        return (index.indexOf('redirect') >= 0);
                    });
                    if (redirectActions.length == 0) {
                        ButtonRegistry.clearAllLoading();
                    }
                }, function (res) {
                    if (res.status == 422) {
                        var rules = res.data.rules;
                        var summary = lodash.get(res.data, 'summary', null);
                        var eventData = request.getEventData();
                        if ($scope.content.view_events[request.getData().event]) {
                            var submitAction = $scope.content.view_events[request.getData().event].form_submit;
                            var formIdentifier = lodash.get(submitAction, 'form_name', lodash.get(eventData,'formIdentifier', false));

                            if (typeof submitAction.schema != typeof undefined) {
                                rules = Action.reverseMapField($scope.content.view_events[request.getData().event].form_submit.schema, rules);
                            }

                            if (formIdentifier) {
                                var FormBuilderService = $injector.get('FormBuilderService');
                                var fbService = FormBuilderService.get(formIdentifier);
                                fbService.elementsService.setValidationRules(rules, summary);
                            } else {
                                // Shouldn't run anymore
                                Action.run('', {
                                    'validate': {
                                        rules: rules,
                                        summary: lodash.get(res.data, 'summary', null),
                                        form_name: res.data.form_name
                                    }
                                }, $scope.content, eventData, $scope);
                            }

                        } else {
                            // Shouldn't run anymore
                            Action.run('', {
                                'validate': {
                                    rules: rules,
                                    summary: summary,
                                    form_name: res.data.form_name
                                }
                            }, $scope.content, eventData, $scope);
                        }
                    }
                    ButtonRegistry.clearAllLoading();
                    defer.resolve();
                });
            return defer.promise;
        }

        function watchRequestService() {
            return Request.requestUpdated();
        }

        function watchRequestServiceFunc() {
            // start showing loading
            Notifier.setLoading(true);
            var requests = Request.getRequest();
            var requestQ = [];
            angular.forEach(requests, function (req) {
                // sendRequest, and get back promise
                requestQ.push(sendRequest(req));
            });

            $q.all(requestQ).then(function () {
                // execute once all promises are resolved
                Notifier.setLoading(false);
            });
        }

        function pageDataWatchRequest() {
            return MasterLayoutService.change();
        }

        function pageDataWatchRequestFunc() {
            $scope.mainIndexData = MasterLayoutService.get();
        }

        function locationChangeStart(e, nextPath, prevPath) {
            if (typeof stopWatchingLocation === typeof function () {
                }) {
                // console.log

                if (PageDirtyChecker.hasDirtyForm()) {
                    e.preventDefault();

                    var targetPath = $location.path();
                    var targetSearch = $location.search();
                    var targetHash = $location.hash();
                    PageDirtyChecker.showConfirmation().then(function () {
                        $location
                            .path(targetPath)
                            .search(targetSearch)
                            .hash(targetHash)
                            .replace()
                        ;
                        stopWatchingLocation();
                        stopWatchingLocation = null;
                    });
                } else {
                    stopWatchingLocation();
                    stopWatchingLocation = null;
                }
            }
        }

        function locationChangeSuccess(evt, newpath, oldpath) {

            var prevPathObj = Path.getPathInfo(oldpath);
            var nextPathObj = Path.getPathInfo(newpath);
            if (isPathDifferent(prevPathObj, nextPathObj)) {
                $scope.currentLocation = $location.url();
                $scope.mainService.getStructure(prevPathObj);
            } else {
                if (Path.paramsIsDiff(prevPathObj.params(), nextPathObj.params())) {
                    $scope.$broadcast('actions.paramsChange', nextPathObj.params());
                }
            }
            if (typeof stopWatchingLocation !== typeof function() {}) {
                stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
            }
        }

        function isPathDifferent(oldPath, newPath) {
            if (oldPath.structurePath() == newPath.structurePath()) {
                return false;
            } else {
                return true;
            }
        }

        function beforeUnloadEvent(e) {

            // http://stackoverflow.com/questions/276660/how-can-i-override-the-onbeforeunload-dialog-and-replace-it-with-my-own
            // no way to use our modal to override the behavior. Too bad. Live with it.
            if (!(typeof function(){} === typeof PageDirtyChecker.verify)) {
                delete e.returnValue;
                return undefined;
            }

            if (PageDirtyChecker.verify()) {
                var confirmationMessage = " ";
                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Webkit, Safari, Chrome
            }
            delete e.returnValue;
            return undefined;
        }
    }
})();
(function () {
    'use strict';

    ConfirmationDialogCtrl.$inject = ['dialogOptions', 'close', '$timeout', 'GenericModel', 'lodash', '$element', '$rootScope'];
    angular
        .module('Controllers')
        .controller('ConfirmationDialogCtrl', ConfirmationDialogCtrl);

    function ConfirmationDialogCtrl(dialogOptions, close, $timeout, GenericModel, lodash, $element, $rootScope) {
        var vm = this;
        var default_remote_msg_path = 'response_data.response.msg';
        var use_remote_message = lodash.get(dialogOptions, 'use_remote_message', true);
        vm.options = dialogOptions;
        vm.dismiss = dismiss;
        vm.confirm = confirm;
        vm.click = click;
        vm.remote_message = getRemoteMsg();
        vm.show = false;



        $timeout(function () {
            vm.show = true;
            getData();
        });

        function dismiss() {
            close(false, 250);
        }

        function confirm() {
            close(true, 250);
        }

        function click(event, isDismiss) {
            if (event) {
                $rootScope.$broadcast(event);
            }

            if (isDismiss) {
                dismiss();
            }
        }

        function getData() {
            if (lodash.has(dialogOptions, 'datasource')) {
                vm.loading = true;
                var endpoint = dialogOptions.datasource.url;
                var method = dialogOptions.datasource.method;

                var resource = new GenericModel(endpoint);
                resource[method](dialogOptions.response_data).$promise.then(function (res) {
                    vm.data = res.data;
                    vm.loading = false;
                });
            }
        }

        function getRemoteMsg() {
            if (!use_remote_message) return false;
            var remote_msg_path = lodash.get(vm.options, 'remoteMsgPath', default_remote_msg_path);
            return lodash.get(vm.options, remote_msg_path);
        }
    }
})();
(function () {
    'use strict';

    DialogNewCtrl.$inject = ['lodash', '$timeout', 'close', 'dialogOptions', 'dialogAction', '$scope', 'dialogModel', '$http'];
    angular
        .module('Controllers')
        .controller('DialogNewCtrl', DialogNewCtrl);

    function DialogNewCtrl(lodash, $timeout, close, dialogOptions, dialogAction, $scope, dialogModel, $http) {
        var vm = this;

        vm.dismiss = dismiss;
        vm.confirm = confirm;
        vm.initEvent = initEvent;
        vm.destroyEvents = destroyEvent;
        vm.addEvents = addEvents;
        vm.removeEvents = removeEvents;
        vm.setEvents = setEvents;
        vm.show = false;
        vm.options = dialogOptions;
        vm.eventRegistrationMap = {};
        vm.validation = {};

        initEvent();
        init();

        $scope.$on('$destroy', onDestroy);
        $timeout( function () {
            vm.show = true;
        } );

        function dismiss() {
            lodash.set(vm, 'data.model.confirm', false);
            close(vm.data, 250);
        }

        function confirm() {
            lodash.set(vm, 'data.model.confirm', true);
            close(vm.data, 250);
        }

        function init() {
            initDatasource();

            if (dialogModel != null) {
                var _model = lodash.get(vm.options, 'form.model', {});
                if (lodash.has(dialogModel, 'isMassSelectedItems') && dialogModel.isMassSelectedItems == true) {
                    _model = angular.extend({}, _model, dialogModel);
                } else {
                    var editModel = lodash.get(dialogModel, 'edit_model', {});
                    _model = angular.extend({}, _model, editModel);
                }
                lodash.set(vm.options, 'form.model', _model);
            }
        }

        function initDatasource() {
            if (lodash.has(dialogOptions, 'datasource')) {
                var _path = decodeURI(dialogOptions.datasource.url).replace(new RegExp('<id>', 'g'), dialogModel.id);
                $http.get(_path).then(function(res) {
                    vm.model = res.data;
                });
            }
        }

        function initEvent() {
            var defaultEvents = {
                'dialog.clear-modal': {
                    clearModal: {}
                },
                'dialog.close-dialog': {
                    closeDialog : {}
                }
            };

            var events = angular.merge(defaultEvents, vm.options.view_events);
            angular.forEach(events, function (actions, evtName) {
                vm.eventRegistrationMap[evtName] = $scope.$on(evtName, function (e, customEventData) {
                    dialogAction(actions, vm, e, customEventData, close);
                });
            });
        }

        function onDestroy() {
            destroyEvent();
        }

        function destroyEvent() {
            // important to destroy events, preventing memory leak
            angular.forEach(vm.eventRegistrationMap, function (evtDeregistration) {
                evtDeregistration();
            });
            vm.eventRegistrationMap = {};
        }

        function addEvents(events) {
            angular.forEach(events, function(actions, evtName) {
                if (lodash.has(vm.eventRegistrationMap, evtName)) {
                    vm.eventRegistrationMap[evtName]();
                    if (lodash.has(vm.eventRegistrationMap, evtName)) {
                        delete vm.eventRegistrationMap[evtName];
                    }
                    //lodash.unset(vm.eventRegistrationMap, evtName);
                }

                vm.eventRegistrationMap[evtName] = $scope.$on(evtName, function (e, customEventData) {
                    dialogAction(actions, vm, e, customEventData, close);
                });
            });
        }

        function setEvents(events) {
            destroyEvent();
            addEvents(events);
        }

        function removeEvents(events) {
            angular.forEach(events, function(evtName) {
                vm.eventRegistrationMap[evtName]();
                lodash.unset(vm.eventRegistrationMap, evtName);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('AccessMainCtrl', AccessMainCtrl);

    function AccessMainCtrl() {
        const map = {};
        return {
            // what a cheater. Wonder if this is eating memory.
            setMainControllerScope: (mainScope) => { map['mainScope'] = mainScope; },
            set: (key, ref) => { map[key] = ref; },
            get: (key) => { return map[key] || null; }
        };
    }
})();
/**
 * A registry of datasource from different elements
 * This allows actions from events to manipulate different datasources straight away.
 * The registry is kept in a map instead of an array, to easily identify, retrieve and delete datasources.
 */
(function () {
    'use strict';

    DatasourceRegistryFactory.$inject = ['Path', 'lodash'];
    angular
        .module('sodCommon')
        .factory('DatasourceRegistry', DatasourceRegistryFactory);

    function DatasourceRegistryFactory(Path,lodash) {
        var datasources = {};
        return {
            add: add,
            remove: remove,
            clear: clear,
            refreshAll: refreshAll,
            get: get,
            refresh: refresh,
            getDs: getDs,
            prepare: prepare
        };

        function add(key,ds) {
            datasources[key] = ds;
        }

        function remove(key) {
            delete datasources[key];
        }

        function clear() {
            datasources = {};
        }

        function refreshAll(){
            for (var key in datasources) {
                datasources[key].read();
            }
        }

        function get(key) {
            return lodash.get(datasources,key,null);
        }

        function refresh(key) {
            datasources[key].read();
        }

        function getDs() {
            return datasources;
        }

        function prepare(ds) {
            var uri = Path.getApiPath(Path.replace(lodash.get(ds,'transport.read.url','')));

            lodash.set(ds,'transport.read.url',uri);
            return new kendo.data.DataSource(ds);
        }
    }
})();
(function () {
    'use strict';

    var FILTER_FACTORY = 'FilterFactory';

    angular
        .module('sodCommon')
        .factory(FILTER_FACTORY, FilterFactory);

    function FilterFactory(lodash, $rootScope) {
        var filters = {};

        function get(pathType, activeFilters) {
            handleActiveFilters(pathType, activeFilters);
            return lodash.get(filters, pathType, []);
        }

        function set(pathType, filtersToSet, skipEmit) {
            var initialFilters = Object.assign({}, filters);
            lodash.set(filters, pathType, filtersToSet);

            if (!skipEmit) {
                handleEmitChanges(initialFilters, pathType);
            }
            return get(pathType);
        }

        function add(pathType, filter, skipEmit) {
            var initialFilters = Object.assign({}, filters);
            var pathTypeFilters = lodash.get(filters, pathType, []);
            var pathTypeFiltersAdded = lodash.concat(pathTypeFilters, filter);

            set(pathType, lodash.uniq(pathTypeFiltersAdded));
            if (!skipEmit) {
                handleEmitChanges(initialFilters, pathType);
            }
            return get(pathType);
        }

        function handleEmitChanges(initialFilters, pathType) {
            var pathTypes = pathType.split('.');
            if (pathTypes.length >= 2) {
                emitChanges(pathType);
                emitChanges(pathTypes[0]);
            } else {
                lodash.forEach(lodash.keys(initialFilters[pathTypes[0]]), function (initialFilterKey) {
                    emitChanges([pathTypes[0], initialFilterKey].join('.'));
                });
                emitChanges(pathTypes[0]);
            }
        }

        function handleActiveFilters(pathType, activeFilters) {
            var pathTypes = pathType.split('.');
            if (!lodash.isEmpty(pathTypes) && pathTypes.length >= 2) {
                var filterTypeKey = pathTypes[1];
                var foundActiveApplied = lodash.find(lodash.get(activeFilters, 'applied', []), { field: filterTypeKey });
                var foundActiveSearch = lodash.find(lodash.get(activeFilters, 'search', []), { field: filterTypeKey });
                var foundActiveFilter = foundActiveApplied || foundActiveSearch;

                if (foundActiveFilter) {
                    var value = lodash.get(foundActiveFilter, 'value');
                    add(pathType, value, true);
                    $rootScope.$broadcast([FILTER_FACTORY, pathTypes[0], 'reload'].join('.'));
                    emitChanges([pathType, 'addDisplayOptions'].join('.'))
                }
            }
        }

        function emitChanges(pathType) {
            $rootScope.$broadcast([FILTER_FACTORY, pathType].join('.'), get(pathType));
        }

        return {
            get: get,
            set: set,
            add: add,
            eventPrefix: FILTER_FACTORY,
        };
    }
})();
(function () {
    'use strict';

    GaService.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .service('GaService', GaService);

    function GaService(lodash) { // eslint-disable-line no-unused-vars
        this.addEvent = function(options, model) {
            var ga_event = lodash.get(options, 'ga_event');
            if (!ga_event) return ;
            if (!model) model = {};
            var modelData = {};
            if (lodash.has(options, 'map')) {
                modelData = lodash.reduce(options.map, function(carry, value, key) {
                    carry[key] = lodash.get(model, value);
                    return carry;
                }, {});
            }
            var gaData = lodash.get(options, 'ga_data', {})
            gtag('event', ga_event, lodash.extend(gaData, modelData));
        };
    }
})();

(function () {
    'use strict';

    var GROUP_FILTER_FACTORY = 'GroupFilterFactory';
    var EVENT_LOADING = 'EventLoading';
    var EVENT_PAGE_CHANGE = 'EventPageReset';

    angular
        .module('sodCommon')
        .factory(GROUP_FILTER_FACTORY, GroupFilterFactory);

    function GroupFilterFactory($q, $location, $rootScope, lodash, GenericModel, FilterFactory) {
        var configSet = {};
        var paramsSet = {};
        var defaultParams = {
            page: 1,
            pageSize: 15,
            skip: 0,
            take: 15,
        };

        var currentId = null;

        function applyFilter(id, params) {
            currentId = id;
            params = params || {};
            params = getParams(params);
            var deferApplyFilter = $q.defer();


            var method = getMethod();
            var datasource = getFullyFormedDatasource(method);

            if (method === 'search') {
                params = { data: params };
            }

            var model = new GenericModel(datasource);
            emitLoadingEvent(true);
            model[method](params).$promise.then(function (res) {
                emitLoadingEvent(false);
                deferApplyFilter.resolve(res);
                setCount(lodash.get(res, 'count', 0));
                emitChangeEvent(res);
            }, function (res) {
                setCount();
                emitChangeEvent();
                emitLoadingEvent(false);
                console.error('res', res);
            });
        }

        function setCount(count) {
            count = count || 0;
            lodash.set(configSet, [currentId, 'count'].join('.'), count);
        }

        function getCount() {
            return lodash.get(configSet, [currentId, 'count'].join('.'), 0);
        }

        function getMethod() {
            var condition = [
                !lodash.isEmpty(paramsSet[currentId].filter.search),
                !lodash.isEmpty(paramsSet[currentId].filter.applied),
            ];

            if (lodash.isEmpty(lodash.compact(condition))) {
                return 'query';
            } else {
                return 'search';
            }
        }

        function getFullyFormedDatasource(method) {
            var urlPath = [currentId, 'datasource', 'list', 'url'].join('.');
            switch (method) {
                case 'search':
                    return [lodash.get(configSet, urlPath, ''), 'filter'].join('/');
                case 'query':
                default:
                    return lodash.get(configSet, urlPath, '');
            }
        }

        function getParams(params) {
            var initialFilterParams = Object.assign({}, lodash.get(paramsSet, [currentId, 'filter'].join('.'), {}));
            var searchFilterConfig = lodash.get(configSet, [currentId, 'search_filter'].join('.'), {});

            paramsSet[currentId].filter.applied = lodash.reduce(FilterFactory.get(currentId), function(accum, value, key) {
                if (lodash.isEmpty(value)) return accum;
                if (key === lodash.get(searchFilterConfig, 'type')) {
                    return accum;
                }
                return lodash.concat(accum, { field: key, operator: 'in', value: value });
            }, []);

            var searchValue = lodash.get(FilterFactory.get(currentId), lodash.get(searchFilterConfig, 'type'), []);
            if (!lodash.isEmpty(searchValue)) {
                paramsSet[currentId].filter.search = [{
                    field: lodash.get(searchFilterConfig, 'type'),
                    operator: lodash.get(searchFilterConfig, 'operator'),
                    value: lodash.get(searchValue, 0),
                }];
            } else {
                paramsSet[currentId].filter.search = [];
            }
            if (!lodash.isEqual(initialFilterParams, lodash.get(paramsSet, [currentId, 'filter'].join('.'), {}))) {
                params.page = 1;
                emitPageChangeEvent(params.page);
            }

            var filteredParams = Object.assign({}, paramsSet[currentId], params);

            return Object.assign({}, filteredParams, {
                skip: (filteredParams.page - 1) * filteredParams.pageSize,
            });
        }

        function setSort(id, sortToSet) {
            currentId = id;
            paramsSet[currentId].sort = sortToSet;
            applyFilter(id);
        }

        function emitChangeEvent(data) {
            $rootScope.$broadcast([GROUP_FILTER_FACTORY, currentId].join('.'), data);
        }

        function emitLoadingEvent(isLoading) {
            $rootScope.$broadcast([GROUP_FILTER_FACTORY, currentId, EVENT_LOADING].join('.'), isLoading);
        }

        function emitPageChangeEvent(page) {
            $rootScope.$broadcast([GROUP_FILTER_FACTORY, currentId, EVENT_PAGE_CHANGE].join('.'), page);
        }

        return function(config) {
            var currentId = lodash.get(config, 'id', 'notExist');
            var isObjectConfig = typeof config === typeof {};

            if (!lodash.has(configSet, currentId) && isObjectConfig) {
                var configSetObject = {};
                configSetObject[currentId] = config;
                configSetObject[currentId] = Object.assign({}, configSetObject[currentId], {
                    debouncedApplyFilter: lodash.debounce(function(id, params) { applyFilter(id, params); }, 300),
                });
                configSet = Object.assign({}, configSet, configSetObject);
            }

            if (!lodash.has(paramsSet, currentId) && isObjectConfig) {
                var paramsSetObject = {};
                paramsSetObject[currentId] = Object.assign({}, defaultParams, {
                    filter: {
                        applied: [],
                        search: [],
                    },
                    sort: [lodash.get(config, 'sort.default', {})],
                });
                paramsSet = Object.assign({}, paramsSet, paramsSetObject);
            }

            function init() {
                $rootScope.$on([FilterFactory.eventPrefix, currentId, 'reload'].join('.'), function(e) {
                    lodash.get(configSet, [currentId, 'debouncedApplyFilter'].join('.'), function () {})(currentId);
                });
            }

            init();

            return {
                applyFilter: function(id, data) { lodash.get(configSet, [id, 'debouncedApplyFilter'].join('.'), function () {})(id, data) },
                setSort: setSort,
                getCount: getCount,
                eventPrefix: GROUP_FILTER_FACTORY,
                eventLoading: EVENT_LOADING,
                eventPageChange: EVENT_PAGE_CHANGE,
            };
        };
    }
})();
(function () {
    'use strict';

    KeyTrackingService.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .factory('KeyTrackingService', KeyTrackingService)

    function KeyTrackingService(lodash) {
        var keys = [];
        var newTabKeyCodeCombination = [
            91, // mac command left
            93, // mac command right
            17, // ctrl
        ];

        document.addEventListener('keydown', function (event) {
            var keyCode = event.keyCode;

            keys = keys.concat(keyCode);
            keys = lodash.uniq(keys);
        });

        document.addEventListener('keyup', function (event) {
            var keyCode = event.keyCode;

            keys = lodash.pull(keys, keyCode);
        });

        function get() {
            return keys;
        }

        function has(keyCodes) {
            return lodash.intersection(keys, lodash.isArray(keyCodes) ? keyCodes : [keyCodes]).length;
        }

        function hasNewTabCombinationKeyCode() {
            return lodash.intersection(keys, newTabKeyCodeCombination).length;
        }

        return {
            get: get,
            has: has,
            hasNewTabCombinationKeyCode: hasNewTabCombinationKeyCode,
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('MasterLayoutService', MasterLayoutService);

    function MasterLayoutService() {
        var json = {},
            time = new Date();
        return {
            get: get,
            set: set,
            change: change
        };

        function get() {
            return json;
        }

        function set(data) {
            json = data;
            time = new Date();
        }

        function change(){
            return time;
        }
    }
})();
(function() {
    'use strict';

    service.$inject = ['$timeout', 'lodash'];
    angular
        .module('sodCommon')
        .factory('NotificationService', service);

    function service($timeout, lodash) {
        var time = new Date(),
            value = {},
            timeoutPromise = null;

        return {
            get: get,
            set: set,
            change: change
        };

        function get() {
            return value;
        }

        function set(val) {
            value = val;
            time = new Date();
            if (lodash.has(value, 'hide_after')) {
                if (timeoutPromise != null) {
                    $timeout.cancel(timeoutPromise);
                }
                timeoutPromise = $timeout(function() {
                    value = {};
                    time = new Date();
                }, value.hide_after);
            }
        }

        function change() {
            return time;
        }
    }
})();

(function () {
    'use strict';

    SodGridFactory.$inject = ['$q', '$rootScope', 'lodash', 'GenericModel'];
    var SOD_GRID_FACTORY = 'SodGridFactory';
    var EVENT_LOADING = 'EventLoading';

    angular
        .module('sodCommon')
        .factory('SodGridFactory', SodGridFactory);

    const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;

    function SodGridFactory($q, $rootScope, lodash, GenericModel) {
        var configSet = {};

        var currentId = null;


        function selectJob(id, job_id) {
            currentId = id;
            if (!job_id) {
                configSet[id].open_detail = false;
                return;
            }
            configSet[id].open_detail = true;
            emitLoadingEvent(true);
            getJobInfo(job_id).then(function(res) {
                configSet[id].selected_job = res.data;
                emitLoadingEvent(false);
            }, function(res) {
                console.error('res', res);
                emitLoadingEvent(false);
            });
        }


        function getFullyFormedDatasource() {
            var urlPath = [currentId, 'datasource', 'get', 'url'].join('.');

            return lodash.get(configSet, urlPath, '');
        }

        function getJobInfo(job_id) {
            var datasource = getFullyFormedDatasource();
            var replacement = {
                id: job_id,
            };
            datasource = decodeURI(datasource).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(replacement, submatch, '');
            });
            var model = new GenericModel(datasource);
            return model.get().$promise;

        }

        function emitLoadingEvent(isLoading) {
            $rootScope.$broadcast(
                [SOD_GRID_FACTORY, currentId, EVENT_LOADING].join('.'),
                isLoading
            );
        }

        return function(config) {
            var currentId = lodash.get(config, 'id', 'notExist');
            var isObjectConfig = typeof config === typeof {};

            if (!lodash.has(configSet, currentId) && isObjectConfig) {
                var configSetObject = {};
                configSetObject[currentId] = config;
                configSet = Object.assign({}, configSet, configSetObject);
            }

            function init() {

            }

            init();

            return {
                eventPrefix: SOD_GRID_FACTORY,
                eventLoading: EVENT_LOADING,
                selectJob: selectJob
            };
        };
    }
})();
(function() {
    'use strict';

    myfactory.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .factory('ButtonRegistry', myfactory);

    function myfactory (lodash) {
        var mybuttons = [];
        return {
            get: get,
            set: set,
            reset: reset,
            remove: remove,
            clearLoading: clearLoading,
            clearAllLoading: clearAllLoading,
            enableButtons: enableButtons,
            disableButtons: disableButtons,
            enableAllButtons: enableAllButtons,
            disableAllButtons: disableAllButtons,
            setLoading: setLoading,
            setAllLoading: setAllLoading
        };

        function get(scope_id) {
            // return mybuttons[button_id];
            return lodash.find(mybuttons, {angular_id: scope_id});
        }

        function set(button) {
            // mybuttons.push(button);
            mybuttons.push(button);
        }

        function remove(scope_id) {
            lodash.remove(mybuttons, { angular_id: scope_id});
        }

        function reset() {
            mybuttons = [];
        }

        function setLoading(name) {
            var buttons = lodash.filter(mybuttons, {name: name});
            angular.forEach(buttons, function (button) {
                button.loading = true;
            });
        }

        function clearLoading(name) {
            //mybuttons[button_id].loading = false;
            var buttons = lodash.filter(mybuttons, {name: name});
            angular.forEach(buttons, function (button) {
                button.loading = false;
            });
        }

        function setAttribute(name, attribute, value) {
            var buttons = lodash.filter(mybuttons, {name: name});
            angular.forEach(buttons, function (button) {
                lodash.set(button, attribute, value);
            });
        }

        function clearAllLoading() {
            angular.forEach(mybuttons, function(button) {
                button.loading = false;
            });
        }

        function setAllLoading() {
            angular.forEach(mybuttons, function(button) {
                button.loading = true;
            });
        }

        function enableButtons(buttonNames) {
            angular.forEach(buttonNames, function(name) {
                setAttribute(name, 'attr.disabled', false);
            });
        }

        function disableButtons(buttonNames) {
            angular.forEach(buttonNames, function(name) {
                //lodash.set(mybuttons, [name, 'attr.disabled'].join('.'), true);
                setAttribute(name, 'attr.disabled', true);
            });
        }

        function enableAllButtons() {
            angular.forEach(mybuttons, function(button) {
                lodash.set(button, 'attr.disabled', false);
            });
        }

        function disableAllButtons() {
            angular.forEach(mybuttons, function(button) {
                lodash.set(button, 'attr.disabled', true);
            });
        }
    }
})();
(function () {
    'use strict';

    dialogAction.$inject = ['lodash', 'GenericModel', 'ButtonRegistry', 'FormBuilderService', 'Path', 'FormEventActions', '$timeout', '$injector', 'ActionCommon'];
    angular
        .module('sodCommon')
        .factory('dialogAction', dialogAction);

    function dialogAction(lodash, GenericModel, ButtonRegistry, FormBuilderService,Path, FormEventActions, $timeout, $injector, ActionCommon) {


        return function(actions, viewModel, btnEvent, eventData, close) {
            var route;
            mapFunction();
            angular.forEach(actions, function(action, actionName) {
                route[actionName](action);
            });

            function getModel() {
                if (lodash.has(viewModel.options, 'form.name')) {
                    var form_name = viewModel.options.form.name;
                    var fbService = FormBuilderService.get(form_name);
                    return fbService.model;
                } else {
                    return lodash.get(viewModel.options, action.data, {});
                }
            }

            function sendRequest(action) {
                var data = {
                    data: getModel(),
                    event: btnEvent.name
                };
                var model = new GenericModel(action.datasource.url);
                var method = lodash.get(action.datasource, 'method', 'get');


                model[method]({}, data, function(res) { //res
                    if (lodash.has(res, 'actions')) {
                        angular.forEach(res.actions, function(act, actionName) {
                            route[actionName](act);
                        });
                    } else {
                        runActionOnSuccess(action);
                    }
                    clearButtonLoading();

                }, function(res) {

                    viewModel.validation = {};
                    switch (res.status) {
                        case 422:
                            validation(res.data);
                            break;
                        case 404:case 500: break;
                    }
                    clearButtonLoading();
                });
            }

            function validation(data) {
                var form_name = viewModel.options.form.name;
                var fbService = FormBuilderService.get(form_name);
                fbService.elementsService.setValidationRules(data.rules, data.summary);

            }

            function clearModel() {
                viewModel.validation = {};
            }

            function callFormActions(actionData) {
                FormEventActions(actionData.form_name, actionData.actions, null, null);
            }

            function closeDialog(data) {
                $timeout(function() {
                    close(data);
                });
            }

            function redirect(data){
                var sub_id = '';
                var _path = Path.replace(data.destination, sub_id);
                Path.redirect(_path);
                closeDialog(data);
            }

            function runActionOnSuccess(action) {
                if (lodash.has(action, 'actionOnSuccess')) {
                    angular.forEach(action.actionOnSuccess, function(act, actionName) {
                        route[actionName](act);
                    });
                }
            }

            function clearButtonLoading() {
                ButtonRegistry.clearLoading(eventData.targetScope.name);
            }

            function refreshGrid(data) {
                var ListFilterStateFactory = $injector.get('ListFilterStateFactory');
                var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                listfilterService.refreshGrid();
            }

            function clearGridSelected(data) {
                var ListFilterStateFactory = $injector.get('ListFilterStateFactory');
                var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                listfilterService.clearSelected();
            }

            function mapFunction() {
                route = {
                    sendRequest: sendRequest,
                    clearModel: clearModel,
                    closeDialog: closeDialog,
                    redirect: redirect,
                    callFormActions: callFormActions,
                    refreshGrid: refreshGrid,
                    show_floating_notification: ActionCommon.show_floating_notifier,
                    show_static_notification: ActionCommon.show_static_notifier,
                    clearGridSelected: clearGridSelected
                };
            }
        };
    }
})();
(function () {
    'use strict';

    ListFilterStateFactory.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .factory('ListFilterStateFactory', ListFilterStateFactory);

    function ListFilterStateFactory(lodash) {
        const state = {};

        return {
            create: function(listFilterMem, identifier) {
                if (identifier === null) {
                    lodash.set(state, 'default', listFilterMem);
                } else {
                    lodash.set(state, identifier, listFilterMem);
                }
            },
            get: function(identifier) {
                if (lodash.isEmpty(identifier)) {
                    return lodash.get(state, 'default', null);
                }
                return lodash.get(state, identifier, null);
            },
            destroy: function(identifier) {
                if (lodash.has(state, identifier)) {
                    state[identifier].destroy();
                    delete state[identifier];
                }
            },
            getAll: function() {
                return state;
            }
        }
    }
})();
(function () {
    'use strict';

    MainService.$inject = ['Action', 'Path', 'ButtonRegistry', 'NotificationService', 'lodash', '$rootScope', '$anchorScroll', '$location', '$http', 'ActionModel', 'DialogManager'];
    angular
        .module('sodCommon')
        .factory('MainService', MainService);

    function MainService(Action, Path, ButtonRegistry, NotificationService, lodash, $rootScope, $anchorScroll, $location, $http, ActionModel, DialogManager) {
        return function($scope) {
            $scope.currentEvents = {};

            return {
                getStructure: getStructure,
                addViewEvents: addViewEvents,
                clearViewEvents: clearViewEvents,
                removeViewEvents: removeViewEvents,
                setViewEvents: setViewEvents
            };

            /**
             * Function to get structure+content of the current path
             * @param path
             * @returns promise of the $http.get
             */
            function getStructure (oldPath) {
                Path.change();
                // SODO: Write a decorator to override/add function to get portal structure path, otherwise, have structurepath accept third variable to control
                var structurePath = Path.getStructurePath();
                destroyEvent();

                var data = Path.getPathInfo().search();
                if (oldPath) {
                    data.oldPath = oldPath.viewPath();
                }

	              // ActionModel.clearAll();
                ButtonRegistry.reset();
                DialogManager.destroyAll();
                return $http.get(structurePath, {params:data})
                    .then(function (res, status) {
                        //SodLogger.pageChange();
                        // success
                        if (status == 302) {
                            // Todo: Handle redirection
                            $location.path('/');
                        }

                        // Only load pathStructure data and events only if the current path matches.
                        // The fix tries to prevent situation where users clicked 2 or more links simultaneously
                        // And load only the structure information of the current path according to the url in the browser
                        // Unsure of any side effects at the time of writing this fix.
                        if (structurePath == Path.getStructurePath()) {
                            $scope.error = !res.data.success;
                            NotificationService.set({});

                            if (res.data.success) {
                                $scope.content = res.data.structure;
                                $rootScope.title = $scope.content.title;
                            } else {
                                if (lodash.has(res, 'data.structure')) {
                                    $scope.content = res.data.structure;
                                }
                                $rootScope.title = lodash.get(res.data, 'structure.display_title', res.data.status_code);
                            }

                            if (lodash.has(res, 'data.actions')) {
                                Action.run('', res.data.actions, $scope.content, {}, $scope);
                            }
                            initEvent();
                            //$scope.getNavBar();
                            $anchorScroll();
                            if (angular.element('.preloader-wrapper')) {
                                angular.element('.preloader-wrapper').remove();
                                angular.element('.main-app-wrapper').css('display','block');
                            }
                        }
                    }, function () {
                        // error
                    });
            }

            function initEvent() {
                angular.forEach($scope.content.view_events, function (evt, evtName) {
                    $scope.currentEvents[evtName] = $scope.$on(evtName, function (e, customEventData) {
                        // console.log('%cEventTriggered: ' + evtName, 'color: #e67e22');
                        // item refers to the element that activates the event
                        Action.run(evtName, evt, $scope.content, customEventData, $scope);
                    });
                });

                // $scope.currentEvents.push($scope.$on('action.common.button.cancel', function () {
                //     Path.redirect(Path.up());
                // }));
                $scope.currentEvents['validate.file'] = $scope.$on('validate.file', function (e, eventData) {
                    Action.run('', eventData.rules, $scope.content, eventData, $scope);
                    $scope.$digest();
                });
                // an event used to check scope
                //$scope.currentEvents.push($scope.$on('action.debug', function () {
                //
                //}));
            }

            function addViewEvents(view_events) {
                angular.forEach(view_events, function(actions, evtName) {
                    if (lodash.has($scope.currentEvents, evtName)) {
                        $scope.currentEvents[evtName]();
                        lodash.unset(vm.eventRegistrationMap, evtName);
                    }

                    $scope.currentEvents[evtName] = $scope.$on(evtName, function (e, eventData) {
                        Action.run(evtName, eventData.rules, $scope.content, eventData, $scope);
                    });
                });
            }

            function setViewEvents(view_events) {
                destroyEvent();
                addViewEvents(view_events);
            }

            function removeViewEvents(view_events) {
                angular.forEach(view_events, function(evtName) {
                    if (lodash.has($scope.currentEvents, evtName)) {
                        $scope.currentEvents[evtName]();
                        lodash.unset($scope.currentEvents, evtName);
                    }
                });
            }

            function clearViewEvents() {
                destroyEvent();
            }

            function destroyEvent() {
                // important to destroy events, preventing memory leak
                angular.forEach($scope.currentEvents, function (evtDeregistration) {
                    evtDeregistration();
                });
                $scope.currentEvents = {};
                //angular.element($window).unbind('beforeunload', handleWindowClose);
            }


        };
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('Notifier', NotifierFactoryFunc);

    function NotifierFactoryFunc() {
        var message= '';
        var type = 'success';
        var loading = false;
        var notification = false;
        return {
            message: function () { return message; },
            type: function () { return type; },

            setMessage: function(msg) {message = msg;},
            setType: function(t) {type = t;},
            show: function(t,m){
                this.setMessage(m);
                this.setType(t);
                this.toggleNotification();
            },

            notificationChanged: function() {return notification; },
            toggleNotification: function() { notification = new Date().getTime();},

            setLoading: function(l) { loading = l; },
            getLoading: function() { return loading; }
        };
    }
})();
(function () {
    'use strict';

    PageDirtyChecker.$inject = ['FormBuilderService', 'ModalService', '$q', '$timeout'];
    angular
        .module('sodCommon')
        .service('PageDirtyChecker', PageDirtyChecker);

    function PageDirtyChecker(FormBuilderService, ModalService, $q, $timeout) { // eslint-disable-line no-unused-vars
        this.hasDirtyForm = () => {
            return FormBuilderService.hasDirtyForm();
        };

        this.showConfirmation = function() {
            // how to pass dynamic data to this confirmation
            const modalQ = $q.defer();

            $timeout(function() {
                ModalService.showModal({
                    templateUrl: 'common/app/components/page-dirty-confirmation',
                    controller: 'PageDirtyConfirmationCtrl',
                    controllerAs: 'vm',
                    appendElement: angular.element('.modal-wrapper'),
                    inputs: {}
                }).then(function (modal) {
                    modal.element.show();
                    modal.close.then(function(result) {
                        (result) ? modalQ.resolve() : modalQ.reject();
                    });
                });
            });

            return modalQ.promise;
        };
    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('sodCommon')
//         .factory('RecursionHelper', RecursionHelper);
//
//     function RecursionHelper($compile) {
//         return {
//             /**
//              * Manually compiles the element, fixing the recursion loop.
//              * @param element
//              * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
//              * @returns An object containing the linking functions.
//              */
//             compile: function (element, link) {
//                 // Normalize the link parameter
//                 if (angular.isFunction(link)) {
//                     link = {post: link};
//                 }
//
//                 // Break the recursion loop by removing the contents
//                 var contents = element.contents().remove();
//                 var compiledContents;
//                 return {
//                     pre: (link && link.pre) ? link.pre : null,
//                     /**
//                      * Compiles and re-adds the contents
//                      */
//                     post: function (scope, element) {
//                         // Compile the contents
//                         if (!compiledContents) {
//                             compiledContents = $compile(contents);
//                         }
//                         // Re-add the compiled contents to the element
//                         compiledContents(scope, function (clone) {
//                             element.append(clone);
//                         });
//
//                         // Call the post-linking function, if any
//                         if (link && link.post) {
//                             link.post.apply(null, arguments);
//                         }
//                     }
//                 };
//             }
//         };
//     }
// })();
(function() {
    'use strict';

    RequestFactoryFunc.$inject = ['Path'];
    angular
        .module('sodCommon')
        .factory('Request', RequestFactoryFunc);

    function RequestFactoryFunc(Path) {
        var updated = null;
        var models = {};
        return {
            /**
             * creates a request object used for executing a api call
             * @param method - GET/POST/PUT/DELETE
             * @param route - uri of the service.
             * @param event - the event that activates this request call
             * @param eventData  - the eventData from the event
             * @param data - Data to send over to the api
             */
            run: function(method, route, event, eventData, data) {
                var update = new Date().getTime();
                if (method == 'delete') data = {};
                if (!data) data = {};
                models[update] = new RequestModel(method, route, event, eventData, data);
                updated = angular.copy(update);
            },
            /**
             * Method to determine if a new request is created and pending for executing (Used at ContentController)
             * @returns (Integer) updated - the last updated time
             */
            requestUpdated: function() {
                return updated;
            },
            /**
             * get the request object necessary to do a request call
             * @returns (Object) request - contains information like method, uri, data, event
             */
            getRequest: function() {
                var result = angular.copy(models);
                models = {};
                return result;
            }
        };

        // require model stores the relavent information for a request
        function RequestModel(method, route, event, eventData, data) {
            return {
                getMethod: function() { return method.toLowerCase(); },
                getRoute: function() { return route; },
                getData: function() {
                    return {
                        path:  Path.getPathInfo().viewPath(),
                        event: event,
                        data :data
                    };
                },
                getElement: function() { return eventData.target; },
                getElementScope: function() { return eventData.targetScope; },
                getEventData: function() { return eventData; }
            };
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .provider('RmsEnum', providerFunc);

    function providerFunc() {
        let path = '/api/v1/form/enum/getEnum/';
        const enums = {};

        providerGetFunc.$inject = ['$http', 'lodash'];
        return {
            $get: providerGetFunc,
            changePath: function(_p) {
                path = _p;
            }
        };


        function providerGetFunc($http, lodash) {
            return {
                load: function(enumName) {
                    return $http.post(path + enumName, {}).then(function(res) {
                        lodash.set(enums, enumName, res.data.data);
                        return res.data.data;
                    }, function (err) {
                        return err;
                    });
                },
                get: function (enumName, value, defaultValue) {
                    const result = lodash.find(lodash.get(enums, enumName, []), function(row) {
                        return value.toString() === row.value.toString();
                    });
                    if (result) {
                        return result.label;
                    }
                    return defaultValue;
                },
                setList: function(enumName, list) {
                  lodash.set(enums, enumName, list);
                },
                getList: function(enumName) {
                    if (lodash.has(enums, enumName)) {
                        return lodash.get(enums, enumName, []);
                    }
                    return this.load(enumName).then(function(res) {
                        return res;
                    })
                },
                has: function(enumName) {
                    return lodash.has(enums, enumName);
                }
            };
        }
    }
})();
(function () {
    'use strict';

    SodState.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .factory('SodState', SodState);

    function SodState(lodash) {
        var mem = {};
        return {
            sync: sync,
            destroy: destroy,
            set: set
        };

        function sync(vm) {
            lodash.set(mem, 'model', vm.model);
        }

        function destroy() {
            mem = {};
        }

        function set(field, value) {
            lodash.set(mem.model, field, value);
        }
    }
})();
(function () {
    'use strict';

    uriActiveLinkService.$inject = ['$location'];
    angular
        .module('sodCommon')
        .factory('uriActiveLinkService', uriActiveLinkService);

    function uriActiveLinkService($location) {
        return function(path) {
            return ($location.path().indexOf(path) == 0);
        };
    }
})();
(function() {
    'use strict';

    uDetailsFactoryFunc.$inject = ['$http', 'Path'];
    angular
        .module('sodCommon')
        .factory('uDetails', uDetailsFactoryFunc);

    function uDetailsFactoryFunc($http, Path) {
        var user;
        return {
            init: function(u) {
                user = u;
            },
            get: function() {
                return $http.get(Path.getApiPath('/auth/user')).then(function() {
                    return user;
                }, function() {

                });
            }
        };
    }
})();
(function () {
    cleanseValue.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('cleanseValue', cleanseValue);

    function cleanseValue(lodash) {
        return function (value) {
            return lodash.reduce(value, function(carry, _val, _key) {
                if (lodash.isBoolean(_val) || lodash.isNumber(_val) || lodash.isString(_val)) {
                    if (lodash.isString(_val) && _val.length <= 0) {
                        return carry;
                    }

                    carry[_key] = _val;
                    return carry;
                }
                
                if (lodash.isEmpty(_val)) {
                    return carry;
                }
                
                carry[_key] = _val;
                return carry;
            }, {});
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('contains', contains);

    function contains() {
        return function (value) {
            var arr = Array.prototype.slice.call(arguments, 1);
            return arr.indexOf(value) > -1;
        };
    }
})();
(function () {
    'use strict';

    emptyText.$inject = ['CommonHelper'];
    angular
        .module('sodCommon')
        .filter('emptyText', emptyText);

    function emptyText(CommonHelper) {
        return function (value, defaultText) {
            if (!defaultText) {
                defaultText = '-';
            }

            if (CommonHelper.isEmpty(value)) {
                return defaultText;
            }
            return value;
        };
    }
})();
(function () {
    'use strict';

    findDisplay.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('findDisplay', findDisplay);

    function findDisplay(lodash) {
        return function (value, collection, field, display_field) {
            var item = lodash.find(collection, function(_item) {
                return lodash.get(_item, field, null) == value;
            });
            return lodash.get(item, display_field, '');
        };
    }
})();
(function () {
    'use strict';

    formatScorer.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('formatScorer', formatScorer);

    function formatScorer(lodash) {
        return function(value) {
            let template = '<span class="background-image droid-2"></span>';
            if (value === undefined) {
                return template;
            }
            const score = parseFloat(value);
            if (!lodash.isNaN(score)) {

                const score = parseFloat(value);
                let colorClass = '';

                if (score >= 70) {
                    colorClass = 'color-green';
                } else {
                    if (score < 30) {
                        colorClass = 'color-red';
                    } else {
                        colorClass = 'color-amber';
                    }
                }
                template += `<span class="${colorClass}">${value}%</span>`
            }

            return template;
        }
    }
})();
(function () {
    'use strict';

    hasProperties.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('hasProperties', hasProperties);

    function hasProperties(lodash) {
        return function(object) {
            return lodash.isObject(object) && lodash.keys(object).length > 0;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('htmlToPlaintext', htmlToPlaintext);

    function htmlToPlaintext() {
        return function(text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('inArray', inArray);

    function inArray() {
        return function (value, arr) {
            if (!(arr instanceof Array)) {
                return false;
            }
            return arr.indexOf(value) > -1;
        };
    }
})();
(function () {
    isMultipleEnumType.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('isMultipleEnumType', isMultipleEnumType);

    function isMultipleEnumType(lodash) {
        return function(type) {
                if (!lodash.isString(type)) {
                return false;
            }

            return type.indexOf('multiple_enum_type') >= 0;
        }
    }
})();
(function () {
    'use strict';

    itemsInArray.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('itemsInArray', itemsInArray);

    function itemsInArray(lodash) {
        return function(inputs,filterValues, field) {
            if (!(filterValues instanceof Array)) {
                return inputs;
            }
            if (!field) {
                field = 'id';
            }

            var output = [];

            angular.forEach(inputs, function (input) {
                var value = lodash.get(input, field, null);
                if (filterValues.indexOf(input.id) !== -1) {
                    output.push(input);
                }
            });
            return output;
        };
    }
})();
(function () {
    'use strict';

    kebabCase.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('kebabCase', kebabCase);

    function kebabCase(lodash) {
        return function(value) {
            return lodash.kebabCase(value);
        }
    }
})();
(function () {
    'use strict';

    limitToEllipsis.$inject = ['$filter'];
    angular
        .module('sodCommon')
        .filter('limitToEllipsis', limitToEllipsis);

    function limitToEllipsis($filter) {
        return function(text, length, isBool) {
            if (typeof text !== typeof '') return text;

            if (isBool) return text.length > length;

            return $filter('limitTo')(text, length).trim()  + ((text.length > length) ? '...' : '');
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('lineBreakReplacement', lineBreakReplacement);

    function lineBreakReplacement() {
        return function(val) {
            if (!val) return val;
            return val.replace(/\\n/g, '<br />');
        };
    }
})();
(function () {
    'use strict';

    notAnEmptyArray.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('notAnEmptyArray', notAnEmptyArray);

    function notAnEmptyArray(lodash) {
        return function (value) {
            return lodash.isArray(value) && value.length >= 1;
        };
    }
})();
(function () {
    'use strict';

    notEmpty.$inject = ['CommonHelper'];
    angular
        .module('sodCommon')
        .filter('notEmpty', notEmpty);

    function notEmpty(CommonHelper) {
        return function(val) {
            return !CommonHelper.isEmpty(val);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('objValuesToString', objValString);

    function objValString() {
        return function(value, delimiter) {
            if (!value) return '';
            value = Object.values(value);
            if (!(value instanceof Array)) return value;
            if (typeof delimiter == typeof undefined) { delimiter = ', '; }
            return value.join(delimiter);
        };
    }
})();
(function () {
    objWithoutKeys.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('objWithoutKeys', objWithoutKeys);

    function objWithoutKeys(lodash) {
        return function (data, keys) {
            return lodash.reduce(data, function(carry, _data, _key) {
                if (lodash.indexOf(keys, _key) < 0) {
                    carry[_key] = _data;
                }
                return carry;
            }, {});
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('overrideMultiple', overrideMultiple);

    function overrideMultiple() {
        return function(value, override) {
            const val = JSON.parse(JSON.stringify(value));
            if (!(val instanceof Array)) {
                return val;
            }

            if (val.length == 1) {
                return val[0];
            }

            return override;
        };
    }
})();
(function () {
    'use strict';

    kebabCase.$inject = ['CommonHelper'];
    angular
        .module('sodCommon')
        .filter('percentageIt', kebabCase);

    function kebabCase(CommonHelper) {
        return function(input, max) {
            input = parseInt(input) || 0;
            if (CommonHelper.isEmpty(max)) {
                return input;
            }
            max = parseInt(max)|| 100;

            var percentage = (input/max) * 100;
            return (Math.round(percentage * 100) / 100) + '%';
        }
    }
})();
(function () {
    'use strict';

    filterFunc.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('replaceTemplate', filterFunc);

    function filterFunc(lodash) {
        return function(value, template) {
            //console.log('%csodName', 'color: #8e44ad', data);
            if (typeof value === 'string') {
                const stringReplacerRegex = /<value>/g; // can get this from the config in the future.
                return template.replace(stringReplacerRegex, value);
            }
            if (typeof value === 'object') {
                const objectReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
                return template.replace(objectReplacerRegex, function(match, submatch) {
                    return lodash.get(value, submatch, '');
                });
            }
        };
    }
})();
(function () {
    'use strict';

    rmsEnumFilter.$inject = ['RmsEnum'];
    angular
        .module('sodCommon')
        .filter('rmsEnum', rmsEnumFilter);

    function rmsEnumFilter(RmsEnum) {
        return function(value, enumName) {
            if (!value) return '';
            return RmsEnum.get(enumName, value, '');
        };
    }
})();
(function () {
    'use strict';

    sodLinkUrl.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('sodLinkUrl', sodLinkUrl);

    function sodLinkUrl(lodash) {
        return function(value, override) {
            const hostname = window.location.hostname;

            if (override) {
                return 'http://' + override + value;
            } else {
                return 'http://' + hostname + value;
            }
        }
    }
})();
(function () {
    'use strict';

    sodNameFilter.$inject = ['lodash', '$filter'];
    angular
        .module('sodCommon')
        .filter('sodName', sodNameFilter);

    function sodNameFilter(lodash, $filter) {
        return function(data, template) {
            //console.log('%csodName', 'color: #8e44ad', data);
            var first_name = lodash.get(data, 'first_name', '');
            var last_name = lodash.get(data, 'last_name', '');
            var middle_name = lodash.get(data, 'middle_name', '');
            if (!template) {
                var name = first_name;
                if (middle_name.length > 0) {
                    name += ' ' + middle_name;
                }
                name += ' ' + last_name;
                return name;
            } else {
                var nameArray = [first_name, last_name, middle_name];
                return $filter('stringFormat')(template, nameArray);
            }
        };
    }
})();
(function () {
    sortObjArrToArrBySamplingData.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('sortObjArrToArrBySamplingData', sortObjArrToArrBySamplingData);

    function sortObjArrToArrBySamplingData(lodash) {
        return function (toBeSorted, samplingData, orderBy, key) {
            var sortedSamplingData = lodash.orderBy(samplingData, orderBy[0], orderBy[1]);
            if (lodash.isArray(toBeSorted)) {
                return lodash.map(sortedSamplingData, function(_sortedSamplingData) { return lodash.get(_sortedSamplingData, key); });
            } else {
                return lodash.reduce(sortedSamplingData, function(carry, _sortedSamplingData) {
                    var _key = lodash.get(_sortedSamplingData, key);
                    return carry.concat([lodash.get(toBeSorted, _key)]);
                }, []);
            }
        };
    }
})();
(function () {
    'use strict';

    statusTextColor.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .filter('statusTextColor', statusTextColor);

    function statusTextColor(lodash) {
        return function(value) {
            var mapping = {
                'black': {
                    'text-white': [''],
                },
                'white': {
                    'text-black': [''],
                },
                'grey': {
                    'text-white': ['darkest', 'darker', 'dark'],
                    'text-black': ['base', 'light', 'lighter', 'lightest'],
                },
                'red': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-red-darkest': ['lighter', 'lightest'],
                },
                'orange': {
                    'text-white': ['darkest', 'darker', 'dark'],
                    'text-orange-darkest': ['base', 'light', 'lighter', 'lightest'],
                },
                'yellow': {
                    'text-white': ['darkest', 'darker'],
                    'text-yellow-darkest': ['dark', 'base', 'light', 'lighter', 'lightest'],
                },
                'green': {
                    'text-white': ['darkest', 'darker', 'dark', 'base'],
                    'text-green-darkest': ['light', 'lighter', 'lightest'],
                },
                'teal': {
                    'text-white': ['darkest', 'darker', 'dark', 'base'],
                    'text-teal-darkest': ['light', 'lighter', 'lightest'],
                },
                'blue': {
                    'text-white': ['darkest', 'darker', 'dark', 'base'],
                    'text-blue-darkest': ['light', 'lighter', 'lightest'],
                },
                'indigo': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-indigo-darkest': ['lighter', 'lightest'],
                },
                'purple': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-purple-darkest': ['lighter', 'lightest'],
                },
                'pink': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-pink-darkest': ['lighter', 'lightest'],
                },
            };

            var globalDefault = 'text-white';
            
            var valueParts = value.split('-');

            if (valueParts.length <= 0) {
                return globalDefault;
            } else if (valueParts.length === 1) {
                valueParts = valueParts.concat(['base']);
            }

            var mainColor = valueParts[0];
            var shadingColor = valueParts[1];

            var hasColorMap = lodash.has(mapping, mainColor);
            if (!hasColorMap) {
                return globalDefault;
            }

            var colorMap = mapping[mainColor];

            return lodash.reduce(Object.keys(colorMap), function (accum, oColorMapKeys) {
                var hasIndex = lodash.indexOf(colorMap[oColorMapKeys], shadingColor) >= 0;

                if (hasIndex) {
                    return oColorMapKeys;
                }

                return accum;
            }, globalDefault);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('stringArray', stringArray);

    function stringArray() {
        return function(value, delimiter) {
            if (!value) return '';
            value = JSON.parse(JSON.stringify(value));
            if (!(value instanceof Array)) return value;
            if (typeof delimiter == typeof undefined) { delimiter = ', '; }
            return value.join(delimiter);
        };
    }
})();
//Port of String.Format from C# to Angular written by David Votrubec - st-software.com
//http://davidjs.com
//Based on String.js from Ajax Control Toolkit - http://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js
(function () {
// Placehoders processing
    angular
        .module('sodCommon')
        .filter('stringFormat', stringFormat);

    function stringFormat() {
        return function (/*string*/template, /*array*/values) {
            if (!values || !values.length || !template) {
                return template;
            }
            return toFormattedString(false, template, values);
        };

        // function _toFormattedString is based on String.js from http://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js
        // as seen in http://stackoverflow.com/questions/2534803/string-format-in-javascript
        function toFormattedString(useLocale, format, values) {
            var result = '';

            for (var i = 0; ;) {
                // Find the next opening or closing brace
                var open = format.indexOf('{', i);
                var close = format.indexOf('}', i);
                if ((open < 0) && (close < 0)) {
                    // Not found: copy the end of the string and break
                    result += format.slice(i);
                    break;
                }
                if ((close > 0) && ((close < open) || (open < 0))) {

                    if (format.charAt(close + 1) !== '}') {
                        throw new Error('format stringFormatBraceMismatch');
                    }

                    result += format.slice(i, close + 1);
                    i = close + 2;
                    continue;
                }

                // Copy the string before the brace
                result += format.slice(i, open);
                i = open + 1;

                // Check for double braces (which display as one and are not arguments)
                if (format.charAt(i) === '{') {
                    result += '{';
                    i++;
                    continue;
                }

                if (close < 0) throw new Error('format stringFormatBraceMismatch');

                // Find the closing brace

                // Get the string between the braces, and split it around the ':' (if any)
                var brace = format.substring(i, close);
                var colonIndex = brace.indexOf(':');
                var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10);

                if (isNaN(argNumber)) throw new Error('format stringFormatInvalid');

                var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1);

                var arg = values[argNumber];
                if (typeof (arg) === "undefined" || arg === null) {
                    arg = '';
                }

                // If it has a toFormattedString method, call it.  Otherwise, call toString()
                if (arg.toFormattedString) {
                    result += arg.toFormattedString(argFormat);
                } else if (useLocale && arg.localeFormat) {
                    result += arg.localeFormat(argFormat);
                } else if (arg.format) {
                    result += arg.format(argFormat);
                } else
                    result += arg.toString();

                i = close + 1;
            }

            return result;
        }
    }

})();
(function () {
    'use strict';

    trustAsHtml.$inject = ['$sce'];
    angular
        .module('sodCommon')
        .filter('trustAsHtml', trustAsHtml);

    function trustAsHtml($sce) {
        return function(value) {
            return $sce.trustAsHtml(value);
        };
    }
})();
(function () {
    'use strict';

    trustAsResourceUrl.$inject = ['$sce'];
    angular
        .module('sodCommon')
        .filter('trustAsResourceUrl', trustAsResourceUrl);

    function trustAsResourceUrl($sce) {
        return function(value) {
            return $sce.trustAsResourceUrl(value);
        };
    }
})();
(function () {
    'use strict';

    userProfileImage.$inject = ['lodash', 'md5', '$filter'];
    angular
        .module('sodCommon')
        .filter('userProfileImage', userProfileImage);

    function userProfileImage(lodash, md5, $filter) {
        const defaultImageUrl = 'https://content.recruiterpal.com/app/assets/images/common/default.jpeg';
        const gravatarUrl = 'https://www.gravatar.com/avatar/{0}?d=' + defaultImageUrl;
        return function(user) {
            // first: determine if there are any user_image in user object
            if (lodash.has(user, 'image_url')) {
                if (!lodash.isEmpty(user.image_url)) {
                    return user.image_url;
                }
            }

            // second: determine if there are any user email provider. if has, get from gravatar and provides the default image url over as well
            if (lodash.has(user, 'email')) {
                const userEmailMd5 = md5.createHash(user.email);
                const generatedGravatarUrl = $filter('stringFormat')(gravatarUrl, [userEmailMd5]);
                return generatedGravatarUrl;
            }

            // otherwise, use the default image url
            return defaultImageUrl;
        };
    }
})();
(function () {
    'use strict';

    bindHtmlCompile.$inject = ['$compile'];
    angular
        .module('sodCommon')
        .directive('bindHtmlCompile', bindHtmlCompile);

    function bindHtmlCompile($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    // Incase value is a TrustedValueHolderType, sometimes it
                    // needs to be explicitly called into a string in order to
                    // get the HTML string.
                    element.html(value && value.toString());
                    // If scope is provided use it, otherwise use parent scope
                    var compileScope = scope;
                    if (attrs.bindHtmlScope) {
                        compileScope = scope.$eval(attrs.bindHtmlScope);
                    }
                    $compile(element.contents())(compileScope);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    braintreeWrapperCtrl.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .directive('braintreeWrapper', braintreeWrapper);

    function braintreeWrapper() {
        return {
            restrict: 'E',
            controller: braintreeWrapperCtrl,
            controllerAs: 'btWrap',
            scope: {
                options: '=',
                callback: '=',
            },
            bindToController: true,
            templateUrl: 'common/app/components/braintree-wrapper'
        };
    }

    function braintreeWrapperCtrl(lodash) {
        var btWrap = this;
        this.$onInit = function () {
            btWrap.callback = callback;

            btWrap.btInstance = null;

            var btOpts = lodash.extend({
                container: '#dropin-container',
            }, btWrap.options);

            braintree.dropin.create(btOpts, function(createErr, instance) {
                btWrap.btInstance = instance;
            });

            // braintree.dropin.create({
            //     authorization: '{{$token}}',
            //     container: '#dropin-container',
            //     vaultManager: true,
            //     card: {
            //         cardholderName: true
            //     },
            //     paypal: {
            //         flow: 'vault'
            //     }
            // }, function (createErr, instance) {
            //     button.addEventListener('click', function () {
            //         instance.requestPaymentMethod(function (err, payload) {
            //             // Submit payload.nonce to your server
            //             console.log(err, payload);
            //         });
            //     });
            // });
        }


        function callback() {
            if (btWrap) {
                btWrap.btInstance.requestPaymentMethod(function (err, payload) {
                    // Submit payload.nonce to your server
                    console.log(err, payload);
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodConsoleLog', sodConsoleLog);

    function sodConsoleLog() {
        return {
            restrict: 'E',
            scope: {
                value: '=',
            },
            link: function(scope) {
                console.log("### LOG ###");
                console.log(scope.value);
            }
        };
    }
})();
(function () {
	'use strict';
	sodDaterangePicker.$inject = ['lodash', 'ModalService'];
	angular
		.module('sodCommon')
		.directive('sodDaterangePicker', sodDaterangePicker);

	function sodDaterangePicker(lodash, ModalService) {
		return {
			restrict: 'E',
			require: 'ngModel',
			scope: {
				options: '=?'
			},
			templateUrl: 'common/components/sod-daterange-picker',
			link: function(scope, elem, attr, ctrl) {
				scope.cData = {
					model: '',
					default_options: {
						date_format: 'D MMM YYYY',
						label: {
							select_date: 'Select Date',
							change_date: 'Change Date'
						}
					},
					selectDate: selectDate,
				};

				var options = angular.merge(scope.cData.default_options, lodash.get(scope, 'options', {}));
				scope.cData.options = options;

				ctrl.$render = function() {
					scope.cData.model = ctrl.$viewValue;
				};

				scope.$watch('cData.model', function() {
					console.log('watch triggered');
						scope.cData.select_date_text =
							(lodash.isEmpty(scope.cData.model))
								? options.label.select_date
								: options.label.change_date;
				});

				function selectDate() {
					ModalService.showModal({
						templateUrl: 'common/components/dialog/sod-daterange-picker-modal',
						controller: 'DateRangePickerCtrl',
						controllerAs: 'drpVm',
						inputs: {
							options: options,
							model: scope.cData.model
						},
						bindToController: true,
					}).then(function(modal) {
						modal.element.show();
						modal.close.then(function(res) {
							if (res !== false) {
								ctrl.$setViewValue(res);
								ctrl.$render();
							}
						})
					});
				}

			}
		};
	}
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('fbqTracker', fbqTracker);

    function fbqTracker() {
        return {
            restrict: 'E',
            scope: {
                type: '=',
                value: '=',
                pixelid: '=',
            },
            link: function(scope, elem, attrs, ctrl) {
                if (typeof fbq == typeof undefined) {
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                }

                if (!!scope.pixelid) {
                    fbq('init', scope.pixelid);
                    fbq('track', 'PageView');
                }
                fbq('track', scope.type, scope.value);
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('sodCommon')
		.directive('myMaxlength', myMaxlength);

	function myMaxlength() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elem, attrs, ctrl) {
				var maxLength = Number(attrs.myMaxlength);
				ctrl.$parsers.push(function fromInput(text) {
					if (text.length > maxLength) {
						var transformedInput = text.substring(0, maxLength);
						ctrl.$setViewValue(transformedInput);
						ctrl.$render();
						return transformedInput;
					}
				});
			}
		};
	}
})();
(function() {
    'use strict';

    otpInputDirective.$inject = ['$timeout'];
    angular
        .module('sodCommon')
        .directive('otpInput', otpInputDirective);

    function otpInputDirective($timeout) {
        otpInputDirectiveCtrl.$inject = ['$scope', '$element'];
        return {
            restrict: 'A', // restrict by attribute
            scope: {
                options: "="
            },
            controller: otpInputDirectiveCtrl,
            // controllerAs: 'vm',
            // bindToController: true,
            template: "<div>" +
            "<input type='{{type}}' ng-init='focus=false;' ng-class='{otpFocus: focus}' ng-focus='focus=true;' ng-blur='focus=false;' ng-repeat=\"c in characters\" autocomplete='on' ng-paste='onPaste($index,$event)' ng-keyup='onKeyUp($index,$event)' ng-keydown='onKeyDown($index,$event)' ng-model='c.value' id='otpInput{{c.index}}' name='otpInput{{c.index}}' ng-style=\"style\" placeholder=\"{{placeholder}}\" maxlength=\"1\"  />\n" +
            "</div>",
            link: link
        };

        function link($scope, elem) {
            // var vm = $scope.vm;
            // vm.onFocus = vm.onFocus();
            // vm.onBlur = vm.onBlur();

           
            var size = parseInt($scope.options.size) || 6;
            var width = 100 / (size + 1);
            var margin = width / size;
            var tmp = [],
                elementArr = [];
            var DEFAULT_COLOR = "#6f6d6d";
            var DEFAULT_BG_COLOR = "transparent";
            //generating a random number to attach to id            
            var randomNumber = Math.floor(Math.random() * 10000) + 100;
            $scope.style = {
                "margin-right": margin + "%",
                "border": "1px solid",
                "border-radius": "0",
                "display": "inline-block",
                "width": width + "%",
                "text-align": "center",
                "padding": "5px 0px",
                "outline":"none",
                "box-shadow":"none",
                "background":$scope.options.style && $scope.options.style.bgColor ? $scope.options.style.bgColor : DEFAULT_BG_COLOR,
                "border-color": $scope.options.style && $scope.options.style.lineColor ? $scope.options.style.lineColor : DEFAULT_COLOR,
                "color": $scope.options.style && $scope.options.style.color ? $scope.options.style.color : DEFAULT_COLOR,
                "font-size": $scope.options.style && $scope.options.style.fontSize ? $scope.options.style.fontSize : "20px"
               
            };

            // elem.focus(function () {
            //     elem.addClass('onFocus');
            // });
            // elem.blur(function () {
            //     elem.removeClass('onFocus');
            // });
            $scope.type = $scope.options.type ? $scope.options.type : "text";
            $scope.placeholder = $scope.options.placeholder && $scope.options.placeholder.length === 1 ? $scope.options.placeholder : "";

            $scope.setOtpValue = function() {
                $scope.options.value = "";
                var done = true;
                angular.forEach($scope.characters, function(v, k) {
                    if (v.value.length !== 1) {
                        done = false;
                        return false;
                    }
                    $scope.options.value = $scope.options.value + v.value;
                });
                if (done) {
                    if (typeof($scope.options.onDone) === "function") {
                        $scope.options.onDone($scope.options.value);
                    }
                }
            };

            $scope.onKeyUp = function(index, e) {
                var key = e.keyCode || e.which;
                var old = $scope.options.value;
                $scope.setOtpValue();
                if ($scope.characters[index].value.length > 0 && key !== 8 && index != size - 1) {
                    $timeout(function() {
                        elementArr[index + 1][0].focus(); 
                    });
                }
                if (typeof($scope.options.onChange) === "function" && old !== $scope.options.value) {
                    $scope.options.onChange($scope.options.value);
                }

            };

            $scope.onKeyDown = function(index, e) {
                var key = e.keyCode || e.which;
                if (key === 8 && $scope.characters[index].value === "" && index !== 0) {
                    $timeout(function() {
                        elementArr[index - 1][0].focus();
                    });
                }
            };

            $scope.onPaste = function(index, e) {
                var values = e.originalEvent.clipboardData.getData('text').trim();
                const items = [...values];
                var old = $scope.options.value;

                var newOtp = '';
                $(items).each(function(i) {
                    $scope.characters[i].value = items[i];
                    newOtp += items[i];
                });

                $scope.options.value = newOtp;
                elementArr[items.length - 1][0].focus();
                if (typeof($scope.options.onChange) === "function" && old !== $scope.options.value) {
                    $scope.options.onChange($scope.options.value);
                }
            };

            for (var i = 0; i < size; i++) {
                tmp.push({
                    index: randomNumber + "-" + i,
                    value: ""
                });
            }
            $scope.characters = tmp;

            $timeout(function() {
                for (var i = 0; i < size; i++) {
                    elementArr.push(angular.element(document.querySelector("#otpInput" + randomNumber + "-" + i)));
                }
            });
        }

        function otpInputDirectiveCtrl($scope,$element){
            var vm = this;
            this.$onInit = function() {
                
            };

            
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('printDom', printDom);

    function printDom() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs, ctrl) {

                var target = attrs.target || '.print-dom-target';

                scope.printDomClick = function() {
                    var printElement =  document.createElement('div');
                    $(printElement).addClass('printSection');
                    document.body.append(printElement);
                    $(target).clone().appendTo(printElement);
                    var originalTitle = document.title;
                    document.title = attrs.title || 'Print';
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    window.print();
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    document.title = originalTitle;
                    $('.printSection').remove();
                }
            }
        };
    }
})();
(function () {
    'use strict';

    showOnHeightDiffDepartments.$inject = ['$timeout'];
    angular
        .module('sodCommon')
        .directive('showOnHeightDiffDepartments', showOnHeightDiffDepartments);

    function showOnHeightDiffDepartments($timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem, attr) {
                var target = attr.target || 'show-on-height-diff-departments';
                var comparer = attr.comparer || 'comparer-object';
                var offset = parseInt(attr.offset) || 2;
                angular.element('.' + target).hide();
                var hasShown = false;

                scope.$watch(function() {
                    if (!hasShown) {
                        return angular.element('.' + comparer).height();
                    }
                    return null;
                }, function() {
                    showFocal();
                });

                function showFocal() {
                    if (!hasShown) {
                        $timeout(function () {
                            var comparerHeight = angular.element('.' + comparer).height();
                            var elemHeight = elem.height();
                            if (comparerHeight > 0 && elemHeight > 0 && (elemHeight - offset) > comparerHeight) {
                                angular.element('.' + target).show();
                                hasShown = true;
                            }
                        });
                    }
                }
            }
        };
    }
})();
(function () {
    'use strict';

    showOnHeightDiff.$inject = ['$timeout'];
    angular
        .module('sodCommon')
        .directive('showOnHeightDiff', showOnHeightDiff);

    function showOnHeightDiff($timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem, attr) {
                var target = attr.target || 'show-on-height-diff';
                var comparer = attr.comparer || 'comparer-object';
                var offset = attr.offset || 5;
                angular.element('.' + target).hide();
                var hasShown = false;

                scope.$watch(function() {
                    if (!hasShown) {
                        return angular.element('.' + comparer).height();
                    }
                    return null;
                }, function() {
                    showFocal();
                });

                function showFocal() {
                    if (!hasShown) {
                        $timeout(function () {
                            var comparerHeight = angular.element('.' + comparer).height();
                            var elemHeight = elem.height();
                            if (comparerHeight > 0 && elemHeight > 0 && comparerHeight > (elemHeight + offset)) {
                                angular.element('.' + target).show();
                                hasShown = true;
                            }
                        });
                    }
                }
            }
        };
    }
})();
(function () {
    'use strict';

    sodAutocomplete.$inject = ['lodash'];
    sodAutocompleteCtrl.$inject = ['$scope', 'lodash', 'GenericModel', '$element', '$templateCache', '$compile'];
    angular
        .module('sodCommon')
        .directive('sodAutocomplete', sodAutocomplete);

    function sodAutocomplete(lodash) {

        return {
            restrict: 'E',
            scope: {
                options: '=',
            },
            // bindToController: true,
            require: 'ngModel',
            templateUrl: 'common/components/sod-autocomplete',
            controller: sodAutocompleteCtrl,
            link: function (scope, elem, attr, ctrl) {
                ctrl.$render = function () {
                    if (ctrl.$viewValue) {
                        scope.currentModel = ctrl.$viewValue;
                    }
                    if (scope.$autocomplete) {
                        scope.$autocomplete.autocomplete('val', scope.currentModel.text);
                    }
                };

                scope.onAcChange = function () {
                    // console.log('test');
                };

                scope.$watch(function () {
                    return (scope.$autocomplete.autocomplete) ? scope.$autocomplete.autocomplete('val') : null;
                }, function () {
                    scope.currentModel.text = scope.$autocomplete.autocomplete('val');
                    // console.log(scope.currentModel);
                    ctrl.$setViewValue(scope.currentModel);
                });
            }
        }
    }

    function sodAutocompleteCtrl($scope, lodash, GenericModel, $element, $templateCache, $compile) {
        var options = {};
        var input_elem;
        var autocomplete_options;
        var $autocomplete;

        this.$onInit = function() {
            options = $scope.options || {};


            // <% vm.options.placeholder || "Type to search" %>

            init();

            $scope.$on('$destroy', function () {
                destroyAutocomplete();
            });

            $scope.testClick = function (data) {
                // console.log('test click', data);
            }
        }


        function init() {
            $scope.currentModel = {
                text: '',
                value: null,
            };
            input_elem = $element.find('input.sod-tagging__input');
            autocomplete_options = lodash.get(options, 'autocomplete', {});
            input_elem.attr('placeholder', lodash.get(options, 'placeholder', 'Type to search'));

            initAutoComplete(autocomplete_options);
            // initAutoCompleteEvents();

            $scope.$autocomplete = $autocomplete;
        }


        function initAutoComplete(autocomplete_options) {
            var options = autocomplete_options; //options seeded in formfields; override here
            var dataset = getDataset();
            $autocomplete = $(input_elem).autocomplete(options, dataset);

            initAutoCompleteEvents($autocomplete)
        }

        function initAutoCompleteEvents($autocomplete) {
            // $autocomplete.on('autocomplete:cursorchanged', function (e, suggestion, dataset, context) {
            //     var $dropdownItem = $(`span.truncate:contains(${suggestion.label})`);
            //     if ($dropdownItem.get(0))
            //         $dropdownItem.get(0).scrollIntoView({
            //             block: "nearest",
            //         });
            // });
        }

        function getDataset() {
            var datasource_option = lodash.get(options, 'datasource', []);
            return datasource_option.map(function (ds) {
                return {
                    source: function (query, cb) {
                        var resource = prepareDsResource(ds);
                        if (!!resource) {
                            resource({query: query}).$promise.then(function (res) {
                                cb(res.data);
                            });
                        } else {
                            cb([]);
                        }
                    },
                    debounce: options.debounce || 400,
                    cache: false,
                    displayKey: lodash.get(options, 'schema.label', 'label'),
                    templates: {
                        suggestion: function (suggestion) {
                            if (lodash.has(suggestion, 'id')) {
                                suggestion.emit = emitEvent;
                                var _template = TemplateEngine(
                                    $templateCache.get(lodash.get(options, 'templateUrl')),
                                    suggestion
                                );
                                return _template;
                            }
                        }
                    }
                }
            });
        }

        function destroyAutocomplete() {
            $autocomplete.autocomplete('destroy');
        };

        function TemplateEngine(html, options) {
            var optionScope = $scope.$new(true);
            optionScope.optionModel = options;
            return $compile(html)(optionScope);

        };

        function prepareDsResource(ds_option) {
            var url = lodash.get(ds_option, 'url', '');
            var method = lodash.get(ds_option, 'method', 'query');
            var resource = (url) ? new GenericModel(url) : null;
            return !!resource ? resource[method] : null;
        }

        function emitEvent(item) {
            // console.log('emit event', item);
            $scope.currentModel.value = item.value;

            var valueKey = lodash.get(options, 'schema.value', 'value');
            var eventName = lodash.get(options, 'event.click', '');
            if (!!eventName) {
                $scope.$emit(eventName, lodash.pick(item, [valueKey]) );
            }
        }
    }
})();
(function() {
    'use strict';

    sodCarouselJobList.$inject = ['$rootScope', 'lodash'];
    angular
        .module('sodCommon')
        .directive('sodCarouselJobList', sodCarouselJobList);

    function sodCarouselJobList($rootScope, lodash) {
        sodCarouselJobListCtrl.$inject = ['GenericModel', '$scope'];
        return {
            restrict: 'E',
            scope: { options: '=' },
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return attrs.template;
                }

                return 'common/components/sod-carousel-job-list';
            },
            controller: sodCarouselJobListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: sodCarouselJobListLink,
        };

        function sodCarouselJobListLink(scope, elem, attr) {
            scope.$watch(function() {
                return elem.attr('sod-slick-child');
            }, function(newValue) {
                scope.vm.sodSlickInitEvent = ['sod-slick', newValue, 'init'].join('.')
                $rootScope.$broadcast(scope.vm.sodSlickInitEvent);
            });
        }

        function sodCarouselJobListCtrl(GenericModel, $scope) {
            var vm = this;

            this.$onInit = function() {
                init();
            }

            function init() {
                vm.featuredJobs = [];
                callRemoteApi(lodash.get(vm, 'options.datasource.list', {}))
                    .then(function (res) {
                        vm.featuredJobs = res || [];
                        $rootScope.$broadcast(vm.sodSlickInitEvent, 600);
                    });

                $scope.$watch(function() {
                    return vm.featuredJobs;
                }, function(newValue) {
                    if (lodash.isEmpty(vm.featuredJobs)) {
                        $('#featured-jobs').hide();
                    } else {
                        $('#featured-jobs').show();
                    }
                });
            }

            function callRemoteApi(datasource, postData) {
                var model = new GenericModel(datasource.url);
                var method = lodash.get(datasource, 'method', 'get');

                var queries = postData;
                var params = {};

                if (method !== 'get') {
                    queries = {};
                    params = {
                        data: postData,
                    }
                }

                return model[method](queries, params).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {

                        return lodash.get(res, 'rows', []);
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(err) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(err); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    sodCarousel.$inject = ['$timeout'];
    sodCarouselCtrl.$inject = ['$timeout', '$window'];
    angular
        .module('sodCommon')
        .directive('sodCarousel', sodCarousel);

    function sodCarousel($timeout) {
        return {
            restrict: 'E',
            controller: sodCarouselCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                items: '=?',
            },
            templateUrl: 'common/components/sod-carousel',
        };
    }

    function sodCarouselCtrl($timeout,$window) {
        this.$onInit = function() {
            var vm = this;
            vm.loading = true;

            vm.onInit = function () {
                $timeout(function () {
                    vm.loading = false;
                    $window.dispatchEvent(new Event("resize"));
                }, 1000);
            }
        }
    }
})();
(function () {
    'use strict';

    sodCharts.$inject = ['$document', 'lodash'];
    sodChartsCtrl.$inject = ['GenericModel', 'lodash', '$timeout', '$element'];
    angular
        .module('sodCommon')
        .directive('sodCharts', sodCharts);

    function sodCharts($document, lodash) {
        return {
            restrict: 'E',
            bindToController: true,
            controller: sodChartsCtrl,
            controllerAs: 'vm',
            templateUrl: 'common/components/sod-charts',
            scope: {
                layout: '=',
            },
        };
    }

    function sodChartsCtrl(GenericModel, lodash, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            init();
        }

        function init() {
            initChartGridOption();
        }

        function initChartGridOption() {
            vm.chartGridOption = { data: vm.layout };



            lodash.forEach(
                lodash.get(vm, 'chartGridOption.data', []),
                function (oData, oDataIndex) {
                    callRemoteApi(lodash.get(oData, 'data.datasource'))
                        .then(function (res) {
                            lodash.set(vm, 'chartGridOption.data[' + oDataIndex + '].chartConfig', res);
                            renderChart(oDataIndex);
                        });
                }
            );
        }

        function renderChart(chartIndex) {
            const chart_config = vm.chartGridOption.data[chartIndex];


            let c3_options = {
                bindto: '#' + chart_config.name +'-' + chartIndex,
                onresize: (function(chartIndex) {
                    return function() {
                        c3ChartResize(chartIndex);
                    };
                })(chartIndex),
            };

            c3_options = lodash.extend(c3_options, lodash.get(vm, 'chartGridOption.data[' + chartIndex + '].chartConfig', {}));




            const c3Chart = c3.generate(c3_options);

            lodash.set(vm, 'chartGridOption.data[' + chartIndex + '].c3Chart', c3Chart);

            $timeout((function(chartIndex) {
                return function() {
                    c3ChartResize(chartIndex);
                };
            })(chartIndex), 300);
        }

        function c3ChartResize(chartIndex) {
            const chart_config = vm.chartGridOption.data[chartIndex];
            const c3Chart = lodash.get(vm, 'chartGridOption.data[' + chartIndex + '].c3Chart', {});

            const cardMainContentElement = $('#' + chart_config.name + '-' + chartIndex)[0];
            const cardMainContentElementWidth = cardMainContentElement.offsetWidth;

            const cardElement = cardMainContentElement.parentElement.parentElement;
            const cardElementChildren = cardElement.children;

            const cardElementHeight = cardElement.clientHeight;
            let cardContentHeight = cardElementHeight;
            for(let i = 0; i < cardElementChildren.length; i++) {
                const isCardMainContent = cardElementChildren[i].className.indexOf('card-main-content') >= 0;
                if (!isCardMainContent) {
                    cardContentHeight -= cardElementChildren[i].clientHeight;
                }
            }

            c3Chart.resize({
                width: cardMainContentElementWidth,
                height: cardContentHeight * 0.9,
            });
        }

        function callRemoteApi(datasource, postData) {
            var model = new GenericModel(datasource.url);
            var method = lodash.get(datasource, 'method', 'get');

            var queries = postData;
            var params = {};

            if (method !== 'get') {
                queries = {};
                params = {
                    data: postData,
                }
            }

            return model[method](queries, params).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    if (lodash.has(res, 'selected')) {
                        vm.modelContent = res.selected;
                        vm.ngModelCtrl.$setViewValue(res.selected);
                    }
                    // return res.data;
                    return additionalSettings(res.data);
                } else {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function(res) {
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }


        function additionalSettings(chart_option) {
            var type = lodash.get(chart_option, 'data.type', 'line');
            switch (type) {
                case 'pie':
                    lodash.set(chart_option, 'pie.label.format', function(value, ratio, id) {
                        return value;
                    });
                    break;
                case 'line':
                    // lodash.set(chart_option, 'axis.y.tick.count', 1);
                    lodash.set(chart_option, 'axis.x.tick.rotate', -75);
                    break;
            }
            return chart_option;
        }
    }
})();
(function () {
    'use strict';

    classToggler.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .directive('classToggler', classToggler);

    function classToggler(lodash) {
        return {
            restrict: 'A',
            scope: {
                toggleOn: '=?',
                toggleOff: '=?'
            },
            link: function (scope, elm, attrs) {
                const elmInstance = elm[0];
                const options = JSON.parse(attrs.classToggler);
                const classes = options.classes;

                $(elmInstance).on(options.on || 'click', (function (options, elmInstance, classes) {
                    return function(e) {
                        lodash.forEach(classes, function (oClass) {
                            const targetElm = $(options.selector);
                            if (targetElm) {
                                if (!targetElm.hasClass(oClass)) {
                                    targetElm.addClass(oClass);
                                } else {
                                    targetElm.removeClass(oClass);
                                }
                            }
                        });
                    }
                })(options, elmInstance, classes));

                scope.toggleOn = function() {
                    lodash.forEach(classes, function (oClass) {
                        const targetElm = $(options.selector);
                        if (targetElm) {
                            if (!targetElm.hasClass(oClass)) {
                                targetElm.addClass(oClass);
                            }
                        }
                    });
                };

                scope.toggleOff = function() {
                    lodash.forEach(classes, function (oClass) {
                        const targetElm = $(options.selector);
                        if (targetElm) {
                            if (targetElm.hasClass(oClass)) {
                                targetElm.removeClass(oClass);
                            }
                        }
                    });
                }
            },
        };
    }
})();
(function () {
    'use strict';

    sodClipboardCtrl.$inject = ['$scope', '$timeout'];
    angular
        .module('sodCommon')
        .directive('sodClipboard', sodClipboard);

    function sodClipboard() {
        return {
            restrict: 'E',
            controller: sodClipboardCtrl,
            controllerAs: 'clip',
            bindToController: true,
            scope: {
                identifier: '=',
                value: '=',
            },
            template: '<div class="row collapse postfix-wrapper"><div class="columns small-11"><input style="background: white" type="text" class="font-small" id="<%clip.identifier%>" value="<%clip.value%>" readonly/></div><div class="columns small-1"><button kendo-tooltip="clip.tooltipObj" k-options="clip.tooltipOption" class="button postfix" id="<%clip.identifier%>-clipboard" data-clipboard-target="#<%clip.identifier%>"><i class="fa fa-clipboard"></i></button></div></div>',
        };
    }

    function sodClipboardCtrl($scope, $timeout) {
        this.$onInit = function() {
            var clip = this;
            clip.tooltipOption = {
                content: 'Copied!',
                showOn: 'click',
                position: 'top'
            };

            var clipboard = new Clipboard('#' + clip.identifier + '-clipboard');
            clipboard.on('success', function(e) {
                e.clearSelection();
            });
            clipboard.on('error', function(e) {
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
            $scope.$on('$destroy', function(e) {
                clipboard.destroy();
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodCollapsible', sodCollapsible);

    function sodCollapsible() {
        return {
            restrict: 'A',
            scope: {
                clickTarget: '@',
                hideTarget: '@',
                showOnDefault: '@?',
                hideOthers: '@?',
                icon: '@?',
                closeDirection: '@?',
                hideLabel: '@?',
                showLabel: '@?',
                label: '@?',
                iconOp: '@?',
                iconCl: '@?'
            },
            link: sodCollapsibleLink
        };

        function sodCollapsibleLink(scope, elem, attr) {
            var elemUniqueId = attr.id || scope.$id;
            elem.addClass('collapsible-' + elemUniqueId);
            var clickTargetElem = elem.find(scope.clickTarget);
            var hideTargetElem = elem.find(scope.hideTarget);
            if (hideTargetElem.length === 0) {
                hideTargetElem = $('.collapsible-' + elemUniqueId + " " + scope.clickTarget);
            }
            var parent = elem.parent();
            var relatedClickTargets = parent.find(scope.clickTarget);

            // default values
            var showOnDefault = scope.showOnDefault ? (scope.showOnDefault == 'yes') : true;
            var hideOthers = scope.hideOthers ? (scope.hideOthers == 'yes') : false;
            var iconClosed = '';
            var iconOpened = '';

            // values for minus and plus
            if(!scope.iconOp){
                if (!scope.closeDirection) {
                    scope.closeDirection = '-right';
                } else {
                    scope.closeDirection = '-' + scope.closeDirection;
                }
                iconClosed = scope.icon ? 'fa-' + scope.icon + scope.closeDirection : '';
                iconOpened = scope.icon ? 'fa-' + scope.icon + '-down' : '';
            }else{
                iconClosed = scope.iconCl ? 'fa-' + scope.iconCl : '';
                iconOpened = scope.iconOp ? 'fa-' + scope.iconOp : '';
            }

            if (scope.icon) {
                elem.addClass('collapsible-has-icon');
            }

            if (scope.iconOp && scope.iconCl) {
                elem.addClass('collapsible-has-icon-open-close');
            }

            var filteredAllText     = null
            var filteredHalfText    = null
            if(hideTargetElem.length > 0){
                filteredAllText     = hideTargetElem.filter('.all-text')
                filteredHalfText    = hideTargetElem.filter('.half-text')
            }

            if (!showOnDefault) {
                hideTargetElem.hide();
                if(filteredAllText){
                    filteredHalfText.hide();
                }
                if(filteredHalfText){
                    filteredHalfText.show();
                }
                clickTargetElem.addClass('collapsible-is-hidden');
                manageToggleable(false, clickTargetElem);
            } else {
                if(filteredAllText){
                    filteredHalfText.show();
                }
                if(filteredHalfText){
                    filteredHalfText.hide();
                }
                elem.addClass('active');
                manageToggleable(true, clickTargetElem);
            }
            clickTargetElem.on('click', function () {
                if (hideOthers) {
                    var others = parent.find('[sod-collapsible]:not(.collapsible-' + elemUniqueId + ')');
                    others.find(scope.hideTarget).hide();
                    others.find(scope.clickTarget).addClass('collapsible-is-hidden');
                    others.removeClass('active');
                    manageToggleable(false);
                }
                if (!clickTargetElem.hasClass('collapsible-is-hidden')) {
                    hideTargetElem.slideUp(150);
                    clickTargetElem.addClass('collapsible-is-hidden');
                    if (!hideOthers) {
                        elem.removeClass('active');
                    }
                    if(filteredAllText){
                        filteredAllText.hide();
                    }
                    if(filteredHalfText){
                        filteredHalfText.show();
                    }
                    manageToggleable(false, clickTargetElem);
                } else {
                    hideTargetElem.slideDown(150);
                    clickTargetElem.removeClass('collapsible-is-hidden');
                    elem.addClass('active');
                    if(filteredAllText){
                        filteredAllText.show();
                    }
                    if(filteredHalfText){
                        filteredHalfText.hide();
                    }
                    manageToggleable(true, clickTargetElem);
                }
            });

            function manageToggleable(state, target) {
                const currentTarget = (!target) ? relatedClickTargets : target;
                const label = currentTarget.find(scope.label);
                if (!state) {
                    label ? label.first().text(scope.showLabel) : null;
                    currentTarget.find('.fa').removeClass(iconOpened).addClass(iconClosed);
                } else {
                    label ? label.first().text(scope.hideLabel) : null;
                    currentTarget.find('.fa').removeClass(iconClosed).addClass(iconOpened);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    sodContextMenu.$inject = ['KeyTrackingService', 'lodash', '$compile'];
    angular
        .module('sodCommon')
        .directive('sodContextMenu', sodContextMenu);

    function sodContextMenu(KeyTrackingService, lodash, $compile) {
        return {
            restrict: 'EA',
            scope: {
                contextMenuEvents: '=?',
                contextMenuDataEvent: '=?',
                position: '@?',
            },
            templateUrl: 'common/components/sod-context-menu',
            transclude: true,
            controller: sodContextMenuCtrl,
            bindToController: true,
            controllerAs: 'vm',
            link: sodContextMenuLink,
        };

        function sodContextMenuCtrl() {
            var vm = this;
        }

        function sodContextMenuLink (scope, element, attrs) {
            var sodContextMenuCtrl = scope.vm;
            var hasContextMenuElement = false;

            element.on('click', function(event) {
                event.preventDefault();
                if (KeyTrackingService.hasNewTabCombinationKeyCode()) {
                    toggleContextMenu();
                }
            });

            document.addEventListener('mousedown', onMouseDown);

            function onMouseDown(event) {
                if (hasContextMenuElement) {
                    event.preventDefault();
                    resetNewTab();
                }
            }

            scope.$on('$destroy', function () {
                document.removeEventListener('mousedown', onMouseDown);
                if (contextMenuInstance) {
                    contextMenuInstance.destroy();
                }
            });

            element.bind('contextmenu', function(event) {
                event.preventDefault();
                toggleContextMenu();
            });

            function resetNewTab() {
                setTimeout(function () {
                    toggleContextMenu();
                }, 120);
            }

            function clearSelection() {
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                }
            }

            var contextMenuInstance = null;
            var contextMenu = element.find('.context-menu');
            contextMenu = $(contextMenu);
            contextMenu.hide();

            function initContextMenu() {
                contextMenuInstance = new Popper(element.children()[0], contextMenu, Object.assign({
                    placement: 'auto-start',
                    // originalPlacement: 'bottom',
                    onCreate: function () {
                        contextMenuInstance.update();
                    },
                }, lodash.get(scope, 'options', {})));
            }

            function updateContextMenu() {
                contextMenuInstance.update();
            }

            function toggleContextMenu() {
                if (!contextMenuInstance) {
                    initContextMenu();
                }

                var newTabElm = element.find('.context-menu');
                if (newTabElm.length > 0) {
                    var selectedNewTabElm = newTabElm[0];
                    var activeClass = 'active';

                    if (!selectedNewTabElm.classList.contains(activeClass)) {
                        selectedNewTabElm.classList.add(activeClass);
                        hasContextMenuElement = true;
                    } else {
                        selectedNewTabElm.classList.remove(activeClass);
                        hasContextMenuElement = false;
                    }
                }

                contextMenu.toggle();
                updateContextMenu();
                clearSelection();
            }
        }
    }
})();
//(function () {
//    'use strict';
//
//    angular
//        .module('sodCommon')
//        .directive('sodCopyText', sodCopyText);
//
//    function sodCopyText() {
//        return {
//            restrict: 'A',
//            link: function(elem) {
//                var copyArea = elem.select();
//                try {
//                    var successful = document.execCommand('copy');
//                    if (successful) {
//
//                    } else {
//
//                    }
//                } catch (err) {
//                    console.warn('Opps, unable to copy');
//                }
//            }
//        }
//    }
//})();
(function () {
    'use strict';

    sodCopyToClipboardPanel.$inject = ['lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('sodCopyToClipboardPanel', sodCopyToClipboardPanel);

    function sodCopyToClipboardPanel(lodash, $timeout) {
        return {
            restrict: 'E',
            transclude: true,
            link: function(scope, elem, attr) {
                scope.copyToClipboard = copyToClipboardFunc;

                if (lodash.has(attr, 'class')) {
                    scope.parentClass = attr.class;
                }

                function copyToClipboardFunc() {
                    try {
                        clipboard.copy({
                            // "text/plain": elem.find('ng-transclude').text(),
                            "text/html": elem.find('ng-transclude').html()
                        });
                        scope.copied = true;
                        $timeout(function() {
                            scope.copied = false;
                        }, 1500);
                    } catch (err) {
                        console.log(err);
                    }
                }
            },
            template: '<div class="copy-to-clipboard-panel <%parentClass%>">' +
                '<ng-transclude></ng-transclude>' +
                // '<sod-tooltip class="popover-top" content="\'Copied\'">' +
                '<button class="button default copy-to-clipboard-button" ng-click="copyToClipboard()"><i class="fa fa-clipboard"></i></button>' +
                '<div class="copied-text" ng-show="copied">Copied</div>' +
                // '</sod-tooltip>' +
                '</div>'
        };
    }
})();
(function () {
    'use strict';

    cssPositionElmBased.$inject = ['lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('cssPositionElmBased', cssPositionElmBased);

    function cssPositionElmBased(lodash, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                function cssPositionElmBasedResize(scope, elm, attrs) {
                    const elmInstance = elm[0];
                    const options = JSON.parse(attrs.cssPositionElmBased);

                    switch (options.position) {
                        case 'right': {
                            const position = options.position;
                            const offset = options.offset;
                            const elmOffsetWidth = elmInstance.offsetWidth;

                            elmInstance.style[position] = ((elmOffsetWidth - offset) * -1) + 'px';
                            break;
                        }
                        case 'left': {
                            const position = options.position;
                            const offset = options.offset;
                            const elmOffsetWidth = elmInstance.offsetWidth;

                            elmInstance.style[position] = ((elmOffsetWidth + offset) * -1) + 'px';
                            break;
                        }
                        case 'top': {
                            const position = options.position;
                            const offset = options.offset;
                            const elmOffsetHeight = elmInstance.offsetHeight;

                            elmInstance.style[position] = ((elmOffsetHeight + offset) * -1) + 'px';
                            break;
                        }
                    }
                }

                $timeout((function (scope, elm, attrs) {
                    return function() {
                        cssPositionElmBasedResize(scope, elm, attrs);
                    }
                })(scope, elm, attrs), 300);

                $(window).resize((function (scope, elm, attrs) {
                   return function() {
                       cssPositionElmBasedResize(scope, elm, attrs);
                   }
                })(scope, elm, attrs));
            },
        };
    }
})();
(function () {
    'use strict';

    cssWidthBasedOnParent.$inject = ['lodash', '$timeout', '$window'];
    angular
        .module('sodCommon')
        .directive('cssWidthBasedOnParent', cssWidthBasedOnParent);

    function cssWidthBasedOnParent(lodash, $timeout, $window) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                angular.element($window).bind('resize', function() {
                    resizeIt();
                });

                resizeIt();

                function resizeIt() {
                    $timeout(function () {
                        var $elem = $(elem);
                        var parentWidth = parseInt($elem.parent().css('width'));
                        $elem.css('width', (parentWidth - 20) + 'px');
                    }, 1000);
                }
            },
        };
    }
})();
(function () {
    'use strict';

    sodDepartmentsItem.$inject = ['$compile', '$templateCache'];
    sodDepartmentsItemCtrl.$inject = ['$scope', '$compile', '$templateCache', 'lodash', '$element'];
    angular
        .module('sodCommon')
        .directive('sodDepartmentsItem', sodDepartmentsItem);

    function sodDepartmentsItem($compile, $templateCache) {
        return {
            restrict: 'E',
            scope: {
                removeItem: '&?',
                department: '=',
                options: '=?',
                type: '@?',
            },
            // templateUrl: function(elem, attrs) {
            //     if (attrs.template) {
            //         return attrs.template;
            //     }
            //
            //     return 'common/components/departments-item';
            // },
            link: function(scope, elem, attr, ctrl) {
                scope.readonly = true

                scope.item.label = scope.department[scope.options.schema.label];

                if (typeof scope.removeItem === typeof function() {}) {
                    scope.readonly = false;
                }
            },
            controller: sodDepartmentsItemCtrl,
        };
    }

    function sodDepartmentsItemCtrl($scope, $compile, $templateCache, lodash, $element) {
        this.$onInit = function() {
            $scope.item = {
                showTooltip: showTooltip,
            };

            var type = !!$scope.type ? $scope.type : 'default';
            var templateUrl = lodash.get($scope.options, 'itemTemplateUrl.' + type, 'common/components/departments-item');

            var template = $templateCache.get(templateUrl);

            $element.html(template);

            var compileScope = $scope;
            var cloneElement = $compile($element.contents())(compileScope);

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }

        function showTooltip() {
            if ($scope.item.label.length > 12) {
                return true;
            }
            return false;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodDepartmentsShow', sodDepartmentsShow);

    function sodDepartmentsShow() {
        return {
            restrict: 'E',
            templateUrl: 'common/components/departments-show',
            require: 'ngModel',
            scope: {
                options: '=?',
            },
            link: function(scope, elem, attr, ctrl) {
                scope.departments = [];
                ctrl.$render = function() {
                    scope.departments = ctrl.$viewValue;
                }
            }
        };
    }
})();
(function () {
    'use strict';

    sodDropdownButton.$inject = ['$document'];
    sodDropdownButtonCtrl.$inject = ['$scope'];
    angular
        .module('sodCommon')
        .directive('sodDropdownButton', sodDropdownButton);

    function sodDropdownButton($document) {
        return {
            restrict: 'E',
            controller: sodDropdownButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/components/sod-dropdown-button',
            scope: {
                actionList: '=?',
                customActionList: '=?',
                dir: '@?',
                template: '=?',
            },
            link: sodDropdownButtonLink
        };

        function sodDropdownButtonLink(scope, elem, attr) {
            var vm = scope.vm;
                //dropdown = elem.find('.dropdown');

            elem.on('click', function(e) {
                e.preventDefault();
                vm.toggle();
            });

            $document.on('click', function(e) {
                var parents = angular.element(e.target).parents('#' + attr.id);
                if (parents.length == 0) {
                    if (vm.toggleState) {
                        vm.toggle();
                    }
                }
            });

            // trigger when li is clicked;

            scope.$on('$destroy', function() {
                elem.off('click');
            });
        }
    }

    function sodDropdownButtonCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.toggleState = false;
            vm.toggle = toggle;
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;
            $scope.$apply();
        }
    }
})();
(function() {
    'use strict';

    sodDropdownMenu.$inject = ['$document'];
    angular
        .module('sodCommon')
        .directive('sodDropdownMenu', sodDropdownMenu);

    function sodDropdownMenu($document) {
        return {
            restrict: "EA",
            link: link
        };

        function link(scope, elem) {
            scope.active = false;

            elem.on('click', toggleClassHandler);

            $document.on('click', ':not(.nav-bar-dropdown a)',removeClassHandler);

            scope.$on('$destroy', function () {
                $document.off('click', removeClassHandler);
                elem.off('click', toggleClassHandler);
            });

            function toggleClassHandler() {
                elem.toggleClass('active');
                toggleActiveVar();
            }

            function removeClassHandler(e) {
                var eventOutsideTarget = (elem[0] !== e.target) && (0 === elem.find(e.target).length);
                if (eventOutsideTarget) {
                    elem.removeClass('active');
                    toggleActiveVar();
                }

            }

            function toggleActiveVar() {
                scope.active = elem.hasClass('active');
                scope.$apply();
            }

        }
    }
})();
(function () {
    'use strict';

    sodElmFloatInvisibleCtrl.$inject = ['$scope', '$window', '$compile', '$element'];
    angular
        .module('sodCommon')
        .directive('sodElmFloatInvisible', sodElmFloatInvisible);

    function sodElmFloatInvisible() {
        return {
            restrict: 'E',
            controller: sodElmFloatInvisibleCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodElmFloatInvisibleCtrl($scope, $window, $compile, $element) {
        this.$onInit = function() {
            onScrollCheckVisibility();
        }

        function checkVisible(elm) {
            var rect = elm.getBoundingClientRect();
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
        }

        function floatTheElm(isCurrentlyVisible) {
            if (!isCurrentlyVisible) {
                $element[0].style.display = 'block';
            } else {
                $element[0].style.display = 'none';
            }
        }

        function onScrollCheckVisibility() {
            var parentElm = $element[0].parentElement;
            var isCurrentlyVisible = checkVisible(parentElm);

            floatTheElm(isCurrentlyVisible);
        }

        $window.addEventListener('scroll', function(e) {
            onScrollCheckVisibility();
        });

        $window.addEventListener('resize', function(e) {
            onScrollCheckVisibility();
        });
    }
})();
(function () {
    'use strict';

    sodEmitEvent.$inject = ['lodash', 'GaService'];
    sodEmitEventCtrl.$inject = ['$scope'];
    angular
        .module('sodCommon')
        .directive('sodEmitEvent', sodEmitEvent);

    function sodEmitEvent(lodash, GaService) {
        return {
            restrict: 'A',
            scope: {
                eventName: '=',
                eventData: '=?',
                label: '=?',
                eventModel: "=?"
            },
            controllerAs: 'emitCtrl',
            bindToController: true,
            controller: sodEmitEventCtrl,
            // template: '<a ng-bind-html="emitCtrl.label" ng-class="emitCtrl.domClass" ng-click="emitCtrl.captureClick($event)"></a>',
            link: function(scope, elem, attrs) {
                var emitCtrl = scope.emitCtrl;
                if (!lodash.isEmpty(emitCtrl.label)) {
                    elem.html(emitCtrl.label);
                }

                elem.on('click', function(e) {
                    e.preventDefault();
                    console.log('sod-emit-event');
                    var event = lodash.get(emitCtrl, 'eventName', null);
                    var eventType = typeof event;

                    switch (eventType) {
                        case "object":
                            scope.$emit(event.name, lodash.get(emitCtrl, 'eventData', null));
                            GaService.addEvent(event, scope.eventModel);
                            break;
                        default:
                            scope.$emit(event, lodash.get(emitCtrl, 'eventData', null));
                            break;
                    }
                })
            }
        };
    }

    function sodEmitEventCtrl($scope) {
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodFilterBar', sodFilterBar);

    function sodFilterBar() {
        sodFilterBarCtrl.$inject = ['$scope', 'GroupFilterFactory', 'lodash', 'FilterFactory'];
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-filter-bar',
            controller: sodFilterBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodFilterBarCtrl($scope, GroupFilterFactory, lodash, FilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // init functions
                vm.handleApply = handleApply;
                vm.handleClear = handleClear;
                vm.handleCancel = handleCancel;
                vm.showAllFilters = showAllFilters;
                vm.hideAllFilters = hideAllFilters;
                vm.setFilters = setFilters;
                vm.filtersCount = 0;

                vm.groupFilterFactory = GroupFilterFactory(lodash.get(vm, 'config.grid_id', null));

                init();
            }



            function handleApply() {
                applyFilter();
                hideAllFilters();
            }

            function handleClear() {
                FilterFactory.set(lodash.get(vm, 'config.grid_id', null), {});
                applyFilter();
                hideAllFilters();
            }

            function handleCancel() {
                hideAllFilters();
            }

            function showAllFilters() {
                vm.isShowingAllFilters = true;
            }

            function hideAllFilters() {
                vm.isShowingAllFilters = false;
            }

            function applyFilter() {
                vm.groupFilterFactory.applyFilter(lodash.get(vm, 'config.grid_id', null));
            }

            function setFilters() {
                vm.filters = FilterFactory.get(lodash.get(vm, 'config.grid_id', null), {});
            }

            function getFilters() {
                return vm.filters;
            }

            function handleFilterCount() {
                var filters = getFilters();
                vm.filtersCount = lodash.reduce(filters, function (accum, filter) {
                    var innerFilterCount = lodash.isArray(filter) ? filter.length : 0;
                    return accum + innerFilterCount;
                }, 0);
            }

            function init() {
                vm.filters = {};
                var filterListener = $scope.$on(
                    [FilterFactory.eventPrefix, lodash.get(vm, 'config.grid_id', null)].join('.'),
                    function (e) {
                        setFilters();
                        handleFilterCount();
                    }
                );

                $scope.$on('$destroy', function () {
                    filterListener();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    sodGaEvent.$inject = ['GaService'];
    angular
        .module('sodCommon')
        .directive('sodGaEvent', sodGaEvent);

    function sodGaEvent(GaService) {
        return {
            restrict: 'A',
            scope: {
                sodGaEvent: '=',
                gaModel: '=?',
            },
            link: function(scope, elem, attrs) {
                if (!gtag) return;
                elem.on('click', function(e) {
                    GaService.addEvent(scope.sodGaEvent, scope.gaModel);
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGridDetail', sodGridDetail);

    function sodGridDetail() {
        sodGridDetailCtrl.$inject = ['$scope', 'lodash', 'SodGridFactory', 'GroupFilterFactory'];
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-grid-detail',
            controller: sodGridDetailCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodGridDetailCtrl($scope, lodash, SodGridFactory, GroupFilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // functions
                vm.sodGridInstance = SodGridFactory(vm.config);
                vm.groupFilterFactory = GroupFilterFactory(lodash.get(vm, 'config.id', null));

                init();
            }


            function init() {
                vm.isLoading = true;
                handleCountShowJob();
                var groupFilterFactoryApplyFilter = $scope.$on(
                    [vm.groupFilterFactory.eventPrefix, lodash.get(vm, 'config.id', null)].join('.'),
                        function (e, eventData) {
                        handleCountShowJob();
                    }
                );

                var sodGridLoadingListener = $scope.$on(
                    [vm.sodGridInstance.eventPrefix, lodash.get(vm, 'config.id', null), vm.sodGridInstance.eventLoading].join('.'),
                    function (e, eventData) {
                        vm.isLoading = eventData;
                    }
                );

                $scope.$on('destroy', function() {
                    groupFilterFactoryApplyFilter();
                    sodGridLoadingListener();
                });
            }

            function handleCountShowJob() {
                vm.count = vm.groupFilterFactory.getCount();

                if (vm.count === 0) {
                    vm.sodGridInstance.selectJob(lodash.get(vm, 'config.id'), null);
                }
            }

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGridMisc', sodGridMisc);

    function sodGridMisc() {
        sodGridMiscCtrl.$inject = ['$scope', 'lodash', 'GroupFilterFactory'];
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-grid-misc',
            controller: sodGridMiscCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodGridMiscCtrl($scope, lodash, GroupFilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // functions
                vm.setSort = setSort;
                vm.getSort = null;

                vm.rows = [];
                vm.count = vm.rows.length;
                vm.groupFilterFactory = GroupFilterFactory(vm.config);

                init();
            }

            function init() {
                var groupFilterFactoryApplyFilter = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id].join('.'), function (e, eventData) {
                    var rows = lodash.get(eventData, 'rows', []);
                    var count = lodash.get(eventData, 'count', []);

                    vm.rows = rows;
                    vm.count = count;
                    formPagination();
                });
                var groupFilterFactoryLoading = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id, vm.groupFilterFactory.eventLoading].join('.'), function (e, eventData) {
                    vm.isLoading = eventData;
                });
                $scope.$on('destroy', function() {
                    groupFilterFactoryApplyFilter();
                    groupFilterFactoryLoading();
                });
            }

            function setSort() {
                vm.groupFilterFactory.setSort(vm.config.id, vm.getSort());
            }

            function formPagination() {
                var list = [];
                var pageLimit = vm.paginationSize;
                var total = Math.ceil(vm.count / vm.pageSize);
                var upperLimit, lowerLimit;
                var currentPage = lowerLimit = upperLimit = Math.min(vm.page, total);

                for (var b = 1; b < pageLimit && b < total;) {
                    if (lowerLimit > 1 ) {
                        lowerLimit--; b++;
                    }
                    if (b < pageLimit && upperLimit < total) {
                        upperLimit++; b++;
                    }
                }

                for (var i = lowerLimit; i <= upperLimit; i++) {
                    if (i == currentPage){
                        list.push({ pageNumber: i, isActive: true });
                    }
                    else{
                        list.push({ pageNumber: i });
                    }
                }

                vm.paginations = list;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGrid', sodGrid);

    function sodGrid() {
        sodGridCtrl.$inject = ['$scope', 'lodash', 'GroupFilterFactory', 'SodGridFactory', 'FilterFactory'];
        return {
            restrict: 'E',
            scope: {config: '='},
            templateUrl: 'common/components/sod-grid',
            controller: sodGridCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodGridCtrl($scope, lodash, GroupFilterFactory, SodGridFactory, FilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // functions
                vm.handlePagination = handlePagination;
                
                vm.page = 1;
                vm.pages = 1;
                vm.pageSize = 15;
                vm.paginationSize = 5;
                vm.paginations = [];
                vm.rows = [];
                vm.count = vm.rows.length;
                vm.groupFilterFactory = GroupFilterFactory(vm.config);
                vm.sodGridInstance = SodGridFactory(vm.config);

                vm.selectJob = selectJob;

                init();
            }

            function selectJob(job_info) {
                window.dataLayer.push({
                    'event': 'jobListItemClick',
                    'job_link': job_info.ad_info.ad_link,
                    'entity_id': job_info.select_id,
                    'entity_label': job_info.job_title
                });
                vm.sodGridInstance.selectJob(lodash.get(vm, 'config.id'), job_info.id);
            }

            function handlePagination(page) {
                if (page === vm.page) return;

                vm.page = page;
                applyFilter();
            }

            function init() {
                var groupFilterFactoryApplyFilter = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id].join('.'), function (e, eventData) {
                    var rows = lodash.get(eventData, 'rows', []);
                    var count = lodash.get(eventData, 'count', 0);

                    // vm.rows = [lodash.set(lodash.head(rows), 'premium', true)].concat(rows.slice(1));
                    vm.rows = rows;
                    vm.count = count;
                    formPagination();
                });
                var groupFilterFactoryLoading = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id, vm.groupFilterFactory.eventLoading].join('.'), function (e, eventData) {
                    vm.isLoading = eventData;
                });
                var groupFilterFactoryPageReset = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id, vm.groupFilterFactory.eventPageChange].join('.'), function (e, eventData) {
                    vm.page = eventData;
                });

                $scope.$on('destroy', function () {
                    groupFilterFactoryApplyFilter();
                    groupFilterFactoryLoading();
                    groupFilterFactoryPageReset();
                });

                applyFilter();
            }

            function applyFilter() {
                var params = getParams();
                vm.groupFilterFactory.applyFilter(lodash.get(vm, 'config.id'), params);
            }

            function getParams() {
                return {
                    page: vm.page,
                    pageSize: vm.pageSize,
                    take: vm.pageSize,
                };
            }

            function formPagination() {
                var list = [];
                var pageLimit = vm.paginationSize;
                var total = Math.ceil(vm.count / vm.pageSize);
                var upperLimit, lowerLimit;
                var currentPage = lowerLimit = upperLimit = Math.min(vm.page, total);

                for (var b = 1; b < pageLimit && b < total;) {
                    if (lowerLimit > 1) {
                        lowerLimit--;
                        b++;
                    }
                    if (b < pageLimit && upperLimit < total) {
                        upperLimit++;
                        b++;
                    }
                }

                for (var i = lowerLimit; i <= upperLimit; i++) {
                    if (i == currentPage) {
                        list.push({pageNumber: i, isActive: true});
                    } else {
                        list.push({pageNumber: i});
                    }
                }

                vm.paginations = list;
            }
        }
    }
})();
(function () {
    'use strict';

    sodGtmDataLayer.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .directive('sodGtmDataLayer', sodGtmDataLayer);

    function sodGtmDataLayer(lodash) {
        return {
            restrict: 'EA',
            scope: {onDataLayer: '@', datalayer: '@?'},
            link: sodGtmDataLayerLink,
        };

        function isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        function objectCompare(obj1, obj2) {
            //Loop through properties in object 1
            for (var p in obj1) {
                //Check property exists on both objects
                if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

                switch (typeof (obj1[p])) {
                    //Deep compare objects
                    case 'object':
                        if (!Object.compare(obj1[p], obj2[p])) return false;
                        break;
                    //Compare function code
                    case 'function':
                        if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
                        break;
                    //Compare values
                    default:
                        if (obj1[p] != obj2[p]) return false;
                }
            }

            //Check object 2 for any extra properties
            for (var p in obj2) {
                if (typeof (obj1[p]) == 'undefined') return false;
            }
            return true;
        };

        function sodGtmDataLayerLink(scope, elem, attr) {
            elem.on(scope.onDataLayer, callback);
            var datalayer = lodash.get(scope, 'datalayer');

            function callback() {
                if (lodash.isEmpty(datalayer)) return;

                var datalayerObj = {};
                if (typeof datalayer === 'string' && isJson(datalayer)) {
                    datalayerObj = JSON.parse(datalayer);
                }

                var lastDataLayer = window.dataLayer.slice(-1);
                if (!lodash.isEmpty(lastDataLayer)) {
                    lastDataLayer = lastDataLayer[0];
                    delete lastDataLayer['gtm.uniqueEventId'];
                } else {
                    lastDataLayer = {};
                }

                if (!lodash.isEmpty(datalayerObj)
                    && !objectCompare(lastDataLayer, datalayerObj)) {
                    window.dataLayer.push(datalayerObj);
                }
            }

            scope.$on('$destroy', function () {
                callback();
            });
        }
    }
})();
(function () {
    'use strict';

    hoverOverlay.$inject = ['lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('hoverOverlay', hoverOverlay);

    function hoverOverlay(lodash, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                const elmInstance = elm[0];
                elmInstance.classList.add('hover-overlay');
            },
        };
    }
})();
(function () {
    'use strict';

    sodListSelectorCtrl.$inject = ['lodash', '$element', 'ActionManager'];
    angular
        .module('sodCommon')
        .directive('sodListSelector', sodListSelector);

    function sodListSelector() {
        return {
            restrict: 'E',
            templateUrl: 'common/components/sod-list-selector',
            scope: {
                options: '=?',
                validate: '=?',
            },
            require: 'ngModel',
            controller: sodListSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;
                ctrl.$render = function () {
                    vm.selected_jobs = ctrl.$viewValue;
                }
            }
        };
    }

    function sodListSelectorCtrl(lodash, $element, ActionManager) {
        var ngModel = $element.controller('ngModel');
        var vm = this;

        this.$onInit = function() {

            vm.selected_jobs = [];
            vm.toggled_more_jobs = [];

            vm.toggleMore = toggleMore;
            vm.isToggledMore = isToggledMore;

            vm.toggleSelection = toggleSelection;
            vm.isSelected = isSelected;

            vm.validate = validate;

            $element.find('.validate-message').hide();
        }

        function toggleSelection(item) {

            var filtered = lodash.filter(vm.selected_jobs, function (_item2) {
                return (_item2 == item.id)
            });
            if (filtered.length == 0) {
                if (vm.options.max > vm.selected_jobs.length) {
                    vm.selected_jobs.push(item.id);
                    dataLayerPush({
                        event: 'jobSelected',
                        entity_id: item.select_id,
                        entity_label: item.title,
                    });

                } else {

                    ActionManager('notify', {
                        'template': vm.options.max_warning,
                        'hasDelay': true,
                        'delay': 3000,
                        'type': 'warning',
                        'position': 'bottom right-float'
                    });

                }
            } else {

                vm.selected_jobs = lodash.filter(vm.selected_jobs, function (_item2) {
                    return _item2 != item.id;
                });
                dataLayerPush({
                    event: 'jobUnselected',
                    entity_id: item.select_id,
                    entity_label: item.title,
                });
            }
            ngModel.$setViewValue(vm.selected_jobs);
        }

        function isSelected(item) {
            return vm.selected_jobs.indexOf(item.id) >= 0;
        }

        function toggleMore(item) {
            var filtered = lodash.filter(vm.toggled_more_jobs, function (_item2) {
                return (_item2 == item.id)
            });

            if (filtered.length == 0) {
                vm.toggled_more_jobs = vm.toggled_more_jobs.concat(item.id);
                dataLayerPush({
                    event: 'jobSelectionShowMore',
                    entity_id: item.select_id,
                    entity_label: item.title,
                });
            } else {
                vm.toggled_more_jobs = lodash.without(vm.toggled_more_jobs, item.id);
                dataLayerPush({
                    event: 'jobSelectionShowLess',
                    entity_id: item.select_id,
                    entity_label: item.title,
                });
            }
        }

        function isToggledMore(item) {
            return vm.toggled_more_jobs.indexOf(item.id) >= 0;
        }

        function validate() {
            if (vm.selected_jobs.length < vm.options.min) {
                dataLayerPush(
                    {
                        event: 'validationErrorOccurred',
                        step: 1
                    }
                );
                $element.find('.validate-message').show();
                return false;
            }
            $element.find('.validate-message').hide();
            return true;

        }

        function dataLayerPush(data) {
            return window.dataLayer.push(data);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodMouseoverItem', sodMouseoverItem);

    function sodMouseoverItem() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                eventName: '=',
                eventData: '=?',
                label: '=?',
                type: '@?',
            },
            template: '<div class="sod-mouseover-item"><ng-transclude></ng-transclude><div ng-class="type"><span sod-emit-event event-name="eventName" event-data="eventData" label="label"></span></div></div>',
            link: function(scope, elem) {
                if (!scope.type) {
                    scope.type = 'default';
                }

            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodNotifications', directive);

    function directive() {
        return {
            restrict: 'E',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true,
            template:
                "<div class='callout callout-notification ' ng-class='vm.getNotificationClass()' ng-if='vm.notification.message'>" +
                    "<div ng-bind='vm.notification.message'></div>" +
                "</div>"
        };
    }

    controller.$inject = ['$scope', 'NotificationService', 'lodash'];

    function controller($scope, NotificationService, lodash) {
        var vm = this;

        this.$onInit = function() {
            vm.getNotificationClass = getNotificationClass;

            $scope.$watch(function() { return NotificationService.change(); }, function() {
                vm.notification = NotificationService.get();
            });
        }

        function getNotificationClass() {
            return [vm.notification.class,getNotificationTypeClass()].join(' ');
        }

        function getNotificationTypeClass() {
            if (lodash.has(vm, 'notification.type')) {
                switch (vm.notification.type) {
                    case "error":
                        return "alert";
                    case "info":
                        return "primary";
                    default:
                        return vm.notification.type;

                }
            }
            return "";
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodOptionToggle', sodOptionToggle);

    function sodOptionToggle() {
        return {
            restrict: 'E',
            scope: {
                option: '=',
                labelText: '=',
            },
            template:'<label class="sod-option-toggle" ng-click="toggle()"><i class="fa fa-circle" ng-class="{ \'activated\': toggleState, \'deactivated\':!toggleState  }"></i> <%labelText%></label>',
            require: 'ngModel',
            link:function(scope, elem, attr, ctrl) {
                scope.toggleState = false;

                scope.toggle = function() {
                  scope.toggleState = !scope.toggleState;
                    ctrl.$setViewValue(scope.toggleState);
                };

                ctrl.$formatters.push(function(modelValue) {
                    return modelValue;
                });
                ctrl.$parsers.push(function(viewValue) {
                    return viewValue;
                });

                ctrl.$render = function(modelValue) {
                    scope.toggleState = modelValue;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    sodPopover.$inject = ['$document', 'lodash'];
    angular
        .module('sodCommon')
        .directive('sodPopover', sodPopover);

    function sodPopover($document, lodash) {
        return {
            restrict: 'E',
            controller: sodPopoverCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/components/sod-popover',
            scope: {
                label: '=',
                options: '=?',
                togglePopover: '=',
                onPopoverClose: '&?',
                onPopoverOpen: '&?'
            },
            link: sodPopoverLink
        };

        function sodPopoverLink(scope, elem, attr) {
            var vm = scope.vm,
                //dropdown = elem.find('.dropdown'),
                popOverActionElem = elem.find('.sod-popover-action');

            popOverActionElem.on('click', sodPopoverActionClick);
            $document.on('mousedown', onDocumentClick);

            elem.find('.sod-popover').addClass(attr.class);

            scope.$on('$destroy', function () {
                popOverActionElem.off('click', sodPopoverActionClick);
                $document.off('mousedown', onDocumentClick);
            });

            function sodPopoverActionClick(e) {
                // console.log('sodPopoverActionClick *************************');
                if (lodash.get(vm, 'options.can_toggle', true) === true) {
                    e.preventDefault();
                    vm.toggle();
                    scope.$apply();
                }
            }

            function onDocumentClick(e) {
                const toggleOptions = lodash.get(vm, 'options', 'toggleable', true);
                if (!toggleOptions) { return; }

                var parents = angular.element(e.target).parents('#' + attr.id + ', .item.active[data-value], .k-calendar-container, .datepicker.datepicker-dropdown');
                if (parents.length == 0) {
                    if (vm.toggleState) {
                        vm.toggle();
                        scope.$apply();
                    }
                }
            }
        }
    }

    function sodPopoverCtrl() {
        var vm = this;

        this.$onInit = function() {
            vm.toggleState = false;

            vm.toggle = toggle;
            vm.togglePopover = () => {
                // console.log('===================================================================================');
                toggle();
            };
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;

            if (!vm.toggleState) {
                if (typeof vm.onPopoverClose === typeof function () {
                    }) {
                    vm.onPopoverClose();
                }
            } else {
                if (typeof vm.onPopoverOpen === typeof function () {
                    }) {
                    vm.onPopoverOpen();
                }
            }
        }
    }
})();
(function() {
    'use strict';

    sodPreventDefaultCtrl.$inject = ['$location', '$document'];
    angular
        .module('sodCommon')
        .directive('sodPreventDefault', sodPreventDefault);

    function sodPreventDefault() {
        return {
            restrict: 'A',
            link: link,
            controller: sodPreventDefaultCtrl,
            controllerAs: 'vm',
            bindToController: true
        };

        function link(scope, elem) {
            elem.on('click', function(e) {
                e.preventDefault();
            });
        }
    }

    function sodPreventDefaultCtrl($location, $document) {
        var vm = this;
        this.$onInit = function() {
            vm.clickHref = clickHref;
        }

        function clickHref(href) {
            var pathInfo = href.split('?');
            var searchInfo = {};

            if (pathInfo.length > 1) {
                var searchInfoArr = pathInfo[1].split('&');
                searchInfo = searchInfoArr.reduce(function(result, _info) {
                    var _info_splited = _info.split('=');
                    result[_info_splited[0]] = _info_splited[1] || true;
                    return result;
                }, searchInfo);
            }

            $location.path(pathInfo[0]).search(searchInfo);
            $document.focus();
        }
    }
})();
(function () {
    'use strict';

    sodScriptLoaderCtrl.$inject = ['$scope'];
    angular
        .module('sodCommon')
        .directive('sodScriptLoader', sodScriptLoader);

    function sodScriptLoader() {
        return {
            restrict: 'E',
            scope: { content: '=?', src: '=?', attrib: '=?' },
            controller: sodScriptLoaderCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodScriptLoaderCtrl($scope) {
        var vm = this;

        this.$onInit = function() {
            if (vm.content || vm.src) {
                var id = randomString(16);
                $scope.$on('$destroy', function () {
                    $('script#' + id).remove();
                });
            }

            if (vm.content) {
                $('<script id="' + id + '">').html(vm.content).appendTo('body');
            }

            if (vm.src) {
                $('<script id="' + id + '" src="' + vm.src + '" ' + (vm.attrib || '') + '>').appendTo('body');
            }
        }

        function randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        }
    }
})();
(function () {
    'use strict';

    sodScrollToMe.$inject = ['$location'];
    angular
        .module('sodCommon')
        .directive('sodScrollToMe', sodScrollToMe);

    function sodScrollToMe($location) {
        return {
            restrict: 'A',
            scope: { id: '@?', offset: '@?' },
            link: function (scope, elem, attrs) {

                var hash = $location.hash();
                if (hash === scope.id) {
                    scrollToListener();
                }
                function scrollToListener() {
                    $('html, body').animate({
                        scrollTop: ($(elem).offset().top) + (parseInt(scope.offset) || 0)
                    }, 500);
                }
            },
        };
    }
})();
(function () {
    'use strict';

    sodScrollTo.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .directive('sodScrollTo', sodScrollTo);

    function sodScrollTo(lodash) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.on('click', scrollToListener);

                var toElem = lodash.get(attrs, 'toElem');
                var offset = lodash.get(attrs, 'offset');

                function scrollToListener(event) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: ($('#' + toElem).offset().top) + (parseInt(offset) || 0)
                    }, 500);
                }
                scope.$on('$destroy', function () {
                    elem.off('click', scrollToListener);
                })
            },
        };
    }
})();
(function () {
    'use strict';

    sodSearchBarApplyCtrl.$inject = ['lodash', '$element', '$scope', 'FilterFactory', '$httpParamSerializer'];
    angular
        .module('sodCommon')
        .directive('sodSearchBarApply', sodSearchBarApply);

    function sodSearchBarApply() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            transclude: true,
            templateUrl: 'common/components/sod-search-bar-apply',
            controller: sodSearchBarApplyCtrl,
            controllerAs: 'vm',
            bindToController: true,
            compile: sodSearchBarApplyCompile,
            link: sodSearchBarApplyLink,
        };

        function sodSearchBarApplyCompile(tElement, attrs, transclude) {
            return function ($scope) {
                transclude($scope, function (clone) {
                    tElement.append(clone);
                });
            };
        }

        function sodSearchBarApplyLink(scope, elem, attr) {
        }
    }

    function sodSearchBarApplyCtrl(lodash, $element, $scope, FilterFactory, $httpParamSerializer) {
        var vm = this;

        this.$onInit = function() {
            vm.filters = {};
            init();
        }

        function getSearchUrl() {
            vm.searchUrl = ['portal/jobs', '?', $httpParamSerializer({ filter: vm.filters })].join('');
        }

        function init() {
            getSearchUrl();
            var filtersChangeListener = $scope.$on(
                [FilterFactory.eventPrefix, lodash.get(vm, 'config.id', null)].join('.'),
                function (e, data) {
                    vm.filters = data;
                    getSearchUrl();
                }
            );

            $scope.$on('$destroy', function () {
                filtersChangeListener();
            });
        }
    }
})();
(function () {
    'use strict';

    sodSearchInputCtrl.$inject = ['lodash', '$element', '$scope', 'FilterFactory', 'GroupFilterFactory', '$httpParamSerializer'];
    angular
        .module('sodCommon')
        .directive('sodSearchInput', sodSearchInput);

    function sodSearchInput() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            transclude: true,
            templateUrl: 'common/components/sod-search-input',
            controller: sodSearchInputCtrl,
            controllerAs: 'vm',
            bindToController: true,
            compile: sodSearchInputCompile,
            link: sodSearchInputLink,
        };

        function sodSearchInputCompile(tElement, attrs, transclude) {
            return function ($scope) {
                transclude($scope, function (clone) {
                    tElement.append(clone);
                });
            };

        }

        function sodSearchInputLink(scope, elem, attr) {
        }
    }

    function sodSearchInputCtrl(lodash, $element, $scope, FilterFactory, GroupFilterFactory, $httpParamSerializer) {
        var vm = this;
        var filterPath = '';
        this.$onInit = function() {
            vm.groupFilterFactory = GroupFilterFactory(lodash.get(vm, 'config.grid_id', null));
            filterPath = [lodash.get(vm, 'config.grid_id', ''), lodash.get(vm, 'config.type', '')].join('.');

            vm.apply = apply;
            vm.directSearch = directSearch;
            vm.handleModelChange = handleModelChange;
            vm.model = getFilterModel(init);

            init();
        }



        function apply() {
            applyFilter();
        }

        function getSearchUrl() {
            var filters = getAllFilters();
            vm.searchUrl = ['portal/jobs', '?', $httpParamSerializer({ filter: filters })].join('');
        }

        function getAllFilters() {
            return FilterFactory.get(lodash.get(vm, 'config.grid_id', ''));
        }

        function getFilterModel(init) {
            var filterValue = FilterFactory.get(filterPath, init ? lodash.get(vm, 'config.active_filters', {}) : {});
            return lodash.get(filterValue, 0, '').toString();
        }

        function setFilterModel() {
            FilterFactory.set(filterPath, [vm.model]);
        }

        function handleModelChange() {
            setFilterModel();
        }

        function applyFilter() {
            vm.groupFilterFactory.applyFilter(lodash.get(vm, 'config.grid_id', null));
        }
        
        function directSearch() {
            getSearchUrl();
        }

        function init() {
            var filtersChangeListener = $scope.$on(
                [FilterFactory.eventPrefix, filterPath].join('.'),
                function (e) {
                    vm.model = getFilterModel();

                    var category = lodash.get(vm, 'config.category', null);
                    if (category === 'direct-search') {
                        directSearch();
                    }
                }
            );

            $scope.$on('$destroy', function () {
                filtersChangeListener();
            });
        }
    }
})();
(function () {
    'use strict';

    sodSelectizeFilter.$inject = ['$document'];
    sodSelectizeFilterCtrl.$inject = ['lodash', '$element', '$scope', 'FilterFactory'];
    var ACTIVE = 'active';
    var CLASS_CHANGE = 'classChange';
    var SELECTIZE_FILTER_MODAL = '.selectize-filter-modal';

    angular
        .module('sodCommon')
        .directive('sodSelectizeFilter', sodSelectizeFilter);

    function sodSelectizeFilter($document) {
        return {
            restrict: 'E',
            scope: { config: '=?', activeFilters: '=?', filterType: '=', gridId: '=', options: '=?', autoApply: '=?', applyCallback: '&?', },
            transclude: true,
            templateUrl: 'common/components/sod-selectize-filter',
            controller: sodSelectizeFilterCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: sodSelectizeFilterLink,
        };

        function sodSelectizeFilterLink(scope, elem, attr) {
            $document.on('click', onDocumentClick);

            scope.$on('$destroy', function () {
                $document.off('click', onDocumentClick);
            });

            function onDocumentClick(e) {
                var $selectizeFilterModal = $(elem.find(SELECTIZE_FILTER_MODAL));

                if (!elem[0].contains(e.target)) {
                    $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
                } else {
                    $selectizeFilterModal.addClass(ACTIVE).trigger(CLASS_CHANGE);
                }
            }
        }
    }

    function sodSelectizeFilterCtrl(lodash, $element, $scope, FilterFactory) {
        var vm = this;
        var selectizeInstance = null;
        var filterPath = '';
        var $selectizeFilterModal = null;

        this.$onInit = function() {
            filterPath = [vm.gridId, vm.filterType].join('.');

            vm.apply = apply;
            vm.clear = clear;
            vm.cancel = cancel;
            vm.onSelect = onSelect;
            vm.isSelected = isSelected;
            vm.hasSelectedChanged = hasSelectedChanged;
            vm.selected = FilterFactory.get(filterPath, lodash.get(vm, 'activeFilters', {}));
            setInitialSelected();
            vm.isCurrentlyActive = false;
            vm.config = Object.assign(lodash.get(vm, 'config', {}), {
                autoApply: vm.autoApply,
                selectizeConfig: Object.assign({
                    dropdownParent :  'body',
                    closeAfterSelect: true,
                    placeholder: 'Add a filter',
                    onInitialize: function(selectize) {
                        selectizeInstance = selectize;
                    },
                    onItemAdd: function (value, $item) {
                        selectizeInstance.clear();
                        selectizeInstance.blur();
                        handleAddValue(value);
                    },
                }, lodash.get(vm, 'config', {})),
            });
            vm.options = vm.options || [];
            vm.displayOptions = lodash.take(vm.options, 0);
            $selectizeFilterModal = $($element.find(SELECTIZE_FILTER_MODAL));

            init();
        }




        function init() {
            var filterFactoryListener = $scope.$on([FilterFactory.eventPrefix, filterPath].join('.'), function (e) {
                vm.selected = FilterFactory.get(filterPath);
                handleAddDisplayOptions(vm.selected);
            });
            var filterFactoryHandleDisplayOptionsListener = $scope.$on([FilterFactory.eventPrefix, filterPath, 'addDisplayOptions'].join('.'), function (e, eventData) {
                handleAddDisplayOptions(eventData);
            });
            $scope.$on('destroy', function() {
                filterFactoryListener()
                filterFactoryHandleDisplayOptionsListener();
            });

            $selectizeFilterModal.on('classChange', function (e) {
                e.preventDefault();
                var isActive = $selectizeFilterModal.hasClass(ACTIVE);
                var hasChanged = vm.isCurrentlyActive !== isActive;

                if (hasChanged) {
                    vm.isCurrentlyActive = isActive;
                    if (isActive) {
                        setInitialSelected();
                    }
                }
            });

            handleAddDisplayOptions(FilterFactory.get(filterPath));
        }

        function setInitialSelected() {
            vm.initialSelected = vm.selected;
        }

        function isSelected(value) {
            return lodash.findIndex(vm.selected, function(item) {
                return item == value;
            }) >= 0;
        }

        function hasSelectedChanged() {
            var added = lodash.difference(vm.selected, vm.initialSelected);
            var removed = lodash.difference(vm.initialSelected, vm.selected);
            return vm.isCurrentlyActive && lodash.concat(added, removed).length;
        }

        function onSelect(value, e) {
            e.stopPropagation();
            handleToggleValue(value);
        }

        function handleAddValue(value) {
            vm.selected = lodash.concat(vm.selected, value);
            vm.selected = lodash.uniq(vm.selected);
            vm.selected = FilterFactory.set(filterPath, vm.selected);

            handleAddDisplayOptions(value);
        }

        function handleToggleValue(value) {
            var hasValue = isSelected(value);

            if (hasValue) {
                vm.selected = lodash.filter(vm.selected, function (oSelected) {
                    return oSelected != value;
                });
            } else {
                vm.selected = lodash.concat(vm.selected, value);
            }
            vm.selected = FilterFactory.set(filterPath, vm.selected);
        }

        function handleAddDisplayOptions(value) {
            if (lodash.isArray(value)) {
                return lodash.forEach(value, function (oValue) {
                    handleAddDisplayOptions(oValue);
                });
            }
            var valueKey = 'value';
            var foundSelected = lodash.filter(vm.options, function (option) {
                return lodash.get(option, valueKey, null) == value;
            });

            var combinedDisplayOptions = lodash.concat(vm.displayOptions, foundSelected);
            vm.displayOptions = lodash.uniqBy(combinedDisplayOptions, valueKey);
        }

        function handleApplyCallback() {
            if (vm.applyCallback) {
                vm.applyCallback();
            }
        }

        function apply(e) {
            e.stopPropagation();
            handleApplyCallback();
            $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
        }

        function clear(e) {
            e.stopPropagation();
            vm.selected = [];
            vm.selected = FilterFactory.set(filterPath, vm.selected);
            handleApplyCallback();
            $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
        }

        function cancel(e) {
            e.stopPropagation();
            vm.selected = vm.initialSelected;
            vm.selected = FilterFactory.set(filterPath, vm.selected);
            $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSimilarJobs', sodSimilarJobs);

    function sodSimilarJobs() {
        sodSimilarJobsCtrl.$inject = ['$scope', 'lodash', 'GenericModel'];
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-similar-jobs',
            controller: sodSimilarJobsCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodSimilarJobsCtrl($scope, lodash, GenericModel) {
            var vm = this;

            // functions
            this.$onInit = function() {
                // initializations
                vm.isLoading = false;
                vm.similarJobs = [];
                init();
            }


            function getSimilarJobs() {
                if (vm.isLoading) return;

                var datasource = lodash.get(vm, 'config.datasource', {});
                var datasourceURL = lodash.get(datasource, 'url', null);
                var datasourceMethod = lodash.get(datasource, 'method', null);

                var model = new GenericModel(datasourceURL);
                model[datasourceMethod]({}).$promise.then(function (res) {
                    vm.similarJobs = lodash.get(res, 'rows', []);
                    vm.isLoading = false;
                }, function (error) {
                    console.log('error', error);
                    vm.isLoading = false;
                });
            }

            function init() {
                getSimilarJobs();
            }
        }
    }
})();
(function() {
    'use strict';

    sodSlick.$inject = ['$document', '$rootScope', 'lodash'];
    angular
        .module('sodCommon')
        .directive('sodSlick', sodSlick);

    function sodSlick($document, $rootScope, lodash) {
        return {
            restrict: 'A',
            scope: { config: '=' },
            link: sodSlickLink,
        };

        function sodSlickLink(scope, elem, attr) {

            init();
            function init() {
                var sodSlickId = randomString(8);
                $document.ready(function () {
                    setSlickId(sodSlickId);

                    $rootScope.$on(
                        ['sod-slick', sodSlickId, 'init'].join('.'),
                        function (delay) {
                            setTimeout(function () {
                                initSlick(sodSlickId);
                            }, delay || 300);
                        }
                    );

                    scope.$on('$destroy', function() {
                        destroySlick(sodSlickId);
                    });

                });
            }

            function setSlickId(sodSlickId) {
                var sodSlickChildElem = elem.find('[sod-slick-child]');
                sodSlickChildElem.attr('sod-slick-child', sodSlickId);
            }

            function destroySlick(sodSlickId) {
                $('.sod-slick-' + sodSlickId).slick('unslick');
            }

            function initSlick(sodSlickId) {
                $('.sod-slick-' + sodSlickId).slick('unslick');
                var sodSlickElem = elem.find('.sod-slick');
                sodSlickElem.addClass('sod-slick-' + sodSlickId);
                var slickOptions = lodash.get(scope, 'config', {});
                $('.sod-slick-' + sodSlickId).slick(slickOptions);

                var isForceCenterMode = lodash.get(slickOptions, 'forceCenterMode', false);
                if (isForceCenterMode) {
                    $('.sod-slick-' + sodSlickId).on('breakpoint', cbForceCenterMode);
                    $('.sod-slick-' + sodSlickId).on('setPosition', cbForceCenterMode);
                    $('.sod-slick-' + sodSlickId).on('init', cbForceCenterMode);
                    $('.sod-slick-' + sodSlickId).on('reInit', cbForceCenterMode);

                    $('.sod-slick-' + sodSlickId).on('destroy', function () {
                        $('.sod-slick-' + sodSlickId).off('breakpoint');
                        $('.sod-slick-' + sodSlickId).off('setPosition');
                        $('.sod-slick-' + sodSlickId).off('init');
                        $('.sod-slick-' + sodSlickId).off('reInit');
                    });

                    setTimeout(cbForceCenterMode, 300);
                }

                function cbForceCenterMode() {
                    forceCenterMode();
                }

                function forceCenterMode() {
                    var slick = $('.sod-slick-' + sodSlickId).slick('getSlick');
                    var activeBreakpoint = lodash.get(slick, 'activeBreakpoint', null);

                    var slidesToShow = null;
                    if (activeBreakpoint) {
                        slidesToShow = lodash.get(slick, ['breakpointSettings', activeBreakpoint, 'slidesToShow'].join('.'), null);
                    } else {
                        slidesToShow = lodash.get(slickOptions, 'slidesToShow', null);
                    }

                    var slidesCount = lodash.get(slick, '$slides.length', null);
                    if (slidesCount < slidesToShow) {
                        var $slideTrack = lodash.get(slick, '$slideTrack', null);
                        $slideTrack.css('width', '');
                    }
                }
            }

            function randomString(length) {
                return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
            }
        }
    }
})();
(function () {
    'use strict';

    sodSortDropdownCtrl.$inject = ['lodash', '$filter'];
    angular
        .module('sodCommon')
        .directive('sodSortDropdown', sodSortDropdown);

    function sodSortDropdown() {
        return {
            restrict: 'E',
            controller: sodSortDropdownCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                getSort: '=?',
                toggleRefresh: '=?'
            },
            templateUrl: 'common/components/sod-sort-dropdown'
        };
    }

    function sodSortDropdownCtrl(lodash, $filter) {
        var vm = this;

        this.$onInit = function() {
            vm.constructQueryText = constructQueryText;
            vm.getSort = getSort;
            vm.select = select;
            vm.change_direction = change_direction;

            vm.directionText = '';

            vm.selected_option = lodash.get(vm.options, 'default', null);
            vm.selected_direction = lodash.get(vm.options, 'default.dir', 'asc');
        }

        function constructQueryText() {
            if (vm.selected_option === null) {
                return vm.options.label.no_sort;
            } else {
                vm.direction_text = lodash.get(vm.options.label.direction, vm.selected_direction, null);
                return $filter('stringFormat')(vm.options.label.sort, [vm.selected_option.label])
            }
        }

        function getSort() {
            if (vm.selected_option === null) {
                return [];
            }
            return [
                angular.extend(vm.selected_option, { dir: vm.selected_direction })
            ];
        }

        function select(option) {
            if (option.id !== vm.selected_option.id) {
                vm.selected_direction = null;
            }

            if (lodash.isEmpty(vm.selected_direction)) {
                vm.selected_direction = lodash.get(option, 'default_direction', 'asc');
            } else {
                vm.selected_direction = (vm.selected_direction === 'asc') ? 'desc' : 'asc';
            }
            vm.selected_option = option;
            if (typeof vm.toggleRefresh === typeof function() {}) {
                vm.toggleRefresh();
            }
            vm.togglePopover();
        }

        function change_direction() {
            vm.selected_direction = (vm.selected_direction === 'asc') ? 'desc' : 'asc';
            if (typeof vm.toggleRefresh === typeof function() {}) {
                vm.toggleRefresh();
            }
        }
    }
})();
(function () {
    'use strict';

    stickyElm.$inject = ['lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('stickyElm', stickyElm);

    function stickyElm(lodash, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                $(window).scroll((function () {

                    return function () {
                        const elmInstance = elm[0];
                        // const sticky = getPosition(elmInstance).y;
                        const sticky = 180;

                        if (window.pageYOffset >= sticky) {
                            elmInstance.classList.add('sticky');
                        } else {
                            elmInstance.classList.remove('sticky');
                        }
                    };
                })(scope, elm, attrs));
            },
        };
    }
})();
(function () {
    'use strict';

    sodTemplateCtrl.$inject = ['$compile', '$scope', '$element'];
    angular
        .module('sodCommon')
        .directive('sodTemplate', sodTemplate);

    function sodTemplate() {
        return {
            restrict: 'E',
            scope: {
                template: '=',
                data: '=?'
            },
            controller: sodTemplateCtrl
        };
    }

    function sodTemplateCtrl($compile, $scope, $element) {
        this.$onInit = function() {
            $element.html($scope.template);
            const cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', ()=> {
                cloneElement.off();
            });
        }
    }
})();
(function () {
    'use strict';

    sodToolTippy.$inject = ['lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('sodToolTippy', sodToolTippy);

    function sodToolTippy(lodash, $timeout) {
        return {
            restrict: 'EA',
            transclude: true,
            templateUrl: 'common/components/sod-tool-tippy',
            link: sodToolTippyLink,
            controllerAs: 'vm',
            controller: sodToolTippyCtrl,
            bindToController: true,
            scope: {
                placement: '@',
                label: '=?',
                model: '=?',
                options: '=?',
                showTooltip: '&?',
                tippyClass: '@?'
            },
        };

        function sodToolTippyLink(scope, elem, attr) {
            var vm = scope.vm;
            var tippyInstance = null;
            var tippy = elem.find('.tippy');
            tippy = $(tippy);
            tippy.hide();


            var showTooltipVar = true;
            $timeout(function() {
               if (!showTooltop()) {
                   showTooltipVar = false;
               }

                $(elem).mouseenter(function (e) {
                    e.preventDefault();
                    if (showTooltipVar) {
                        tippy.hide();
                        toggleTippy();
                    }
                });

                $(elem).mouseleave(function (e) {
                    e.preventDefault();
                    if (showTooltipVar) {
                        tippy.show();
                        toggleTippy();
                    }
                });

            });


            function toggleTippy() {
                if (!tippyInstance) {
                    tippyInstance = new Popper(elem.children()[0], tippy, Object.assign({
                        placement: vm.placement ? vm.placement : 'auto',
                        positionFixed: true,
                        onCreate: function () {
                            tippyInstance.update();
                        },
                    }, lodash.get(vm, 'options', {})));
                    tippyInstance.scheduleUpdate();
                } else {
                    tippyInstance.update();
                }

                tippy.toggle();
            }

            function showTooltop() {
                if (typeof vm.showTooltip == typeof function() {}) {
                    return vm.showTooltip();
                }
                return true;
                // return false;
            }
        }

        function sodToolTippyCtrl() {
            var vm = this;
        }
    }
})();
(function () {
    'use strict';

    sodWizardStepsCtrl.$inject = ['$scope', '$timeout', '$injector'];
    angular
        .module('sodCommon')
        .directive('sodWizardSteps', sodWizardSteps);

    function sodWizardSteps() {
        return {
            restrict: 'E',
            templateUrl: 'common/components/sod-wizard-steps',
            controller: sodWizardStepsCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodWizardStepsCtrl($scope, $timeout, $injector) {
        var vm = this;

        this.$onInit = function() {
            vm.executingAPI;
            vm.submitted = false;
            vm.wizardStepActive;

            vm.handleStepClicked = handleStepClicked;

            init();
        }

        function init() {
            setWizardSetActive(0);
        }

        function setWizardSetActive(stepIndex) {
            vm.wizardStepActive = stepIndex;
        }

        function handleStepClicked(stepIndex, externalApi) {
            return function () {
                if (vm.executingAPI)
                    return;

                if (!(stepIndex === 'submit')) {
                    // if jump of the stepIndex is more than 1
                    // do not execute the steps
                    if (stepIndex - vm.wizardStepActive > 1)
                        return;

                    // allows immediate change of step if it's
                    // returning to previous steps
                    if (stepIndex < vm.wizardStepActive) {
                        setWizardSetActive(stepIndex);
                        return;
                    }
                }

                vm.executingAPI = true;
                var funcCallType = (typeof externalApi == typeof function () {
                });
                var funcCall = funcCallType ? externalApi : executeAPI;

                funcCall()
                    .then(function () {
                        setWizardSetActive(stepIndex);
                    })
                    .catch(function (res) {
                        // console.log(res);

                        switch (res.status) {
                            case 422: {
                                var FormBuilderService = $injector.get('FormBuilderService');
                                var fbService = FormBuilderService.get($scope.panel.data.options.massApply.form_id);
                                fbService.elementsService.setValidationRules(res.data.rules, res.data.summary);
                                window.dataLayer.push(
                                    {
                                        event: 'validationErrorOccurred',
                                        step: vm.wizardStepActive
                                    }
                                );
                                // // ActionManager('enable-button', data.evtData.targetScope.name);
                                break;
                            }
                        }
                        // var FormBuilderService = $injector.get('FormBuilderService');
                        // var fbService = FormBuilderService.get(data.evtData.formIdentifier);
                        // fbService.elementsService.setValidationRules(data.response.rules, data.response.summary);
                        // // ActionManager('enable-button', data.evtData.targetScope.name);
                        // ActionManager('enable-button', {
                        //     enable_all_disabled: true
                        // });
                    })
                    .finally(function () {
                        if (funcCallType) {
                            vm.executingAPI = false;
                            if (stepIndex === 'submit') {
                                vm.submitted = true;
                                window.dataLayer.push({event: 'applicationSubmit'});
                            }
                        } else {
                            $scope.$apply(function () {
                                vm.executingAPI = false;
                                if (stepIndex === 'submit') {
                                    vm.submitted = true;
                                }

                            });
                        }
                        // $scope.$apply();
                    });

            };
        }

        function handleSubmit(externalApi) {

        }

        function executeAPI() {
            return new Promise(function (resolve, reject) {
                $timeout(function () {
                    resolve();
                }, 1000);
            });
        }
    }
})();
//http://bgrins.github.io/spectrum/
(function () {
    'use strict';

    sodColorPicker.$inject = ['$timeout', 'lodash'];
    angular
        .module('sodCommon')
        .directive('sodColorPicker', sodColorPicker);

    function sodColorPicker($timeout, lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                name: '@inputName',
                readonly: '=',
                disabled: '='
            },
            template: '<div class="color-picker-wrapper">' +
                '<input type="text" name="<%inputName%>" ng-readonly="readonly" ng-disabled="disabled" ng-disabled class="color-picker-dom" />' +
                '<input type="text" ng-model="displayModel" class="color-picker-value" ng-change="displayModelChange()" />' +
            '</div>',
            link: function(scope, elem, attr, ngModelCtrl) {
                var inputDom = elem.find('.color-picker-dom');
                var inputDomValue = elem.find('.color-picker-value');
                inputDom.spectrum({
                    preferredFormat: 'hex',
                    change: function(color) {
                        ngModelCtrl.$setViewValue(color.toHexString().toUpperCase());
                        scope.$apply(function() {
                            ngModelCtrl.$render();
                        });
                    },
                    move: function(color) {
                        // scope.displayModel = color.toHexString().toUpperCase();
                        // scope.$apply();

                        scope.displayModel = color.toHexString().toUpperCase();
                        ngModelCtrl.$setViewValue(color.toHexString().toUpperCase());
                        scope.$apply(function() {
                            ngModelCtrl.$render();
                        });
                    },
                    hide: function(color) {
                        if (scope.displayModel.length > 0) {
                            ngModelCtrl.$setViewValue(color.toHexString().toUpperCase());
                        } else {
                            ngModelCtrl.$setViewValue(null);
                        }

                        scope.$apply(function() {
                            ngModelCtrl.$render();
                        });
                    },
                    containerClassName: 'color-picker-container'
                });

                scope.displayModelChange = function() {
                    inputDom.spectrum('set', scope.displayModel.toUpperCase());
                    if (scope.displayModel.length > 0) {
                        ngModelCtrl.$setViewValue(scope.displayModel.toUpperCase());
                    } else {
                        ngModelCtrl.$setViewValue(null);
                    }
                    ngModelCtrl.$render();
                };

                inputDomValue.click(function(e) {
                    inputDom.spectrum('show');
                    return false;
                });

                ngModelCtrl.$render = function() {
                    scope.currentModel = ngModelCtrl.$viewValue || null;
                };

                $timeout(function() {
                    let currentModel = scope.currentModel;
                    if (!lodash.isEmpty(currentModel)) {
                        currentModel = currentModel.toUpperCase();
                    }
                    inputDom.spectrum('set',  currentModel);
                    scope.displayModel =  currentModel;
                    ngModelCtrl.$setViewValue(currentModel);
                });

                scope.$on('$destroy', function() {
                    inputDom.spectrum('destroy');
                    inputDomValue.off();
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('talentSidebarToggle', talentSidebarToggle);

    function talentSidebarToggle() {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, elem) {
            elem.on('click', function() {
                if (elem.hasClass('active')) {
                    angular.element('.sidebar-wrapper').removeClass('active');
                    elem.removeClass('active');
                } else {
                    angular.element('.sidebar-wrapper').addClass('active');
                    elem.addClass('active');
                }

            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('talentSidebarWrapper', talentSidebarWrapper);

    function talentSidebarWrapper() {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, elem) {
            elem.on('click', function() {
                angular.element('.sidebar-menu-toggle').removeClass('active');
                angular.element('.sidebar-wrapper').removeClass('active');
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('textWrapper', textWrapper);

    function textWrapper() {
        return {
            restrict: 'E',
            scope: {
                'wrapperLabel': '='
            },
            transclude: true,
            link: function(scope) {
                if (!scope.wrapperLabel || scope.wrapperLabel.length === 0) {
                    scope.wrapperLabelPrefix = '';
                    scope.wrapperLabelSuffix = '';
                } else {
                    var splitted = scope.wrapperLabel.split('<content>');
                    if (splitted.length === 1) {
                        scope.wrapperLabelPrefix = splitted[0];
                    } else {
                        scope.wrapperLabelPrefix = splitted[0];
                        scope.wrapperLabelSuffix = splitted[1];
                    }
                }
            },
            template: '<div><%wrapperLabelPrefix%><ng-transclude></ng-transclude><%wrapperLabelSuffix%></div>'
        };
    }
})();
(function () {
    'use strict';

    sodTimeSlotPicker.$inject = ['lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('sodTimeSlotPicker', sodTimeSlotPicker);

    function sodTimeSlotPicker(lodash, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                render: '=?'
            },
            templateUrl: 'common/components/sod-time-slot-picker',
            link: function(scope, elem, attr, ctrl) {
                var formatDisplay = lodash.get(scope.options, 'datepicker.format_display', 'D MMM YYYY');
                var formatValue = lodash.get(scope.options, 'datepicker.format_value', 'YYYY-M-D');

                if (!scope.options) {
                    scope.options = {};
                }
                scope.testCtrl = ctrl;
                var fields = {
                    start_date: lodash.get(scope.options, 'field.start_date', 'start_date'),
                    start_time: lodash.get(scope.options, 'field.start_time', 'start_time'),
                    end_date: lodash.get(scope.options, 'field.end_date', 'end_date'),
                    end_time: lodash.get(scope.options, 'field.end_time', 'end_time'),
                    time_zone: lodash.get(scope.options, 'field.time_zone', 'time_zone'),
                };
                
                var time_slot_picker_dom = elem.find('.sod-time-slot-picker'),
                    // time_picker_dom = elem.find('.sod-time-slot-picker .time'),
                    start_date_picker_dom = elem.find('.sod-time-slot-picker .date.start'),
                    end_date_picker_dom = elem.find('.sod-time-slot-picker .date.end'),
                    start_time_picker_dom = elem.find('.sod-time-slot-picker .time.start'),
                    end_time_picker_dom = elem.find('.sod-time-slot-picker .time.end')
                ;

                ctrl.$formatters.push(function(modelValue) {
                    return {
                        start_date: lodash.get(modelValue, fields.start_date, ''),
                        start_time: lodash.get(modelValue, fields.start_time, ''),
                        end_date: lodash.get(modelValue, fields.end_date, ''),
                        end_time: lodash.get(modelValue, fields.end_time, ''),
                        time_zone: lodash.get(modelValue, fields.time_zone, ''),
                    };
                });

                // ctrl.$viewChangeListeners.push(function() {
                //     setValueFromExternal();
                // });

                scope.setValue = setValueFromExternal;
                scope.render = function() {
                    ctrl.$render();
                };

                scope.$watch('start_date + start_time + end_date + end_time + time_zone', function() {
                   setValue();
                });
                // scope.$watch(function() {
                //     return ctrl.$modelValue;
                // }, function() {
                //    console.log(ctrl.$modelValue);
                // });

                ctrl.$render = function() {
                    setValueFromExternal();
                };

                ctrl.$parsers.push(function(viewValue) {
                    viewValue.start_date = moment(viewValue.start_date, formatDisplay).format(formatValue);
                    viewValue.end_date = moment(viewValue.end_date, formatDisplay).format(formatValue);
                    return viewValue;
                });


                initPickers();

                function setValueFromExternal() {
                    var start_date = moment(ctrl.$viewValue.start_date, formatValue);
                    var end_date = moment(ctrl.$viewValue.end_date, formatValue);

	                  scope.start_date = start_date.isValid() ? start_date.format(formatDisplay) : "";
	                  scope.end_date = end_date.isValid() ? end_date.format(formatDisplay) : "";
                    scope.start_time = ctrl.$viewValue.start_time;
                    // scope.end_date = ctrl.$viewValue.end_date;
                    scope.end_time = ctrl.$viewValue.end_time;
                    scope.time_zone = ctrl.$viewValue.time_zone;
                }

                function setValue() {
                    ctrl.$setViewValue({
                        [fields.start_date]: scope.start_date,
                        [fields.start_time]: scope.start_time,
                        [fields.end_date]: scope.end_date,
                        [fields.end_time]: scope.end_time,
                        [fields.time_zone]: scope.time_zone,
                    });
                }

                function initPickers() {
                    var remote_dp_options = generateDatepickerOptions(lodash.get(scope.options, 'datepicker', {}));
                    var lang = angular.element('html').attr('lang');

                    var time_options = {
                        'showDuration': true,
                        'timeFormat': 'g:i a',
                        'disableTextInput': true,
                        'language': lang,
                        'step': lodash.get(scope.options, 'step', 15)
                        // 'minTime': '2:00pm',
                    };

                    var date_options = angular.merge(
                        {
                            'autoclose': true,
                            'orientation': 'auto bottom',
                            'language': lang,
                        },
                        remote_dp_options,
                        {
                            'format': {
                                toDisplay: function(date, format, language) {
                                    return moment(date, formatValue).format(formatDisplay);
                                },
                                toValue: function(date, format, language) {
                                    return moment(date, 'YYYY-M-D').format('D MMM YYYY');
                                }
                            }
                        }
                    );




                    start_time_picker_dom.timepicker(angular.merge(
                        time_options,
                        lodash.get(scope.options.timepicker, {})
                    ));
                    end_time_picker_dom.timepicker(angular.merge(
                        time_options,
                        lodash.get(scope.options.timepicker, {})
                    ));

                    start_date_picker_dom.datepicker(date_options)
                        .on('changeDate', function(e) {
                            // console.log('changeDate');
                            if (lodash.has(remote_dp_options, 'startDate')) {
                                // var start_date_moment = moment(e.date);
                                // var current_date_time = moment();
                                start_time_picker_dom.timepicker('option', 'minTime', null);
                                start_time_picker_dom.timepicker('option', 'maxTime', null);
                                /*if (start_date_moment.isSame(current_date_time, 'day')) {
                                    var min_time_str = current_date_time.startOf('hour').add(1,'hour').format('h:mma');
                                    var end_of_day_str = current_date_time.endOf('day').format('h:mma');
                                    start_time_picker_dom.timepicker('option', 'minTime', min_time_str);
                                    start_time_picker_dom.timepicker('option', 'maxTime', end_of_day_str);
                                } else {
                                    start_time_picker_dom.timepicker('option', 'minTime', null);
                                    start_time_picker_dom.timepicker('option', 'maxTime', null);
                                }*/
                            }
                        });
                    end_date_picker_dom.datepicker(date_options);

                    var currentDate = new Date();
                    // console.log(currentDate);

                    // initialize datepair
                    var datePairObj = new Datepair(time_slot_picker_dom[0], {
                        updateTime: function(input, dateObj){
                            var momentObj =  moment(dateObj);

                            if (angular.element(input).hasClass('time start')) {
                                scope.start_time = momentObj.format('h:mm a');
                                elem.find('.time.start').timepicker('setTime', scope.start_time);
                                input.value = momentObj.format('h:mm a');
                            } else {
                                scope.end_time = momentObj.format('h:mm a');
                                elem.find('.time.end').timepicker('setTime', scope.end_time);
                                input.value = momentObj.format('h:mm a');
                            }
                            // console.log(angular.element(input));
                            // scope.end_time = input.value;
                            scope.$apply();
                        },
                        setMinTime: new Date(),
                    });
                    // datePairObj.
                }

                function generateDatepickerOptions(dp_options) {
                    if (lodash.has(dp_options, 'startDate')) {
                        var dp_start_date = dp_options.startDate;
                        var start_date = new Date(dp_start_date.year, dp_start_date.month - 1, dp_start_date.day);
                        dp_options.startDate = start_date
                    }
                    return dp_options;
                }
            }
        };
    }
})();
// TODO: DEPRECATED
(function () {
    'use strict';

    sodTooltip.$inject = ['$document', 'lodash', '$timeout'];
    angular
        .module('sodCommon')
        .directive('sodTooltip', sodTooltip);

    function sodTooltip($document, lodash, $timeout) {
        return {
            restrict: 'E',
            controller: sodTooltipCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/components/sod-tooltip',
            scope: {
                content: '=',
                options: '=?',
                hide: '=?',
            },
            link: sodTooltipLink
        };
        function sodTooltipLink(scope, elem, attr) {
            var vm = scope.vm,
                //dropdown = elem.find('.dropdown'),
                popOverActionElem = elem.find('.tooltip-action-wrapper .fa');

            popOverActionElem.on('click', sodPopoverActionClick);
            $document.on('click', onDocumentClick);

            elem.find('.sod-popover').addClass(attr.class);

            scope.$on('$destroy', function () {
                popOverActionElem.off('click', sodPopoverActionClick);
                $document.off('click', onDocumentClick);
            });

            function sodPopoverActionClick(e) {
                e.preventDefault();
                vm.toggle();
                scope.$apply();
            }

            function onDocumentClick(e) {
                const toggleOptions = lodash.get(vm, 'options', 'toggleable', true);
                if (!toggleOptions) { return; }

                var parents = angular.element(e.target).parents('#' + attr.id + ', .item.active[data-value]');
                if (parents.length == 0) {
                    if (vm.toggleState) {
                        vm.toggle();
                        scope.$apply();
                    }
                }
            }
        }
    }

    function sodTooltipCtrl() {
        var vm = this;
        this.$onInit = function() {
            vm.toggleState = false;

            vm.toggle = toggle;

            function toggle() {
                vm.toggleState = !vm.toggleState;
            }
        }
    }
})();
(function() {
    'use strict';

    sodTopbarMenuDirective.$inject = ['$document', 'uriActiveLinkService'];
    angular
        .module('Controllers')
        .directive('sodTopbarMenu', sodTopbarMenuDirective);

    function sodTopbarMenuDirective($document, uriActiveLinkService) {
        return {
            restrict: 'A',
            link: sodTopbarMenuDirectiveLink
        };

        function sodTopbarMenuDirectiveLink(scope, elem) {
            $document.on('click', function() {
                //e.preventDefault();
                if (isShown()) {
                    elem.removeClass('is-active');
                    elem.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
                }
            });

            elem.on('click', function(e) {
                e.stopPropagation();
                if (isShown()) {
                    elem.removeClass('is-active');
                    elem.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
                } else {
                    var otherIsActiveDoms = $document.find('li.has-submenu.is-active');
                    otherIsActiveDoms.removeClass('is-active');
                    otherIsActiveDoms.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
                    elem.addClass('is-active');
                    elem.find('.menu.submenu.is-dropdown-submenu').addClass('js-dropdown-active');
                }
            });

            elem.on('click', '> ul > li > a', function(e) {
                e.stopPropagation();
                elem.removeClass('is-active');
                elem.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
            });

            function isShown() {
                return elem.hasClass('is-active');
            }

            scope.isActive = function(path) {
                return uriActiveLinkService(path);
            };
        }
    }
})();
(function () {
    'use strict';

    sodSvgCtrl.$inject = ['$scope', '$compile', '$templateCache', '$element'];
    angular
        .module('sodCommon')
        .directive('sodSvg', sodSvg);

    function sodSvg() {
        return {
            scope: {
                type: '@'
            },
            controller: sodSvgCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function sodSvgCtrl($scope, $compile, $templateCache, $element) {
        var vm = this;
        var cloneElement = null;

        this.$onInit = function() {
            var templateUrl = 'common/components/svg/' + vm.type;
            var html = '<div class="' + vm.type + '">' + $templateCache.get(templateUrl) + '</div>';
            $element.html(html);
            cloneElement = $compile($element.contents())($scope);
            $scope.$on('$destroy', scopeDestroy);
        }

        function scopeDestroy() {
            cloneElement.off();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodTaggingDisplay', sodTaggingDisplay);

    function sodTaggingDisplay() {
        return {
            restrict: 'E',
            templateUrl: 'common/components/tagging/display',
            require: 'ngModel',
            scope: {
                options: '=?',
            },
            link: function(scope, elem, attr, ctrl) {
                scope.tags = [];
                ctrl.$render = function() {
                    scope.tags = ctrl.$viewValue;
                }
            }
        };
    }
})();
(function () {
    'use strict';

    sodTaggingInput.$inject = ['lodash', '$templateCache'];
    var EVENTS = {
        'ready': 'sodTaggingInput:ready'
    };

    angular
        .module('sodCommon')
        .directive('sodTaggingInput', sodTaggingInput);

    function sodTaggingInput(lodash, $templateCache) {
        sodTaggingInputCtrl.$inject = ['$scope', '$element', '$interval', '$timeout', 'lodash', 'GenericModel', '$compile'];
        return {
            restrict: 'E',
            scope: {
                addItem: '&',
                options: '=?',
                tags: '=?',
            },
            templateUrl: 'common/components/tagging/input',
            controller: sodTaggingInputCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodTaggingInputCtrl($scope, $element, $interval, $timeout, lodash, GenericModel, $compile) {
            var vm = this;
            this.$onInit = function() {
                vm.intervals = {};
                vm.timeouts = {};
                vm.windowsOn = {};
                vm.toBeDestroyed = {};

                $timeout(function() {
                    init();
                });
                //
                $element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        // scope.$apply(function (){
                        //     scope.$eval(attrs.myEnter);
                        // });

                        event.preventDefault();
                    }
                });
            }

            function init() {
                vm.$findInputSodTaggingInput = $element.find('input.sod-tagging__input');

                getSodTaggingInput();
                getAriaOwnsId();
                emitReady();

                initAutoComplete();
                initAutoCompleteEvents();

                initDropDownStyleWidth();
                initWindowResizeSetDropDownWidth();

                initEvents();
            }

            function getSodTaggingInput() {
                vm.intervals.getSodTaggingInput = $interval(function () {
                    vm.$sodTaggingInput = vm.$findInputSodTaggingInput.length ?
                        lodash.head(vm.$findInputSodTaggingInput) : null;

                    if (vm.$sodTaggingInput) {
                        $interval.cancel(vm.intervals.getSodTaggingInput);
                    }
                }, 300);
            }

            function getAriaOwnsId() {
                vm.intervals.getAriaOwnsId = $interval(function () {
                    var hasAriaOwnsAttr = vm.$sodTaggingInput.hasAttribute('aria-owns');

                    if (vm.$sodTaggingInput && hasAriaOwnsAttr) {
                        vm.ariaOwnsId = vm.$sodTaggingInput.getAttribute('aria-owns');
                        $interval.cancel(vm.intervals.getAriaOwnsId);
                    }
                }, 300);
            }

            function emitReady() {
                vm.intervals.emitReady = $interval(function () {
                    if (vm.$sodTaggingInput && vm.ariaOwnsId) {
                        $scope.$emit(EVENTS.ready);
                        $interval.cancel(vm.intervals.emitReady);
                    }
                }, 300);
            }

            function initDropDownStyleWidth() {
                vm.intervals.initDropDownStyleWidth = $interval(function () {
                    var executed = onResizeDropDownWidth();
                    if (executed) {
                        $(vm.$findInputSodTaggingInput).prop('disabled', false);
                        $interval.cancel(vm.intervals.initDropDownStyleWidth);
                    }
                }, 300);
            }

            function initWindowResizeSetDropDownWidth() {
                vm.windowsOn.initWindowResizeSetDropDownWidth = {
                    type: 'resize',
                    cb: function () {
                        $scope.$apply(function () {
                            onResizeDropDownWidth();
                        });
                    }
                };

                $(window).on(
                    vm.windowsOn.initWindowResizeSetDropDownWidth.type,
                    vm.windowsOn.initWindowResizeSetDropDownWidth.cb
                );
            }

            function onResizeDropDownWidth() {
                if (vm.ariaOwnsId && vm.$sodTaggingInput) {
                    setDropDownStyleWidth();

                    return true;
                }

                return false;
            }

            function setSodTaggingInputWidth() {
                if (vm.$sodTaggingInput) {
                    vm.sodTaggingInputWidth = lodash.get(vm.$sodTaggingInput.getBoundingClientRect(), 'width');
                }
            }

            function setDropDownStyleWidth() {
                if (vm.ariaOwnsId) {
                    var $dropdownMenu = document.getElementById(vm.ariaOwnsId);
                    if ($dropdownMenu) {
                        setSodTaggingInputWidth();
                        $dropdownMenu.style.width = vm.sodTaggingInputWidth + 'px';
                    }
                }
            }

            function initAutoComplete() {
                var defaultOptions = {hint: false};
                var options = lodash.get(vm, 'options.autocomplete', defaultOptions);

                var dataset = getDataset();

                vm.$autocomplete = $(vm.$findInputSodTaggingInput).autocomplete(options, dataset);
                vm.toBeDestroyed.autocomplete = function () {
                    if (vm.$findInputSodTaggingInput) {
                        $(vm.$findInputSodTaggingInput).autocomplete('destroy');
                    }
                };

                function appendDataIfEmpty(query, data) {
                    var singleOption = {};
                    singleOption[lodash.get(vm, 'options.schema.label')] = query;
                    var hasOption = hasOptionOrTag(data, singleOption);

                    if (!hasOption) {
                        if (!hasOptionOrTag(vm.tags, singleOption)) {

                            return [singleOption].concat(data);
                        } else {
                            singleOption.added = true;
                            return [singleOption].concat(data);
                        }
                    }
                    //
                    return data;
                }

                function getDataset() {
                    return [{
                        source: function (query, cb) {
                            prepareSearchEndpoint();
                            if (vm.search_resource) {
                                vm.loading = true;
                                vm.search_resource[vm.search_method]({
                                    query: query,
                                }).$promise.then(function (res) {
                                    var dataset = determineAdded(res.data);

                                    var appendedDataIfEmpty = appendDataIfEmpty(query, dataset);
                                    cb(appendedDataIfEmpty);
                                    vm.loading = false;
                                });
                            } else {
                                var dataset = [];
                                var filteredOptions = lodash.filter(dataset, function (option) {
                                    return !hasOptionOrTag(vm.tags, option);
                                });

                                var appendedDataIfEmpty = appendDataIfEmpty(query, filteredOptions);

                                cb(appendedDataIfEmpty);
                            }

                            cb(appendedDataIfEmpty);
                        },
                        debounce: 400,
                        displayKey: lodash.get(vm, 'options.schema.label'),
                        templates: {
                            suggestion: function (suggestion) {
                                if (!lodash.has(suggestion, 'id')) {
                                    if (!hasOptionOrTag(vm.items, suggestion)) {
                                        var _template = TemplateEngine(
                                            $templateCache.get(lodash.get(vm, 'options.addTemplateUrl')),
                                            suggestion
                                        );
                                        return _template;
                                    }
                                } else {
                                    var _template = TemplateEngine(
                                        $templateCache.get(lodash.get(vm, 'options.templateUrl')),
                                        suggestion
                                    );
                                    return _template;
                                }
                                //
                                // return !lodash.has(suggestion, 'id') ?
                                //     TemplateEngine(
                                //         $templateCache.get(lodash.get(vm, 'options.addTemplateUrl')),
                                //         suggestion
                                //     ) : TemplateEngine(
                                //         $templateCache.get(lodash.get(vm, 'options.templateUrl')),
                                //         suggestion
                                //     );
                            },
                        },
                        cache: false,
                    }];
                }

                function determineAdded(data) {
                    return data.map(function (_item) {
                        var match = lodash.find(vm.tags, {select_id: _item.select_id});
                        if (match) {
                            _item.added = true;
                        }
                        return _item;
                    });
                }

                function hasOptionOrTag(items, item) {
                    var foundTag = lodash.findIndex(items, function (oItem) {
                        return lodash.lowerCase(
                            oItem[lodash.get(vm, 'options.schema.label')]
                        ) === _.lowerCase(
                            item[lodash.get(vm, 'options.schema.label')]
                        );
                    });
                    return foundTag >= 0;
                }
            }

            function initDropDownMenu(event) {
                vm.$dropdownMenu = new Tether({
                    element: document.getElementById(vm.ariaOwnsId),
                    target: vm.$sodTaggingInput,
                    attachment: 'top left',
                    targetAttachment: 'bottom left',
                    constraints: [
                        {
                            to: 'scrollParent',
                            attachment: 'together',
                            pin: true
                        },
                    ],
                });

                vm.toBeDestroyed.dropDownMenu = function () {
                    if (lodash.get(vm, '$dropdownMenu', false)) {
                        vm.$dropdownMenu.destroy();
                    }
                };
            }

            function initAutoCompleteEvents() {
                function handleAddItem(item) {
                    vm.addItem({item: item});
                    clearCurrentState();
                }

                function clearCurrentState() {
                    $(vm.$findInputSodTaggingInput).autocomplete('val', '');
                    // $(vm.$findInputSodTaggingInput).blur();

                    vm.timeouts.sodTaggingInputRefocus = $timeout(function () {
                        $(vm.$findInputSodTaggingInput).focus();
                    }, 300);
                }

                vm.$autocomplete.on(
                    'autocomplete:selected',
                    function (event, suggestion, dataset) {
                        $scope.$apply(function () {
                            if (!lodash.isEmpty(suggestion)) {
                                handleAddItem(suggestion)
                            }
                        });
                    }
                );

                vm.$autocomplete.on(
                    'autocomplete:updated',
                    function () {
                        onResizeDropDownWidth();
                    }
                );

                vm.$autocomplete.on(
                    'autocomplete:closed',
                    function () {
                        clearCurrentState();
                    }
                );


                // vm.$autocomplete.on(
                //     'autocomplete:opened',
                //     function () {  }
                // );


            }

            function initEvents() {
                $scope.$on(EVENTS.ready, initDropDownMenu);

                $scope.$on('$destroy', function () {
                    lodash.forEach(lodash.keys(vm.timeouts), function (oTimeout) {
                        $timeout.cancel(lodash.get(vm.timeouts, oTimeout));
                    });

                    lodash.forEach(lodash.keys(vm.intervals), function (oInterval) {
                        $interval.cancel(lodash.get(vm.timeouts, oInterval));
                    });

                    lodash.forEach(lodash.keys(vm.windowsOn), function (oWindowsOn) {
                        $(window).off(
                            lodash.get(oWindowsOn, 'type'),
                            lodash.get(oWindowsOn, 'cb')
                        );
                    });

                    lodash.forEach(lodash.keys(vm.toBeDestroyed), function (oToBeDestroyed) {
                        lodash.get(vm.toBeDestroyed, oToBeDestroyed, function () {
                        })();
                    });
                });
            }

            function TemplateEngine(html, options) {
                // var re = /<%([^%>]+)?%>/g, reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g, code = 'var r=[];\n', cursor = 0, match;
                // var add = function(line, js) {
                //     js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
                //         (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
                //     return add;
                // };
                // while(match = re.exec(html)) {
                //     add(html.slice(cursor, match.index))(match[1], true);
                //     cursor = match.index + match[0].length;
                // }
                // add(html.substr(cursor, html.length - cursor));
                // code += 'return r.join("");';
                // return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);

                var optionScope = $scope.$new(true);
                optionScope.optionModel = options;
                return $compile(html)(optionScope);

            };

            function prepareSearchEndpoint() {
                // var url = lodash.get(vm.opt)
                if (!vm.search_resource) {

                    var url = lodash.get(vm.options, 'search_route.url', null);

                    vm.search_resource = (url) ? new GenericModel(url) : null;
                    vm.search_method = lodash.get(vm.options, 'search_route.method', 'query');
                }
            }

            function checkIfAdded(dataset) {
                return dataset.map(function ($_item) {
                    if (lodash.filter(vm.tags, {searchText: $_item.searchText}).length > 0) {
                        return $_item._added = true;
                    }
                });
            }
        }
    }
})();
(function () {
    'use strict';

    sodTaggingItem.$inject = ['$compile', '$templateCache'];
    sodTaggingItemCtrl.$inject = ['$scope', '$compile', '$templateCache', 'lodash', '$element'];
    angular
        .module('sodCommon')
        .directive('sodTaggingItem', sodTaggingItem);

    function sodTaggingItem($compile, $templateCache) {
        return {
            restrict: 'E',
            scope: {
                removeItem: '&?',
                tag: '=',
                options: '=?',
                type: '@?',
            },
            // templateUrl: function(elem, attrs) {
            //     if (attrs.template) {
            //         return attrs.template;
            //     }
            //
            //     return 'common/components/tagging/item';
            // },
            link: function(scope, elem, attr, ctrl) {
                scope.readonly = true

                scope.item.label = scope.tag[scope.options.schema.label];

                if (typeof scope.removeItem === typeof function() {}) {
                    scope.readonly = false;
                }
            },
            controller: sodTaggingItemCtrl,
        };
    }

    function sodTaggingItemCtrl($scope, $compile, $templateCache, lodash, $element) {
        this.$onInit = function() {
            $scope.item = {
                showTooltip: showTooltip,
            };

            var type = !!$scope.type ? $scope.type : 'default';
            var templateUrl = lodash.get($scope.options, 'itemTemplateUrl.' + type, 'common/components/tagging/item');

            var template = $templateCache.get(templateUrl);

            $element.html(template);

            var compileScope = $scope;
            var cloneElement = $compile($element.contents())(compileScope);

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }

        function showTooltip() {
            if ($scope.item.label.length > 12) {
                return true;
            }
            return false;
        }
    }
})();
(function () {
    'use strict';

    sodTagging.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .directive('sodTagging', sodTagging);

    function sodTagging(lodash) {

        window.sodTagging = {};

        var TO_BE_ADDED = 'TO_BE_ADDED';
        lodash.set(window.sodTagging, ['enum', TO_BE_ADDED].join('.'), TO_BE_ADDED);

        var TO_BE_REMOVED = 'TO_BE_REMOVED';
        lodash.set(window.sodTagging, ['enum', TO_BE_REMOVED].join('.'), TO_BE_REMOVED);

        var NO_CHANGE = 'NO_CHANGE';
        lodash.set(window.sodTagging, ['enum', NO_CHANGE].join('.'), NO_CHANGE);

        var __initial = '__initial';
        lodash.set(window.sodTagging, ['enum', __initial].join('.'), __initial);

        var __action = '__action';
        lodash.set(window.sodTagging, ['enum', __action].join('.'), __action);

        return {
            restrict: 'E',
            templateUrl: 'common/components/tagging/tagging',
            require: 'ngModel',
            scope: {
                options: '=',
            },
            link: function(scope, elem, attr, ctrl) {
                scope.local = {
                    add: add,
                    remove: remove,
                    existingTags: [],
                    toBeRemovedTags: [],
                };

                scope.local.tags = [];
                ctrl.$render = function() {
                    scope.local.tags = ctrl.$viewValue || [];
                    markInitialTags();

                    updateTags();
                };

                function markInitialTags() {
                    scope.local.tags = lodash.map(
                        lodash.get(scope, 'local.tags', []),
                        function (tag) {
                            var defaultObj = {};
                            lodash.set(defaultObj, window.sodTagging.enum.__initial, true);
                            lodash.set(defaultObj, window.sodTagging.enum.__action, window.sodTagging.enum.NO_CHANGE);
                            return Object.assign(defaultObj, tag);
                        }
                    );
                }

                function updateTags() {
                    var tagActionFilter = function(actions) {
                        actions = actions || [];
                        return function (oTag) {
                            return lodash.indexOf(actions, lodash.get(oTag, __action, null)) >= 0;
                        }
                    };
                    scope.local.existingTags = lodash.filter(scope.local.tags, tagActionFilter([NO_CHANGE, TO_BE_ADDED]));
                    scope.local.toBeRemovedTags = lodash.filter(scope.local.tags, tagActionFilter([TO_BE_REMOVED]));
                    ctrl.$setViewValue(scope.local.tags);
                }

                function add(item) {
                    if (!exists(item)) {
                        var defaultObj = {};
                        lodash.set(defaultObj, window.sodTagging.enum.__action, window.sodTagging.enum.TO_BE_ADDED);
                        lodash.set(defaultObj, 'value', lodash.get(item, getSchemaProp(item)));
                        scope.local.tags = scope.local.tags.concat([Object.assign(defaultObj, item)]);
                    } else {
                        var isInitial = lodash.get(item, window.sodTagging.enum.__initial, false);

                        if (isInitial) {
                            scope.local.tags = setTagAndReturnTags(item,  window.sodTagging.enum.NO_CHANGE);
                        }
                    }
                    // ctrl.$setViewValue(scope.local.tags);
                    updateTags();
                }

                function exists(item) {
                    var tmpItem = {};
                    var schemaProp = getSchemaProp(item);
                    lodash.set(tmpItem, schemaProp, lodash.get(item, schemaProp));

                    return lodash.findIndex(scope.local.tags, tmpItem) >= 0;
                }

                function remove(item) {
                    var isInitial = lodash.get(item, window.sodTagging.enum.__initial, false);

                    if (isInitial) {
                        setTagAndReturnTags(item, window.sodTagging.enum.TO_BE_REMOVED);
                    } else {
                        var tmpItem = {};
                        var schemaProp = getSchemaProp(item);
                        lodash.set(tmpItem, schemaProp, lodash.get(item, schemaProp));

                        lodash.remove(scope.local.tags, tmpItem);
                    }
                    // ctrl.$setViewValue(scope.local.tags);
                    updateTags();
                }

                function getSchemaProp(item) {
                    return lodash.get(scope, getSchemaPropPathString(item));
                }
                
                function getSchemaPropPathString(item) {
                    return [
                        'options',
                        'options',
                        'schema',
                        !lodash.has(item, 'id') ? 'label' : 'key'
                    ].join('.');
                }

                function setTagAndReturnTags(tag, action) {
                    var finalAction = (tag[window.sodTagging.enum.__action] == action) ? window.sodTagging.enum.NO_CHANGE : action;

                    lodash.set(
                        tag,
                        window.sodTagging.enum.__action,
                        // tag[window.sodTagging.enum.__action] == action ? null : action
                        finalAction
                    );



                    // return lodash.map(scope.local.tags, function (oTag) {
                    //     var found = lodash.get(oTag, 'id', null) === lodash.get(tag, 'id', undefined);
                    //     if (found) {
                    //         var defaultObj = {};
                    //         lodash.set(
                    //             defaultObj,
                    //             window.sodTagging.enum.__action,
                    //             // tag[window.sodTagging.enum.__action] == action ? null : action
                    //             action
                    //         );
                    //         return Object.assign(oTag, defaultObj);
                    //     }
                    //
                    //     return oTag;
                    // })
                }
            }
        };
    }

})();
(function () {
    'use strict';

    validatorRequired.$inject = ['lodash'];
    angular
        .module('sodCommon')
        .directive('validatorRequired', validatorRequired);

    function validatorRequired(lodash) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.required = function(modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return false;
                    } else {
                        return true;
                    }
                };

                elm.on('blur', function() {
                    scope.$apply(function () {
                        lodash.set(scope, [
                            'form',
                            attrs.validatorRequired,
                            '$error',
                            'required',
                        ].join('.'), lodash.get(ctrl, '$error.required', false));
                    })
                });
            },
        };
    }
})();
(function () {
    'use strict';

    handleActionCall.$inject = ['ActionManager'];
    angular
        .module('ActionManager')
        .factory('handleActionCall', handleActionCall);

    function handleActionCall(ActionManager) {
        return function(actionName, actionOptions, actionData, panel, evtData) {
            if (actionName.split('-')[0] === 'ap') {
                return ActionManager(actionName, panel, actionOptions, actionData, evtData);
            }
            if (actionName.split('-')[0] !== 'ap') {
                return ActionManager(actionName, actionOptions, actionData, evtData);
            }
            return null;
        };
    }
})();
/**
 * Handles Actions triggered by events. Equivalent to redux
 * Only Actions can manipulate the state of a panel
 * This manager only handles actions processing. Individual actions is a service on its own.
 *      -> This allow us to expand the support of more customized actions in future.
 */
(function () {
    'use strict';

    ActionManagerGet.$inject = ['SodLogger', '$injector'];
    angular
        .module('ActionManager')
        .provider('ActionManager', ActionManager);

    function ActionManager() {

        return {
            setConfig: setConfig,
            $get: ActionManagerGet
        };

        function setConfig() {

        }
    }

    function ActionManagerGet(SodLogger, $injector) {
        return function () {
            if (arguments.length === 0) {
                SodLogger.warn('ActionManager: No Action Name Provided');
                return;
            }

            const actionName = arguments[0];
            const args = Array.prototype.slice.call(arguments, 1);
            const action = $injector.get('action-' + actionName);
            SodLogger.debug('ActionManager', actionName);
            return action.apply(null, args);
        };
    }
})();
(function () {
    'use strict';

    ActionCommon.$inject = ['$injector', 'ActionModel', 'lodash', '$rootScope'];
    angular
        .module('SodCustomAction')
        .factory('ActionCommon', ActionCommon);

    function ActionCommon($injector, ActionModel, lodash, $rootScope) {
        return {
            show_floating_notifier: show_floating_notifier,
            show_static_notifier: show_static_notifier,
            show_dialog: show_dialog
        };

        function show_floating_notifier(data) {
            var notifier = $injector.get('notifier');
            notifier.notify({
                template: data.template || '&nbsp;',
                hasDelay: data.hasDelay || true,
                delay: data.delay || 3000,
                type: data.type || '', // default success warning info error
                position: data.position || 'top center'
            });
        }

        function show_static_notifier(data) {
            // {
            //     name: viewModel.options.form.name,
            //     message:'Test 123',
            //     // classes: 'error',
            //     // icon: 'exclamation-triangle',
            //     classes: 'success-inverted text-center',
            //     type: 'success-animated',
            //     delay: 3000
            // }
            // Either use classes with icon, or success-inverted with type

            var $timeout = $injector.get('$timeout');
            $timeout(function() {
	            ActionModel.set('static-notifier', data.name, data);
	            if (lodash.has(data, 'delay') && data.delay !== null) {
		            $timeout(function() {
			            ActionModel.set('static-notifier', data.name, {});
		            }, data.delay);
	            }
            });
        }

        function show_dialog(data, model) {
            var ModalService = $injector.get('ModalService'),
                ButtonRegistry = $injector.get('ButtonRegistry'),
                ListFilterStateFactory = $injector.get('ListFilterStateFactory');
            ModalService.showModal({
                templateUrl: data.templateUrl,
                controller: data.controller,
                controllerAs: 'vm',
                appendElement: angular.element('.modal-wrapper'),
                inputs: {
                    dialogModel: model,
                    dialogOptions:  lodash.get(data,'dialogOptions', {})
                }
            }).then(function (modal) {
                dialogManipulatePace(true);
                ButtonRegistry.clearAllLoading();
                modal.info = model;
                modal.element.show();
                modal.close.then(function (result) {
                    var refreshGrid = lodash.get(result, 'datasourceRefresh', false);
                    if (refreshGrid) {
                        var listFilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                        listFilterService.refreshGrid();
                    }
                    dialogManipulatePace(false);
                });
            });
        }

        function dialogManipulatePace(state) {
            if (state) {
                angular.element('body').addClass('dialog-active');
            } else {
                angular.element('body').removeClass('dialog-active');
            }
        }
    }
})();

/**
 * ActionProvider that executes possible actions after an event occurs.
 */
(function () {
    'use strict';

    ActionFactory.$inject = ['Request', 'lodash', 'Path', '$window', '$timeout', 'ModalService', 'DatasourceRegistry', 'NotificationService', 'MasterLayoutService', '$http', 'ButtonRegistry', '$injector', 'FormBuilderService', 'ActionCommon', 'ListFilterStateFactory'];
    angular
        .module('SodCustomAction')
        .factory('Action', ActionFactory);

    function ActionFactory(Request, lodash, Path, $window, $timeout,
                           ModalService, DatasourceRegistry, NotificationService, MasterLayoutService, $http,
                           ButtonRegistry, $injector, FormBuilderService, ActionCommon, ListFilterStateFactory) {
        var controller = {};
        return {
            run: function (event, actions, content, eventData, scope) {
                controller[event] = new ctrl(event, actions, content, eventData, scope);
                controller[event].run();
            },
            closeDialogActions: function () {
                return {
                    dialog_close_quick: {}
                };
            },
            reverseMapField: function (schema, rules) {
                var result = {};
                for (var key in rules) {
                    result[schema[key]] = rules[key];
                }
                return result;
            }
        };

        function ctrl(event, actions, content, eventData, scope) {
            return {
                run: function () {
                    // need a control to allow step by step execution of actions?
                    angular.forEach(actions, function (action, actionType) {
                        if (lodash.has(action, 'dialogTemplate')) {
                            this['confirmation'](action, actionType);
                        } else {
                            this[actionType](action);
                        }
                    }, this);
                },
                notification: function (data) {
                    NotificationService.set(data);
                },
                redirect: function (data) {
                    var sub_id = '';
                    if (data.sub_id) {
                        sub_id = lodash.get(eventData.model, data.sub_id, '');
                    }
                    var _path = Path.replace(data.destination, sub_id);
                    Path.redirect(_path);
                },
                download: function (data) {
                    var _path = data.route;
                    window.location.href = _path;
                },
                redirect_external: function (data) {

                    if (data.history_path) {
                        var _path = Path.replace(data.history_path);
                        window.history.pushState({}, '', _path);
                    }

                    $window.location.href = data.destination;
                },
                back_to_previous: function () {
                    $window.history.back();
                },
                grid_item_redirect: function (data) {
                    // get the grid object from sender wrapper
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');

                    // get the selected data
                    var dataItem = grid.dataItem(eventData.target.parents('tr'));

                    // generate the path
                    //var _path = Path.replace(data.destination, lodash.get(dataItem, 'schema.key', dataItem['id']));
                    var _path = decodeURI(data.route).replace(new RegExp('<id>', 'g'), dataItem.id);
                    // redirect
                    Path.redirect(_path);
                },

                grid_item_download: function (data) {
                    // get the grid object from sender wrapper
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');

                    // get the selected data
                    var dataItem = grid.dataItem(eventData.target.parents('tr'));

                    // generate the path
                    //var _path = Path.replace(data.destination, lodash.get(dataItem, 'schema.key', dataItem['id']));
                    var _path = decodeURI(data.route).replace(new RegExp('<id>', 'g'), dataItem.id);
                    window.location.href = _path;
                    // // redirect
                    // var anchor = angular.element('<a/>');
                    // anchor.attr({
                    //     href: _path,
                    //     target: '_self',
                    //     download: dataItem.candidate_profile_version_id + '.pdf'
                    // })[0].click();

                },
                grid_item_api_call: function (data) {
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');
                    var dataItem = grid.dataItem(eventData.target.parents('tr'));
                    var _path = decodeURI(data.route).replace(new RegExp('<id>', 'g'), dataItem.id);
                    var method = lodash.get(data, 'method', 'post');
                    var model = lodash.get(data, 'model', angular.copy(dataItem));
                    if (data.schema) {
                        model = this.set_schema(model, data.schema);
                    }

                    Request.run(method, _path, event, eventData, model);
                },

                grid_selected_api_call: function (data) {
                    // get the current listFilter object and get the model
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    var model = listfilterService.getSelectedModel();
                    var path = data.datasource.url;
                    var method = lodash.get(data.datasource, 'method', 'get');
                    // get the datasource/route
                    // send request
                    Request.run(method, path, event, eventData, model);
                },

                grid_mass_dialog: function (data) {
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    var model = listfilterService.getSelectedModel();
                    ActionCommon.show_dialog(data, model);
                },

                grid_row_dialog: function (data) {
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');
                    var dataItem = grid.dataItem(eventData.target.parents('tr')).toJSON();

                    ActionCommon.show_dialog(data, dataItem);
                },

                grid_clear_selected: function (data) {
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    listfilterService.clearSelected();
                },
                form_submit_selected: function (data) {
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    eventData.selected = listfilterService.getSelectedModel();
                    this.form_submit(data);
                },

                form_submit: function (data) {
                    var _path = Path.replace(data.route);
                    var model = eventData.model || content.model;

                    if (data.form_name.length > 0) {
                        var fbService = FormBuilderService.get(data.form_name);
                        model = fbService.model;
                        eventData.fbService = fbService;
                    }

                    if (data.schema) {
                        model = this.set_schema(model, data.schema);
                    }
                    Request.run(data.method, _path, event, eventData, model);
                },
                dialog_submit: function (data) {
                    var _path = Path.replace(data.destination);
                    Request.run(data.method, _path, event, eventData, content.dialogModel);
                },
                api_call: function (data) {

                    var _path = Path.replace(data.route);
                    var method = lodash.get(data, 'method', 'get');
                    var model = lodash.get(eventData, 'model', content.model);
                    if (data.model) {
                        model = lodash.merge({}, model, data.model);
                    }
                    if (data.schema) {
                        model = this.set_schema(model, data.schema);
                    }

                    Request.run(method, _path, event, eventData, model);
                },

                panel_api_call: function (data) {
                    var _path = Path.replace(data.route);
                    var method = lodash.get(data, 'method', 'get');
                    var PanelService = $injector.get('PanelRegistry');
                    var model = PanelService.get(data.panel_id, data.data_path);
                    Request.run(method, _path, event, eventData, model);
                },

                dialog_open: function (data) {
                    //var that = this;

                    if (lodash.has(data.dialogOptions, 'appendSelectedModel')) {
                        var modelKey = lodash.get(data.dialogOptions, 'appendSelectedModel.key', 'dialogOptions.form.model.selected');
                        var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                        var selected = listfilterService.getSelectedModel();
                        lodash.set(data, modelKey, selected);
                    }
                    //
                    ActionCommon.show_dialog(data);
                },

                validate: function (data) {
                    angular.element('label').removeClass('error');
                    angular.element('.error-message').remove();
                    content.validation = data;
                    this.scroll_to_error(data);
                    //ElementRegistry.setValidation(data);
                },

                set_schema: function (data, rules) {
                    var object = {};
                    for (var key in rules) {
                        lodash.set(object, key, angular.copy(lodash.get(data, rules[key], '')));
                    }
                    return object;
                },
                scroll_to_error: function (data) {
                    $timeout(function () {
                        if (data.summary) {
                            $('html,body').animate({
                                scrollTop: angular.element('.callout').offset().top - 50
                            }, 300);
                        } else {
                            $('html,body').animate({
                                scrollTop: angular.element('.error').offset().top - 50
                            }, 300);
                        }

                    });
                },
                set_model: function (data) {
                    content.model = angular.merge(data.clearModel, data.model);
                    if (lodash.has(content.model, 'hid_ref_form')) {
                        var formIdentifier = content.model.hid_ref_form;
                        var FormBuilderService = $injector.get('FormBuilderService');
                        var fbService = FormBuilderService.get(formIdentifier);
                        fbService.model = content.model;
                        lodash.set(fbService, 'fbData.model', content.model);
                    }
                },
                dom_manipulation: function (data) {
                    switch (data.type) {
                        case "add_class":
                            angular.element(data.dom).addClass(data.cssClass);
                            break;
                        case "remove_class":
                            angular.element(data.dom).removeClass(data.cssClass);
                            break;
                    }

                },
                update_panel_data: function (data) {
                    var PanelRegistry = $injector.get('PanelRegistry');
                    PanelRegistry.refresh(data.panel_id, data.panel);
                },
                confirmation: function (data, actionType) {
                    var that = this;
                    ModalService.showModal({
                        template: data.dialogTemplate,
                        controller: 'ConfirmationDialogCtrl',
                        controllerAs: 'vm',
                        appendElement: angular.element('.modal-wrapper'),
                        inputs: {
                            dialogOptions: data.dialogOptions
                        }
                    }).then(function (modal) {
                        modal.element.show();
                        modal.close.then(function (result) {
                            if (result) {
                                that[actionType](data);
                            } else {
                                ButtonRegistry.clearAllLoading();
                            }
                        });
                    });
                },

                datasource_refresh: function (data) {
                    if (data.datasource_name == 'ListFilterService') {
                        var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                        listfilterService.refreshGrid();
                    } else {
                        DatasourceRegistry.refresh(data.datasource_name);
                    }
                },
                datasource_refresh_all: function () {
                    DatasourceRegistry.refreshAll();
                },
                //update_tabstrip: function(data) {
                //    var datasource = DatasourceRegistry.get(data.name);
                //    var datasource = DatasourceRegistry.get(data.name);
                //    var index = lodash.findIndex(datasource.view(), function(item) a
                //        return item.title == data.title;
                //    });
                //    angular.element('.' + data.name).data('kendoTabStrip').select(index);
                //},
                //select_tabstrip: function(data) {
                //    var datasource = DatasourceRegistry.get(eventData.targetScope.description);
                //    var tab = lodash.find(datasource.data(), function(item) { return item.title == eventData.event.item.textContent });
                //    Path.selectTabstrip(tab.title.toLowerCase());
                //}

                // Todo: Some actions that can be created
                // 1. Loading overlay to prevent users from clicking on more button
                // 2. Remove the loading overlay
                // 3. Form validation: showing of error messages upon exception - Pending validation endpoint from backend
                // 4
                structure_refresh: function () {
                    //todo please refresh the structure
                    var currentPath = Path.getPathInfo();
                    scope.mainService.getStructure(currentPath);
                },
                masterpage_data_refresh: function () {
                    var navUrl = Path.getMasterLayoutDataPath();
                    $http.get(navUrl).then(function (res) {
                        if (res.data.success) {
                            MasterLayoutService.set(res.data.structure);
                        }
                    }, function () {
                    });
                },
                trigger_async_panel_event: function (data) {
                    const PanelManager = $injector.get('PanelManager');
                    const panel = PanelManager.getByPanelContentId(data.panel_content_id);
                    panel.emitEvent(data.event_name, data.event_data);
                },

                show_floating_notification: ActionCommon.show_floating_notifier,
                show_static_notification: ActionCommon.show_static_notifier
            };
        }
    }
})();

(function () {
    'use strict';

    actionCloseDialog.$inject = ['$q', 'lodash', 'DialogManager'];
    angular
        .module('dialog-manager')
        .factory('action-dm-close-dialog', actionCloseDialog);

    function actionCloseDialog($q, lodash, DialogManager) {
        return function (options) {
            return $q.when(run());

            function run() {
                const dialogId = lodash.get(options, 'dialogId', null);
                if (!dialogId) {
                    return DialogManager.closeAll();
                }
                return DialogManager.close(dialogId);
            }
        };
    }
})();

(function() {
    'use strict';

    DialogAsyncCtrl.$inject = ['dialogOptions', '$timeout', 'close', 'dialogId', '$compile', '$element', '$scope'];
    angular
        .module('dialog-manager')
        .controller('DialogAsyncCtrl', DialogAsyncCtrl);

    function DialogAsyncCtrl(dialogOptions, $timeout, close, dialogId, $compile, $element, $scope) {
        const vm = this;
        vm.show = false;
        vm.dialogOptions = dialogOptions;
        vm.options =  dialogOptions;

        vm.dismiss = dismiss;

        $timeout(function () {
            vm.show = true;
            const asyncPanelWrapper = $element.find('.async-panel-wrapper');
            asyncPanelWrapper.html(dialogOptions.async_panel_template);

            const cloneElement = $compile(asyncPanelWrapper.contents())($scope);

            $scope.$on('$destroy', function() {
                if (cloneElement) {
                    cloneElement.off();
                }
            });
        });

        function dismiss() {
            close(false);
        }
    }
})();
(function() {
    'use strict';

    DialogFormCtrl.$inject = ['dialogOptions', '$timeout', 'close'];
    angular
        .module('dialog-manager')
        .controller('DialogFormCtrl', DialogFormCtrl);

    function DialogFormCtrl(dialogOptions, $timeout, close) {
        const vm = this;
        vm.show = false;
        console.log('DialogFormCtrl loaded');
        vm.options =  dialogOptions;

        vm.dismiss = dismiss;
        vm.submit = submit;

        $timeout(function () {
            vm.show = true;
        });

        function dismiss() {
            close(false);
        }

        function submit() {
            close(vm.getModel());
        }
    }
})();
(function () {
    'use strict';

    DialogManager.$inject = ['lodash', '$q', 'ModalService', '$rootScope'];
    angular
        .module('dialog-manager')
        .factory('DialogManager', DialogManager);

    const avoidCPWS = ['bubbles', 'context', 'angular_id', 'innerHTML', '$root', '$parent', '$promise', '$resolved', 'window', '__proto__'];

    function DialogManager(lodash, $q, ModalService, $rootScope) {
        const dialogsRef = [];
        return {
            init: (dialogId, data) => {
                return showAndRegisterDialog(dialogId, data);
            },
            get: (dialogId) => {
                const dialogRefObj = findDialog(dialogId);
                return (dialogRefObj) ? dialogRefObj.modal : null;
            },
            getAll: () => {
                return dialogsRef;
            },
            getData: (dialogId, dataPath) => {
                const dialogRefObject = findDialog(dialogId);
                if (!dialogRefObject) return false;
                return lodash.get(dialogRefObject.modal.controller, dataPath, false);
            },
            hasDialog: (dialogId) => {
                const dialogRefObj = findDialog(dialogId);
                return !!dialogRefObj;
            },
            setData: (dialogId, dataPath, value) => {
                const dialogRefObject = findDialog(dialogId);
                if (!dialogRefObject) return false;
                return lodash.set(dialogRefObject.modal.controller, dataPath, value);
            },
            setOption: (dialogId, key, value) => {
                var dialog = findDialog(dialogId);
                lodash.set(dialog.modal, key, value);
            },
            close: (dialogId) => {
                return closeDialog(dialogId);
            },
            destroy: (dialogId) => {
                return closeDialog(dialogId);
            },
            destroyAll: () => {
                return closeAll();
            },
            closeAll: () => {
                return closeAll();
            }
        };

        function findDialog(dialogId) {
            return lodash.find(dialogsRef, {dialogId: dialogId});
        }

        function closeDialog(dialogId) {
            return $q.when(function () {
                const dialogRefObj = findDialog(dialogId);
                if (dialogRefObj) {
                    dialogRefObj.modal.controller.dismiss();
                    return dialogRefObj.closed;
                }
                return false;
            }());
        }

        function closeAll() {
            return $q.when(dialogsRef.map(function (dialog) {
                return closeDialog(dialog.dialogId);
            }));
        }

        function showAndRegisterDialog(dialogId, data) {
            var dialog_options = {};
            try {
                var dialog_option_temp = lodash.get(data, 'dialog_options', {});
                dialog_options = cleanDialogOptions(dialog_option_temp);
            } catch (e) {
                console.log(e);
            }
            const showModalOptions = {
                controller: data.controller,
                controllerAs: 'vm',
                appendElement: angular.element('.modal-wrapper'),
                inputs: {
                    dialogId: dialogId,
                    dialogOptions: angular.copy(dialog_options)
                }
            };

            if (lodash.has(data, 'template')) {
                showModalOptions.template = data.template;
            }

            if (lodash.has(data, 'templateUrl')) {
                showModalOptions.templateUrl = data.templateUrl;
            }

            return ModalService.showModal(showModalOptions).then(function (modal) {
                if (lodash.has(data, 'trigger.init')) {
                    $rootScope.$broadcast(data.trigger.init, modal);
                }
                dialogManipulatePace(true);
                modal.element.show();

                var modals = $('.modal');
                if (modals.length > 1) processOffset(modals);

                modal.close.then(function (res) {
                    if (lodash.has(data, 'trigger.closing')) {
                        $rootScope.$broadcast(data.trigger.closing, data.dialog_options.actionData);
                    }
                });
                modal.closed.then(function (res) {
                    if (dialogsRef.length <= 1) {
                        dialogManipulatePace(false);
                    }
                    const refId = lodash.findIndex(dialogsRef, {dialogId: dialogId});
                    dialogsRef.splice(refId, 1);

                    if (res !== false) {
                        if (lodash.has(data, 'trigger.completed')) {
                            $rootScope.$broadcast(data.trigger.completed, data.dialog_options.actionData);
                        }
                    }

                    if (lodash.has(data, 'trigger.closed')) {
                        $rootScope.$broadcast(data.trigger.closed, data.dialog_options.actionData);
                    }
                    return res;
                });

                const dialogRefObj = {
                    dialogId: dialogId,
                    modal: modal
                };
                dialogsRef.push(dialogRefObj);
                return dialogRefObj;
            });
        }

        function processOffset($modals) {
            var top = 15;
            var left = 15;
            $modals.each(function (index) {
                if (index >= 1) {
                    $(this).children('.modal-dialog').css({
                        top: top + 'px',
                        left: left + 'px'
                    });
                    top += 5;
                    left += 5;
                }
            });
        }

        function dialogManipulatePace(state) {
            if (state) {
                angular.element('body').addClass('dialog-active');
            } else {
                angular.element('body').removeClass('dialog-active');
            }
        }


        function cleanDialogOptions(data) {
            if (['string', 'number'].indexOf(typeof data) >= 0) {
                return data;
            }
            if (data === null) {
                return data;
            }
            if (data instanceof Array) {
                console.log('arrayData', data);
                return data;
            }
            const result = {};

            lodash.forIn(data, function (value, key) {
                try {
                    switch (typeof value) {
                        case 'string':
                        case 'number':
                        case 'boolean': {
                            // string and numbers are safe.
                            result[key] = value;
                            break;
                        }
                        case 'object': {
                            if (value === null) {
                                result[key] = value;
                                break;
                            }
                            if (value instanceof jQuery.Event) {
                                break;
                            }
                            if (value instanceof jQuery.fn.init) {
                                break;
                            }
                            if (value instanceof Array) {
                                // preparing or temp valResult
                                var valResult = [];
                                lodash.forEach(value, function (val) {
                                    // check if the cpws objects exists
                                    const exists = avoidCPWS.reduce(function (r, cpwsField) {
                                        if (r === true) return r;
                                        return lodash.has(val, cpwsField);
                                    }, false);
                                    if (!exists) {
                                        // set the value to
                                        const _d1 = cleanDialogOptions(val);
                                        valResult.push(_d1);
                                    }
                                });
                                result[key] = valResult;
                            } else {
                                const exists = avoidCPWS.reduce(function (r, cpwsField) {
                                    if (r === true) return r;
                                    return lodash.has(value, cpwsField);
                                }, false);
                                if (!exists) {
                                    const _d1 = cleanDialogOptions(value);
                                    if (!lodash.isEmpty(_d1)) {
                                        result[key] = _d1;
                                    }
                                }
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                } catch (e) {
                    console.log({key, value}, e);
                    throw e;
                }

            });
            return result;
        }
    }
})();
(function() {
    'use strict';

    DialogSimpleCtrl.$inject = ['dialogOptions', '$timeout', 'close'];
    angular
        .module('dialog-manager')
        .controller('DialogSimpleCtrl', DialogSimpleCtrl);

    function DialogSimpleCtrl(dialogOptions, $timeout, close) {
        const vm = this;
        vm.show = false;
        vm.dialogOptions = dialogOptions;
        vm.options =  dialogOptions;

        vm.dismiss = dismiss;

        $timeout(function () {
            vm.show = true;
        });

        function dismiss() {
            close(false);
        }
    }
})();
(function () {
    'use strict';

    actionDialogSetOptions.$inject = ['DialogManager', 'lodash', '$q'];
    angular
        .module('dialog-manager')
        .factory('action-dm-dialog-set-options', actionDialogSetOptions);

    function actionDialogSetOptions(DialogManager, lodash, $q) {
        return function (options, eventData, actionData) {
            return $q.when(run());

            function run() {
                DialogManager.setOption(options.dialogId, options.key, options.value);
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    actionGetDialogData.$inject = ['$q', 'lodash', 'DialogManager'];
    angular
        .module('dialog-manager')
        .factory('action-dm-get-data', actionGetDialogData);

    function actionGetDialogData($q, lodash, DialogManager) {
        return function (options) {
            return $q.when(run());

            function run() {
                const dialogId = lodash.get(options, 'dialogId', null);
                if (!dialogId) return false;
                return DialogManager.getData(dialogId, lodash.get(options, 'path', ''));
            }
        };
    }
})();

(function () {
    'use strict';

    actionOpenDialog.$inject = ['DialogManager', 'lodash', '$q'];
    angular
        .module('dialog-manager')
        .factory('action-dm-open-dialog', actionOpenDialog);

    function actionOpenDialog(DialogManager, lodash, $q) {
        return function (options, eventData, actionData) {
            return $q.when(run());

            function run() {
                if (lodash.get(options, 'remote_dialog_options', false) !== true) {
                    let dialogId = lodash.get(options, 'dialog_id', null);
                    if (!dialogId) dialogId = new Date().getTime();

                    if (!canOpenDialog(dialogId)) { return false; }
                    lodash.set(options, 'dialog_options.eventData', eventData);
                    lodash.set(options, 'dialog_options.actionData', actionData);
                    return DialogManager.init(dialogId, options);
                } else {
                    let dialogId = lodash.get(actionData.data, 'dialog_id', null);
                    if (!dialogId) dialogId = new Date().getTime();
                    if (!canOpenDialog(dialogId)) { return false; }
                    return DialogManager.init(dialogId, actionData.data);
                }

            }

            function canOpenDialog(dialogId) {
                if (!lodash.get(options, 'allow_duplicate', false)) {
                    return !(DialogManager.hasDialog(dialogId));
                }
            }
        };
    }
})();

(function () {
    'use strict';

    actionSetDialogData.$inject = ['$q', 'lodash', 'DialogManager'];
    angular
        .module('dialog-manager')
        .factory('action-dm-set-data', actionSetDialogData);

    function actionSetDialogData($q, lodash, DialogManager) {
        return function (options) {
            return $q.when(run());

            function run() {
                const dialogId = lodash.get(options, 'dialogId', null);
                if (!dialogId) return false;
                const path = lodash.get(options, 'path', '');
                const value = lodash.get(options, 'value', null);
                return DialogManager.setData(dialogId, path, value);
            }
        };
    }
})();

(function () {
    'use strict';

    fbElementGeneratorDirectiveCtrl.$inject = ['FormBuilderService', '$compile', '$element', '$scope', 'lodash', '$timeout', 'CommonHelper'];
    angular
        .module('FormBuilder')
        .directive('fbElementGenerator', fbElementGeneratorDirective);

    function fbElementGeneratorDirective() {
        return {
            restrict: 'EA',
            scope: {
                fbElement: '=',
                formIdentifier: '=',
                elementIdentifier: '=',
                renderedElements: '=',
                model: '=',
                refreshElement: '=?',
                templates: '=?',
                disable: '=?'
            },
            controller: fbElementGeneratorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbElementGeneratorDirectiveCtrl(FormBuilderService, $compile, $element, $scope, lodash, $timeout, CommonHelper) {
        var cloneElement;
        var vm = this;
        var type, template;
        var showIfTemplate = false;

        this.$onInit = function() {
            vm.currentElement = angular.copy(vm.fbElement);

            vm.isEmpty = CommonHelper.isEmpty;

            if (vm.disable && vm.disable === true) {
                vm.currentElement.attr.disabled = true;
            }

            vm.currentElement.refreshElement = refreshElement;
            // console.log(vm.fbElement.name, ',', vm.elementIdentifier);
            vm.currentElement.elementIdentifier = vm.elementIdentifier;
            FormBuilderService.sync(vm.formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger;
            vm.refreshElement = refreshElement;


            showIfTemplate = (lodash.has(vm, 'fbElement.showIf')) ? 'ng-show="vm.showFunc(vm.currentElement)"' : "";

            handleElementOptions();

            switch (vm.currentElement.type) {
                case "subform":
                    template = contructSubFormTemplate();
                    break;
                case "subform-selection":
                    template = contructSubFormSelectionTemplate();
                    break;
                case "custom":
                    template = constructCustomTemplate();
                    break;
                case "anchor":
                case "button":
                    template = constructButtonTemplate(vm.currentElement.type);
                    break;
                case "hidden":
                    template = constructHiddenTemplate();
                    break;
                case "settings-button":
                case "settings-toggle":
                case "settings-text":
                case "settings-select":
                    template = constructSettingsTemplate();
                    break;
                case "template":
                case "compile":
                    template = constructTemplateFieldTemplate();
                    break;
                // case "display-only":
                //     template = constructDisplayOnlyFieldTemplate();
                //     break;

                default:
                    template = constructDefaultTemplate();
                    break;
            }

            compileTemplate();
            $scope.$on('$destroy', scopeDestroy);
        }

        function compileTemplate() {
            $element.html(template);
            cloneElement = $compile($element.contents())($scope);
        }

        function refreshElement() {
            cloneElement.off();
            $element.empty();
            $timeout(function () {
                compileTemplate();
            }, 200);
        }

        function constructDefaultTemplate() {
            var settings_attr = '';

            setDefaultModel(vm.currentElement.type);

            vm.renderedElements[vm.currentElement.name] = vm.currentElement;

            type = getElementType(vm.currentElement.type);
            let labelType = "fb-label";
            
            if (['field-radio-checkbox', 'field-checkbox-button', 'field-toggle'].indexOf(type) >= 0) {
                labelType = "fb-label-right";
            }

            if (['field-select', 'field-timeslotpicker',
                'field-daterangepicker', 'field-rankchoice', 'field-two-level-selector'

            ].indexOf(type) >= 0) {
                labelType = "fb-label-div";
            }

            if ([
                'field-employment-type-details',
            ].indexOf(type) >= 0) {
                labelType = "fb-label-no-error";
            }

            if (['field-skillset-manager', 'field-datatable-toggle-manager'].indexOf(type) >= 0) {
                labelType = "fb-label-div-no-msg";
            }

            if (['field-image', 'field-duration', 'field-approver-selector', 'field-signer-details'].indexOf(type) >= 0) {
                labelType = 'fb-label-text';
            }

            let modelStringType = vm.currentElement.type;
            if (lodash.get(vm.fbElement, 'options.settings_type', null)) {
                settings_attr = getSettingFieldsAttr(type);
                modelStringType = 'settings-field';
                type = 'settings-field';
            }

            var templateUrl = '';
            if (lodash.has(vm.currentElement,  'options.templateUrl')) {
                templateUrl = 'template="' + vm.currentElement.options.templateUrl + '"';
            }

            const modelString = constructModelString(modelStringType);
            var mainTemplate = '<fb-' + type + ' element="vm.currentElement" options="vm.currentElement.options" ' + modelString + ' class="field-element" event-handler="vm.onEventTrigger(type)"' +
                getTemplateAttr(vm.currentElement.type) +
                settings_attr + ' ' + templateUrl +
                '></fb-' + type + '>';



            if (type === 'settings-field') {
                return mainTemplate;
            } else {
                var hideIfEmptySetting = '';

                if (lodash.get(vm.currentElement, 'options.hide_if_empty', false)) {
                    hideIfEmptySetting = 'ng-if="!vm.isEmpty(vm.model[vm.currentElement.name])"';
                }

                return '' +
                    '<' + labelType + ' ' + showIfTemplate + ' element="vm.currentElement" ng-class="vm.currentElement.attr.labelClass" element-identifier="vm.elementIdentifier" ' + hideIfEmptySetting + '>' +
                    mainTemplate +
                    '</' + labelType + '>';
            }
        }

        function constructNgModelTemplate() {

        }

        function constructHiddenTemplate() {
            vm.renderedElements[vm.currentElement.name] = vm.currentElement;
            return '<fb-field-hidden element="vm.currentElement" options="vm.currentElement.options" model="vm.model[vm.currentElement.name]" ></fb-field-hidden>';
        }

        function constructTemplateFieldTemplate() {
            return '<fb-field-' + vm.currentElement.type + ' element="vm.currentElement"></fb-field-' + vm.currentElement.type + '>';
        }

        function constructButtonTemplate(type) {
            return '<fb-field-' + type + ' ' + showIfTemplate + ' element="vm.currentElement" class="small"></fb-field-' + type + '>';
        }

        function constructCustomTemplate() {
            type = lodash.get(vm, 'fbElement.name', '');
            return '<' + type + ' ' + showIfTemplate + ' element="vm.currentElement" model="vm.model"></' + type + '>';
        }

        function constructModelString(type) {
            switch (type) {
                case "smart-text-element":
                    return 'model="vm.model[vm.currentElement.name].value"';
                case 'settings-field':
                case 'tag':
                case 'autocomplete':
                case 'skillset-manager':
                case 'toggle':
                case 'file-upload':
                case 'approver-selector':
                case 'datatable-toggle-manager':
                case "employment-type-details":
                case 'datepicker':
                case 'datepicker2':
                case 'signer-details':
                    return 'ng-model="vm.model[vm.currentElement.name]"';
                default:
                    return 'model="vm.model[vm.currentElement.name]"';
            }
        }

        function contructSubFormTemplate() {
            var subfieldType = lodash.get(vm, 'fbElement.subfields.type', 'form');

            if (subfieldType == 'group') {
                if (!lodash.has(vm.model, vm.currentElement.name)) {
                    vm.model[vm.currentElement.name] = {};
                }
                vm.renderedElements[vm.currentElement.name] = {};
            } else {
                if (!lodash.has(vm.model, vm.currentElement.name)) {
                    vm.model[vm.currentElement.name] = [];
                }
                vm.renderedElements[vm.currentElement.name] = [];
            }

            return '<fb-subform-' + subfieldType + ' ' + showIfTemplate + '  fb-element="vm.currentElement" rendered-elements="vm.renderedElements[vm.currentElement.name]" class="section" model="vm.model[vm.currentElement.name]"></fb-subform>';
        }

        function contructSubFormSelectionTemplate() {
            var subfieldType = lodash.get(vm, 'fbElement.subfields.type', 'form');

            // if (subfieldType == 'group') {
            //     if (!lodash.has(vm.model, vm.currentElement.name)) {
                    vm.model[vm.currentElement.name] = {};
                // }
                // vm.renderedElements[vm.currentElement.name] = {};
            // } else {
            //     if (!lodash.has(vm.model, vm.currentElement.name)) {
            //         vm.model[vm.currentElement.name] = [];
            //     }
            //     vm.renderedElements[vm.currentElement.name] = [];
            // }

            return '<fb-subform-' + subfieldType + ' ' + showIfTemplate + '  fb-element="vm.currentElement" rendered-elements="vm.renderedElements[vm.currentElement.name]" class="section" model="vm.model[vm.currentElement.name]"></fb-subform>';
        }

        function scopeDestroy() {
            cloneElement.off();
        }

        function getElementType(type) {
            switch (type) {
                case "checkbox":
                case "radio":

                    return "field-radio-checkbox";
                case "textbox":
                    return "field-textfield";
                case "text":
                case "number":
                case "email":
                case "password":
                case "tel":
                case "search":
                case "smart-text-element":
                    return "field-simple";
                case "remote-select":
                    return "field-select";
                case "checkbox-button":
                    return "field-checkbox-button";
                case "color-picker":
                // return "field" + type;
                case "display-only":
                default:
                    return "field-" + type;
            }
        }

        function setDefaultModel(type) {
            if (!lodash.has(vm.model, vm.currentElement.name)) {
                switch (type) {
                    case "file":
                    case "file-upload":
                        if (lodash.get(vm.currentElement, 'options.multiple', false)) {
                            lodash.set(vm.model, vm.currentElement.name, []);
                        } else {
                            lodash.set(vm.model, vm.currentElement.name, {});
                        }
                        break
                    case "yesno":
                    case "singlechoice":
                    case "singlechoicedropdown":
                    case "multichoice":
                    case "freetext":
                    case "image":
                    case "timeslotpicker":
                    case "daterangepicker":
                    case "settings-button":
                    case "duration":
                    case "approver-selector":
                    case "signer-details":
                    case "interview-medium-selector":
                    case "two-level-selector":

                        lodash.set(vm.model, vm.currentElement.name, {});
                        break;
                    case "settings-select":
                    case "tag":
                    case "skillset-manager":
                    case "employment-type-details":
                        lodash.set(vm.model, vm.currentElement.name, []);
                        break;
                    case "settings-toggle":
                    case "checkbox-button":
                    case "toggle":

                        lodash.set(vm.model, vm.currentElement.name, false);
                        break;
                    case "checkbox-qn":
                        lodash.set(vm.model, vm.currentElement.name + ".answer", false);
                        break;
                    case "number":
                        lodash.set(vm.model, vm.currentElement.name, 0);
                        break;
                    case "text":
                    case "email":
                    case "password":
                    case "textbox":
                    case "date":
                    case "captcha":
                    case "tel":
                    case "search":
                    case "settings-text":
                    case "display-only":
                    case "video-url":
                    case "email-verify-element":
                        lodash.set(vm.model, vm.currentElement.name, '');
                        break;
                    case "smart-text-element":
                        lodash.set(vm.model, vm.currentElement.name, {value: null});
                        break;
                    case "dropdown-qn":
                        lodash.set(vm.model, vm.currentElement.name, null);
                        break;
                }
            }
        }

        function constructSettingsTemplate() {
            setDefaultModel(vm.currentElement.type);
            var type = 'fb-field-' + vm.currentElement.type;
            return '<' + type + ' element="vm.currentElement" model="vm.model[vm.currentElement.name]"></' + type + '>';
        }

        function handleElementOptions() {
            var prefix = lodash.get(vm.model, [vm.currentElement.name, 'prefix'].join('.'), null);
            if (prefix) {
                lodash.set(vm.currentElement, 'attr.prefix.value', prefix);
            }
            var suffix = lodash.get(vm.model, [vm.currentElement.name, 'suffix'].join('.'), null);
            if (suffix) {
                lodash.set(vm.currentElement, 'attr.suffix.value', suffix);
            }
        }

        function getTemplateAttr(type) {
            if (lodash.isEmpty(vm.templates)) {
                return '';
            }

            var templateValue = lodash.get(vm.templates, type, '');

            var templateValueOverride = lodash.get(vm, 'currentElement.options.templateUrl');
            if (templateValueOverride) {
                templateValue = templateValueOverride;
            }

            return ' template="' + templateValue + '" ';
        }

        function getSettingFieldsAttr(type) {
            var settings_type = lodash.get(vm.fbElement, 'options.settings_type', null);
            if (!settings_type) {
                return '';
            }

            return ' field-type="' + type + '" ';
        }
    }
})();

(function () {
    'use strict';

    fbFormGeneratorDirective.$inject = ['$timeout'];
    fbFormGeneratorDirectiveCtrl.$inject = ['FormBuilderService', '$scope', 'lodash', 'FormBuilderHelper', '$timeout', '$element', '$compile', '$templateCache'];
    angular
        .module('FormBuilder')
        .directive('fbFormGenerator', fbFormGeneratorDirective);

    const defaultTemplateUrl = 'common/libraries/formBuilder/formGenerator';

    function fbFormGeneratorDirective($timeout) {
        return {
            restrict: 'EA',
            scope: {
                fbData: '=',
                fbModel: "=?",
                hideButtons: '=?',
                getModel: '=?',
                submit:'&?',
                setModel: '=?',
            },
            controller: fbFormGeneratorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope) {
                $timeout(function() {
                    scope.vm.init();
                })
            }
        };
    }

    function fbFormGeneratorDirectiveCtrl(FormBuilderService, $scope, lodash, FormBuilderHelper, $timeout, $element, $compile, $templateCache) {
        // console.log('form generator controller');
        var vm = this;

        this.$onInit = function() {
            vm.loaded = false;

            const templateUrl = lodash.get(vm.fbData, 'settings.template_url', defaultTemplateUrl);
            const template = $templateCache.get(templateUrl);

            vm.submitEvent = submitEvent;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            vm.getModel = getModel;
            vm.setModel = setModel;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.init = init;

            $element.html(template);
            var cloneElem = $compile($element.contents())($scope);

            $scope.$on('$destroy', function () {
                FormBuilderService.destroy(vm.formIdentifier);
                if (cloneElem != null) {
                    cloneElem.off();
                }
            });
        }

        function init() {
            vm.formIdentifier = vm.fbData.name;
            vm.elements = angular.copy(vm.fbData.elements);
            vm.buttons = angular.copy(vm.fbData.buttons);
            vm.buttonsWrapperType = vm.fbData.buttons_wrapper_type || 'grid';
            vm.renderedElements = {};
            vm.loaded = true;

            if (!vm.fbModel) {
                vm.model = angular.copy(lodash.get(vm.fbData, 'model', {}));
            } else {
                angular.merge(vm.fbModel, angular.copy(lodash.get(vm.fbData, 'model', {})));
                vm.model = vm.fbModel;
            }

            var fbMem = FormBuilderService.init(vm.formIdentifier, vm,$scope);
            fbMem.elementsService.syncRenderedElements(vm.renderedElements);
            if (lodash.has(vm.fbData, 'settings.hide_form_buttons')) {
                vm.hideButtons = vm.fbData.settings.hide_form_buttons;
            }

            if (!vm.hideButtons){
                if (lodash.isEmpty(vm.buttons)) {
                    vm.hideButtons = true;
                }
            }
        }



        function getModel() {
            return vm.model;
        }

        function setModel(model) {
            angular.merge(vm.model, model);
        }


        function submitEvent($event) {
            if (typeof vm.submit === typeof function() {}) {
                vm.submit();
            } else {
                $timeout(function () {
                    if (lodash.has(vm.fbData, 'events.submit')) {
                        var eventData = {
                            targetScope: {
                                name: vm.formIdentifier,
                                elements: vm.fbElements,
                                buttons: vm.fbButtons
                            },
                            target: $element,
                            event: $event,
                            model: vm.model,
                            formIdentifier: vm.formIdentifier
                        };

                        $scope.$emit(vm.fbData.events.submit, eventData);
                    }
                });
            }
        }
    }
})();
(function () {
    'use strict';

    fbFormLiveGeneratorDirectiveCtrl.$inject = ['FormBuilderService', '$scope', 'lodash', 'FormBuilderHelper', '$timeout', '$element'];
    angular
        .module('FormBuilder')
        .directive('fbFormLiveGenerator', fbFormLiveGeneratorDirective);

    function fbFormLiveGeneratorDirective() {
        return {
            restrict: 'EA',
            scope: {
                fbData: '=',
                setModel: "=",
                hideButtons: '=?'
            },
            templateUrl: 'common/libraries/formBuilder/formGenerator',
            controller: fbFormLiveGeneratorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFormLiveGeneratorDirectiveCtrl(FormBuilderService, $scope, lodash, FormBuilderHelper, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            vm.submitEvent = submitEvent;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            vm.setModel = setModel;

            init();
        }

        function init() {
            vm.formIdentifier = vm.fbData.name;
            vm.elements = angular.copy(vm.fbData.elements);
            vm.buttons = angular.copy(vm.fbData.buttons);
            vm.buttonsWrapperType = vm.fbData.buttons_wrapper_type || 'grid';
            vm.renderedElements = {};

            vm.model = vm.fbModel;

            var fbMem = FormBuilderService.init(vm.formIdentifier, vm,$scope);
            fbMem.elementsService.syncRenderedElements(vm.renderedElements);
        }
        $scope.$on('$destroy', function () {

            FormBuilderService.destroy(vm.formIdentifier);
        });

        function setModel(model) {
            vm.model = model;
        }

        function submitEvent($event) {
            $timeout(function () {
                if (lodash.has(vm.fbData, 'events.submit')) {
                    var eventData = {
                        targetScope: {
                            name: vm.formIdentifier,
                            elements: vm.fbElements,
                            buttons: vm.fbButtons
                        },
                        target: $element,
                        event: $event,
                        model: vm.model,
                        formIdentifier: vm.formIdentifier
                    };

                    $scope.$emit(vm.fbData.events.submit, eventData);
                }
            });
        }
    }
})();
// dependency: selectize
(function() {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('sodSelector', directiveFunc);

    function directiveFunc() {
        directiveCtrl.$inject = ['FbSelectService', 'lodash', 'GenericModel', '$scope'];
        return {
            restrict: 'E',
            scope: {
                element: '=',
                onSelect: '&',
                refresh: '=?'
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: directiveCtrl,
            template: '<selectize config="vm.config" options="vm.ds" ng-model="vm.selected"></selectize>'
        };

        function directiveCtrl(FbSelectService, lodash, GenericModel, $scope) {
            const vm = this;
            this.$onInit = function() {
                vm.selected = null;
                vm.refresh = loadRemoteData;

                vm.additionalOptions = {};

                FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

                if (lodash.has(vm.element, 'datasource.data')) {
                    vm.ds = angular.copy(lodash.get(vm.element, 'datasource.data', null));
                    $scope.$watch(function() {return vm.element.datasource.data; }, function() { vm.ds = angular.copy(lodash.get(vm.element, 'datasource.data', null)); });
                } else {
                    loadRemoteData();
                }

                vm.config =
                    angular.merge(
                        {
                            highlight: true,
                            create: false,
                            labelField: 'label',
                            valueField: 'value',
                            maxItems: 1,
                            searchField: ['label'],
                            plugins: ['remove_button'],
                            onChange: function(selectedValue) {
                                const selected = lodash.find(vm.ds, function(item) {
                                    return lodash.get(item, lodash.get(vm.config, 'valueField', 'value'), null).toString() === selectedValue.toString();
                                });
                                vm.onSelect(selected);
                                this.clear(true);
                                this.refreshOptions(false); // false = do not trigger dropdown
                                $scope.$apply();
                            }
                        },
                        lodash.get(vm.element, 'options.selectize', {}),
                        vm.additionalOptions
                    );

                $scope.$watch(function() {return vm.element.datasource }, function() {
                    vm.isLoading = true;
                    setTimeout(function() {
                        vm.isLoading = false
                    }, 3000)
                });
            }

            function loadRemoteData(params, postData) {
                if (lodash.has(vm.element, 'datasource.url')) {
                    vm.isLoading = true;
                    var callRemoteApiPromise = callRemoteApi(params, postData);
                    callRemoteApiPromise.then(function(res) {
                        vm.ds = res;
                        vm.isLoading = false;
                    });
                }
            }


            function callRemoteApi(params, postData) {
                if (!params) { params = {}; }
                if (!postData) { postData = {}; }

                var model = new GenericModel(vm.element.datasource.url);
                var method = lodash.get(vm.element.datasource, 'method', 'get');
                return model[method](params, postData).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {
                        return res.data;
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(res) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(res); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    layoutGeneratorDirectiveCtrl.$inject = ['$scope', '$element', '$templateCache', '$compile', 'Notifier', 'lodash', 'PanelRegistry'];
    angular
        .module('LayoutBuilder')
        .directive('layoutGenerator', layoutGeneratorDirective)
    ;

    function layoutGeneratorDirective() {
        return {
            restrict: 'EA',
            scope: {
                content: '='
            },
            controller: layoutGeneratorDirectiveCtrl
        };
    }

    function layoutGeneratorDirectiveCtrl($scope, $element, $templateCache, $compile, Notifier, lodash, PanelRegistry) {
        var cloneElement = null,
            cloneScope = null;

        this.$onInit = function() {
            $scope.getColumnClass = getColumnClass;
            $scope.$on('$destroy', destroyElem);
            $scope.$watch("content", contentWatch);
        }

        function getColumnClass (column) {
            var classStr = column.class_name;
            if (!lodash.isNull(column.size)) {
                classStr = [classStr, 'small-12', 'medium-' + column.size].join(' ');
            }
            return classStr;
        }

        function destroyElem() {
            cloneElement.off();
        }

        function contentWatch() {
            var template = $templateCache.get("common/libraries/layoutBuilder/layout");

            if (template) {
                if (cloneElement) {
                    cloneScope.$destroy();
                    cloneScope = null;

                    cloneElement.off();
                    cloneElement.remove();
                    cloneElement = null;
                }

                PanelRegistry.clear();
                cloneScope = $scope.$new();

                var _html = angular.element(template);
                if (lodash.has($scope, 'content.directives')) {
                    angular.forEach($scope.content.directives, function (val) {
                        if (typeof val == 'string') {
                            _html.find('.lb-layout').attr(val, '');
                        } else {
                            _html.find('.lb-layout').attr(val[0], val[1]);
                        }

                    });
                }
                $element.html(_html);
                cloneElement = $compile($element.contents())(cloneScope);
            }

            Notifier.setLoading(false);
        }
    }
})();
(function () {
    'use strict';

    lbPanelDirectiveCtrl.$inject = ['$scope', '$element', '$compile', 'lodash', 'PanelRegistry'];
    angular
        .module('LayoutBuilder')
        .directive('lbPanel', lbPanelDirective)
    ;

    function lbPanelDirective() {
        return {
            restrict: 'E',
            scope: {
                panel: "=",
                model: '=',
                content: '='
            },
            //templateUrl: '/api/admin/templates/panel',
            controller: lbPanelDirectiveCtrl
        };
    }

    function lbPanelDirectiveCtrl ($scope, $element, $compile, lodash, PanelRegistry) {
        this.$onInit = function() {
            var type = lodash.get($scope, 'panel.panel_type.name', '');

            PanelRegistry.register($scope.panel.panel_type.identifier, $scope.panel);
            // Types: grid, form, template, tabstrip
            var template = '<lb-' + type + '-panel panel="panel" model="model" content="content"></lb-' + type + '-panel>';
            $element.html(template);
            var cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', function () {
                cloneElement.off();
            });
        }
    }
})();
// (function () {
//     'use strict';
//
//     angular
//         .module('fauzanKhanQueryBuilder')
//         .directive('qbEditBracket', qbEditBracket);
//
//     function qbEditBracket() {
//         return {
//             restrict: 'E',
//             controller: qbEditBracketCtrl,
//             controllerAs: 'qb',
//             bindToController: true
//         };
//     }
//
//     function qbEditBracketCtrl() {
//         var vm = this;
//
//     }
// })();
(function () {
    'use strict';

    angular
        .module('fauzanKhanQueryBuilder')
        .constant('QB_CONSTANTS', {
            'FILTER_MODE': 1,
            'EQUATION_MODE': 2,
            'ALLOW_CUSTOM_QUERY': true,
            'DISALLOW_CUSTOM_QUERY': false,
        });
})();
/**
 * References from https://github.com/FauzanKhan/angular-query-builder
 */
;(function(angular) {
	'use strict';

	angular
		.module('fauzanKhanQueryBuilder')
		.directive('queryBuilder', ['$compile', 'QBTemplatesFactory', 'QB_CONSTANTS', function($compile, QBTemplatesFactory, QB_CONSTANTS) {
		return {
			restrict: 'EA',
			require: 'ngModel',
			scope: {
				// 'data': '=', // Object in which the query will be reflected
				'columns': '=', //Columns for building query
				// 'operations': '=', //Operations  which are to be applied on columns
				'options': '=?',
			},
			link: function(scope, ele, attr, ctrl) {
				var getTemplates = QBTemplatesFactory.get;
				var buildTemplate = QBTemplatesFactory.build;
				scope.options = angular.extend({
                    expressionValuePrefix: '',
                    jointOperators: ['+', '-', '*', '/', 'AND', 'OR'],
                    showBrackets: true,
					mode: QB_CONSTANTS.FILTER_MODE,
					valueOperators: ['>', '<', '<=', '>=', '==', '=', 'is'],
					allowCustomQuery: QB_CONSTANTS.ALLOW_CUSTOM_QUERY,
				}, scope.options || {});


				//Object template for custom query
				var customQuery = {
					type: 'custom',
					column: '',
					operation: '',
					value: '',
					custom: ''
				};

				//Object template for basic query
				var basicQuery = {
					type: 'basic',
					column: '',
					operation: '',
					value: '',
					custom: ''
				};

				ctrl.$formatters.push(function(modelValue) {
					console.log('ctrl.$formatters');
					if (!modelValue) {
						modelValue = {};
					}
					modelValue.expression = modelValue.expression || null;
					modelValue.operands = modelValue.operands || [angular.copy(basicQuery)]; // if no operands are present then push a basicQuery to oprands array
					modelValue.bracketIds = modelValue.bracketIds || []; //If bracketIds are not present initialize it to an empty array
					return modelValue;
				});

				ctrl.$render = function() {
                    console.log('ctrl.$render');
					scope.query = ctrl.$viewValue;
					init();
				};

				ctrl.$parsers.push(function(viewValue) {
					console.log('ctrl.$parsers');
					return viewValue;
				});

				// scope.query = query;

				// scope.query.expression = scope.query.expression ? scope.query.expression : null;
				// scope.query.operands = scope.query.operands || [angular.copy(basicQuery)]; // if no operands are present then push a basicQuery to oprands array
				// scope.query.bracketIds = scope.query.bracketIds || []; //If bracketIds are not present initialize it to an empty array

				//Hides/shows Popover
				scope.togglePopover = function(event) {
					var isVisible = angular.element(event.target).closest('.popover-parent').hasClass('active');
					angular.element('.popover-parent').removeClass('active');
					if (!isVisible)
						angular.element(event.target).closest('.popover-parent').addClass('active');

					setViewValue();
				};

				//Adds a new Sub Query
				scope.newEntry = function(event) {
					scope.currIndex = parseInt(scope.currIndex);
					scope.currIndex += 1;
					// var currIndex = scope.currIndex;
					scope.query.operands.push(angular.copy(basicQuery));
					var templates = getTemplates(scope.currIndex);
					ele.find('.query-builder-wrapper').append($compile(templates.operator)(scope));
					ele.find('.query-builder-wrapper').append($compile(templates.operandSelection)(scope));
                    setViewValue();
				};

				//Changes type of Sub QUery
				scope.changeQueryType = function(index, queryType) {
					if (queryType == 'basic')
						scope.query.operands[index] = angular.copy(basicQuery);
					else
						scope.query.operands[index] = angular.copy(customQuery);
				};

				//Changes operator between two sub queries
				scope.changeOperator = function(newOperator, event) {
					var operatorWrapper = angular.element(event.target).closest('.operator-wrapper');
					operatorWrapper.find('.operator').text(newOperator);
					operatorWrapper.removeClass('active');
                    setViewValue();
				};

				//Calculates position of brackets and adds them in the DOM
				scope.addBrackets = function(event) {
					var parent = angular.element(event.target).closest('.operator-wrapper');
					var operatorId = parent.attr('data-operator-id');
					var next = parent.next();
					var prev = parent.prev();
					var leftBracket = '<span class="bracket opening-bracket" data-bracket-id="' + operatorId + '">(</span>';
					var rightBracket = '<span class="bracket closing-bracket" data-bracket-id="' + operatorId + '">)</span>';
					// if next element is not an opening bracket then add a bracket
					if (!next.hasClass('bracket opening-bracket')) {
						next.after(rightBracket);
					} else {
						//if next element is a bracket the recursively iterate to the next of next elements
						//counting the no. of opening and closing brackets encountered
						//when they become equal add another colsing bracket 
						next = next.next();
						var openingBracketsCount = 1;
						while (next.length > 0) {;
							if (next.hasClass('bracket opening-bracket')) {
								openingBracketsCount += 1;
							} else if (next.hasClass('bracket closing-bracket')) {
								openingBracketsCount -= 1;
								if (openingBracketsCount == 0) {
									angular.element(next).after(rightBracket);
									break;
								}
							}
							next = next.next();
						}
					}
					// if prev element is not a closing bracket then add a bracket
					if (!prev.hasClass('bracket closing-bracket')) {
						prev.before(leftBracket);
					} else {
						//if prev element is a bracket the recursively iterate to the prev of prev elements
						//counting the no. of opening and closing brackets encountered
						//when they become equal add another opening bracket 
						prev = prev.prev();
						var closingBracketsCount = 1;
						while (prev.length > 0) {
							if (prev.hasClass('bracket closing-bracket')) {
								closingBracketsCount += 1;
							} else if (prev.hasClass('bracket opening-bracket')) {
								closingBracketsCount -= 1;
								if (closingBracketsCount == 0) {
									angular.element(prev).before(leftBracket);
									break;
								}
							}
							prev = prev.prev();
						}
					}
					parent.removeClass('active');
					getBracketIds();
                    setViewValue();
				};

				//Removes brackets corresponding to a sub query
				scope.removeBrackets = function(event) {
					var parent = angular.element(event.target).closest('.operator-wrapper');
					var operatorId = parent.attr('data-operator-id');
					var builderWrapper = parent.closest('.query-builder-wrapper');
					builderWrapper.find('.bracket[data-bracket-id="' + operatorId + '"]').remove();
					parent.removeClass('active');
					getBracketIds();
                    setViewValue();
				};

				function init() {
                    var currIndexTemp = scope.query.expression ? scope.query.expression.match(/[^A-Za-z()]/g) : 0;
                    scope.currIndex = scope.query.expression ? currIndexTemp[currIndexTemp.length - 1] : 0; // currIndex refers to the index of last sub query

                    ele.append('<div class="query-builder-wrapper"></div>');
                    ele.append('<div class="add-sub-query"></div>');
                    ele.find('.add-sub-query').append($compile(getTemplates(0).addMoreBtn)(scope));
                    if (!scope.query.expression) {
                        ele.find('.query-builder-wrapper').append($compile(getTemplates(0).operandSelection)(scope));
                    } else {
                        buildTemplate(ele, scope.query.expression, scope.query.operands, scope.query.bracketIds, scope);
                    }
                    angular.element('.query-builder-wrapper').on('click', '.popover-parent', function (e) {
                        e.stopPropagation();
                    });
                    angular.element('body').on('click', function () {
                        angular.element('.query-builder-wrapper .popover-parent').removeClass('active');
                    });
                }

                // scope.query.expression = buildExpression();

				function setViewValue() {
                    scope.query.expression = buildExpression();
					ctrl.$setViewValue(scope.query);
				}


                //Gets the data-bracket-Ids of current brackets in the DOM
                function getBracketIds() {
                    var brackets = ele.find('.query-builder-wrapper').find('.bracket');
                    var temp = [];
                    for (var i = 0; i < brackets.length; i++) {
                        var bracketId = angular.element(brackets[i]).attr('data-bracket-id');
                        temp.push(parseInt(bracketId));
                    }
                    scope.query.bracketIds = temp;
                }

                //Builds an expression corresponding to current query
                function buildExpression() {
                    var expression = [];
                    var temp = angular.element('.query-builder-wrapper').children();
                    for (var i = 0; i < temp.length; i++) {
                        var elem = angular.element(temp[i]);
                        var eleText = elem.text();
                        if (elem.hasClass('bracket')) {
                            expression.push(eleText);
                        } else if (elem.hasClass('operator-wrapper')) {
                            eleText = elem.find('.operator').text();
                            expression.push(eleText);
                        } else {
                            var opererand_index = elem.attr('data-opererand-id');
                            var opererand = scope.query.operands[parseInt(opererand_index)];
                            expression.push(scope.options.expressionValuePrefix + opererand.column.identifier);
                        }
                    }
                    return expression.join(' ');
                }
			}
		}
	}]);
})(angular);
;(function(angular) {
    'use strict';

    angular
        .module('fauzanKhanQueryBuilder')
        .factory('QBTemplatesFactory', ['$compile', 'QB_CONSTANTS', function($compile, QB_CONSTANTS) {

            //Returns templates for sub query popover, operation popover and add more button
            var getTemplates = function(currIndex) {
                currIndex = parseInt(currIndex);
                var templates = {};
                templates.addMoreBtn = '<span class="new-entry-btn" ng-click="newEntry($event)" data-curr-index="<%currIndex}}"><span class="plus-icon">+</span></span>';
                templates.operator = '<div class="operator-wrapper popover-parent" data-operator-id="' + currIndex + '">' +
                    '<span class="operator query-builder-label neutral" ng-click="togglePopover($event)">AND</span>' +
                    '<div class="operator-popover query-popover">' +
                    '<div class="popover-body">' +
                    '<span class="triangle"></span>' +
                    '<span ng-repeat="jointOperator in options.jointOperators" class="operator-option" ng-click="changeOperator(jointOperator, $event)" ng-bind="jointOperator"></span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'+\', $event)">+</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'-\', $event)">-</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'*\', $event)">*</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'/\', $event)">/</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'AND\', $event)">AND</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'OR\', $event)">OR</span>' +
                    '<span class="operator-option add-bracket" ng-click="addBrackets($event)" ng-hide="query.bracketIds.indexOf(' + currIndex + ') > -1">(brackets)</span>' +
                    '<span class="operator-option remove-bracket" ng-if="options.showBrackets" ng-show="query.bracketIds.indexOf(' + currIndex + ') > -1" ng-click="removeBrackets($event)"><strike>(brackets)</strike></span>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                templates.operandSelection = '<div class="operand-selection popover-parent" data-opererand-id="' + currIndex + '">' +
                    '<span class="query-builder-btn query-builder-btn-dropdown query-text" ng-click="togglePopover($event)">' +
                    '<span ng-if="query.operands[' + currIndex + '].column || query.operands[' + currIndex + '].custom">' +
                    '<%query.operands[' + currIndex + '].column.label+" "+query.operands[' + currIndex + '].operation+" "+query.operands[' + currIndex + '].value+""+query.operands[' + currIndex + '].custom%>'+
                    '</span>' +
                    '<span ng-hide="query.operands[' + currIndex + '].column || query.operands[' + currIndex + '].custom">Enter Query</span>' +
                    '</span>' +
                    '<div class="operand-popover query-popover">' +
                    '<div class="operand-popover-content">' +
                    '<span class="triangle"></span>' +
                    '<div class="popover-header" ng-if="options.allowCustomQuery">' +
                    '<div class="heading">' +
                    '<span>Query Type</span>' +
                    '</div>' +
                    '<div class="query-types">' +
                    '<div class="query-type">' +
                    '<input type="radio" name="query-type-' + currIndex + '" id="query-type-' + currIndex + '-basic" value="basic" ng-model="query.operands[' + currIndex + '].type" ng-change="changeQueryType(' + currIndex + ',\'basic\' )"/>' +
                    '<label for="query-type-' + currIndex + '-basic">Basic</label>' +
                    '</div>' +
                    '<div class="query-type">' +
                    '<input type="radio" name="query-type-' + currIndex + '" id="query-type-' + currIndex + '-custom" value="custom" ng-model="query.operands[' + currIndex + '].type" ng-change="changeQueryType(' + currIndex + ',\'custom\' )"/>' +
                    '<label for="query-type-' + currIndex + '-custom">Custom</label>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="popover-body">' +
                    '<div ng-show="query.operands[' + currIndex + '].type==\'basic\'">' +
                    '<div class="col-name-wrapper">' +
                    '<label>Select Column</label>' +
                    '<select ng-model="query.operands[' + currIndex + '].column" ng-options="col as col.label for col in columns" ng-change="columns"></select>'+
                    '</div>' +
                    '<div class="operation-wrapper" ng-if="options.mode === ' + QB_CONSTANTS.FILTER_MODE + '">' +
                    '<label>Select Operation</label>' +
                    '<select ng-model="query.operands[' + currIndex + '].operation" ng-options="valueOperator for valueOperator in options.valueOperators">'+
                    '</select>' +
                    '</div>' +
                    '<div class="value-wrapper" ng-if="options.mode === ' + QB_CONSTANTS.FILTER_MODE + '">' +
                    '<label>Value</label>' +
                    '<input type="text" ng-model="query.operands[' + currIndex + '].value" />' +
                    '</div>' +
                    '</div>' +
                    '<div ng-show="query.operands[' + currIndex + '].type==\'custom\'">' +
                    '<textarea ng-model="query.operands[' + currIndex + '].custom" plaveholder="Enter custom sub query"></textarea>' +
                    '</div>' +
                    '<div class="done-btn-wrapper">' +
                    '<button class="query-builder-btn small no-margins" ng-click="togglePopover($event)">Done</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                return templates;
            };

            //Builds/Prepopulate query in DOM in case scope.data is present
            var buildTemplate = function(ele, expression, operands, bracketIds, scope) {
                var bracketCount = 0;
                var expArray = expression.split(/((?:\(|\)|[A-Z]+|\d+))/g);
                var currOperand = 0;
                var expressionArray = expArray.filter(function(e) {
                    return e != '';
                })
                for (var i = 0; i < expressionArray.length; i++) {
                    var temp = expressionArray[i];
                    var template = getTemplates(i);
                    if (temp == '(') {
                        var bracketId = bracketIds[bracketCount];
                        var leftBracket = '<span class="bracket opening-bracket" data-bracket-id="' + bracketId + '">(</span>';
                        ele.find('.query-builder-wrapper').append(leftBracket);
                        bracketCount += 1;
                    } else if (temp == ')') {
                        var bracketId = bracketIds[bracketCount];
                        var rightBracket = '<span class="bracket closing-bracket" data-bracket-id="' + bracketId + '">)</span>';
                        ele.find('.query-builder-wrapper').append(rightBracket);
                        bracketCount += 1;
                    } else if (temp == 'AND' || temp == 'OR') {
                        var template = getTemplates(parseInt(currOperand));
                        ele.find('.query-builder-wrapper').append($compile(template.operator)(scope));
                    } else if (!isNaN(temp)) {
                        var template = getTemplates(parseInt(temp));
                        ele.find('.query-builder-wrapper').append($compile(template.operandSelection)(scope));
                        currOperand = parseInt(currOperand);
                        currOperand += 1;
                    }
                }
            };
            return {
                get: getTemplates,
                build: buildTemplate
            }
        }])
})(angular);
(function () {
    'use strict';

    angular
        .module('ResourceGenerator')
        .factory('GenericDsStore', GenericDsStore);

    function GenericDsStore() {
        var store = {};

    }
})();
(function() {
    'use strict';

    AbstractModelService.$inject = ['lodash'];
    angular
        .module('ResourceGenerator')
        .factory('AbstractModelService', AbstractModelService);

    function AbstractModelService(lodash) {
        var crud_actions = {
            'query'  : {
                method: 'GET',
                isArray:false,
                params: {
                    search: '@search',
                    page: '@page',
                    size: '@size',
                    sort: '@sort'
                },
                cancellable: true
            },
            'search'  : {
                method: 'POST',
                isArray:false
            },
            'get'    : { method: 'GET', cancellable: true},
            'create' : { method: 'POST' },
            'post' : { method: 'POST' },
            'patch'  : { method: 'PATCH' },
            'update' : { method: 'PUT' },
            'delete' : { method: 'DELETE'},
            'getArray'    : { method: 'GET', isArray: true }
        };

        /**
         * AbstractModelService generates actions of resources base on "option" object. See below for example data.
         */
        /*
         {
         basePath: '', // required
         defaultActions: ['query', 'get', 'patch'], // optional. If not defined, use all.
         levels: [
         {
         path: 'relationships', // required
         param: ':relationshipId', // required
         suffix: 'relationship', // if not specify, use path,
         actions: ['query', 'get'] // if not defined, use all
         }
         ]
         };
         */
        return function(options) {
            var actions = angular.copy(crud_actions);

            // if not options object provided, return the basic CRUD Actions
            if (!options) {
                return actions;
            }

            // If DefaultActions field is detected, remove those not needed.
            if (lodash.has(options, 'defaultActions')) {
                //for (var action in actions) {
                //    if (options,defaultActions.indexOf(action) < 0) {
                //        delete(actions[action]);
                //    }
                //}
                angular.forEach(options.defaultActions, function(option, index) {
                    var action = lodash.get(actions, index, false);
                    if (!action) {
                        actions.delete(actions[index]);
                    }
                });
                actions = angular.merge(actions, options.defaultActions);
            }

            // If Levels is required, go through the levels to generate the actions
            if (lodash.has(options, 'levels')) {
                angular.forEach(options.levels, function(level) {

                    // prepare of data for the level
                    var tempActions = angular.copy(crud_actions);
                    var levelActions = {};

                    // generate all actions
                    for (var action in tempActions) {
                        var path = options.basePath + "/" + angular.copy(level.path);
                        if (['query','create'].indexOf(action) < 0) {
                            path += '/' + level.param;
                        }

                        //
                        var actionNameSuffix = level.suffix || level.path;
                        actionNameSuffix = actionNameSuffix.charAt(0).toUpperCase() + actionNameSuffix.substr(1);

                        var prefix = (action == 'create') ? 'add' : action;

                        levelActions[prefix + actionNameSuffix] = angular.merge(tempActions[action], {
                            url: path
                        });
                    }

                    // if have actions field, remove those not needed
                    if (lodash.has(level,'actions')) {
                        for (var levelAction in levelActions) {
                            if (level.actions.indexOf(levelAction) < 0) {
                                delete(levelActions[levelAction]);
                            }
                        }
                    }

                    // Merge the generated actions back to the return result
                    actions = angular.merge(actions, levelActions);
                });
            }
            return actions;
        };
    }
})();


(function () {
    'use strict';

    GenericModel.$inject = ['$resource', 'AbstractModelService'];
    angular
        .module('ResourceGenerator')
        .factory('GenericModel', GenericModel);

    function GenericModel($resource, AbstractModelService) {
        return function(url, modelOptions, canceller) {
            var actions;
            if (modelOptions) {
                actions = AbstractModelService(url, modelOptions);
            } else {
                actions = AbstractModelService();
            }
            //var actions =
            const cancellerObj = {};
            if (canceller) {
                cancellerObj.timeout = canceller;
            }

            const params = angular.merge(
                {},
                {
                    id: '@id'
                },
                cancellerObj
            );

            return $resource(
                url,
                params,
                actions
            );
        };
    }
})();
(function () {
    'use strict';

    configFunc.$inject = ['SodLoggerProvider', 'SodEnvironmentContants'];
    angular
        .module('sod-logger')
        .config(configFunc);

    function configFunc(SodLoggerProvider, SodEnvironmentContants) {
        const env = angular.element('body').attr('data-environment');
        SodLoggerProvider.config((env !== SodEnvironmentContants.PRODUCTION) ? env : SodEnvironmentContants.PRODUCTION);
    }
})();
(function () {
    'use strict';

    SodLoggerFactory.$inject = ['SodEnvironmentContants'];
    angular
        .module('sod-logger')
        .constant('SodEnvironmentContants', {
            'PRODUCTION': 'production',
            'DEVELOPMENT': 'development',
            'LOCALHOST': 'localhost',
            'RELEASE': 'release',
            'LOCALHOSTPRODUCTION': 'localhostproduction'
        })
        .provider('SodLogger', SodLogger);

    function SodLogger() {
        let environment = 'production';
        return {
            config: (_env) => {
                environment = _env;
            },
            getEnvironment: () => {
                return environment;
            },
            $get: SodLoggerFactory
        };
    }

    function SodLoggerFactory(SodEnvironmentContants) {
        const vm = this;
        vm.logLevel = {
            'DEBUG': 'debug',
            'INFO': 'info',
            'WARNING': 'warning',
            'ERROR': 'error'
        };
        return {
            debug: function() {
                log2(vm.logLevel.DEBUG, arguments);
            },
            info: function() {
                log2(vm.logLevel.INFO, arguments);
            },
            warn: function() {
                log2(vm.logLevel.WARNING, arguments);
            },
            error: function() {
                log2(vm.logLevel.ERROR, arguments);
            },
            log: () => {
                log(vm.logLevel.DEBUG, '', arguments);
            },
            LOG_LEVEL: vm.logLevel
        };

        function log2(loglevel, args) {
            const title = args[0];
            log(loglevel, title, Array.prototype.slice.call(args, 1));
        }

        function log(level, title, msg) {
            if (!title) { title = ''; }

            const env = vm.getEnvironment();
            switch (env) {
                case SodEnvironmentContants.PRODUCTION:

                    break;
                case SodEnvironmentContants.RELEASE:
                case SodEnvironmentContants.DEVELOPMENT:
                case SodEnvironmentContants.LOCALHOST:
                case SodEnvironmentContants.LOCALHOSTPRODUCTION:
                    // consoleLog(level, title.toUpperCase(), msg);
                    break;
            }

            if (env.indexOf(SodEnvironmentContants.LOCALHOST) >= 0) {
                consoleLog(level, title.toUpperCase(), msg);
            }
        }

        function consoleLog() {
            if (!console) return ;
            const level = arguments[0];
            const title = arguments[1];

            const label = '%c## ' + level.toUpperCase() + ((title.length > 0) ? (' : ' + title + ' ##') : ' ##');
            // const args = Array.prototype.slice.call(arguments, 2);
            const args = arguments[2];
            let color = '#fff';
            let type = 'log';

            switch (level) {
                case vm.logLevel.DEBUG:
                    color = '#1abc9c';
                    break;
                case vm.logLevel.INFO:
                    color = '#95a5a6';
                    break;
                case vm.logLevel.WARNING:
                    color = '#e67e22';
                    type = 'warn';
                    break;
                case vm.logLevel.ERROR:
                    color = '#c0392b';
                    type = 'error';
                    break;
            }

            // console[type].apply(null, [label, 'color: ' + color].concat(Array.prototype.slice.call(args))); // eslint-disable-line no-console
            // console.trace(); // eslint-disable-line no-console
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('SodCustomAction')
        .directive('panelAction', actionElem);

    function actionElem() {
        return {
            restrict: 'A',
            scope: {
                event:'=?',
                triggeredWhen: '=?',
            },
            link: function(scope, elem) {
                elem.on('click', function() {
                    if (scope.event && scope.event.length > 0) {
                        if (typeof scope.triggeredWhen !== typeof undefined) {
                            scope.triggeredWhen && scope.$emit(scope.event);
                        } else {
                            scope.$emit(scope.event);
                        }
                    }
                });
                scope.$on('$destroy', function() {
                    elem.off();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    sodStaticNotifierCtrl.$inject = ['ActionModel', '$scope'];
    angular
        .module('SodCustomAction')
        .directive('sodStaticNotifier', sodStaticNotifier);

    function sodStaticNotifier() {
        return {
            restrict :'E',
            scope: {
            },
            controller: sodStaticNotifierCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/notifier/static-notifier'
        };
    }

    function sodStaticNotifierCtrl(ActionModel, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.name = $scope.$parent.vm.fbData.name;

            ActionModel.sync(vm, 'static-notifier', vm.name);

            $scope.$on('$destroy', function() {
                ActionModel.destroy('static-notifier', vm.name);
            });
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-copy-to-clipboard', actionFunc);

    function actionFunc($q, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {

                try {
                    var range = document.createRange();
                    range.selectNode(angular.element(options.className)[0]);
                    window.getSelection().addRange(range);
                    return document.execCommand('copy');
                } catch (err) {
                    console.log('Oops, unable to copy', err);
                    return false;
                }


            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-dom-add-class', actionFunc);

    function actionFunc($q, lodash) {
        return function(options, actionData, eventData) {
            return $q.when(run());
            function run() {
                let target = null;
                if (lodash.get(options, 'parent' ,false)) {
                    const parent = angular.element(options.parent_dom);
                    if (parent.length > 0) {
                        target = parent.find(options.dom);
                    }
                } else {
                    target = angular.element(options.dom);
                }

                if (target !== null && target.length > 0) {
                    target.addClass(options.class_to_add);
                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-dom-func-call', actionFunc);

    function actionFunc($q, lodash) {
        return function(options, actionData, eventData) {
            return $q.when(run());
            function run() {
                let target = null;
                if (lodash.get(options, 'parent' ,false)) {
                    const parent = angular.element(options.parent_dom);
                    if (parent.length > 0) {
                        target = parent.find(options.dom);
                    }
                } else {
                    target = angular.element(options.dom);
                }

                if (target !== null && target.length > 0) {
                    // target.addClass(options.class_to_add);
                    const func_name = lodash.get(options, 'func_name', null);
                    if (!func_name) {
                        return false;
                    }
                    target[func_name]();
                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-dom-remove-class', actionFunc);

    function actionFunc($q, lodash) {
        return function(options, actionData, eventData) {
            return $q.when(run());
            function run() {
                let target = null;
                if (lodash.get(options, 'parent' ,false)) {
                    const parent = angular.element(options.parent_dom);
                    if (parent.length > 0) {
                        target = parent.find(options.dom);
                    }
                } else {
                    target = angular.element(options.dom);
                }

                if (target !== null && target.length > 0) {
                    target.removeClass(options.class_to_remove);
                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-download', actionFunc);

    function actionFunc($q, lodash) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
        return function (options, data, actionResponseData) {
            return $q.when(run());

            function run() {
                if (lodash.has(options, 'route')) {

                    let postData = data;
                    if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                        postData = actionResponseData;
                    }

                    let endpoint = decodeURI(options.route).replace(urlReplacerRegex, (match, submatch) => {
                        return lodash.get(postData, submatch, '');
                     });

                    if (lodash.get(options, 'new_tab', false) === true) {
                        window.open(endpoint, "_blank");
                    } else {
                        window.location.href = endpoint;
                    }
                }
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'GaService', 'lodash', 'PanelManager'];
    angular
        .module('ActionManager')
        .factory('action-emit-ga-event', actionFunc);

    function actionFunc($q, GaService, lodash, PanelManager) {
        return function(options, eventData, actionResponse) {
            return $q.when(run());
            function run() {
                const modelData = {
                    actionResponse: actionResponse,
                    eventData: eventData
                };
                const panel_id = lodash.get(options, 'panel_id', false);
                if (panel_id) {
                    const panel = PanelManager.get(panel_id);
                    var panelModel = panel.getModel();
                    modelData.panelModel = panelModel
                }

                GaService.addEvent(options, modelData);
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-fbq-event-tracker', actionFunc);

    function actionFunc($q, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {

                try {
                    var type = lodash.get(options, 'type', null);
                    var fb_pixel_id = lodash.get(options, 'fb_pixel_id', null);
                    var value = lodash.get(options, 'value', {});
                    if (!!type) {
                        if (typeof fbq == typeof undefined) {
                            !function(f,b,e,v,n,t,s)
                            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                                n.queue=[];t=b.createElement(e);t.async=!0;
                                t.src=v;s=b.getElementsByTagName(e)[0];
                                s.parentNode.insertBefore(t,s)}(window, document,'script',
                                'https://connect.facebook.net/en_US/fbevents.js');

                        }
                        if (!!fb_pixel_id) {
                            fbq('init', fb_pixel_id);
                            fbq('track', 'PageView');
                        }
                        fbq('track', type, value);
                    }
                    return true;
                } catch (err) {
                    return false;
                }


            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', '$rootScope'];
    angular
        .module('ActionManager')
        .factory('action-localstorage-listener', actionFunc);

    function actionFunc($q, lodash, $rootScope) {
        return function(options, actionData, eventData) {
            var event_key = lodash.get(options, 'event', 'listening-for-localstorage-changes');
            var next_event = lodash.get(options,'next_event', null);
            var initialValue = '1';
            localStorage.setItem(event_key, initialValue);
            return $q.when(run());
            function run() {
                window.onstorage = function(e) {
                    if (e.key == event_key && e.newValue != initialValue && e.newValue != e.oldValue) {
                        window.onstorage = null;
                        localStorage.removeItem(event_key);
                        $rootScope.$broadcast(next_event, actionData, eventData);
                    }
                }
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['GenericModel', '$q', 'lodash'];
    angular
        .module('ActionManager')
        .factory('action-request', actionFunc);

    function actionFunc(GenericModel, $q, lodash) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
        return function(options, data, actionResponseData) {
            // Todo: This request action may encounter issue when during doing api call against child state
            // E.g, put to /candidates/1/profiles/23. Need to find ways to put in those into the param portion of the request.
            const deferred = $q.defer();
            if (!lodash.has(options, 'url')) {
                deferred.reject('No Endpoint specified');
                return deferred;
            }

            let postData = data;
            if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                postData = actionResponseData;
            }

            let endpoint = decodeURI(options.url).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(postData, submatch, '');
            });

            const method = lodash.get(options, 'method', 'get');
            const resource = new GenericModel(endpoint);
            const finalPostData = lodash.extend({}, postData);

            if (method === 'get') {
                return resource[method](finalPostData).$promise;
            } else {
                return resource[method]({}, {'data':finalPostData}).$promise;
            }
        };
    }
})();
(function () {
    'use strict';

    ActionModel.$inject = ['lodash'];
    angular
        .module('SodCustomAction')
        .factory('ActionModel', ActionModel);

    function ActionModel(lodash) {
        var mem = {};

        return {
            set: set,
            sync: sync,
            destroy: destroy,
            // getAll: function() { return mem; },
            // clearAll: clearAll
        };

        function set(type, name, data) {
            lodash.set(mem, [type, name, 'model'].join('.'), data);
        }

        function sync(ref, type, name) {
            if (!lodash.has(mem, [type, name, 'model'].join('.'))) {
                lodash.set(mem, [type, name, 'model'].join('.'), {
                });
            }
            lodash.set(ref,'viewData', lodash.get(mem, [type, name].join('.'), {}));
        }

        function destroy(type, name) {
            if (lodash.has(mem, [type, name].join('.'))) {
                delete mem[type][name];
            }
        }

        // function clearAll() {
        //     mem = {};
        // }
    }
})();
 (function () {
    'use strict';

    asyncPanelCtrl.$inject = ['PanelManager', '$scope', '$element', 'SodLogger', 'lodash', '$compile', '$templateCache'];
    angular
        .module('AsyncPanel')
        .directive('asyncPanel', asyncPanel);

    function asyncPanel() {
        return {
            restrict: 'E',
            controller: asyncPanelCtrl,
            controllerAs: 'vm',
            scope: {
                // must expose function to refresh panel
                options: '=', // requirement, otherwise we don't know what to do with the panel
                data: '=?',
                refresh: '=?', // for debugging purpose only
                isRefreshing: '=?', // for debugging purpose only
                panel: '=?'
            },
            bindToController: true,
            template: '<div class="async-panel-loading" ng-if="!vm.options.settings.hide_loading"></div>',
        };
    }

    function asyncPanelCtrl(PanelManager, $scope, $element, SodLogger, lodash, $compile, $templateCache) {
        // const vm = this;
        var vm = this;

        // vm = this;

        this.$onInit = function() {
            vm.panel = PanelManager.init($scope, vm.options, vm.data);
            vm.panelState = {};
            vm.panel.syncState(vm);
            vm.panel.run();
        }

        vm.handleRender = handleRender;
        vm.refresh = refresh;
        vm.isRefreshing = isRefreshing;


        $scope.$on('$destroy', function() {
            // console.log('%c Destroying Panel: ' + vm.panel.getId(), 'color: red');
            PanelManager.destroy(vm.panel.getId());
        });

        function refresh() {
            vm.panel.refresh();
        }

        function isRefreshing() {
            return vm.panel.isLoading();
        }

        function handleRender() {
            let template;

            if (lodash.has(vm.panelState, 'structure')) {
                if (lodash.has(vm.panelState,'structure.template')) {
                    template = vm.panelState.structure.template;
                }
                if (!lodash.has(vm.panelState, 'structure.template') && lodash.has(vm.panelState, 'structure.templateUrl')) {
                    template = $templateCache.get(vm.panelState.structure.templateUrl);
                }
                // SodLogger.debug('Rendering Template', vm, vm.panelState, template);
            }

            if (vm.panel && vm.panel.destroyCompileElement)
                vm.panel.destroyCompileElement();
            if (template && template.length > 0) {
                $element.html(template);
                vm.panel.setCurrentScope($scope.$new());
                const compileElementRef = $compile($element.contents())(vm.panel.getCurrentScope());
                vm.panel.setCompileElement(compileElementRef);
            }
        }
    }
})();

(function () {
    'use strict';

    panelContentTab.$inject = ['lodash', 'CommonHelper'];
    panelContentTabCtrl.$inject = ['$timeout', 'lodash', 'PanelContentTabService', '$scope', 'PanelManager', '$location'];
    angular
        .module('AsyncPanel')
        .directive('panelContentTab', panelContentTab);

    // const template = ``;
    //const template = `<div class="async-panel-tab flex-style flex-column flex-nowrap"><div class="apt-menu-wrapper"><ul class="menu"><li ng-repeat="panelContent in vm.panelContents" ng-bind="panelContent.name" ng-click="vm.setActive(panelContent)" ng-class="{'active': vm.isActive(panelContent)}"></li></ul></div><div class="apt-content-wrapper flex-item-grow-1" style="min-height: 0;"><async-panel data="vm.data" options="vm.pageData.activeOption" refresh="vm.refreshAsyncPanel" ng-if="vm.pageData.activeOption" is-refreshing="vm.refreshing"></async-panel></div></div>`;

    function panelContentTab(lodash, CommonHelper) {
        return {
            restrict: 'E',
            controller: panelContentTabCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                panelContents: '=?',
                data: '=?',
                settings: '=?',
            },
            templateUrl: function (tElement, tAttrs) {
                // var templateName = lodash.get(tAttrs, 'template', '');
                if (lodash.has(tAttrs, 'templateFullPath')) {
                    return tAttrs.templateFullPath;
                }

                if (lodash.has(tAttrs, 'templateName')) {
                    return 'common/app/panel-content/' + tAttrs.templateName;
                } else {
                    return 'common/app/panel-content/panel-content-tab-horizontal';
                }
            }
        };
    }

    function panelContentTabCtrl($timeout, lodash, PanelContentTabService, $scope, PanelManager, $location) {
        var vm = this;
        var stopWatchingLocation = null;
        var field = '';
        var identifier = '';

        this.$onInit = function() {
            vm.pageData = {
                activeOption: null,
            };
            refreshTabsVisibility();
            // vm.visiblePanelContents = angular.copy(vm.panelContents);

            vm.settings = lodash.get(vm, 'settings', {});
            vm.settings.setActiveFromAction = setActiveFromAction;
            vm.settings.refreshTabsVisibility = refreshTabsVisibility;
            vm.settings.stepIsRefreshing = false;

            field = lodash.get(vm.settings, 'tab_identifier_key', 'panel_content_id');

            identifier = lodash.get(vm.settings, 'identifier', $scope.$id);
            PanelContentTabService.init(vm.settings);
            PanelContentTabService.sync(identifier, vm);
            PanelContentTabService.refreshModel(identifier);

            // vm.pageData.activeOption = vm.panelContents[0];
            // handleInitActive();

            vm.setActive = setActive;
            vm.isActive = isActive;
            vm.showButton = showButton;
            vm.isRefreshing = isRefreshing;
            vm.setActiveInit = setActiveInit;
            vm.isStepModelEmpty = isStepModelEmpty;

            $scope.$on('$destroy', function () {
                PanelContentTabService.destroy(identifier);
            });

            $scope.$on('$locationChangeSuccess', locationChangeSuccess);
            stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
        }

        function locationChangeSuccess(evt, newpath, oldpath) {
            var path_info = newpath.split('?');
            if (path_info.length > 1) {
                var params = path_info[1].split('&').reduce(function (result, _param) {
                    var split_param = _param.split('=');
                    result[split_param[0]] = split_param[1];
                    return result;
                }, {});

                var step = lodash.get(params, 'step');
                var type = lodash.get(params, 'type');
                if (step) {

                    var panel_content = lodash.find(vm.visiblePanelContents, function (_p) {
                        return _p.name.toLowerCase() === step.toLowerCase();
                    });
                    if (panel_content && lodash.get(vm.pageData.activeOption, 'name') !== step) {
                        // if (panel_content && lodash.get(vm.pageData.activeOption, 'step', step) !== step) {
                        setActive(panel_content, type);
                    }
                }
            }
            if (typeof stopWatchingLocation !== typeof function () {
            }) {
                stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
            }
        }

        function locationChangeStart() {
            if (typeof stopWatchingLocation === typeof function () {
            }) {
                stopWatchingLocation();
            }
        }

        function setActive(panelContent, childKey) {
            var children = lodash.get(panelContent, 'children', []);
            var panel = panelContent;

            vm.settings.stepIsRefreshing = true;
            vm.pageData.activeOption = null;

            $location.search({});

            if (children.length > 0) {
                panel = children[0];

                if (childKey) {
                    panel = lodash.find(children, function (child) {
                        return child.key === childKey || child.name === childKey;
                    });
                }

                if (panel === undefined) {
                    return;
                }

                panel['siblings'] = children;
                panel['parent'] = panelContent;
                $location.search('type', panel.name);
            }

            $location.search('step', panelContent.name);

            $timeout(function () {
                vm.pageData.activeOption = panel;
                var event = lodash.get(vm.settings, 'async.event.change', null);
                vm.settings.stepIsRefreshing = false;
                if (event) {
                    $scope.$emit(event, {scope: vm, target: panel});
                }
            });
        }

        function setActiveFromAction(identifier) {
            var panelContent = lodash.find(vm.visiblePanelContents, {[field]: identifier});
            var parentKey = lodash.get(panelContent, 'parent_key', false);
            if (parentKey) {
                var parent = lodash.find(vm.visiblePanelContents, {key: parentKey});
                return setActive(parent, panelContent.key)
            }
            setActive(panelContent);
        }

        function isActive(panelContent) {
            var children = lodash.get(panelContent, 'children', false);
            var activePanelContentIdentifier = lodash.get(vm.pageData.activeOption, field, false);
            return children
                ? lodash.some(children, function (child) {
                    return child[field] === activePanelContentIdentifier
                })
                : panelContent[field] === activePanelContentIdentifier;
        }

        function setActiveInit() {
            // var activePanels = lodash.filter(vm.data)
            // console.log('setActiveInit', vm.stepModel);
            var activeVisiblePanelContents = angular.copy(vm.visiblePanelContents);
            if (!isStepModelEmpty()) {
                var activePanelsRef = lodash.filter(lodash.values(vm.stepModel), {active: true});
                activeVisiblePanelContents = activePanelsRef.reduce(function (result, ref) {
                    var _p = lodash.find(vm.visiblePanelContents, {step: ref.identifier});
                    if (!!_p) {
                        result.push(_p);
                    }
                    return result;
                }, []);
            }

            var stepPanelContent = null;
            var typePanelContent = null;
            var activePanelContent = null;

            var searchData = $location.search();
            var step = lodash.get(searchData, 'step', null);
            var type = lodash.get(searchData, 'type', null);

            if (!!step) {
                stepPanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                    return panel_content.name.toLowerCase() === step.toLowerCase();
                });

                activePanelContent = stepPanelContent;

                var children = lodash.get(activePanelContent, 'children', false);
                var isChild = lodash.get(activePanelContent, 'child', false);

                if (children && children.length > 0) {
                    // !!type
                    //     ? typePanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                    //         return panel_content.name.toLowerCase() === type.toLowerCase();
                    //     })
                    //     : typePanelContent = children[0];

                    if (!!type) {
                        typePanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                            return panel_content.name.toLowerCase() === type.toLowerCase();
                        })
                    }

                    if (!typePanelContent) {
                        typePanelContent = children[0];
                    }

                    typePanelContent['siblings'] = stepPanelContent.children;
                    typePanelContent['parent'] = stepPanelContent;
                    activePanelContent = typePanelContent;

                    $location.search('type', lodash.get(typePanelContent, 'name'));
                }

                if (isChild) {
                    var parentKey = lodash.get(activePanelContent, 'parent_key');
                    var parent = lodash.find(vm.visiblePanelContents, {key: parentKey});
                    $location.search('step', parent.name);
                    $location.search('type', lodash.get(stepPanelContent, 'name'));
                }

                if (stepPanelContent) {
                    vm.pageData.activeOption = activePanelContent;
                    return;
                }
            }

            $location.search('step', null);

            var defaultStep = lodash.get(vm.settings, 'defaultStep', null);
            if (defaultStep) {
                stepPanelContent = lodash.find(activeVisiblePanelContents, function (panel_content) {
                    return panel_content.name.toLowerCase() === defaultStep.toLowerCase();
                });
                vm.pageData.activeOption = stepPanelContent;
            } else {
                vm.pageData.activeOption = activeVisiblePanelContents[0];
            }
        }

        function isStepModelEmpty() {
            return lodash.isEmpty(vm.stepModel);
        }

        function showButton(button) {
            // var selected_panel_content_id = lodash.get(vm.pageData, 'activeOption.panel_content_id', false);

            // if (!selected_panel_content_id) return false;

            // var buttons_data = lodash.get(vm.settings, 'buttonShowConfig.' + selected_panel_content_id, {});

            // return lodash.get(buttons_data, button.name, false);

            var visible_buttons = lodash.get(vm.pageData.activePanelState, 'state.structure.options.button_visibility', []);
            return !!lodash.get(visible_buttons, button.name, false);
        }

        function refreshTabsVisibility() {
            var panelContents = angular.copy(vm.panelContents);
            var parents = [];

            if (lodash.has(vm.settings, 'tab_visibility_rules')) {
                panelContents = panelContents.filter(function (panelContent, index) {
                    if (isVisible(panelContent)) {
                        if (lodash.has(panelContent, 'children')) parents.push(panelContent.key);
                        return true;
                    }
                });
            }

            vm.groupedTabs = lodash.groupBy(panelContents, function (panelContent) {
                return lodash.has(panelContent, 'child');
            });

            if (parents.length > 0) {
                parents.forEach(function (parentKey) {
                    var parentIndex = lodash.findIndex(panelContents, {key: parentKey});
                    var parent = panelContents[parentIndex];
                    panelContents[parentIndex]['children'] = vm.groupedTabs[true].filter(function (childPanel) {
                        return childPanel['parent_key'] === parent.key;
                    });
                });
            }
            vm.visiblePanelContents = panelContents;
            vm.visibleMenuTabs = vm.groupedTabs[false];
        }

        function isVisible(panelContent) {
            var rule = lodash.get(vm.settings, 'tab_visibility_rules.' + panelContent.key, false);
            if (rule && Array.isArray(rule)) {
                return lodash.some(rule, function (_rule) {
                    return lodash.get(vm.data, _rule, false);
                })
            }

            return lodash.get(vm.data, rule, false);
        }

        function isRefreshing() {
            return ((typeof vm.refreshing === typeof function () {
            }) ? vm.refreshing() : false) || vm.settings.stepIsRefreshing;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .constant('REFRESH_CONST', {
            REFRESH_ALL: 0,
            REFRESH_STRUCTURE: 1,
            REFRESH_MODEL: 2,
            REFRESH_NONE: 3,
            REFRESH_INIT: 4,
            REFRESH_INIT_DONE: 5
        });
})();
(function () {
    'use strict';

    actionRefreshPanelContentTab.$inject = ['PanelContentTabService', 'lodash'];
    angular
        .module('AsyncPanel')
        .factory('action-panel-content-tab-refresh-model', actionRefreshPanelContentTab);

    function actionRefreshPanelContentTab(PanelContentTabService, lodash) {
        return function(options) {
            var identifier = lodash.get(options, 'identifier', null);
            if (identifier !== null) {
                return PanelContentTabService.refreshModel(identifier);
            }
            // returning false. It is up to the person writing the actions to understand
            // that they shouldn't use this actions if they didn't set the async model for panel
            // content tab
            return false;
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', '$rootScope'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-call-event', actionFunc);

    function actionFunc($q, lodash, $rootScope) {
        return function (panel, options, actionData, eventData) {
            return $q.when(run());

            function run() {
                const scope = panel.getPanelScope();
                if (lodash.has(options, 'conditions')) {
                    const panelData = {
                        panel,
                        actionData,
                        eventData
                    };
                    const result = options.conditions.reduce(function (result, condition) {
                        if (result === false) return result;
                        const keyPath = lodash.get(condition, 'path', '');
                        let value = '';
                        if (lodash.has(condition, 'valuePath')) {
                            value = lodash.get(panelData, condition.valuePath, false);
                        } else {
                            value = lodash.get(condition, 'value', false);
                        }

                        return lodash.get(panelData, keyPath, false) === value;
                    }, true);

                    if (!result) return result;
                }
                $rootScope.$broadcast(lodash.get(options, 'event', ''), {
                    actionData, eventData
                });
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-destroy-panel-content', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                let panel_ids = lodash.get(options, 'panel_ids', null);
                if (!panel_ids) {
                    return false;
                }

                if (!(panel_ids instanceof Array)) {
                    panel_ids = [panel_ids];
                }

                panel_ids.map(function(panel_id) {
                    PanelManager.destroy(panel_id);
                });
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-func-callback', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function (panel, options) {
            const panel_id_override = lodash.get(options, 'panel_id', null);
            const funcName = lodash.get(options, 'funcName', 'getModel');
            const pathToFun = lodash.get(options, 'pathToFunc', null);
            const targetted_panel = (panel_id_override) ? PanelManager.get(panel_id_override) : panel;

            var callbackFunc = null;

            if (pathToFun) {
                const parent = lodash.get(targetted_panel, pathToFun);
                callbackFunc = parent[funcName];
            } else {
                callbackFunc = targetted_panel[funcName];
            }
            console.log(targetted_panel);

            if (typeof callbackFunc === typeof function() {}) {
                callbackFunc();
            }
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-get-component-model', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                const funcName = lodash.get(options, 'funcName', 'getModel');
                const updateStateFunc = lodash.get(options, 'updateFunc', 'setState');
                const panel_id_override = lodash.get(options, 'panel_id', null);
                const targetted_panel = (panel_id_override) ? PanelManager.get(panel_id_override) : panel;
                if (typeof targetted_panel.panelScope.vm[funcName] === typeof function() {}) {
                    let modelPath = 'model';
                    if (lodash.has(options, 'modelPath')) {
                        modelPath = [modelPath, options.modelPath].join('.')
                    }

                    const optionParams = lodash.get(options, 'params', false);
                    const componentModel = targetted_panel.panelScope.vm[funcName](optionParams);
                    if (lodash.has(options, 'update_panel') && !options.update_panel) {
                        return componentModel;
                    }

                    targetted_panel[updateStateFunc](modelPath, componentModel);
                    return true;
                }
                return false;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', '$injector', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-mutate-component-data', actionFunc);

    function actionFunc($q, lodash, $injector, PanelManager) {
        return function(panel, options, eventData, actionData) {
            const panelStateObj = {
                options,
                eventData,
                actionData
            };
            $q.when(options.map(function(option) {
                const library = $injector.get(option.component);
                if (lodash.has(option, 'panel_id')) {
                    lodash.set(panelStateObj, 'panel', PanelManager.get(option.panel_id));
                } else {
                    lodash.set(panelStateObj, 'panel', panel);
                }
                // if have data, will take precendent and directly set the state using its content
                if (lodash.has(option, 'data')) {
                    if (lodash.has(option, 'replacements')) {
                        /**
                         * {
                         *      source: <- the path to the value of interest
                         *      target: <- the path to the value we want to replace
                         *      key: <- the regex key we want to replace at the source. Optional
                         *              if Key does not exist, the source value will be replaced entirely by the target value.
                         * }
                         */
                        for (const replacement of option.replacements) {
                            let replacementValue = lodash.get(panelStateObj, replacement.source, '');

                            if (lodash.has(replacement, 'key')) {
                                const replacementTarget = lodash.get(option.data, replacement.target,'');
                                replacementValue = decodeURI(replacementTarget.replace(new RegExp(replacement.key, 'g'), replacementValue));
                            }
                            lodash.set(
                                option.data,
                                replacement.target,
                                replacementValue
                            );
                        }
                    }

                    // panel.setState(option.key, option.data);

                    library.setData(option.key, option.data);
                }
                // if no data, then look for next best thing, model key
                if (!lodash.has(option, 'data') && lodash.has(option, 'modelKey')) {
                    // panel.setState(key, lodash.get(model, option.modelKey, null));
                    library.setData(option.key, lodash.get(panelStateObj, option.modelKey, null));
                }
                return true;
            }));

            // return $q.when(run());
            // function run() {
            //
            //
            //
            //     return ListFilterService.getData(options.path);
            // }
        };
    }
})();

(function () {
    'use strict';

    actionMutatePanelState.$inject = ['lodash', '$q', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-mutate-panel-state', actionMutatePanelState);

    function actionMutatePanelState(lodash, $q, PanelManager) {
        return function(panel, options, actionData, responseModel) {
            const panelStateObj = {
                panel,
                options,
                actionData,
                responseModel
            };
            /**
             * Structure of option
             * key: required. To set the key in panelState
             * data: optional. If exists, will set the state using contents of data. Takes precedent over model key
             * modelKey: optional. If exists, will take the content of model[modelKey] and set the state.
             */
            $q.when(options.map(function(option) {

                // if have data, will take precendent and directly set the state using its content
                if (lodash.has(option, 'data')) {
                    let newData = option.data;
                    if (lodash.has(option, 'replacements')) {
                        if (newData === null) {
                            newData = {};
                        }
                        /**
                         * {
                         *      source: <- the path to the value of interest
                         *      target: <- the path to the value we want to replace
                         *      key: <- the regex key we want to replace at the source. Optional
                         *              if Key does not exist, the source value will be replaced entirely by the target value.
                         * }
                         */
                        for (const replacement of option.replacements) {
                            let replacementValue = lodash.get(panelStateObj, replacement.source, '');

                            if (lodash.has(replacement, 'key')) {
                                const replacementTarget = lodash.get(option.data, replacement.target,'');
                                replacementValue = decodeURI(replacementTarget.replace(new RegExp(replacement.key, 'g'), replacementValue));
                            }

                            if (lodash.has(replacement, 'target') && !lodash.isEmpty(replacement.target)) {
                                lodash.set(
                                    newData,
                                    replacement.target,
                                    replacementValue
                                );
                            } else {
                                if (lodash.isObject(newData)) {
                                    lodash.merge(newData, replacementValue);
                                } else {
                                    newData = replacementValue;
                                }
                            }
                        }
                    }

                    // panel.setState(option.key, option.data);
                    setPanelState(option.key, newData, lodash.get(option, 'panel', false));
                }
                // if no data, then look for next best thing, model key
                if (!lodash.has(option, 'data') && lodash.has(option, 'modelKey')) {
                    // panel.setState(key, lodash.get(model, option.modelKey, null));
                    setPanelState(
                        option.key,
                        lodash.get(panelStateObj, option.modelKey, null),
                        lodash.get(option, 'panel', false)
                    );
                }

                if (lodash.get(option, 'updateFormModel', false) === true) {
                    updateFormModel(lodash.get(option, 'panel', false));
                }
                return true;
            }));

            function setPanelState(key, data, panelId) {
                let panel = panelStateObj.panel;
                if (!!panelId) {
                    panel = PanelManager.get(panelId);
                }

                if (!!panel) {
	                panel.setState(key, data);
                }
            }

            function updateFormModel(panelId) {
                let panel = panelStateObj.panel;
                if (!!panelId) {
                    panel = PanelManager.get(panelId);
                }

                if (!!panel) {
                    panel.updateFormModel();
                }
            }
        };
    }
})();
(function () {
    'use strict';

    actionParallel.$inject = ['handleActionCall', '$q', 'lodash'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-parallel', actionParallel);

    function actionParallel(handleActionCall, $q, lodash) {
        return function(panel, options, actionData, responseModel) {
            const calls = options.actions.map(function(action) {
               return handleActionCall(action.name, action.options, actionData, panel, responseModel);
            });
            return $q.all(calls).then(function(res) {
               if (options.merge === true) {
                   return res.reduce(function(result, row) {
                       if (typeof row !== typeof {}) {
                           return result;
                       }
                       return lodash.merge({}, result, row);
                   }, {});
               }
               if (options.named) {
                   // the length of name must be equals to the length of calls, otherwise data will be lost.
                   return options.named.reduce(function(result, name, index) {
                       lodash.set(result, name, res[index]);
                       return result;
                   }, {});
               }
               return res;
            });
        };
    }
})();
//PanelContentTabService
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', 'PanelContentTabService'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-select-panel-content-tab', actionFunc);

    function actionFunc($q, lodash, PanelContentTabService) {
        return function(panel, options, eventData, actionData) {
            return $q.when(run());

            function run() {
                const combinedData = (options.useActionResponse)
                    ? angular.merge(angular.copy(options), actionData.data)
                    : angular.merge(angular.copy(options), eventData);
                const identifier = lodash.get(options, 'identifier', null);
                const active_identifier = lodash.get(combinedData, 'panel_content_identifier', null);
                if (identifier === null || active_identifier === null) {
                    return false;
                }

                PanelContentTabService.setActive(identifier, active_identifier);
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-set-component-validation-model', actionFunc);

    function actionFunc($q, lodash) {
        return function(panel, options, eventData, actionData) {
            return $q.when(run());

            function run() {
                const funcName = lodash.get(options, 'funcName', 'setValidationModel');
                if (typeof panel.panelScope.vm[funcName] === typeof function() {}) {
                    let modelPath = 'model';
                    if (lodash.has(options, 'modelPath')) {
                        modelPath = [modelPath, options.modelPath].join('.')
                    }
                    let data = eventData;
                    if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                        data = actionData;
                    }
                    if (lodash.has(options, 'dataPath')) {
                        data = lodash.get(data, options.dataPath, data);
                    }

                    panel.panelScope.vm[funcName](data);
                    return true;
                }
                return false;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-set-panel-options', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                const panel_id = lodash.get(options, 'panel_id', null);
                const data = lodash.get(options, 'data', null);
                if (!panel_id || !data) {
                    return false;
                }

                const panel = PanelManager.get(panel_id);
                if (!panel) {
                    return false;
                }

                panel.setOptions(data);
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', '$rootScope'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-split-call-event', actionFunc);

    function actionFunc($q, lodash, $rootScope) {
        return function (panel, options, actionData, eventData) {
            return $q.when(run());

            function run() {
                const scope = panel.getPanelScope();
                if (lodash.has(options, 'conditions')) {
                    const panelData = {
                        panel,
                        actionData,
                        eventData
                    };
                    const result = options.conditions.map(function (condition) {
                        const keyPath = lodash.get(condition, 'path', '');
                        let value = '';
                        if (lodash.has(condition, 'valuePath')) {
                            value = lodash.get(panelData, condition.valuePath, false);
                        } else {
                            value = lodash.get(condition, 'value', false);
                        }

                        if (lodash.get(panelData, keyPath, false) === value) {
                            $rootScope.$broadcast(lodash.get(condition, 'event', ''), {
                                actionData, eventData
                            });
                        }

                    });
                }
                return false; // false because there shouldn't be any actions after this action from the same event.
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$timeout', 'SodLogger'];
    angular
        .module('AsyncPanel')
        .factory('action-ap-test-logger', actionFunc);

    function actionFunc($timeout, SodLogger) {
        return function() {
            const args = arguments;
            return $timeout(function() {
                SodLogger.info('ACTIONTEST LOGGER', args);
            });
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['GenericModel', 'lodash'];
    angular
        .module('AsyncPanel')
        .factory( 'action-get-model', actionFunc);

    function actionFunc(GenericModel, lodash) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;
        return function(asyncOptions, model) {
            let asyncUrl = asyncOptions.url;
            const method = lodash.get(asyncOptions, 'method', 'get');

            asyncUrl = decodeURI(asyncUrl).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(model, submatch, '');
            });

            const resource = new GenericModel(asyncUrl);
            return resource[method]().$promise.then(function(res) {
                return res;
            }, function() {
                return arguments;
            });
        };
    }
})();
(function () {
    'use strict';

    getPanelModel.$inject = ['lodash', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-get-panel-model', getPanelModel);

    function getPanelModel(lodash, PanelManager) {
        return function(options) {
            const panel_id = lodash.get(options, 'panel_id', false);
            if (!panel_id) return false;
            const panel = PanelManager.get(panel_id);
            return panel.getModel();
        };
    }
})();
(function () {
    'use strict';

    actionGetStructure.$inject = ['lodash', 'GenericModel'];
    angular
        .module('AsyncPanel')
        .factory('action-get-structure', actionGetStructure);

    function actionGetStructure(lodash, GenericModel) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;
        return function(panelId, asyncOptions, model) {
            let asyncPanelPath = asyncOptions.url;
            const method = lodash.get(asyncOptions, 'method', 'get');
            const requestData = lodash.get(asyncOptions, 'params', {});

            if (lodash.has(model, 'event', false)) { delete model.event; }
            if (lodash.has(model, 'target', false)) { delete model.target; }
            if (lodash.has(model, 'targetScope', false)) { delete model.targetScope; }

            requestData.stateModel = model;

            asyncPanelPath = decodeURI(asyncPanelPath).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(model, submatch, '');
            });

            // const resource = new GenericModel(asyncPanelPath + '?XDEBUG_SESSION_START');
            const resource = new GenericModel(asyncPanelPath);
            return resource[method]({},{data:requestData}).$promise.then(function(res) { return res; }, function() { return arguments; });
        };
    }
})();
(function () {
    'use strict';

    actionRefreshPanel.$inject = ['lodash', '$q', 'PanelManager'];
    angular
        .module('AsyncPanel')
        .factory('action-refresh-panel', actionRefreshPanel);

    function actionRefreshPanel(lodash, $q, PanelManager) {
        return function(option) {
            $q.when([run(option)]);
        };

        function run(option) {
            if (lodash.has(option, 'panel_ids')) {
                // refresh that panel only
                let panel_ids = option.panel_ids;
                if (!(option.panel_ids instanceof Array)) {
                    panel_ids = [panel_ids];
                }

                for (const _panel_id of panel_ids) {
                    const _panel = PanelManager.get(_panel_id);
                    executeRefresh(option, _panel);
                }
            }
            if (!lodash.has(option, 'panel_ids')) {
                // refresh all panel
                const panels = PanelManager.getAll();
                for (const _panel of panels) {
                    executeRefresh(option, _panel);
                }
            }
        }

        function executeRefresh(options, panel) {
            if (!panel) return;
            const type = lodash.get(options, 'type', '');
            const showLoading = lodash.get(options, 'show_loading', false);

            switch (type) {
                case "model": {
                    return panel.refreshModel(showLoading);
                }
                case "structure": {
                    return panel.refreshStructure(showLoading);
                }
                case "none": {
                    return true;
                }
                case "all":
                default: {
                    return panel.refresh(showLoading);
                }
            }
        }
    }
})();
//PanelContentTabService
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'lodash', 'PanelContentTabService'];
    angular
        .module('AsyncPanel')
        .factory('action-refresh-tab-visibility', actionFunc);

    function actionFunc($q, lodash, PanelContentTabService) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                console.log('action-refresh-tab-visibility');
                const identifier = lodash.get(options, 'identifier', null);

                PanelContentTabService.refreshTabVisibility(identifier);
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$timeout'];
    angular
        .module('AsyncPanel')
        .factory('action-test-get-model', actionFunc);

    function actionFunc($timeout) {
        return () => {
            return $timeout(() => {
                return {
                    test1: '1',
                    test2: 2
                };
            }, 1000);
        };
    }
})();
(function () {
    'use strict';

    actionTestGetStructure.$inject = ['$timeout', 'SodLogger'];
    angular
        .module('AsyncPanel')
        .factory('action-test-get-structure', actionTestGetStructure);

    /* - Need a mixture of way we define the rules
     1. by name <- name should not be an actionable name (e.g. redirect, notify, request), instead, should be descriptive: validation-fail, success, failure
     2. by status code
     3. by status code range
     - A Rule should link to an event. When rule is triggered, it will call the next event and pass over all the response from the REST API, or otherwise stated
     - Will go through the list of rules. Rules should be triggered by priority. Once triggered it will break away from the loop.
     - Event name will be prefix by current event name, unless otherwise stated.
     - To make it simpler for the backend (no need to pass over certain rules). Certain status code should be taken care of by the engine. <- discuss with Jag
     Still need to pass me events for these situations.
     - Logic: 422, 400, 500 first, then custom rules, then success rules.
     */

    function actionTestGetStructure($timeout, SodLogger) {
        return (panelId) => {
            SodLogger.debug('Test Get Structure, Panel Id', panelId);
            return $timeout(() => {
                return {
                    events: [
                        {
                            //
                            event: "action-manager.rms.login_form.form_submit",
                            actions: {
                                async : [
                                    {
                                        name: "request",
                                        options: {
                                            endpoint:'/v1/auth/login',
                                            method: 'post'
                                        },
                                        stateMap: {
                                            key: 'model'
                                        }
                                        // stateMutate: {}, // contains info to help mutate the result of the state into what the action required. Not needed to code for now.
                                        // rules: []
                                    }
                                ],
                                sync: []
                            }
                        },

                        {
                            event: "action-manager.rms.login_form.form_submit.request.success",
                            actions: {
                                async: [
                                    {
                                        name: 'notify',
                                        options: {
                                            template: 'Login Successfully' // can do replace here also if needed.
                                        }
                                    }
                                ],
                                sync: []
                            }
                        },

                        {
                            event: "action-manager.rms.login_form.form_submit.error",
                            actions: {
                                async: [],
                                sync: [
                                    {
                                        name: 'mutate-panel-state',
                                        options: [
                                            {
                                                key: 'panel',
                                                data: {

                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        }

                    ],
                    templateUrl: '<fb-form-generator fb-data="vm.panelState.structure.form" fb-model="vm.panelState.model"></fb-form-generator>',
                    form: {
                        "schema": [],
                        "model": {
                            "hid_ref_form": "3476915e3d59ac4bbef03b6e0ec243e1922e",
                            "hid_form_draft_id": "2344194f76f27abc5806fc9cb1476f0b3d6c"
                        },
                        "name": "e369853df766fa44e1ed0ff613f563bd",
                        "form_events": [],
                        "buttons_wrapper_type": "inline",
                        "settings": {
                            "check_for_dirty": false
                        },
                        "elements": [
                            {
                                "label": "Email Address",
                                "type": "email",
                                "name": "txt_email",
                                "attr": [],
                                "position": 1,
                                "options": []
                            },
                            {
                                "label": "Password",
                                "type": "password",
                                "name": "txt_password",
                                "attr": [],
                                "position": 2,
                                "options": []
                            },
                            {
                                "label": "fields.form_draft_id",
                                "type": "hidden",
                                "name": "hid_form_draft_id",
                                "attr": [],
                                "position": 99,
                                "options": []
                            },
                            {
                                "label": "Form ID",
                                "type": "hidden",
                                "name": "hid_ref_form",
                                "attr": [],
                                "position": 99,
                                "options": []
                            }
                        ],
                        "buttons": [
                            {
                                "label": "Login",
                                "type": "submit",
                                "name": "btn_submit",
                                "class": "main expanded rounded",
                                "event": {
                                    "click": "action-manager.rms.login_form.form_submit"
                                },
                                "icon": "",
                                "attr": []
                            }
                        ]
                    }
                };
            }, 1000);
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$timeout', 'SodLogger'];
    angular
        .module('AsyncPanel')
        .factory('action-test-logger', actionFunc);

    function actionFunc($timeout, SodLogger) {
        return function() {
            const args = arguments;
            return $timeout(function() {
                console.log(args);
                return true;
                // SodLogger.info('ACTIONTEST LOGGER', args);
            });
        };
    }
})();
(function () {
    'use strict';

    EventsManager.$inject = ['lodash', 'SodLogger', 'ActionManager', 'handleActionCall', '$q', '$rootScope', '$injector', '$timeout', 'KeyTrackingService'];
    angular
        .module('AsyncPanel')
        .factory('EventsManager', EventsManager);

    function EventsManager(lodash, SodLogger, ActionManager, handleActionCall, $q, $rootScope, $injector, $timeout, KeyTrackingService) {
        const registration = [];
        genericListeners();
        return {
            listen: listen,
            isRegistered: isRegistered,
            isRegistedGlobally: isRegistedGlobally,
            destroy: destroy,
            trigger: trigger,
            getRegistrations: function() { return registration},
        };

        function listen(panel, events) {
            // fix empty panel to not run handleRefresh
            // cause when it's destroy, it's still left as empty panel and when it runs
            // if empty panel run after proper panel it could cause listeners = []
            // due to the fact that our function paramaeter for events default to []
            var panelScope = panel.getPanelScope();
            if (panelScope === null) return

            const listeners = [];
            SodLogger.info('The list of events ', events);
            if (events instanceof Array) {
                events.map(function(eventObj) {
                    const refFunc = function (e, eventData) {
                        SodLogger.debug('event triggered', eventObj, e, eventData, panel);
                        // handle sync and async action types separately.
                        if (lodash.has(eventObj, 'delay')) {
                            $timeout(function() {
                                processEventActions(panel, eventObj, e, eventData);
                            }, lodash.get(eventObj,'delay', 0));
                        } else {
                            processEventActions(panel, eventObj, e, eventData);
                        }
                    };

                    if (eventObj.type === 'broadcast') {
                        listeners.push({
                            name: eventObj.event,
                            reference: $rootScope.$on(eventObj.event, refFunc)
                        });
                    } else {
                        listeners.push({
                            name: eventObj.event,
                            reference: panel.getPanelScope().$on(eventObj.event, refFunc)
                        });
                    }
                });

                if (lodash.find(registration, {panelId: panel.getId()})) {
                    destroy(panel.getId());
                }

                registration.push({
                    panelId: panel.getId(),
                    listeners: listeners
                });
            }
        }

        function trigger(panel, event) {
            processEventActions(panel, event, {name: event.event}, null);
        }

        function isRegistered(panelId, eventName) {
            const panelListeners = lodash.find(registration, {panelId: panelId});
            if (!panelListeners) return false;
            return lodash.find(panelListeners.listeners, {name: eventName});
        }

        function isRegistedGlobally(eventName) {
            return registration.reduce(function(carry, _reg) {
                if (carry) return carry;
                return lodash.find(_reg.listeners, {name:eventName});
            }, false);
        }

        function destroy(panelId) {
            const panelListenersIndex = lodash.findIndex(registration, {panelId: panelId});

            if (panelListenersIndex >= 0) {
                const panelListeners = registration[panelListenersIndex];
                for (const listener of panelListeners.listeners) {
                    listener.reference();
                }
                registration.splice(panelListenersIndex, 1);
            }
        }

        function processEventActions(panel, event, evt, evtData) {
            // if (KeyTrackingService.hasNewTabCombinationKeyCode() && !(event.event.indexOf('.new_tab') >= 0)) {
            //     return;
            // }
            const asyncActions = lodash.get(event, 'actions.async', []);
            const syncActions = lodash.get(event, 'actions.sync', []);
            for (const asyncAction of asyncActions) {
                handleAsyncAction(panel, asyncAction, evt, evtData);
            }

            handleSyncAction(panel, syncActions, 0, evt, evtData);
        }

        function handleSyncAction(panel, actions, currentActionIndex, evt, evtData) { // eslint-disable-line no-unused-var
            if (currentActionIndex === actions.length) return;
            const action = actions[currentActionIndex];
            const actionName = lodash.get(action, 'name', false);
            if (!actionName) return;

            const actionOptions = lodash.get(action, 'options', {});
            const actionData = prepareAction(action, panel);
            $q.when(handleActionCall(actionName, actionOptions, actionData, panel, evtData), function(actionResponse) {
                // TODO: TAKE NOTE OF THIS LOGIC: WHEN actionResponse === false end sync;
                const onSuccessName = lodash.get(action, 'onSuccess', 'success');
                const onFailureName = lodash.get(action, 'onFail', false);
                if (actionResponse === false && !onFailureName) {
                    if (lodash.get(actionOptions, 'ignoreResponse', false) === false) {
                        return;
                    }
                }

                const nextEventType =   (actionResponse === false) ? onFailureName : onSuccessName;

                const nextEventName = [evt.name, action.name, nextEventType].join('.');
                let panel_id = panel.getId();
                let broadcast = false;
                if (lodash.has(action, 'options.target_panel')) {
                    panel_id = action.options.target_panel;
                    broadcast = true;
                }
                if (isRegistered(panel_id, nextEventName)) {
                    (broadcast)
                        ? $rootScope.$broadcast(nextEventName, actionResponse ? actionResponse : null)
                        : panel.getPanelScope().$emit(nextEventName, actionResponse ? actionResponse : null);
                } else {
                    handleSyncAction(panel, actions, currentActionIndex + 1, evt, actionResponse || evtData);
                }
            }, function(errorResponse) {
                handleError(errorResponse, panel, action, actionData, evt, evtData);
            });
        }

        function handleAsyncAction(panel, action, evt, evtData) { // eslint-disable-line no-unused-var
            const actionName = lodash.get(action, 'name', false);
            if (!actionName) return;
            const actionOptions = lodash.get(action, 'options', {});
            const actionData = prepareAction(action, panel);
            // Need to be careful with this as not all actions have response. Or should I make them have response.
            // need to prepare the information needed to pass over to the action

            $q.when(handleActionCall(actionName, actionOptions, actionData, panel, evtData), function (actionResponse) {
                // if there are rules from the action, go through it.
                // Async-type handle success responses differently from SyncType. So we can't mix them together.

                const onSuccessName = lodash.get(action, 'onSuccess', 'success');
                const onFailureName = lodash.get(action, 'onFail', false);
                const nextEventType =   (actionResponse === false) ? onFailureName : onSuccessName;
                const nextEventName = [evt.name, action.name, nextEventType].join('.');
                if (isRegistered(panel.getId(), nextEventName)) {
                    panel.getPanelScope().$emit(nextEventName, actionResponse ? actionResponse : null);
                }

                // call success event.
            }, function(errorResponse) {
                handleError(errorResponse, panel, action, actionData, evt, evtData);
            });
        }

        function handleError(errorActionResponse, panel, action, actionData, evt, evtData) {
            // if errorAction has statusCode, look through status code stuff.
            // Similarly, Async-type handle error responses differently from SyncType.
            const errorObject = {
                response: errorActionResponse.data,
                panel,
                action,
                actionData,
                evt,
                evtData
            };

            const statusCode = lodash.get(errorActionResponse, 'status', null);
            if (!statusCode) {
                SodLogger.debug('Action Error Response of: ' + action.name, errorObject);
                handleErrorTrigger(panel, evt.name, action.name, 'error', errorObject);
            }
            if (statusCode) {
                switch (statusCode) {
                    case 422:
                        // call validation event if have, otherwise call generic validation event
                        handleErrorTrigger(panel, evt.name, action.name, 'validation', errorObject);
                        break;
                    case 403:
                        handleErrorTrigger(panel, evt.name, action.name, 'unauthorized', errorObject);
                        break;
                    default:
                        // call error event if have, otherwise call generic error event
                        handleErrorTrigger(panel, evt.name, action.name, 'error', errorObject);
                        break;
                }
            }
        }

        function handleErrorTrigger(panel, eventName, actionName, type, errorObj) {
            let isRmsEventNameRegistered = false;
            let nextRmsEventName;
            if (lodash.has(errorObj, 'response.rms_error_code')) {
                nextRmsEventName = [eventName, actionName, type, errorObj.response.rms_error_code].join('.');
                isRmsEventNameRegistered = isRegistered(panel.getId(), nextRmsEventName);
            }

            if (isRmsEventNameRegistered) {
                panel.getPanelScope().$emit(nextRmsEventName, errorObj);
            } else {
                const nextEventName = [eventName, actionName, type].join('.');
                const _isRegistered = isRegistered(panel.getId(), nextEventName);
                if (_isRegistered) {
                    panel.getPanelScope().$emit(nextEventName, errorObj);
                }
                if (!_isRegistered) {
                    const _isGloballyRegistered = isRegistedGlobally(nextEventName);
                    if (_isGloballyRegistered) {
                        $rootScope.$broadcast(nextEventName, errorObj);
                    } else {
                        panel.getPanelScope().$emit('action-manager.generic.' + type, errorObj);
                    }
                }
            }
        }

        function prepareAction(action, panel) {
            let actionData = {};

            const stateKey = lodash.get(action, 'stateMap.key', false);
            if (stateKey) {
                const defaultState = lodash.get(action, 'stateMap.defaultState', {});
                actionData = panel.getState(stateKey, defaultState);
                // if action.has('stateMutate'), call ActionData.mutate. Function and service not create at this point.
            }

            const stateWrapper = lodash.get(action, 'stateMap.wrapper', false);
            if (stateWrapper) {
                actionData = lodash.set({}, stateWrapper, actionData);
            }


            if (lodash.has(action, 'appendModel')) {
                lodash.forIn(action.appendModel, function(value, key) {
                    lodash.set(actionData, key, value);
                });
            }

            return actionData;
        }

        function genericListeners() {
            $rootScope.$on('action-manager.generic.validation', function(e, data) {
                SodLogger.info('action-manager.generic.validation triggered', e, data);
                // Todo: quickfix for now, until fully implements
                var FormBuilderService = $injector.get('FormBuilderService');
                var fbService = FormBuilderService.get(data.evtData.formIdentifier);
                fbService.elementsService.setValidationRules(data.response.rules, data.response.summary);
                // ActionManager('enable-button', data.evtData.targetScope.name);
                ActionManager('enable-button', {
                    enable_all_disabled: true
                });
            });
            $rootScope.$on('action-manager.generic.error', function(e, eventData) {
                SodLogger.warn('action-manager.generic.error triggered', e, eventData);
            });
        }
    }
})();
(function () {
    'use strict';

    EventsRunner.$inject = ['$q', 'lodash', 'ActionManager'];
    angular
        .module('AsyncPanel')
        .factory('EventsRunner', EventsRunner);

    function EventsRunner($q, lodash, ActionManager) {
        return function(events, trigger, inputData) {
            return $q.when(eventsRunnerFunc(trigger, inputData));

            function eventsRunnerFunc(_trigger, data) {
                const event = lodash.find(events, {event: _trigger});
                // usually only 1 event to run.

                if (event) {
                    return $q.when(handleEventRunner(event, data));
                }
                return data;
            }

            function handleEventRunner(event, data) {
                const asyncActions = lodash.get(event, 'actions.async', []);
                const syncActions = lodash.get(event, 'actions.sync', []);
                for (const asyncAction of asyncActions) {
                    ActionManager(
                        asyncAction.name, // required
                        lodash.get(asyncAction, 'options', {}),
                        data
                    );
                }

                if (syncActions.length > 0) {
                    return handleEventSyncActions(syncActions, 0, data).then(function(res) {
                        const lastAction = lodash.last(syncActions);
                        return eventsRunnerFunc([event.event, lastAction.name, res.actionType].join('.'), res.response);
                    });
                } else {
                    const eventLastName = lodash.last(event.event.split('.'));
                    return !(['error', '422'].indexOf(eventLastName) >= 0);
                }
            }

            function handleEventSyncActions(actions, currentIndex, data) {
                if (currentIndex >= actions.length) {
                    return data;
                }
                const currentAction = actions[currentIndex];
                return $q.when(ActionManager(
                    currentAction.name,
                    lodash.get(currentAction, 'options', {}),
                    data
                )).then(function(resp) {
                    return {
                        actionType: 'success',
                        response: handleEventSyncActions(actions, currentIndex+1, resp)
                    };
                }, function(err) {
                    return {
                        actionType: (err.status === 422) ? 422 : 'error',
                        response: (err.status === 422) ? err : false
                    };
                });
            }
        };


    }
})();
(function () {
    'use strict';

    PanelContentTabService.$inject = ['lodash', 'GenericModel'];
    angular
        .module('AsyncPanel')
        .factory('PanelContentTabService', PanelContentTabService);
    const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;
    function PanelContentTabService(lodash, GenericModel) {
        const mem = {};

        return {
            init: init,
            sync: sync,
            refreshModel: refreshModel,
            destroy: destroy,
            setActive: setActive,
            refreshTabVisibility: refreshTabVisibility,
        };

        function init(settings) {
            if (lodash.has(settings, 'identifier')) {
                lodash.set(mem, settings.identifier, settings);
            }
        }

        function sync(identifier, state) {
            mem[identifier].state = state;
        }

        function refreshModel(identifier) {
            if (lodash.has(mem, identifier + '.datasource.model')) {
                let asyncUrl = mem[identifier].datasource.model.url;
                const method = lodash.get(mem[identifier].datasource.model, 'method', 'get');

                asyncUrl = decodeURI(asyncUrl).replace(urlReplacerRegex, (match, submatch) => {
                    return lodash.get(model, submatch, '');
                });

                const resource = new GenericModel(asyncUrl);
                return resource[method]().$promise.then(function(res) {
                    mem[identifier].state.stepModel = res.data;
                    return res;
                }, function() {
                    return arguments;
                });
            }
            return false;
        }

        function destroy(identifier) {
            if (lodash.has(mem, identifier)) {
                delete mem[identifier];
            }
        }

        function setActive(identifier, panel_content_id) {
            if (lodash.has(mem, identifier)) {
                mem[identifier].setActiveFromAction(panel_content_id);
            }
        }

        function refreshTabVisibility(identifier) {
            if (lodash.has(mem, identifier)) {
                mem[identifier].refreshTabsVisibility();
            }
        }
    }
})();
/**
 * Handle the panel's structure.
 *      ->
 * Handles the panel's state
 *      The state consist of:
 *      -> Options that the panel will use, including components settings, endpoints
 *      -> Overall model of the panel
 *      -> Event -> Action mapping
 *      -> Templates
 *      -> Current step, should the panel has progression view
 */
(function () {
    'use strict';

    PanelManager.$inject = ['lodash', 'ActionManager', 'EventsManager', 'SodLogger', '$q', 'REFRESH_CONST', '$timeout'];
    angular
        .module('AsyncPanel')
        .factory('PanelManager', PanelManager);

    const STRUCTURE_URL_PATH = 'async.structure.url';
    const MODEL_URL_PATH = 'async.model.url';

    function PanelManager(lodash, ActionManager, EventsManager, SodLogger, $q, REFRESH_CONST, $timeout) {
        const panels = [];
        class Panel {
            constructor(panelScopeRef, options, externalData) {
                // options should be in this format
                // {
                //     model, <- optional, model/state that the panel should refer to for initial load
                //     structure, <- optional, structure that the panel adheres to for initial load
                //     async: {
                //         model, <- api info to make restful call to get model. optional. Used when model is absent, or when refresh is made
                //         structure <- api info to get structure info. Required when structure is absent. Used when structure is absent or when refresh is made.
                //     },
                //     panelId <- id of panel
                // };
                this.options = options;
                this.panelScope = panelScopeRef;
                this.currentScope = null;
                this.initState(externalData);
                this.getModel = function() {
                    return lodash.get(this.state, 'model', {});
                }
            }
            run() {
                this.handleRefresh(this._determineInitRefreshOptions());
            }
            initState(externalData) {
                this.state = { // default state;
                    async: null,
                    structure: null,
                    model: this._mapExternalDataToModel(externalData),
                    panelOptions: {},
                    panelId: null,
                    panelContentId: null,
                };
                this.setState('panelId', lodash.get(this.options, 'panel_id', (new Date()).getTime()));
                this.setState('panelContentId', lodash.get(this.options, 'panel_content_id', null));
                this.setState('async', lodash.get(this.options, 'async', null));
                if (lodash.has(this.options, 'structure')) {
                    this.setState('structure', angular.copy(this.options.structure));
                }
                if (lodash.has(this.options, 'model')) {
                    this.setState('model', angular.copy(this.options.model));
                }
                if (lodash.has(this.options, 'options')) {
                    this.setState('panelOptions', angular.copy(this.options.options));
                }
            }
            _mapExternalDataToModel(externalData) {
                if (!lodash.isEmpty(externalData)) {
                    return externalData;
                }
                return {};
            }
            _determineInitRefreshOptions() {
                let refreshOptions = REFRESH_CONST.REFRESH_ALL;
                const currentState = this.getState('structure');
                if (currentState !== null) {
                    if (lodash.has(this.state, MODEL_URL_PATH)) {
                        refreshOptions = REFRESH_CONST.REFRESH_MODEL;
                    }
                    if (!lodash.has(this.state, MODEL_URL_PATH)) {
                        refreshOptions = REFRESH_CONST.REFRESH_NONE;
                    }
                    this.initRender = REFRESH_CONST.REFRESH_INIT;
                    this.render();
                }
                if (currentState === null) {
                    refreshOptions = this._determineRefreshOptions();
                }
                return refreshOptions;
            }
            _determineRefreshOptions() {
                let refreshOptions = REFRESH_CONST.REFRESH_ALL;
                if (!lodash.has(this.state, STRUCTURE_URL_PATH) && !lodash.has(this.state, MODEL_URL_PATH)) {
                    refreshOptions = REFRESH_CONST.REFRESH_NONE;
                }
                if (lodash.has(this.state, STRUCTURE_URL_PATH) && !lodash.has(this.state, MODEL_URL_PATH)) {
                    refreshOptions = REFRESH_CONST.REFRESH_STRUCTURE;
                }
                if (!lodash.has(this.state, STRUCTURE_URL_PATH) && lodash.has(this.state, MODEL_URL_PATH)) {
                    refreshOptions = REFRESH_CONST.REFRESH_MODEL;
                }
                return refreshOptions;
            }
            isLoading() {
                return this.loading;
            }
            getId() {
                return this.state.panelId;
            }
            getPanelContentId() {
                return this.state.panelContentId;
            }
            getPanelScope() {
                return this.panelScope;
            }
            setState(key, value) {
                lodash.set(this.state, key, value);
            }
            syncState(external) {
                external.panelState = this.state;
            }
            getState(key, _default) {
                if (!_default) _default = false;
                return lodash.get(this.state, key, _default);
            }
            setOptions(data, externalModel = {}) {
                this.options = data;
                this.initState(externalModel);
            }
            updateModel(resData) {
                const storeType = lodash.get(this.state.async.model, 'storeType', false);
                switch (storeType) {
                    case "merge": {
                        angular.merge(this.state.model, resData);
                        break;
                    }
                    case "extend": {
                        angular.extend(this.state.model, resData);
                        break;
                    }
                    default:
                        this.setState('model', resData);
                        break;
                }

            }
            refresh(showLoading = false) {
                this.handleRefresh(this._determineRefreshOptions(), showLoading);
            }
            refreshModel(showLoading = false) {
                this.handleRefresh(REFRESH_CONST.REFRESH_MODEL, showLoading);
            }
            refreshStructure(showLoading = false) {
                this.handleRefresh(REFRESH_CONST.REFRESH_STRUCTURE, showLoading);
            }

            handleRefresh(refreshOptions, showLoading = false) {
                // fix empty panel to not run handleRefresh
                if (lodash.get(this, 'panelScope.vm') === undefined) return;
                if (showLoading) {
                    this.state.structure.template = '<div class="async-panel-loading" ng-if="!vm.options.settings.hide_loading"></div>';
                    this.render();
                }

                this.loading = true;
                const _promises = [];

                if ([REFRESH_CONST.REFRESH_ALL, REFRESH_CONST.REFRESH_STRUCTURE].indexOf(refreshOptions) >= 0) {
                    EventsManager.destroy(this.getId());

                    if (lodash.has(this.state.async, 'structure.event.loading')) {
                        this.panelScope.$emit(this.state.async.structure.event.loading);
                    }

                    if (this.compileElementRef) this.compileElementRef.off();
                    // _promises.push(ActionManager('test-get-structure', this.getId()));
                    _promises.push(ActionManager('get-structure', this.getId(), this.state.async.structure, this.state.model));
                }
                if ([REFRESH_CONST.REFRESH_ALL, REFRESH_CONST.REFRESH_MODEL].indexOf(refreshOptions) >= 0) {
                    // _promises.push(ActionManager('test-get-model'));
                    _promises.push(ActionManager('get-model', this.state.async.model, this.state.model));
                }

                $q.all(_promises).then(responses=> { // On Success
                    SodLogger.info('Responses', responses[0]);

                    switch (refreshOptions) {
                        case REFRESH_CONST.REFRESH_ALL:
                            this.setState('structure', responses[0]);
                            this.updateModel(responses[1].data || responses[1].rows);
                            break;
                        case REFRESH_CONST.REFRESH_STRUCTURE:
                            this.setState('structure', responses[0]);
                            break;
                        case REFRESH_CONST.REFRESH_MODEL:
                            this.updateModel(responses[0].data || responses[0].rows);
                            break;
                        default: break;
                    }

                    // bind events
                    if ([REFRESH_CONST.REFRESH_ALL, REFRESH_CONST.REFRESH_STRUCTURE].indexOf(refreshOptions) >= 0) {
                        EventsManager.listen(this, this.getState('structure.events', []));
                        if (this.initRender && this.initRender === REFRESH_CONST.REFRESH_INIT) {
                            this.initRender = REFRESH_CONST.REFRESH_INIT_DONE;
                            this.destroyCompileElement();
                        }

                        if (lodash.has(this.state.async, 'structure.event.loaded')) {
                            // $timeout(function() {
                                var structure_event = lodash.find(this.getState('structure.events'), {event: this.state.async.structure.event.loaded});
                                if (structure_event)
                                    EventsManager.trigger(this, structure_event);
                            // }.bind(this));
                        }
                    }
                    if ([REFRESH_CONST.REFRESH_ALL, REFRESH_CONST.REFRESH_MODEL].indexOf(refreshOptions) >= 0) {
                        if (lodash.has(this.state.async, 'model.event.loaded')) {
                            this.panelScope.$emit(this.state.async.model.event.loaded);
                        }
                    }
                    this.render();
                    this.loading = false;
                }, (...args)=> { // On Error
                    SodLogger.error('Panel Refresh has Error', ...args);
                });
            }
            render() {
                // console.log('render',this.panelScope);
                // fix empty panel to not run handleRefresh
                if (lodash.get(this, 'panelScope.vm') === undefined) return;
                this.panelScope.vm.handleRender();
            }
            setCompileElement(ref) {
                this.compileElementRef = ref;
            }
            destroyCompileElement() {
                if (this.compileElementRef) {
                    this.compileElementRef.off();
                }
            }
            destroyPanelScope() {
                if (this.panelScope !== null) {
                    this.panelScope.$destroy();
                    this.panelScope = null;
                }
            }
            setCurrentScope(_scope) {
                this.destroyCurrentScope();
                this.currentScope = _scope;
            }
            getCurrentScope() {
                return this.currentScope;
            }
            destroyCurrentScope() {
                if (this.currentScope !== null) {
                    this.currentScope.$destroy();
                    this.currentScope = null;
                }
            }
            destroy() {
                // destroy all events
                this.destroyCompileElement();
                this.destroyCurrentScope();
                this.destroyPanelScope();
                EventsManager.destroy(this.getId());
            }
            emitEvent(eventName, event_data) {
                this.panelScope.$emit(eventName, event_data);
            }
            getModel() {
                return this.state.model;
            }
            updateFormModel() {
                if (typeof this.state.setModel === typeof function() {}) {
                    this.state.setModel(this.state.model);
                }
            }
        }

        return {
            init: function(panelScopeRef, panelSettings, externalData) {
                const panel = new Panel(panelScopeRef, panelSettings, externalData);
                const panelIndex = lodash.findIndex(panels, function(_p) {
	                return _p.getId() === panel.getId();
                });
                if (panelIndex >= 0)
                {
	                panels[panelIndex] = panel;
                } else {
	                panels.push(panel);
                }

                return panel;
            },
            get: function(id) {
                return lodash.find(panels, (panel) => panel.getId() == id);
            },
            getByPanelContentId: function(panelContentId) {
                return lodash.find(panels, (panel) => panel.getPanelContentId() == panelContentId);
            },
            getAll: function() {
                return panels;
            },
            refreshAll: function() {
                panels.map(function(panel) {
                   panel.refresh();
                });
            },
            destroy: destroy,
            destroyAll: destroyAll
        };

        function destroy(id) {
            const index = lodash.findIndex(panels, (panel) => panel.getId() == id);
            const panel = panels[index];
            if (panel) {
                panel.destroy();
                panels.splice(index, 1);
            }
            return $q.when(true);
        }

        function destroyAll() {
            return $q.when(panels.map(function(panel) {
                return destroy(panel.getId());
            }));
        }
    }
})();
angular.module('sodAppointmentSelector', ['ngLodash', 'dialog-manager', 'ActionManager', 'ResourceGenerator']);
angular.module('sodDocumentLibrary', ['ngLodash', 'dialog-manager', 'ActionManager', 'ResourceGenerator']);

angular.module('sodNotificationCenter', ['ngLodash', 'ActionManager', 'ResourceGenerator']);
(function () {
    'use strict';

    customDropdownButton.$inject = ['$document', 'lodash', 'customDropdownButtonService'];
    customDropdownButtonCtrl.$inject = ['customDropdownButtonService', '$scope', '$element'];
    angular
        .module('sod.helper')
        .directive('customDropdownButton', customDropdownButton);

    const template = `
        <div class="sod-dropdown-button" ng-class="{dark: vm.dark}">
            <div class=" button-group">
                <button type="button"
                        class="button default"
                        ng-bind-html="vm.quickButtonContent"
                        ng-if="vm.quickButtonContent"
                        ng-click="vm.quickButtonAction()"
                ></button>
                <button type="button"
                        class="button default toggle-trigger-button"
                        ng-click="vm.toggle()"
                        ng-bind-html="vm.buttonContent"
                >
                </button>
            </div>
            <div class="dropdown-wrapper" ng-show="vm.toggleState">
            <ul class="dropdown">
                <ng-transclude></ng-transclude>
            </ul>
            </div>
        </div>
    `;

    function customDropdownButton($document, lodash, customDropdownButtonService) {
        return {
            restrict: 'E',
            controller: customDropdownButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            template: template,
            scope: {
                buttonContent: '=?',
                quickButtonContent: '=?',
                quickButtonAction: "&?"
            },
            link: customDropdownButtonLink
        };

        function customDropdownButtonLink(scope, elem, attr) {
            var vm = scope.vm;

            if (!vm.buttonContent) {
                vm.buttonContent = '<i class="fa fa-cog"></i>'
            }

            vm.dark = lodash.has(attr, 'dark');

            $document.on('click', function (e) {
                let buttonElem = angular.element(e.target);
                if (buttonElem.hasClass('toggle-trigger-button')) return;

                buttonElem = buttonElem.parents('.toggle-trigger-button');
                if (buttonElem.hasClass('toggle-trigger-button')) return;

                customDropdownButtonService.closeAll();
                scope.$apply();
                // if (vm.toggleState) {
                //     vm.toggle();
                //     scope.$apply();
                // }
            });

            // trigger when li is clicked;

            scope.$on('$destroy', function () {
                elem.off('click');
            });
        }
    }

    function customDropdownButtonCtrl(customDropdownButtonService, $scope, $element) {
        var vm = this;

        this.$onInit = function() {
            vm.toggleState = false;

            vm.toggle = toggle;
            vm.close = close;

            vm.currentServiceId = customDropdownButtonService.createReference({
                close: vm.close,
                toggle: vm.toggle
            });
        }

        function toggle() {
            customDropdownButtonService.closeAll();
            vm.toggleState = !vm.toggleState;
        }

        function close() {
            vm.toggleState = false;
        }

        $scope.$on('$destroy', function() {
            if (vm.currentServiceId !== null) {
                customDropdownButtonService.destroy(vm.currentServiceId);
            }
        })
    }
})();
(function () {
    'use strict';

    customDropdownList.$inject = ['$document', 'lodash'];
    customDropdownListCtrl.$inject = ['lodash', '$scope'];
    angular
        .module('sod.helper')
        .directive('customDropdownList', customDropdownList);

    const template = `
        <div class="sod-dropdown-button" ng-class="{dark: vm.dark}">
            <div class=" button-group">
                <button type="button"
                        class="button default"
                        ng-bind-html="vm.quickButtonContent"
                        ng-if="vm.quickButtonContent"
                        ng-click="vm.quickButtonAction()"
                ></button>
                <button type="button"
                        class="button default toggle-trigger-button"
                        ng-click="vm.toggle()"
                        ng-bind-html="vm.buttonContent"
                >
                </button>
            </div>
            <div class="dropdown-wrapper" ng-show="vm.toggleState">
            <ul class="dropdown">
                <li ng-repeat="listItem in vm.list">
                    <a ng-click="vm.clickListItem(listItem)">
                        <i class="fa" ng-class="listItem.icon" ng-if="listItem.icon"></i>
                        <%listItem.label%>
                    </a>
                </li>
            </ul>
            </div>
        </div>
    `;

    function customDropdownList($document, lodash) {
        return {
            restrict: 'E',
            controller: customDropdownListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: template,
            scope: {
                buttonContent: '=?',
                quickButtonContent: '=?',
                quickButtonAction: "&?",
                list: '=?',
            },
            link: customDropdownListLink
        };

        function customDropdownListLink(scope, elem, attr) {
            var vm = scope.vm;

            if (!vm.buttonContent) {
                vm.buttonContent = '<i class="fa fa-cog"></i>'
            }

            vm.dark = lodash.has(attr, 'dark');

            if (!vm.list) {
                vm.list = [];
            }

            $document.on('click', function (e) {
                let buttonElem = angular.element(e.target);
                if (buttonElem.hasClass('toggle-trigger-button')) return;

                buttonElem = buttonElem.parents('.toggle-trigger-button');
                if (buttonElem.hasClass('toggle-trigger-button')) return;

                if (vm.toggleState) {
                    vm.toggle();
                    scope.$apply();
                }
            });

            function test() {
                if (vm.toggleState) {
                    vm.toggleState = false;
                }
            }

            // trigger when li is clicked;

            scope.$on('$destroy', function () {
                elem.off('click');
            });
        }
    }

    function customDropdownListCtrl(lodash, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.toggleState = false;
            vm.clickListItem = clickListItem;

            vm.toggle = toggle;
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;

        }

        function clickListItem(listItem) {
            if (lodash.has(listItem, 'event')) {
                $scope.$emit(listItem.event, lodash.get(listItem, 'eventData', {}));
            }
        }
    }
})();
(function () {
    "use strict";

    dropdownSelectSearchable.$inject = ['lodash', '$document'];
    angular.module("sod.helper").directive("dropdownSelectSearchable", dropdownSelectSearchable);

    const template = `<div class="dropdown-select-searchable-wrapper" id="<%elementId%>">
        <input
            type="text"
            ng-model="current"
            class="dropdown-select-searchable-selector mb-0 text-sm" 
            ng-click="showDropdown()"
            ng-keydown="handleKeyDown($event)"
        >
        <div class="dropdown-select-searchable-options-wrapper">
            <ul class="dropdown-select-searchable-options" ng-style="selectOptionsStyle" ng-class="{active: dropdownActive}">
                <li ng-class="{'highlighted': $index === selectedIndex} " class="dropdown-select-searchable-item" ng-repeat="option in filterOptions()" ng-bind-html="option.label" ng-click="select(option)" ng-mouseenter="highlightOptionWithMouse($index)"></li>
            </ul>
        </div>
    </div>`;
    function dropdownSelectSearchable(lodash, $document) {
        return {
            restrict: "E",
            require: "ngModel",
            template: template,
            scope: {
                options: "=",
            },
            link: function (scope, elem, attr, ctrl) {
                scope.dropdownActive = false;
                scope.elementId = scope.$id;
                scope.selectOptionsStyle = {};
                scope.previousValue = '';
                scope.selectedIndex = 0;
                var showAllFilters = true;
            
                var height = 0;
                for (var i = 0; scope.options.length > i; i++) {
                    height += 25;
                }
            
                ctrl.$render = function () {
                    const selected = lodash.find(scope.options, {
                        value: ctrl.$viewValue,
                    });
                    scope.current = selected ? selected.label : "";
                    scope.previousValue = scope.current;
                };
            
                scope.filterOptions = function () {
                    if(showAllFilters){
                        return scope.options.filter(function (option) {
                            return option.label
                                .toLowerCase()
                                .includes(scope.current.toLowerCase());
                        });
                    }
                    return scope.options;
                };
            
                scope.select = function (option) {
                    ctrl.$setViewValue(option.value);
                    scope.current = option.label;
                    scope.previousValue = option.label;
                    scope.dropdownActive = false;
                };
            
                scope.showDropdown = function () {
                    if(scope.current){
                        scope.previousValue = scope.current;
                        const indexes       = scope.options.map((opt, index) => opt.label === scope.current ? index : -1);
                        scope.selectedIndex = indexes.find(index => index !== -1);
                    }
                    showAllFilters = false;
                    scope.dropdownActive = true;
                    scope.selectOptionsStyle.height = height + 1;

                    var inputElem   = elem[0].querySelector('.dropdown-select-searchable-selector');
                    var offWidth    = inputElem.offsetWidth
                    scope.selectOptionsStyle.width = offWidth + 'px';

                    var optionList = elem[0].querySelector('.dropdown-select-searchable-options');
                    var highlightedOption = optionList.children[scope.selectedIndex];

                    if (highlightedOption) {
                        var optionListHeight = optionList.clientHeight;
                        var optionHeight = highlightedOption.clientHeight;

                        var highlightedTop = highlightedOption.offsetTop;
                        var highlightedBottom = highlightedTop + optionHeight;

                        if (highlightedBottom > optionList.scrollTop + optionListHeight) {
                            optionList.scrollTop = highlightedBottom - optionListHeight;
                        } else if (highlightedTop < optionList.scrollTop) {
                            optionList.scrollTop = highlightedTop;
                        }
                    }
                };
            
                scope.resetCurrent = function () {
                    if (!scope.current) {
                        scope.current = scope.previousValue;
                    }else{
                        const selected = lodash.find(scope.options, {
                            label: scope.current,
                        });
                        scope.current = selected ? selected.label : scope.previousValue;
                        scope.previousValue = scope.previousValue;
                    }
                };
            
                scope.isSelected = function (option) {
                    return option.label === scope.previousValue;
                };

                scope.highlightOption = function(key) {
                    var filteredOptions = scope.filterOptions();
                    var selectedIndex   = scope.selectedIndex <= filteredOptions.length ? scope.selectedIndex : -1;
                
                    if (key === "ArrowDown") {
                        selectedIndex = (selectedIndex == (filteredOptions.length - 1)) ? 0 : selectedIndex + 1;
                    } else if (key === "ArrowUp") {
                        selectedIndex = (selectedIndex == 0) ? filteredOptions.length - 1 : selectedIndex - 1;
                    }
                
                    scope.selectedIndex = selectedIndex;

                    var optionList = elem[0].querySelector('.dropdown-select-searchable-options');
                    var previouslyHighlightedOption = optionList.querySelector('.highlighted');
                    if (previouslyHighlightedOption) {
                        previouslyHighlightedOption.classList.remove('highlighted');
                    }   
                
                    var highlightedOption = optionList.children[selectedIndex];
                    if (highlightedOption) {
                        highlightedOption.classList.add('highlighted');
                    }
                
                    if (highlightedOption) {
                        var optionListHeight = optionList.clientHeight;
                        var optionHeight = highlightedOption.clientHeight;
                
                        var highlightedTop = highlightedOption.offsetTop;
                        var highlightedBottom = highlightedTop + optionHeight;
                
                        if (highlightedBottom > optionList.scrollTop + optionListHeight) {
                            optionList.scrollTop = highlightedBottom - optionListHeight;
                        } else if (highlightedTop < optionList.scrollTop) {
                            optionList.scrollTop = highlightedTop;
                        }
                    }
                
                    scope.$apply();
                };
            
            
                scope.handleKeyDown = _.debounce(function (event) {
                    var filteredOptions = scope.filterOptions();
                    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
                        event.preventDefault();
                        scope.highlightOption(event.key);
                    } else if (event.key === "Enter") {
                        event.preventDefault();
                        if (scope.selectedIndex >= 0 && scope.selectedIndex < filteredOptions.length) {
                            scope.select(filteredOptions[scope.selectedIndex]);
                        }
                    } else if (event.key === "Backspace") {
                        scope.current = '';
                        showAllFilters = true;
                    }
                    scope.$apply();
                }, 100);
                

                elem.on("keydown", scope.handleKeyDown);

                $document.on("click", function (e) {
                    if (
                        angular
                            .element(e.target)
                            .parents(".dropdown-select-searchable-wrapper").length === 0
                    ) {
                        scope.dropdownActive = false;
                        scope.resetCurrent();
                        scope.$apply();
                        return;
                    }
                    if (
                        angular
                            .element(e.target)
                            .parents(".dropdown-select-searchable-wrapper")
                            .attr("id") !== scope.elementId.toString()
                    ) {
                        scope.dropdownActive = false;
                        scope.resetCurrent();
                        scope.$apply();
                    }
                });

                scope.highlightOptionWithMouse = function(index) {
                    scope.selectedIndex = index;
                    scope.$apply();
                };
            
                scope.$on('$destroy', function() {
                    elem.off("keydown", scope.handleKeyDown);
                    $document.off("click");
                });
            },            
        };
    }
})();

(function () {
    'use strict';

    dropdownSelect.$inject = ['lodash', '$document'];
    angular
        .module('sod.helper')
        .directive('dropdownSelect', dropdownSelect);

    const template = '<div class="dropdown-select-wrapper" id="<%elementId%>">' +
        '<div class="dropdown-select-selector" ng-click="showDropdown()"><span  ng-bind-html="current"></span><i class="fa fa-caret-down selector-icon"></i></div>' +
        '<div class="dropdown-select-options-wrapper">' +
        '<ul class="dropdown-select-options" ng-style="selectOptionsStyle" ng-class="{active: dropdownActive}"><li class="dropdown-select-item" ng-repeat="option in options" ng-bind-html="option.label" ng-click="select(option)"></li></ul>' +
        '</div>' +
        '</div>';

    function dropdownSelect(lodash, $document) {
        return {
            restrict: 'E',
            require: 'ngModel',
            template: template,
            scope: {
                options: '='
            },
            link: function(scope, elem, attr, ctrl) {
                scope.dropdownActive = false;
                scope.elementId = scope.$id;
                scope.selectOptionsStyle = {};
                var optionsElem = elem.find('.dropdown-select-options');
                ctrl.$render = function() {
                    const selected = lodash.find(scope.options, { value: ctrl.$viewValue });
                    scope.current = selected.label;
                };

                scope.select = function(option) {
                    ctrl.$setViewValue(option.value);
                    scope.current = option.label;
                    scope.dropdownActive = false;
                };
                ctrl.$formatters.push(function(modelValue) {
                   return modelValue;
                });
                ctrl.$parsers.push(function(viewValue) {
                   return viewValue;
                });

                scope.showDropdown = function() {
                    scope.dropdownActive = true;
                    scope.selectOptionsStyle.height = optionsElem.height();

                };

                $document.on('click', function (e) {
                    e.stopPropagation();
                    if (angular.element(e.target).parents('.dropdown-select-wrapper').length === 0) {
                        scope.dropdownActive = false;
                        scope.$apply();
                        return;
                    }
                    if (angular.element(e.target).parents('.dropdown-select-wrapper').attr('id') !== scope.elementId.toString()) {
                        scope.dropdownActive = false;
                        scope.$apply();
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('hasMinHeight', hasMinHeight);

    function hasMinHeight() {
        return {
            restrict: 'AC',
            link: hasMinHeightLink
        };

        function hasMinHeightLink(scope, elem) {
            MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            try {
                var observer = new MutationObserver(observerTriggeredFunc);

                // define what element should be observed by the observer
                // and what types of mutations trigger the callback
                observer.observe(elem[0], {
                    subtree: true,
                    characterData: true,
                    childList: true
                    /**
                     * childList
                     ** Set to true if mutations to target's children are to be observed.
                     *
                     * attributes
                     ** Set to true if mutations to target's attributes are to be observed.
                     *
                     * characterData
                     ** Set to true if mutations to target's data are to be observed.
                     *
                     * subtree
                     *
                     ** Set to true if mutations to not just target, but also target's descendants are to be observed.
                     *
                     * attributeOldValue
                     ** Set to true if attributes is set to true and target's attribute value before the mutation needs to be recorded.
                     *
                     * characterDataOldValue
                     ** Set to true if characterData is set to true and target's data before the mutation needs to be recorded.
                     *
                     * attributeFilter
                     ** Set to a list of attribute local names (without namespace) if not all attribute mutations need to be observed.
                     */
                });
            }
            catch (e) {
                console.warn('Mutation Error', e); // eslint-disable-line no-console
            }

            function observerTriggeredFunc() { //(mutations, observer)
                // fired when a mutation occurs
                elem.css('min-height', elem.children().height() + 50);
            }
        }
    }
})();
(function () {
    'use strict';

    sodIframePreview.$inject = ['$timeout'];
    angular
        .module('sod.helper')
        .directive('sodIframePreview', sodIframePreview);

    function sodIframePreview($timeout) {
        function link(scope, element) {
            var iframe = document.createElement('iframe');
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            iframe.style.overflow = 'visible';
            iframe.height = '100%';

            var element0 = element[0];
            element0.appendChild(iframe);
            var body = iframe.contentDocument.body;
            scope.iframeHeight = iframe.contentWindow.innerHeight;

            scope.getIframeHeight = function() {
                return iframe.contentWindow.document.body.offsetHeight;
            };

            scope.resize = function() {
                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
            };

            scope.$watch('content', function () {
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.close();
                iframe.contentWindow.document.body.innerHTML = scope.content;
                setStyle();
            });

            scope.$watch(scope.getIframeHeight(), function() {
                scope.resize();
            });

            $timeout(function () {
                setStyle();
            }, 1000);

            function setStyle() {
                var css = document.createElement('style');
                css.type = 'text/css';

                var styles = [
                    '* {',
                    'font-family: Roboto, Helvetica, Arial, sans-serif;',
                    'overflow-wrap: break-word;',
                    '}',
                ].join('');

                css.appendChild(document.createTextNode(styles));

                iframe.contentWindow.document.head.appendChild(css);
            }
        }

        return {
            link: link,
            restrict: 'E',
            scope: {
                content: '=',
                resize: '=?'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('toggleSwitch', toggleSwitch);

    const template = '<div class="switch" style="margin-bottom: 0px;"><input type="checkbox" class="switch-input" ng-model="active" /><label class="switch-paddle" ng-click="toggleActive()"></label></div>';

    function toggleSwitch() {
        return {
            restrict: 'E',
            require: 'ngModel',
            template: template,
            link: function(scope, elem, attr, ctrl) {
                scope.active = false;

                ctrl.$render = function() {
                    scope.active = ctrl.$viewValue;
                };

                scope.toggleActive = function() {
                    scope.active = !scope.active;
                    ctrl.$setViewValue(scope.active);
                };
            }
        };
    }
})();
(function () {
    'use strict';

    rmsCarousel.$inject = ['lodash', '$timeout', '$compile'];
    angular
        .module('sod.helper')
        .directive('rmsCarousel', rmsCarousel);

    function rmsCarousel(lodash, $timeout, $compile) {
        return {
            restrict: 'E',
            template: '<div class="unite-gallery" ng-class="options.rms_class"></div>',
            scope: {
                'options': '=?',
                'items': '=?',
            },
            link: {
                post: function (scope, elem) {
                    const isGalleryAwards = scope.options.elem_id === 'gallery-awards';
                    const isGallerySecondary = scope.options.elem_id === 'gallery-secondary';
                    const isGalleryVideos = scope.options.elem_id === 'gallery_videos';

                    var options = angular.copy(scope.options) || {
                        gallery_skin: 'alexis',
                        slider_bullets_skin: 'alexis',
                    };
                    options = determineCenterMode(options, scope.items);

                    if (isGalleryAwards || isGallerySecondary) {
                        var slick = elem
                            .find('.unite-gallery')
                            .attr('id', scope.options.elem_id || 'slick-gallery-1')
                            .html(scope.galleryItemHtml)
                            .slick(options);

                        scope.$on('$destroy', (function (scope) {
                            return function () {
                                $('#' + scope.options.elem_id).slick('unslick');
                            };
                        })(scope));
                    } else {
                        var ug = elem
                            .find('.unite-gallery')
                            .attr('id', scope.options.elem_id || 'unite-gallery-1')
                            .html(scope.galleryItemHtml)
                            .unitegallery(options);

                        scope.$on('$destroy', function () {
                            ug.destroy();
                        });

                        function sodSetUniteGallerySize(scope, options, ug) {
                            const itemCount = scope.items.length;
                            const padding = options.carousel_padding || 10;
                            const outerWrapperWidth = $('#gallery_videos').width();
                            const tileWidth = options.tile_width + (padding * 2);
                            const tileCount = Math.floor(outerWrapperWidth / tileWidth);

                            if (itemCount <= tileCount) {
                                const width = itemCount * tileWidth - padding;
                                const left = (outerWrapperWidth - width) / 2;
                                $('#' + scope.options.elem_id + ' .ug-carousel-wrapper')
                                    .css('width', width + 'px')
                                    .css('left', left + 'px');

                                $('#' + scope.options.elem_id + ' .ug-pause-icon').click();
                                $('#' + scope.options.elem_id + ' .ug-tile-navigation-wrapper').css('display', 'none');
                            }
                        }

                        if (isGalleryVideos) {
                            sodSetUniteGallerySize(scope, options, ug);

                            ug.on('resize', (function (scope, options, ug) {
                                return function () {
                                    width
                                    sodSetUniteGallerySize(scope, options, ug);
                                };
                            })(scope, options, ug));
                        }
                    }

                    var compileScope = scope;
                    $compile(elem.contents())(compileScope);
                },
                pre: function (scope) {
                    const isGalleryAwards = scope.options.elem_id === 'gallery-awards';
                    const isGallerySecondary = scope.options.elem_id === 'gallery-secondary';
                    var galleryItems = !lodash.isEmpty(scope.items) ? scope.items : lodash.get(scope.options, 'gallery_items', []);

                    if (isGalleryAwards) {
                        scope.galleryItemHtml = galleryItems.map(function (item) {
                            const galleryContentWidth = lodash.get(scope, 'options.width', 160);
                            const galleryContentWidthPx = galleryContentWidth + 'px';

                            return [
                                '<div class="gallery-award">',
                                '<div class="gallery-award-header">' + (item.alt || '') + '</div>',
                                '<div style="margin: auto; text-align: center;">',
                                '<div class="gallery-award-image-wrapper">',
                                '<div style="margin: auto; width: ' + galleryContentWidthPx + '; height: ' + galleryContentWidthPx + '; background-repeat: no-repeat; background-position: center; background-size: contain;background-image: url(\'' + item.src + '\')"></div>',
                                '</div>',
                                '</div>',
                                '<div class="gallery-award-caption">' + (item.description || '') + '</div>',
                                '</div>'
                            ].join('');
                        }).join('');
                    } else if (isGallerySecondary) {
                        scope.galleryItemHtml = galleryItems.map(function (item) {
                            return [
                                '<div class="gallery-award secondary">',
                                '<div css-width-based-on-parent style="margin: auto; width: 240px; height: 185px; background-repeat: no-repeat; background-position: center; background-size: contain;background-image: url(\'' + item.src + '\')"></div>',
                                '<div style="font-size: 1.54em; padding: 5px 0;" class="text-bold text-center emphasis-header">' + (item.title || '') + '</div>',
                                '<div style="font-size: 1.08em; padding: 5px 0;">' + (item.description || '') + '</div>',
                                '</div>'
                            ].join('');
                        }).join('');
                    } else {
                        scope.galleryItemHtml = galleryItems.map(function (item) {
                            switch (item.type) {
                                case 'html5video':
                                case 'youtube':
                                case 'vimeo':
                                case 'soundcloud':
                                    return '<img data-type="' + item.type + '" ' + generateAttr(item) + ' />';
                                default:
                                    var template = '<img ' + generateAttr(item) + '/>';

                                    if (!lodash.isEmpty(item.link)) {
                                        template = "<a href='" + item.link + "' target='_blank'>" + template + "</a>"
                                    }
                                    return template;
                            }
                        }).join('');
                    }


                    function generateAttr(item) {
                        return lodash.toPairs(item).reduce(function (result, pair) {
                            var key = pair[0];
                            var value = pair[1];
                            if (key === 'type') {
                                return result;
                            }
                            if (['src', 'alt'].indexOf(key) >= 0) {
                                result.push(key + '="' + value + '"');
                                return result;
                            }

                            if (['image', 'videoid', 'description', 'videoogv', 'videowebm', 'videomp4', 'trackid'].indexOf(key) >= 0) {
                                if (key === 'description') {
                                    result.push('data-' + key + '="' + value.replace(/<[\/][^>]*>/gi, " ").replace(/<[^>]*>/gi, " ") + '"');
                                } else {
                                    result.push('data-' + key + '="' + value + '"');
                                }
                                return result;
                            }
                            return result;
                        }, []).join(' ');
                    }
                },
            }
        };

        function determineCenterMode(options, items) {
            var itemCount = (items || []).length;
            if (itemCount === 0) return options;

            var rootSlidesToShow = lodash.get(options, 'slidesToShow', -1);
            if (rootSlidesToShow > 0) {
                options = lodash.set(options, 'centerMode', itemCount >= rootSlidesToShow);
            }

            var responsiveSlidesToShow = lodash.get(options, 'settings.slidesToShow', -1);
            if (responsiveSlidesToShow > 0) {
                options = lodash.set(options, 'settings.centerMode', itemCount >= responsiveSlidesToShow);
            }

            var responsive = lodash.get(options, 'responsive', []);
            var updatedResponsive = lodash.reduce(responsive, function (updatedResponsive, oResponsive) {
                return updatedResponsive.concat([determineCenterMode(oResponsive, items)]);
            }, []);
            if (updatedResponsive.length > 0) {
                options = lodash.set(options, 'responsive', updatedResponsive);
            }

            return options;
        }

        // function determineSlidesToShow(options, items) {
        //     var itemCount = (items || []).length;
        //     if (itemCount === 0) return options;
        //
        //     var rootSlidesToShow = lodash.get(options, 'slidesToShow', -1);
        //     if (rootSlidesToShow >= 0) {
        //         if (itemCount < rootSlidesToShow) {
        //             options = lodash.set(options, 'slidesToShow', itemCount);
        //         }
        //     }
        //
        //     var responsiveSlidesToShow = lodash.get(options, 'settings.slidesToShow', -1);
        //     if (responsiveSlidesToShow >= 0) {
        //         if (itemCount < responsiveSlidesToShow) {
        //             options = lodash.set(options, 'settings.slidesToShow', itemCount);
        //         }
        //     }
        //
        //     var responsive = lodash.get(options, 'responsive', []);
        //     var updatedResponsive = lodash.reduce(responsive, function (updatedResponsive, oResponsive) {
        //         return updatedResponsive.concat([determineSlidesToShow(oResponsive, items)]);
        //     }, []);
        //     if (updatedResponsive.length > 0) {
        //         options = lodash.set(options, 'responsive', updatedResponsive);
        //     }
        //
        //     return options;
        // }
    }
})();
(function () {
    'use strict';

    templateReplacement.$inject = ['lodash'];
    angular
        .module('sod.helper')
        .filter('templateReplacement', templateReplacement);

    const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.

    function templateReplacement(lodash) {
        return function(templateOptions, value) {
            const replacements = lodash.get(templateOptions, 'replacements', false);

            return decodeURI(templateOptions.template).replace(urlReplacerRegex, (match, submatch) => {
                // first check if
                const valuePath = lodash.get(replacements, submatch, submatch);
                return lodash.get(value, valuePath, '');
            });
        }
    }
})();
(function () {
    'use strict';

    CommonHelper.$inject = ['lodash'];
    angular
        .module('sod.helper')
        .factory('CommonHelper', CommonHelper);

    function CommonHelper(lodash) {
        return {
            isEmpty: isEmpty,
            bytesToSize: bytesToSize,
        };

        function isEmpty(value) {
            if (lodash.isNumber(value)) {
                return lodash.isNaN(value);
            } else {
                if (lodash.isDate(value)) {
                    return false;
                }
                return lodash.isEmpty(value);
            }
        }

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        }
    }
})();
(function () {
    'use strict';

    customDropdownButtonService.$inject = ['lodash'];
    angular
        .module('sod.helper')
        .factory('customDropdownButtonService', customDropdownButtonService);

    function customDropdownButtonService(lodash) {
        var state = [];
        return {
            createReference: createReference,
            closeOthers: closeOthers,
            closeAll: closeAll,
            destroy: destroy,
            getState: function() {
                return state;
            },
        };

        function createReference(ref) {
            ref.id = new Date().getTime();
            state.push(ref);
            return ref.id;
        }

        function closeOthers() {

        }

        function closeAll() {
            state.map(function(item) {
                var func = lodash.get(item, 'close', function() {});
                func();
            });
        }

        function destroy(id) {
            lodash.remove(state, { id: id });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('HtmlHelper', HtmlHelper);

    function HtmlHelper() {
        return {
            generateHtmlTag:generateHtmlTag,
            generateAttr: generateAttr
        };

        function generateHtmlTag(tag, attrs) {
            if (!tag) return '';
            return '<' + tag + ' ' + generateAttr(attrs) + '></' + tag + '>';
        }

        function generateAttr(attrs) {
            if (!attrs.length) return "";

            return attrs.map(function(attr) {
                return attr.name + '="' + attr.value + '"';
            }).join(' ');
        }
    }
})();
(function () {
    'use strict';

    RequestHelper.$inject = ['lodash', 'GenericModel'];
    angular
        .module('sod.helper')
        .factory('RequestHelper', RequestHelper);

    function RequestHelper(lodash, GenericModel) {
        const urlReplacerRegex = /<([\w.]*)>/g;
        return {
            getNeeded: getNeeded,
            prepareDatasource: prepareDatasource,
        };

        function getNeeded(model, needed) {
            let result = {};
            angular.forEach(needed, (val) => {
                const valArr = val.split('.');
                const modelValue = lodash.get(model, val, '');
                const modelIndex = valArr[valArr.length - 1];
                lodash.set(result, modelIndex, modelValue);
            });

            return result;
        }

        function prepareDatasource(datasource, data) {
            let endpoint = datasource.url;

            const method = lodash.get(datasource, 'method', 'get');
            endpoint = decodeURI(endpoint).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(data, submatch, '');
            });

            const resource = new GenericModel(endpoint);

            if (method === 'get') {
                return resource[method](data).$promise;
            } else {
                return resource[method]({}, {data:data}).$promise;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('TextHelper', TextHelper);

    function TextHelper() {
        return {
            addText: addText,
            removeText: removeText
        };

        function addText(original, text, padding) {
            if (hasText(original, text)) {
                return original;
            }

            if (!padding) {
                padding = '';
            }

            return [original, text].join(padding);
        }

        function removeText(original, text) {
            if (!hasText(original, text)) {
                return original;
            }

            const result = original.replace(text, '');
            return result.trim();
        }

        function hasText(original, text) {
            return (original.indexOf(text) >= 0);
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'FormBuilderService', 'lodash'];
    angular
        .module('FormBuilder')
        .factory('action-form-clear-validation', actionFunc);

    function actionFunc($q, FormBuilderService, lodash) {
        return function(options, evtData, actionResponse) {
            $q.when(run());

            function run() {
                const formId = lodash.get(options, 'formId', false);
                if (!formId) return false;

                const fbService = FormBuilderService.get(formId);
                fbService.elementsService.setValidationRules({}, '', true);

                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q'];
    angular
        .module('FormBuilder')
        .factory('action-form-execute-recaptcha', actionFunc);

    function actionFunc($q) {
        return function() {
            return $q.when(run());

            function run() {
                return window.grecaptcha.execute();
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q'];
    angular
        .module('FormBuilder')
        .factory('action-form-reset-recaptcha', actionFunc);

    function actionFunc($q) {
        return function() {
            return $q.when(run());

            function run() {
                window.grecaptcha.reset();
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['FormBuilderService', '$q'];
    angular
        .module('FormBuilder')
        .factory('action-form-get-model', actionFunc);

    function actionFunc(FormBuilderService, $q) {
        return function(options) {
            return $q.when(run());

            function run() {
                return FormBuilderService.getModel(options.form_name);
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['FormBuilderService', '$q'];
    angular
        .module('FormBuilder')
        .factory('action-form-re-render', actionFunc);

    function actionFunc(FormBuilderService, $q) {
        return function(options) {
            return $q.when(run());

            function run() {
                return FormBuilderService.rerender(options.form_name);
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['FormBuilderService', '$q', 'lodash'];
    angular
        .module('FormBuilder')
        .factory('action-form-set-pristine', actionFunc);

    function actionFunc(FormBuilderService, $q, lodash) {
        return function(options) {
            $q.when(run());

            function run() {
                const fbService = FormBuilderService.get(options.form_name);
                if (!lodash.isEmpty(fbService)) {
                    fbService.eventsService.setPristine();
                }
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'FormBuilderService', 'lodash', '$timeout'];
    angular
        .module('FormBuilder')
        .factory('action-form-validation', actionFunc);

    function actionFunc($q, FormBuilderService, lodash, $timeout) {
        return function(options, evtData, actionResponse) {
            $q.when(run());

            function run() {
                const formId = lodash.get(options, 'formId', false);
                const summaryField = lodash.get(options, 'summaryField', 'summary');
                if (!formId) return false;

                const fbService = FormBuilderService.get(formId);
                const container = lodash.get(options, 'classTag', 'html,body');
                const animateOffset = lodash.get(options, 'offsetHeight', 50);
                if (fbService.elementsService) {
                    fbService.elementsService.setValidationRules(actionResponse.response.rules, actionResponse.response.summary, true, summaryField);
                }

                return $timeout(function () {
                    if (lodash.has(fbService, 'validation.summary') && fbService.validation.summary) {
                        if (angular.element('.callout').length > 0) {
                            angular.element(container).animate({
                                scrollTop: angular.element('.callout').offset().top - animateOffset
                            }, 500);
                        }
                    } else {
                        if (angular.element('.error, .sub-form-row-error').length > 0) {
                            angular.element(container).animate({
                                scrollTop: angular.element('.error, .sub-form-row-error').offset().top - animateOffset
                            }, 500);
                        }
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    fbBindHtmlCompileCtrl.$inject = ['$compile', '$element', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbBindHtmlCompile', fbBindHtmlCompile);

    function fbBindHtmlCompile() {
        return {
            restrict: 'E',
            controller: fbBindHtmlCompileCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                template: '=',
                options: '=?',
                data: '=?',
                getModel: '=?'
            }
        };
    }

    function fbBindHtmlCompileCtrl($compile, $element, $scope) {
        var vm = this;
        var cloneElement = null;
        this.$onInit = function() {
            if (!vm.data) vm.data = {};

            $scope.$watch(function() {return vm.template; }, function() {
                if (cloneElement) { cloneElement.off(); }
                $element.html(vm.template);
                cloneElement = $compile($element.contents())($scope);
            });

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }
    }
})();
(function () {
    'use strict';

    fbButtonsWrapperCtrl.$inject = ['$compile', '$templateCache', '$element', '$scope', 'FormBuilderHelper'];
    angular
        .module('FormBuilder')
        .directive('fbFieldButtonsWrapper', fbButtonsWrapper);

    function fbButtonsWrapper() {
        return {
            restrict: 'E',
            scope: {
                buttons: '=',
                type: '=',
                name: '=?',
            },
            controller: fbButtonsWrapperCtrl,
            controllerAs: 'vm',
            bindToController:true
        };
    }

    function fbButtonsWrapperCtrl($compile, $templateCache, $element, $scope, FormBuilderHelper) {
        var vm = this;
        this.$onInit = function() {
            vm.formIdentifier = vm.name || $scope.$parent.vm.formIdentifier;

            vm.getElementSize = FormBuilderHelper.getElementSize;

            var templateName = 'common/libraries/formBuilder/buttons-wrapper/button-' + vm.type;
            var template = $templateCache.get(templateName);
            $element.html(template);
            var cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('formLabelAction', formLabelAction);

    function formLabelAction() {
        return {
            restrict: 'A',
            scope: {
                event: '=?'
            },
            link: function(scope, elem) {
                elem.bind('click', function(e) {
                    e.preventDefault();
                    if (scope.event && scope.event.length > 0) {
                        var eventData = {
                            target: elem,
                            event: e
                        };

                        scope.$emit(scope.event, eventData);
                        // scope.$apply();
                    }
                });

                scope.$on('$destroy', function() {
                   elem.off();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    fbSubformFormDirectiveCtrlfunction.$inject = ['FormBuilderHelper', '$scope', 'lodash', 'FormBuilderService', 'RmsEnum', '$timeout'];
    angular
        .module('FormBuilder')
        .directive('fbSubformForm', fbSubformFormDirective);

    function fbSubformFormDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/form',
            controller: fbSubformFormDirectiveCtrlfunction,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformFormDirectiveCtrlfunction(FormBuilderHelper, $scope, lodash, FormBuilderService, RmsEnum, $timeout) {
        var vm = this;
        var fbService;
        var elementIdentifier;

        vm.addToModel = addToModel;
        vm.deleteFromModel = deleteFromModel;
        vm.hasMaxItems = hasMaxItems;
        vm.hasMinItems = hasMinItems;

        vm.showRowClass = showRowClass;
        vm.showRow = showRow;
        vm.toggleVisibility = toggleVisibility;
        vm.moveUp = moveUp;
        vm.moveDown = moveDown;
        vm.hasError = hasError;
        vm.canDelete = canDelete;
        vm.canAdd = canAdd;
        vm.generateChildIdentifier = generateChildIdentifier;
        vm.setDefault = setDefault;
        vm.hasDefaultOption = hasDefaultOption;

        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(vm.formIdentifier);
            elementIdentifier = $scope.$parent.vm.elementIdentifier;
            vm.currentElementIdentifier = elementIdentifier;
            vm.renderedElementsOptions = [];
            vm.getElementSize = FormBuilderHelper.getElementSize;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.view_only = lodash.get(fbService, 'fbData.settings.view_only', false);
            vm.default_field = lodash.get(vm.fbElement, 'options.default_field', 'default');

            init();
        }

        // $scope.$watch(function() { return vm.model.length; }, function() {
        //     console.log('scope.watch');
        //     if (vm.renderedElements.length < vm.model.length) {
        //         angular.forEach(vm.model, function(value, index) {
        //             console.log(value);
        //             if (!lodash.has(vm, 'renderedElements[' + index+ ']')) {
        //                 lodash.set(vm,'renderedElements[' + index + ']', {});
        //             }
        //         });
        //     }
        // });

        function toggleVisibility(row) {
            const renderedElementsOptions = lodash.find(vm.renderedElementsOptions, { tempRowId: row.tempRowId});
            if (renderedElementsOptions !== null) {
                renderedElementsOptions.showForm = !renderedElementsOptions.showForm;
            }
        }

        function moveUp(index) {
            shift(index, index - 1);
        }

        function moveDown(index) {
            shift(index, index + 1);
        }

        function filterElements(element) {
            return ['wysiwyg'].indexOf(element.type) >= 0;
        }

        function shift(currentPosition, newPosition) {
            // unloadWysiwyg(oldIndex, newIndex);
            const currentRowModel = lodash.get(vm.model, currentPosition);

            vm.model.splice(currentPosition, 1);
            vm.model.splice(newPosition, 0, currentRowModel);
            angular.forEach(vm.model, (row, index) => {
                row.order = index;
            });

            angular.forEach(vm.renderedElements, function(elements, index) {
                angular.forEach(elements, function(element, idx) {
                     if (filterElements(element)) {
                        element.refreshElement();
                    }
                });
            });
        }

        function init() {
            if (typeof vm.model == typeof undefined || vm.model == null) {
                vm.model = [];
            }
            if (lodash.has(vm.fbElement, 'subfields.options.min_items')
                && !!vm.fbElement.subfields.options.min_items) {
                while (vm.model.length < vm.fbElement.subfields.options.min_items) {
                    vm.model.push({});
                }
            }

            let defaultValue = null;
            if (lodash.has(vm.fbElement, 'options.default_value')) {
                defaultValue = lodash.get(vm.fbElement, 'options.default_value', null);
            }

            if (vm.model.length > 0) {
                for (var i = 0; i < vm.model.length; i++) {
                    const tempRowId = new Date().getTime() + i;
                    vm.renderedElements.push({
                        tempRowId: tempRowId
                    });
                    vm.renderedElementsOptions.push({ showForm: true, tempRowId: tempRowId });
                    vm.model[i].tempRowId = tempRowId;
                    vm.model[i].hid_position = (i+1);
                    if (defaultValue) {
                        const keys  = Object.keys(vm.fbElement.options.default_value);
                        const value = Object.values(vm.fbElement.options.default_value);
                        for (let idxDefaultValue = 0; idxDefaultValue < keys.length; idxDefaultValue++) {
                            lodash.set(vm.model[i], keys[idxDefaultValue], value[idxDefaultValue]);
                        }
                    }
                }
            }

            setFirstAsDefault();

            if (lodash.has(vm.fbElement, 'subfields.options.summary_header.enum_fields')) {
                lodash.forIn(vm.fbElement.subfields.options.summary_header.enum_fields, function(enumName) {
                    if (!RmsEnum.has(enumName)) {
                        RmsEnum.load(enumName);
                    }
                });
            }
        }

        function showRowClass(row) {
            const renderedElementsOptions = lodash.find(vm.renderedElementsOptions, { tempRowId: row.tempRowId});
            return (lodash.get(renderedElementsOptions ,'showForm', false)) ? "fa-angle-down" : "fa-angle-right";
        }

        function showRow(row) {
            const renderedElementsOptions = lodash.find(vm.renderedElementsOptions, { tempRowId: row.tempRowId});
            return renderedElementsOptions.showForm;
        }

        function addToModel() {
            const tempRowId = new Date().getTime();
            vm.model.push({
                hid_position: getNextHidPosition(),
                tempRowId: tempRowId,
            });
            vm.renderedElements.push({tempRowId: tempRowId});
            vm.renderedElementsOptions.push({ showForm: true, tempRowId: tempRowId });
        }

        function getNextHidPosition() {
            const obj = vm.model.reduce(function(result, o) {
                if (result === null) {
                    return o;
                }
                if (result.hid_position < o.hid_position) {
                    return o;
                }
                return result;
            }, null);
            if (obj === null) {
                return 1;
            }
            return obj.hid_position + 1;
        }

        function deleteFromModel(item) {
            var index = vm.model.indexOf(item);
            vm.model.splice(index, 1);
            vm.renderedElements.splice(index, 1);
        }

        function hasMaxItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.max_items')) { return true; }
            return (vm.fbElement.subfields.options.max_items > vm.model.length);
        }

        function hasMinItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.min_items')) {
                return true;
            }
            return (vm.fbElement.subfields.options.min_items < vm.model.length);
        }


        function hasError(index) {
            return fbService.elementsService.getValidationRule(elementIdentifier + '.' + index);
        }


        function canDelete() {
            if (vm.view_only) return false;
            if (vm.hasMinItems()) {
                return lodash.get(vm.fbElement, 'options.can_delete', true);
            }
            return false;
        }

        function canAdd() {
            return vm.view_only ? false : lodash.get(vm.fbElement, 'options.can_add', true);
        }

        function determineDisabled(element, rowModel) {
            if (!lodash.has(vm.fbElement, 'options.disable_fields') || !Array.isArray(vm.fbElement.options.disable_fields)) {
                return null;
            }

            var disabled_field = lodash.find(vm.fbElement.options.disable_fields, { 'target_field_name': element.name });
            if (!disabled_field) {
                return null;
            }

            var compared_value = lodash.get(rowModel, disabled_field.source_field_name, null);
            if (compared_value === null) {
                return null;
            }

            return !(lodash.get(disabled_field, 'value_flip', false)) ? compared_value : !compared_value;
        }

        function generateChildIdentifier(index, element_name) {
            return vm.currentElementIdentifier + '[' + index + '].' + element_name;
        }

        function setDefault($event, row) {
            // $event.preventDefault();
            defaultFunc(row);
        }

        function defaultFunc(row) {
            const result = vm.model.map((_row) => {
                var obj = {};
                lodash.set(obj, vm.default_field, (_row.$$hashKey == row.$$hashKey));
                return obj;
            });
            angular.merge(vm.model, result);
        }

        function setFirstAsDefault() {
            if (lodash.get(vm.fbElement.subfields.options, 'select_first_as_default', true) === true) {

                if (vm.model.length > 0) {
                    // check first if got default===true also
                    const defaultRow = lodash.find(vm.model, function(item) {
                        return lodash.get(item, vm.default_field, false);
                    });
                    if (!defaultRow) {
                        lodash.set(vm.model[0], vm.default_field, true);
                    }
                }
            }
        }
        function hasDefaultOption() {
            return !!lodash.get(vm.fbElement, 'subfields.options.select_default', false);
        }
    }
})();
(function () {
    'use strict';

    fbSubformGroupSelectionDirectiveCtrl.$inject = ['FormBuilderHelper', '$scope', 'CommonHelper'];
    angular
        .module('FormBuilder')
        .directive('fbSubformGroupSelection', fbSubformGroupSelectionDirective);

    function fbSubformGroupSelectionDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/group-selection',
            require: "^fbFormGenerator",
            controller: fbSubformGroupSelectionDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformGroupSelectionDirectiveCtrl(FormBuilderHelper, $scope, CommonHelper) {
        var vm = this;
        vm.selectGroup = select;
        vm.getChecked = getChecked;

        this.$onInit = function() {
            vm.generateChildIdentifier = generateChildIdentifier;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.currentElementIdentifier = $scope.$parent.vm.elementIdentifier;

            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            if (CommonHelper.isEmpty(vm.model)) {
                // if (typeof vm.model === typeof undefined || vm.model === null) {
                vm.model = {};
            }
        }

        function generateChildIdentifier(element_name) {
            return vm.currentElementIdentifier + '.' + element_name;
        }

        function select(name) {
            $scope.$parent.vm.model.selected = vm.fbElement.name;
        }

        function getSelected() {
            return $scope.$parent.vm.model.selected;
        }

        function getChecked() {
            return getSelected() == vm.fbElement.name;
        }
    }
})();
(function () {
    'use strict';

    fbSubformGroupDirectiveCtrl.$inject = ['FormBuilderHelper', '$scope', 'CommonHelper'];
    angular
        .module('FormBuilder')
        .directive('fbSubformGroup', fbSubformGroupDirective);

    function fbSubformGroupDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/group',
            require: "^fbFormGenerator",
            controller: fbSubformGroupDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformGroupDirectiveCtrl(FormBuilderHelper, $scope, CommonHelper) {
        var vm = this;
        this.$onInit = function() {
            vm.generateChildIdentifier = generateChildIdentifier;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.currentElementIdentifier = $scope.$parent.vm.elementIdentifier;

            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            if (CommonHelper.isEmpty(vm.model)) {
                // if (typeof vm.model === typeof undefined || vm.model === null) {
                vm.model = {};
            }
        }

        function generateChildIdentifier(element_name) {
            return vm.currentElementIdentifier + '.' + element_name;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbSubformHeader', fbSubformHeader);

    const template = `
        <div ng-if="!vm.element.subfields.options.hide_header" class="subform-header mb-2">
            <h4 ng-bind-html="vm.element.label | trustAsHtml"></h4>
            <div class="subform-header-options" ng-if="vm.element.subfields.options.actions">
                <custom-dropdown-list dark list="vm.element.subfields.options.actions"></custom-dropdown-list>
            </div>
        </div>
    `;

    function fbSubformHeader() {
        return {
            restrict: 'E',
            controller: fbSubformHeaderCtrl,
            controllerAs: 'vm',
            scope: {
                element: '='
            },
            bindToController: true,
            template: template
        };
    }

    function fbSubformHeaderCtrl() {
        var vm = this;
    }
})();
(function () {
    'use strict';

    fbSubformTabularDirectiveCtrl.$inject = ['$scope', 'lodash', '$timeout', 'FormBuilderService', 'FormBuilderHelper'];
    angular
        .module('FormBuilder')
        .directive('fbSubformTabular', fbSubformTabularDirective);

    function fbSubformTabularDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/tabular',
            controller: fbSubformTabularDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformTabularDirectiveCtrl($scope, lodash, $timeout, FormBuilderService, FormBuilderHelper) {
        var vm = this,
            elemCount,
            fbService = null
        ;

        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(vm.formIdentifier);
            var elementIdentifier = $scope.$parent.vm.elementIdentifier;
            vm.currentElementIdentifier = elementIdentifier;

            vm.addToModel = addToModel;
            vm.deleteFromModel = deleteFromModel;
            vm.show = show;
            vm.hasRows = hasRows;
            vm.getElementSize = getElementSize;
            vm.hasMaxItems = hasMaxItems;
            vm.hasMinItems = hasMinItems;
            vm.setDefault = setDefault;
            vm.hasDefaultOption = hasDefaultOption;
            vm.hasSortableOption = hasSortableOption;
            vm.hasError = hasError;
            vm.canDelete = canDelete;
            vm.canAdd = canAdd;
            vm.generateChildIdentifier = generateChildIdentifier;
            vm.canSort = false;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;

            vm.view_only = lodash.get(fbService, 'fbData.settings.view_only', false);

            init();
        }

        function init() {
            if (typeof vm.model == typeof undefined) {
                vm.model = [];
            }

            if (lodash.has(vm.fbElement, 'subfields.options.min_items')
                && !!vm.fbElement.subfields.options.min_items) {
                while (vm.model.length < vm.fbElement.subfields.options.min_items) {
                    vm.model.push({});
                }
            }

            if (vm.model.length > 0) {
                for (var i = vm.model.length; i--;) {
                    vm.renderedElements.push({});
                }
            }
            setFirstAsDefault();

            var filtered = lodash.filter(vm.fbElement.subfields.elements, function (o) {
                return o.type != 'hidden';
            });
            elemCount = filtered.length;
            initSortableOptions();
        }

        function setFirstAsDefault() {
            if (lodash.get(vm.fbElement.subfields.options, 'select_first_as_default', true) === true) {

                if (vm.model.length > 0) {
                    // check first if got default===true also
                    const defaultRow = lodash.find(vm.model, {default:true});
                    if (!defaultRow) {
                        vm.model[0].default = true;
                    }
                }
            }
        }

        function mobileAndTabletcheck() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substring(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if (!check) {
                check = (navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);
            }
            return check;
        };

        function initSortableOptions() {
            reorderRowIndex();
            var sortableOptions = {
                handler: '.sortable-handler, .sortable-handler .fa',
                filter: '.sub-form-row.tabular',
                ignore: 'input,textarea'
            };
            vm.canSort = lodash.has(vm.fbElement, 'subfields.options.sortable') && !mobileAndTabletcheck();

            if (vm.canSort) {
                angular.merge(sortableOptions, {
                    change: (e) => {
                        if (e) {
                            var itemMoved = vm.model[e.oldIndex];
                            vm.model.splice(e.oldIndex, 1);
                            vm.model.splice(e.newIndex, 0, itemMoved);
                            $scope.$apply();
                        }
                        reorderRowIndex();
                    },
                    placeholder: function (element) {
                        const elementClone = element.clone();
                        elementClone.addClass('sortable-placeholder');
                        elementClone.find('.tabular-content').html('<div>Drop Here</div>');
                        return elementClone;
                    },
                    hint: function (element) {
                        return element.clone().addClass('sortable-hint');
                    }
                });
                vm.sortableOptions = sortableOptions;
            } else {
                vm.sortableOptions = false;
            }
        }

        function addToModel() {
            vm.model.push({});
            vm.renderedElements.push({});
            reorderRowIndex();
            if (vm.model.length === 1) {
                setFirstAsDefault();
            }
        }

        function deleteFromModel(item) {
            var index = vm.model.indexOf(item);
            vm.model.splice(index, 1);
            vm.renderedElements.splice(index, 1);
            reorderRowIndex();
        }

        function show(elemObj) {
            return !(elemObj.type == 'hidden');
        }

        function hasRows() {
            return vm.model.length > 0;
        }

        function getElementSize(element) {
            if (lodash.has(element, 'attr.size')) {
                return "small-" + element.attr.size;
            }
            return "small-" + (12 / elemCount);
        }

        function hasMaxItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.max_items')) {
                return true;
            }
            return (vm.fbElement.subfields.options.max_items > vm.model.length);
        }

        function hasMinItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.min_items')) {
                return true;
            }
            return (vm.fbElement.subfields.options.min_items < vm.model.length);
        }

        function hasDefaultOption() {
            return lodash.get(vm.fbElement, 'subfields.options.select_default', false);
        }

        function hasSortableOption() {
            return lodash.get(vm.fbElement, 'subfields.options.sortable', false);
        }

        function setDefault($event, row) {
            $event.preventDefault();
            defaultFunc(row);
        }


        function reorderRowIndex() {
            if (hasSortableOption()) {
                $timeout(function () {
                    angular.forEach(vm.model, (row, index) => {
                        row.order = index;
                    });
                });
            }
        }

        function defaultFunc(row) {
            const result = vm.model.map((_row) => {
                return {
                    default: (_row.$$hashKey == row.$$hashKey)
                };
            });
            angular.merge(vm.model, result);
        }

        function hasError(index) {
            return fbService.elementsService.getValidationRule(vm.currentElementIdentifier + '.' + index);
        }

        function canDelete() {
            return vm.view_only ? false : lodash.get(vm.fbElement, 'options.can_delete', true);
        }

        function canAdd() {
            return vm.view_only ? false : lodash.get(vm.fbElement, 'options.can_add', true);
        }

        function generateChildIdentifier(index, element_name) {
            return vm.currentElementIdentifier + '[' + index + '].' + element_name;
        }

        // hsa default
    }
})();

(function () {
    'use strict';

    FormElements.$inject = ['lodash', '$timeout'];
    angular
        .module('FormBuilder')
        .factory('FormElements', FormElements);

    function FormElements(lodash, $timeout) {
        return function (mem) {
            return {
                setValidationRules: setValidationRules,
                clearElementValidationRule: clearElementValidationRule,
                getValidationRule: getValidationRule,
                syncRenderedElements: syncRenderedElements,
                getRenderedElements: getRenderedElements,
                updateRenderedElements: updateRenderedElements,
                setValidationError: setValidationError,
                setValidationSummary: setValidationSummary,
                clearValidationSummary: clearValidationSummary
            };

            function setValidationError(elementIdentifier, error, dont_jump) {
                lodash.set(mem, ['validation.rules', elementIdentifier].join('.'), error);
                if (!dont_jump) {
                    gotoFirstError();
                }
            }

            function clearElementValidationRule(elementIdentifier) {
                lodash.set(mem, ['validation.rules', elementIdentifier].join('.'), []);
            }


            function setValidationSummary(rules, summary, preventScrollToError, summary_field) {
                if (!summary_field) {
                    summary_field = 'summary';
                }
                var validation_obj = {
                    rules: rules,
                };
                validation_obj[summary_field] = summary;

                lodash.set(mem, 'validation', validation_obj);

                if (!!preventScrollToError) return true;

                gotoFirstError();
            }

            function clearValidationSummary(elementIdentifier) {
                lodash.set(mem, ['validation.rules', elementIdentifier].join('.'), []);
                mem.validation.summary = null;
            }

            function setValidationRules(rules, summary, preventScrollToError, summary_field) {
                if (!summary_field) {
                    summary_field = 'summary';
                }
                var validation_obj = {
                    rules: rules,
                };
                validation_obj[summary_field] = summary;

                lodash.set(mem, 'validation', validation_obj);

                if (!!preventScrollToError) return true;

                gotoFirstError();
            }

            function gotoFirstError() {
                $timeout(function () {
                    if (mem.validation.summary) {
                        if (angular.element('.callout').length > 0) {
                            angular.element('html,body').animate({
                                scrollTop: angular.element('.callout').offset().top - 50
                            }, 500);
                        }
                    } else {
                        if (angular.element('.error').length > 0) {
                            angular.element('html,body').animate({
                                scrollTop: angular.element('.error').offset().top - 50
                            }, 500);
                        }
                    }
                });
            }

            function getValidationRule(elementIdentifier) {
                // if (elementIdentifier.indexOf('sub_candidate_education') >= 0) {
                //     console.log(mem.validation.rules);
                // }
                return lodash.get(mem.validation, ['rules', elementIdentifier].join('.'), false);
            }

            function syncRenderedElements(ref) {
                mem.renderedElements = ref;
            }

            function getRenderedElements() {
                return mem.renderedElements;
            }

            function updateRenderedElements(elementPath, data, checkRendered, fieldSpecificData) {
                var element = null;
                if (checkRendered) {
                    element = lodash.get(mem.renderedElements, elementPath, {});
                } else {
                    element = lodash.find(mem.elements, { name: elementPath });
                }


                angular.forEach(data, function (value, field) {
                    var previous = lodash.get(element, field, null);
                    if (previous === null) {
                        lodash.set(element, field, value);
                    } else {
                        if (previous instanceof Array || !(typeof previous == typeof {})) {
                            lodash.set(element, field, value);
                        } else {
                            var newValue = angular.merge(previous, value);
                            lodash.set(element, field, newValue);
                        }
                    }
                });

                if (fieldSpecificData) {
                    var enum_lists = lodash.get(fieldSpecificData, 'datasources', []);
                    var path = lodash.get(fieldSpecificData, 'path', 'options.datasource.data');
                    var element_enum = lodash.get(enum_lists, elementPath, []);
                    lodash.set(element, path, element_enum);
                    
                }


            }
        };
    }
})();
(function () {
    'use strict';

    FormEventActions.$inject = ['$injector', 'lodash', 'TextHelper', 'GenericModel', 'notifier', 'ButtonRegistry', 'ActionCommon', '$q', 'RequestHelper'];
    angular
        .module('FormBuilder')
        .factory('FormEventActions', FormEventActions);

    function FormEventActions($injector, lodash, TextHelper, GenericModel, notifier, ButtonRegistry, ActionCommon, $q, RequestHelper) {
        return function (originFormIdentification, actions, element, elementValue) {

            run(actions);

            function run(_actions) {
                angular.forEach(_actions, function (action, actionName) {
                    actionCtrl(actionName, action, getFormBuilderService(action));
                });
            }

            function getFormBuilderService(action) {
                var formIdentifier = lodash.get(action, 'form_name', originFormIdentification);
                var FormBuilderService = $injector.get('FormBuilderService');
                return FormBuilderService.get(formIdentifier);
            }

            function actionCtrl(actionName, action, fbService) {
//                var actionPromise = $q.defer();
                var functionMap = {
                    send_request: send_request,
                    validate: validate,
                    append_html: append_html,
                    clear_html: clear_html,
                    add_elements: add_elements,
                    append_model: append_model,
                    validation: validation,
                    show_loading: show_loading,
                    hide_loading: hide_loading,
                    show_element_loading: show_element_loading,
                    hide_element_loading: hide_element_loading,
                    show_element_icon: show_element_icon,
                    hide_element_icon: hide_element_icon,
                    call_event: call_event,
                    set_elements: set_elements,
                    update_element: update_element,
                    update_multiple_element: update_multiple_element,
                    set_buttons: set_buttons,
                    show_notification: ActionCommon.show_floating_notifier,
                    show_static_notification: ActionCommon.show_static_notifier,
                    append_view_events: append_view_events,
                    set_view_events: set_view_events,
                    remove_view_events: remove_view_events,
                    refresh_form_elements: refresh_form_elements,
                    set_model: set_model,
                    enable_button: enable_button,
                    disable_button: disable_button,
                    set_active: set_active,
                    remove_elements: remove_elements,
                    remove_buttons: remove_buttons
                };
                functionMap[actionName](action);

                function send_request() {
                    var modelData = {};
                    lodash.set(modelData, element.name, elementValue);

                    var model = new GenericModel(action.datasource.url);
                    var method = lodash.get(action.datasource, 'method', 'get');
                    //lodash.set(action.data, 'model', lodash.pick(fbService.model, action.data.needed));
                    lodash.set(action.data, 'model', RequestHelper.getNeeded(fbService.model, action.data.needed));
                    var request_data = {"data": action.data};
                    model[method]({}, request_data, function (res) {

                        fbService.validation = {};
                        runActions(res);
                    }, handleRequestError);
                }

                function clearLoadings() {
                    hide_loading();
                    hide_element_loading();
                }

                function runActions(res) {
                    if (lodash.has(res, 'actions')) {
                        run(res.actions);
                    }
                }

                function append_html() {
                    fbService.formResultTemplate = action.html;
                    fbService.formResultTemplateModel = action.htmlModel;
                    runActions(action);
                    // if(lodash.has(action,'view_event_action')){
                    //     var view_event_action = action.view_event_action.action;
                    //     action.view_events = action.view_event_action.view_events;
                    //     switch (view_event_action) {
                    //         case 'append':
                    //             append_view_events();
                    //             break;
                    //
                    //         case 'set':
                    //             set_view_events();
                    //             break;
                    //     }
                    // }
                    //
                    //
                    // if(lodash.has(action,'button_action')){
                    //     var button_action = action.button_action.action;
                    //     action.buttons = action.button_action.buttons;
                    //     switch (button_action) {
                    //         case 'set':
                    //             set_buttons();
                    //             break;
                    //     }
                    // }
                    // For reference to access anything in the formResultTemplateModel in the action.html:
                    // to access action.htmlModel.test
                    // in html, refer to vm.options.test
                }

                function clear_html() {
                    fbService.formResultTemplate = "";
                    fbService.formResultTemplateModel = {};
                }

                function refresh_form_elements() {
                    var refreshElements = angular.copy(fbService.fbData.elements);

                    if (lodash.has(action, 'type')) {
                        var field_names = lodash.get(action, 'field_names', []);
                        refreshElements = lodash.filter(refreshElements, function (elem) {
                            return (action.type === 'only') && lodash.indexOf(field_names, elem.name) >= 0;
                        });
                        angular.forEach(refreshElements, function (elem) {
                            var elemIndex = lodash.findIndex(fbService.elements, {name: elem.name});
                            fbService.elements.splice(elemIndex, 1);
                            fbService.elements.splice(elemIndex, 0, elem);
                        });
                    } else {
                        fbService.elements = refreshElements;
                    }
                }

                //todo function to refresh subform form elements

                function add_elements(type) {

                    var elements = [];
                    action[type].reduce(function (prev, curr) {
                        var elementInForm = lodash.find(fbService[type], function (element) {
                            return (element.name == curr.name);
                        });
                        if (!elementInForm) {
                            prev.push(curr);
                        }
                        return prev;
                    }, elements);
                    fbService[type] = lodash.sortBy(fbService[type].concat(elements), 'position');
                }

                function do_remove_elements(type) {
                    lodash.remove(fbService[type], function (item) {
                        var in_actions_elements = lodash.find(action[type], function (element) {
                            return element.name == item.name;
                        });
                        return (!in_actions_elements);
                    });
                }

                function set_elements() {
                    do_remove_elements('elements');
                    add_elements('elements');
                    runActions(action);
                }

                function remove_elements() {
                    do_remove_elements('elements');
                }

                function remove_buttons() {
                    do_remove_elements('buttons');
                }

                function set_buttons() {
                    do_remove_elements('buttons');
                    add_elements('buttons');
                }

                function append_model() {
                    const type = lodash.get(action, 'type', 'merge');
                    if (type === 'merge') {
                        angular[type](fbService.model, action.model);
                    } else {
                        lodash.forIn(action.model, function (value, index) {
                            lodash.set(fbService.model, index, value);
                        });
                    }
                    // angular.merge(fbService.model, action.model);
                }

                function validation(data) {
                    fbService.validation = data || {};
                    hide_loading();
                    hide_element_loading();
                }

                function validate() {
                    var model = new GenericModel(action.datasource.url);
                    var method = lodash.get(action.datasource, 'method', 'get');
                    var request_data = {"data": {"field_value": elementValue, "field_name": element.name}};
                    model[method]({}, request_data, function (res) {
                        fbService.validation = {};
                        runActions(res);
                    }, handleRequestError);
                }

                function show_loading() {
                    fbService.showLoading = true;
                }

                function hide_loading() {
                    fbService.showLoading = false;
                }

                function show_element_loading() {
                    element.wrapper_class = TextHelper.addText(element.wrapper_class || '', 'loading', ' ');
                }

                function hide_element_loading() {
                    element.wrapper_class = TextHelper.removeText(element.wrapper_class || '', 'loading');
                }

                function show_element_icon() {
                    element.wrapper_class = TextHelper.addText(element.wrapper_class || '', action.className, ' ');
                }

                function hide_element_icon() {
                    element.wrapper_class = TextHelper.removeText(element.wrapper_class || '', action.className);
                }

                function separate_view_events_from_dialog(events) {
                    var results = {
                        view_events: {},
                        dialog_events: {}
                    };

                    angular.forEach(events, function (event, index) {
                        if (index.indexOf('dialog') === 0) {
                            results.dialog_events[index] = event;
                        } else {
                            results.view_events[index] = event;
                        }
                    });
                    return results;
                }

                function append_view_events() {
                    var events = separate_view_events_from_dialog(action.view_events);

                    if (!lodash.isEmpty(events.dialog_events)) {
                        //fbService.currentScope.$parent.vm.options.view_events = angular.merge({}, fbService.currentScope.$parent.vm.options.view_events, events.dialog_events);
                        fbService.currentScope.$parent.vm.addEvents(events.dialog_events);
                    }

                    if (!lodash.isEmpty(events.view_events)) {
                        fbService.mainCtrlScope.mainService.addViewEvents(events.view_events);
                    }
                    // fbService.mainCtrlScope.mainService.updateViewEvents(action.view_events);
                }

                function set_view_events() {
                    var events = separate_view_events_from_dialog(action.view_events);

                    if (!lodash.isEmpty(events.dialog_events)) {
                        fbService.currentScope.$parent.vm.setEvents(events.dialog_events);
                    }

                    if (!lodash.isEmpty(events.view_events)) {
                        fbService.mainCtrlScope.mainService.setViewEvents(events.view_events);
                    }

                    // fbService.currentScope.$parent.vm.options.view_events  = action.view_events;
                    // fbService.currentScope.$parent.vm.initEvent();
                }

                function set_active() {
                    element.active = data.active;
                }

                // Todo: Potential to have bug. The view_events here might not be an object but an array of events name. Will handle it when we need it.
                function remove_view_events() {
                    var events = separate_view_events_from_dialog(action.view_events);

                    if (!lodash.isEmpty(events.dialog_events)) {
                        fbService.currentScope.$parent.vm.removeEvents(events.dialog_events);
                    }

                    if (!lodash.isEmpty(events.view_events)) {
                        fbService.mainCtrlScope.mainService.removeViewEvents(events.view_events);
                    }
                }

                function set_model() {
                    fbService.model = action.model;
                    lodash.set(fbService, 'fbData.model', action.model);
                }

                function call_event() {
                    var eventData = {
                        targetScope: {
                            name: fbService.formIdentifier
                        },
                        target: element,
                        event: null,
                        model: fbService.model,
                        formIdentifier: fbService.formIdentifier
                    };

                    fbService.currentScope.$emit(action.event, eventData);
                }

                function update_element() {
                    if (lodash.has(action, 'field_name')) {
                        fbService.elementsService.updateRenderedElements(action.field_name, action.data, lodash.get(action, 'rendered', true));
                    }
                }

                function update_multiple_element() {
                    if (Array.isArray(action.field_name)) {
                        var field_specific_data = lodash.get(action, 'field_specific_data', null);
                        action.field_name.forEach(function(field) {
                            fbService.elementsService.updateRenderedElements(field, action.data, lodash.get(action, 'rendered', true), field_specific_data);
                        });
                    }
                }

                function enable_button() {
                    ButtonRegistry.enableButtons(action.buttons);
                }

                function disable_button() {
                    ButtonRegistry.disableButtons(action.buttons);
                }

                function handleRequestError(res) {
                    switch (res.status) {
                        case 422:
                            fbService.validation = {};
                            runActions(res.data);
                            validation(res.data);
                            break;
                        case 404:
                        case 500:
                        default:
                            clearLoadings();
                            break;

                    }
                }
            }
        };
    }
})();

(function () {
    'use strict';

    FormEvents.$inject = ['lodash', 'FormEventActions', '$timeout', '$rootScope'];
    angular
        .module('FormBuilder')
        .factory('FormEvents', FormEvents);

    function FormEvents(lodash, FormEventActions, $timeout, $rootScope) {
        return function (mem) {
            return {
                onEventTrigger: onEventTrigger,
                getEventOptions: getEventOptions,
                getModelOptions: getModelOptions,
                refreshDataOfElement: refreshDataOfElement,
                setPristine: setPristine
            };

            function onEventTrigger(type) {
                var elementViewModel = this; // through using .bind(this) in the element's Directive

                $timeout(function () {
                    var actions = lodash.get(mem.fbData, ['form_events', generateEventPath(elementViewModel.element.elementIdentifier), 'type', type, 'actions'].join('.'), false);
                    if (actions) {
                        FormEventActions(mem.formIdentifier, actions, elementViewModel.element, elementViewModel.model);
                    }

                    var allActions = lodash.get(mem.fbData, ['form_events.all.type', type, 'actions'].join('.'), false);
                    if (allActions) {
                        var exclude = lodash.get(mem.fbData, ['form_events.all.type', type, 'rules', 'exclude'].join('.'), []);
                        var is_excluded = lodash.indexOf(exclude, elementViewModel.element.name);
                        if (is_excluded == -1) {
                            FormEventActions(mem.formIdentifier, allActions, elementViewModel.element, elementViewModel.model);
                        }
                    }
                });
                if (type === 'onChange') {
                    if (lodash.get(mem, 'fbData.settings.formOnChange', '').length > 0) {
                        $rootScope.$broadcast(mem.fbData.settings.formOnChange, {
                            model: mem.fbModel
                        });
                    }
                }
            }

            function getModelOptions() {
                var elementViewModel = this; // through using .bind(this) in the element's Directive

                var modelOptions = {
                    debounce: {
                        //'default': 500
                    }
                };

                if (lodash.has(mem.fbData, ['form_events', generateEventPath(elementViewModel.element.elementIdentifier)]) || lodash.has(mem.fbData, 'all')) {
                    modelOptions = lodash.get(elementViewModel.element, 'events.options.ngModelOptions', {
                        debounce: {
                            'default': 500
                        }
                    });
                }

                if (lodash.has(elementViewModel.element, 'options.ngModelOptions')) {
                    modelOptions = angular.extend(modelOptions, elementViewModel.element.options.ngModelOptions);
                }

                return modelOptions;
            }

            function getEventOptions(elementName, type) {
                return lodash.get(mem.fbData, ['form_events', generateEventPath(elementName), 'type', type, 'options'].join('.'), {});
            }

            function generateEventPath(path) {
                return path.replace(/(\[[\w\d\s]*\])/g, '');
            }

            function refreshDataOfElement(elementName) {
                refreshData(mem.renderedElements, elementName);
            }

            function refreshData(elements, elementName) {
                angular.forEach(elements, (element) => {
                    if (!lodash.has(element, 'name')) {
                        refreshData(element, elementName);
                    } else {
                        if (element.name == elementName && lodash.has(element, 'refreshData') && (typeof element.refreshData == typeof function () {
                            })) {
                            element.refreshData();
                        }
                    }
                });
            }

            function setPristine() {
                if (mem.currentScope.form) {
                    mem.currentScope.form.$setPristine();
                    mem.currentScope.form.$setUntouched();
                }
            }
        };
    }
})();

(function () {
    'use strict';

    FormBuilderState.$inject = ['lodash'];
    angular
        .module('FormBuilder')
        .factory('FormBuilderState', FormBuilderState);

    function FormBuilderState(lodash) {
        return function(model) {
            return {
                set: set,
                destroy: destroy
            };

            function set(field, value) {
                lodash.set(model, field, value);
            }

            function destroy() {
                model = {};
            }
        };
    }
})();
(function () {
    'use strict';

    FormBuilderHelper.$inject = ['lodash'];
    angular
        .module('FormBuilder')
        .factory('FormBuilderHelper', FormBuilderHelper);

    function FormBuilderHelper(lodash) {
        return {
            getElementSize: getElementSize,
            determineDisabled: determineDisabled
        };


        function getElementSize(elemObj, isLast) {
            //if (elemObj.type == 'button') {  }

            if (elemObj.type == 'hidden') return "hide";
            if (!lodash.has(elemObj, 'attr.size') && !lodash.has(elemObj, 'attr.class')) {
                return "small-12";
            }

            var smallSize = "small-12";
            var mediumSize = 'medium-' + lodash.get(elemObj, 'attr.size', 12);
            var endingClass = (lodash.get(elemObj, 'attr.end', true)) ? "end" : "";
            var additionalClass = lodash.get(elemObj, 'attr.class', '');

            if (isLast) endingClass = 'end';

            var startClass = (lodash.get(elemObj, 'attr.start', false)) ? "start" : "";
            return [startClass, smallSize, mediumSize, endingClass, additionalClass].join(' ');
        }

        function determineDisabled(disabled_fields_option, element, model) {
            if (!Array.isArray(disabled_fields_option)) {
                return null;
            }

            var disabled_field = lodash.find(disabled_fields_option, { 'target_field_name': element.name });
            if (!disabled_field) {
                return null;
            }

            var compared_value = lodash.get(model, disabled_field.source_field_name, null);
            if (compared_value === null) {
                return null;
            }

            return !(lodash.get(disabled_field, 'value_flip', false)) ? compared_value : !compared_value;
        }
    }
})();
(function () {
    'use strict';

    FormBuilderService.$inject = ['lodash', 'FormBuilderState', 'FormEvents', 'FormElements', '$timeout'];
    angular
        .module('FormBuilder')
        .factory('FormBuilderService', FormBuilderService);

    function FormBuilderService(lodash, FormBuilderState, FormEvents, FormElements, $timeout) {
        var mem = {},
            mainCtrlScope = null; // eslint-disable-line no-unused-vars

        return {
            initApp: initApp,
            init: init,
            sync: sync,
            get: get,
            getModel: getModel,
            destroy: destroy,
            rerender: rerender,
            hasDirtyForm: hasDirtyForm,
            getAll: function() { return mem; },
        };

        function initApp(scope) {
            mainCtrlScope = scope;
        }

        function init(form_name, ref, scope) {
            lodash.set(mem, form_name, ref);
            mem[form_name].currentScope = scope;
            mem[form_name].modelService = new FormBuilderState(mem[form_name].model);
            mem[form_name].elementsService = new FormElements(mem[form_name]);
            mem[form_name].eventsService = new FormEvents(mem[form_name]);
            return mem[form_name];
        }

        function sync(form_name, ref) {
            lodash.set(ref, 'pageData', lodash.get(mem, form_name, {}));
        }

        function get(form_name) {
            return lodash.get(mem, form_name, {});
        }

        function destroy(form_name) {
            mem = lodash.omit(mem, [form_name]);
        }

        function getModel(form_name) {
            return lodash.get(mem, form_name + '.model', {});
        }

        function hasDirtyForm() {
            return lodash.values(mem).reduce((results, current) => {
                if (results) return results; // if result is true, just continue. No need to check anymore
                if (!lodash.has(current.fbData, 'settings.check_for_dirty') || !current.fbData.settings.check_for_dirty) return results; // if form says don't check for data, then don't. Continue;
                return current.currentScope.form.$dirty; // Otherwise, set "results" as current form.$dirty;
            }, false);
        }

        function rerender(form_name) {
            console.log('rerender', mem[form_name].elements);
            $timeout(function() {
                var elements = mem[form_name].elementsService.getRenderedElements();
                angular.forEach(elements, function(element) {
                    if (lodash.has(element, 'render') && typeof element.render === typeof function() {}) {
                        element.render();
                    }
                });
            });
        }
    }
})();
(function () {
    'use strict';

    FbSelectService.$inject = ['lodash'];
    angular
        .module('FormBuilder')
        .factory('FbQuestionWrapperService', FbSelectService);

    function FbSelectService(lodash) {
        return {
            showTextbox: function (vm) {
                var textSetting = vm.element.options.settings.showText || null;
                if (vm.model.answer == null) {
                    return false;
                }

                var result = false;
                switch (textSetting.operator) {
                    case "eq":
                        result = (textSetting.value == lodash.get(vm, 'model.answer', null));
                        break;
                    case "notEq":
                        result = (textSetting.value != lodash.get(vm, 'model.answer', null));
                        break;
                    case "in":
                        if (['multichoice'].indexOf(vm.element.type) >= 0) {
                            result = false;
                            var ansArr = lodash.get(vm, 'model.answer', []);
                            for (var i in ansArr) {
                                var _ans = ansArr[i];
                                if (textSetting.value.indexOf(_ans) >= 0) {
                                    result = true;
                                    break;
                                }
                            }

                        } else {
                            result = (textSetting.value.indexOf(parseInt(lodash.get(vm, 'model.answer', -1))) != -1);
                        }
                        break;
                }
                return result;

            },
            onBlur: function(vm, target) {
                if (!lodash.has(vm.model,'others') || lodash.get(vm.model,'others','').length == 0) {
                    angular.element(target).parent().addClass('error');
                    angular.element(target).parent().find('.error-message').remove();
                    angular.element(target).after('<span class="error-message">Additional details are required.</span>');
                } else {
                    angular.element(target).parent().removeClass('error');
                    angular.element(target).parent().find('.error-message').remove();
                }
            },
            onChange: function(vm) {
                if(lodash.get(vm.model, 'others')){ 
                    const model = {
                        answer: vm.model.answer
                    };
                    lodash.set(vm, 'model', model);
                }
                return vm;
            }
        }
    }
})();
(function () {
    'use strict';

    FbSelectService.$inject = ['lodash', '$compile', '$timeout', '$templateCache'];
    angular
        .module('FormBuilder')
        .factory('FbSelectService', FbSelectService);

    function FbSelectService(lodash, $compile, $timeout, $templateCache) {
        return {
            initTemplateCall: initTemplateCall
        };

        function initTemplateCall(elementOptions, additionalOptions) {
            if (lodash.has(elementOptions, 'template.item')) {
                lodash.set(additionalOptions, 'render.item', renderItem);
            }
            if (lodash.has(elementOptions, 'template.option')) {
                lodash.set(additionalOptions, 'render.option', renderOption);
            }
            if (lodash.has(elementOptions, 'template.option_create')) {
                lodash.set(additionalOptions, 'render.option_create', renderOptionCreate);
            }
            if (lodash.has(elementOptions, 'template.optgroup_header')) {
                lodash.set(additionalOptions, 'render.optgroup_header', renderOptgroupHeader);
            }
            if (lodash.has(elementOptions, 'template.optgroup')) {
                lodash.set(additionalOptions, 'render.optgroup', renderOptgroup);
            }

            function renderItem(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.item', {html: '', schema: []}));
            }

            function renderOption(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.option', {html: '', schema: []}));
            }

            function renderOptionCreate(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.create', {html: '', schema: []}));
            }

            function renderOptgroupHeader(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.optgroup_header', {html: '', schema: []}));
            }

            function renderOptgroup(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.optgroup', {html: '', schema: []}));
            }

            function render(data, escape, template) {
                if (lodash.isEmpty(template.html)) {
                    if (lodash.has(template, 'htmlTemplateUrl')) {
                        template.html = $templateCache.get(template.htmlTemplateUrl);
                    }
                }

                const result = template.schema.reduce((previous, current) => {
                    const dataEscaped = escape(lodash.get(data, current, ''));
                    const replaceKey = `#${current}#`;
                    return previous.replace(replaceKey, dataEscaped);
                }, template.html);

                return TemplateEngine(result, lodash.pick(data, template.schema || []));
            }

            var TemplateEngine = function(html, options) {
                var re = /<@([^@>]+)?@>/g, reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g, code = 'var r=[];\n', cursor = 0, match;
                var add = function(line, js) {
                    js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
                        (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
                    return add;
                }
                while(match = re.exec(html)) {
                    add(html.slice(cursor, match.index))(match[1], true);
                    cursor = match.index + match[0].length;
                }
                add(html.substr(cursor, html.length - cursor));
                code += 'return r.join("");';
                return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
            }

        }


    }
})();
(function () {
    'use strict';

    fbFieldAnchorTranscludeDirectiveCtrl.$inject = ['$scope', '$element', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbFieldAnchorTransclude', fbFieldAnchorTranscludeDirective);

    function fbFieldAnchorTranscludeDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model:'='
                //type: '@'
            },
            controller:fbFieldAnchorTranscludeDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude:true,
            template: '<a  ng-click="vm.click($event)" class="<%vm.getClass()%>" ><ng-transclude></ng-transclude></a>'
        };
    }

    function fbFieldAnchorTranscludeDirectiveCtrl ($scope, $element, lodash) {
        var vm = this;

        vm.click = click;
        vm.getClass = getClass;

        function getClass() {
            return lodash.get($scope, 'element.class','');
        }

        function click($event) {
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event,
                model: vm.model
            };

            if (lodash.has(vm.element, 'event.click') && !lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                $scope.$emit(vm.element.event.click, eventData);
            }
        }
    }
})();
(function () {
    'use strict';

    fbFieldAnchorDirectiveCtrl.$inject = ['$scope', '$element', 'lodash', '$compile', '$interval'];
    angular
        .module('FormBuilder')
        .directive('fbFieldAnchor', fbFieldAnchorDirective);

    function fbFieldAnchorDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model:'='
                //type: '@'
            },
            controller:fbFieldAnchorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldAnchorDirectiveCtrl ($scope, $element, lodash, $compile, $interval) {
        var vm = this;
        var spam_protection = false;
        var start_protection_on_load = false;
        var duration = 0;
        var cloneElement = null;
        this.$onInit = function() {
            vm.click = click;

            spam_protection = lodash.get(vm.element, 'attr.spam_protection', false);
            start_protection_on_load = lodash.get(spam_protection, 'start_on_load', false);
            duration = lodash.get(spam_protection, 'duration', 0);
            vm.is_protected = start_protection_on_load;
            vm.protection_remaining = 0;

            if (start_protection_on_load) {
                registerProtection();
            }

            var template =
                '<a  ng-click="vm.click($event)" class="' + getClass() + '" ng-if="!vm.is_protected">' +
                '<i class="fa position-right" ng-class="\'fa-\' + vm.element.icon" ng-if="vm.element.icon"></i>' +
                '<%vm.element.label%>' +
                '</a><span ng-if="vm.is_protected"><%vm.element.label%> (<%vm.protection_remaining%>)</span>';
            $element.html(template);
            cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', onDestroy);
        }

        // function getIconClass() {
        //     return 'fa-'+lodash.get(vm, 'element.icon',' hide');
        // }

        function getClass() {
            return lodash.get(vm, 'element.class','');
        }

        function click($event) {
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event,
                model: vm.model
            };

            if (lodash.has(vm.element, 'event.click') && !lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                $scope.$emit(vm.element.event.click, eventData);
            }
            registerProtection();
        }

        function registerProtection() {
            if (!!spam_protection) {
                vm.is_protected = true;
                vm.protection_remaining = duration;
                vm.protection_interval = $interval(function () {
                    if (vm.protection_remaining > 0) {
                        vm.protection_remaining = vm.protection_remaining - 1;
                    } else {
                        vm.is_protected = false;
                        $interval.cancel(vm.protection_interval);
                    }
                }, 1000);
            }
        }

        function onDestroy() {
            cloneElement.off();
        }
    }
})();
(function () {
    'use strict';

    fbFieldApproverSelector.$inject = ['$timeout', 'lodash'];
    fbFieldApproverSelectorCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', 'GenericModel', 'ActionCommon', '$timeout', 'FbSelectService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldApproverSelector', fbFieldApproverSelector);

    function fbFieldApproverSelector($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                eventHandler: '&'
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldApproverSelector',
            controller: fbFieldApproverSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                ctrl.$render = function (viewValue) {
                    vm.model = vm.setInitialModel(ctrl.$modelValue);
                }

                vm.commitChange = function () {
                    ctrl.$setViewValue(vm.model);
                }
            }
        };
    }

    function fbFieldApproverSelectorCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService) {
        var vm = this;
        this.$onInit = function() {
            vm.selectizes = null;
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);
            vm.additionalOptions = {};
            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            vm.roles_ds = lodash.get(vm.element, 'options.datasource.roles', []);
            vm.approvers_ds = lodash.get(vm.element, 'options.datasource.approvers', {});


            console.log('fbFieldApproverSelector', vm.element);
            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions = {optgroups: vm.element.options.datasource.optgroup_data};
            }

            vm.setInitialModel = function (modelValue) {
                var result = {};
                lodash.forEach(vm.roles_ds, function (value) {
                    var id = value.id;
                    if (lodash.has(modelValue, id)) {
                        result[id] = modelValue[id];

                        lodash.set(result[id], 'main', lodash.get(modelValue[id], 'main', null));
                        lodash.set(result[id], 'proxy', lodash.get(modelValue[id], 'proxy', null));
                    } else {
                        result[id] = {
                            value: id,
                            main: null,
                            proxy: null,
                        };
                    }
                });
                return result;
            }

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        onInitialize: function (selectize) {
                            // vm.selectize = selectize;
                            // $timeout(function() {
                            //     if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                            //         vm.selectize.disable();
                            //     }
                            // });
                        },
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        }
    }
})();

(function () {
    'use strict';

    fbFieldAutocompleteDirective.$inject = ['lodash'];
    fbFieldAutocompleteDirectiveCtrl.$inject = ['FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldAutocomplete', fbFieldAutocompleteDirective);

    function fbFieldAutocompleteDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
            },
            require: 'ngModel',
            controller: fbFieldAutocompleteDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldAutocomplete',
            link: fbFieldAutocompleteDirectiveLink
        };

        function fbFieldAutocompleteDirectiveLink(scope, elem, attr, ctrl) {
            // const vm = scope.vm;
            // if (lodash.has(vm.element, 'attr.attributes')) {
            //     if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
            //         const inputElem = elem.find('input');
            //         lodash.forIn(vm.element.attr.attributes, (value, attr) => {
            //             inputElem.attr(attr, value);
            //         });
            //     }
            // }
            ctrl.$render = function() {
                scope.currentScopeModel = ctrl.$viewValue;
            }

            scope.$watch('currentScopeModel', function() {
                ctrl.$setViewValue(scope.currentScopeModel);
            });

        }
    }

    function fbFieldAutocompleteDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
        }
    }
})();

(function () {
    'use strict';

    fbFieldButtonDirectiveCtrl.$inject = ['$scope', '$element', 'ButtonRegistry', 'lodash', '$compile', 'FormBuilderService', 'GaService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldButton', fbFieldButtonDirective);

    function fbFieldButtonDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model:'=',
                myClass: "@"
                //type: '@'
            },
            controller:fbFieldButtonDirectiveCtrl,
            bindToController: true,
            controllerAs: 'vm'
        };
    }

    function fbFieldButtonDirectiveCtrl($scope, $element, ButtonRegistry, lodash, $compile, FormBuilderService, GaService) {
        var vm = this;
        var cloneElement = null;
        this.$onInit = function() {
            vm.element.loading = false;
            vm.element.angular_id = $scope.$id;
            ButtonRegistry.set(vm.element);

            vm.click = click;

            vm.spinnerColor = '';

            setDefaultSpinnerColor();

            var template =
                '<button ladda="vm.element.loading" type="' + getType() + '" ng-click="vm.click($event)" name="' + vm.element.name + '" class="button ladda-button ' + [vm.myClass, getClass()].join(' ') +
                '" ng-disabled="vm.element.attr.disabled || vm.pageData.fbData.settings.view_only" ' +
                vm.spinnerColor + '>' +
                '<text class="div-table"><text class="div-cell">' +
                '<i class="fa ' + getIconClass() + '"></i></text>' +
                '<text class="div-cell">' +
                getLabel() + '</text></text>' +
                '</button>';

            $element.html(angular.copy(template));
            cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', onDestroy);
        }

        function click($event) {
            if  (lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                return;
            }
            if (lodash.get(vm.element, 'attr.loading', true) === true) {
                //vm.element.loading = true;
                ButtonRegistry.setLoading(vm.element.name);
            }
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event,
            };

            if (!!vm.model) {
                eventData.model = vm.model;
            }

            if (lodash.has($scope, '$parent.vm.formIdentifier')) {
                vm.formIdentifier = $scope.$parent.vm.formIdentifier;
                var fbService = FormBuilderService.get(vm.formIdentifier);
                lodash.set(eventData, 'model', fbService.model || {});
                lodash.set(eventData, 'formIdentifier', vm.formIdentifier);
            }

            // switch (vm.element.type) {
            //     case "back":
            //         if (lodash.has(vm, 'element.event.click')) {
            //             $scope.$emit(vm.element.event.click, eventData);
            //         } else {
            //             $scope.$emit('action.common.button.back', eventData);
            //         }
            //         break;
            //     case "custom":
            //         vm.element.click();
            //         break;
            //     case "dialog-close":
            //
            //         if (lodash.has(vm, 'element.event.click')) {
            //             $scope.$emit(vm.element.event.click, eventData);
            //         } else {
            //             $scope.$emit('action.common.dialog.close', eventData);
            //         }
            //         break;
            //     case "submit":
            //         break;
            //     default:
            if (lodash.has(vm, 'element.event.click')) {
                $scope.$emit(vm.element.event.click, eventData);
            }
            //         break;
            // }
        }
        
        function getType() {
            var buttonType = (lodash.get(vm,'element.type','button'));
            if (buttonType == 'submit' || buttonType == 'reset') return buttonType; // button type = submit or button type = reset
            return "button"; // otherwise, button type = button
        }

        function getClass() {
            var classnames = [lodash.get(vm, 'element.class', '')];
            if (vm.element.label.length > 0) {
                classnames.push('has-text')
            }
            return classnames.join(' ');
        }

        function getIconClass() {
            const iconClass = lodash.get(vm, 'element.icon', '');
            if (iconClass.length === 0) {
                return 'no-icon-class';
            }
            return appendFa(iconClass);
        }

        function appendFa(className) {
            if (className.indexOf('fa-') === 0) return className;
            return 'fa-' + className;
        }

        function getLabel() {
            return lodash.get(vm.element, 'attr.fixed_label', vm.element.label);
        }

        function onDestroy() {
            cloneElement.off();
            ButtonRegistry.remove($scope.$id);
        }

        function setDefaultSpinnerColor() {
            if (getClass().indexOf('default') >= 0) {
                vm.spinnerColor = 'data-spinner-color="#888888"';
            }
        }
    }
})();
(function () {
    'use strict';

    fbFieldCheckboxButtonDirectiveCtrl.$inject = ['FormBuilderService', '$scope', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbFieldCheckboxButton', fbFieldCheckboxButtonDirective);

    function fbFieldCheckboxButtonDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model: '=',
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldCheckboxButton',
            controller: fbFieldCheckboxButtonDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldCheckboxButtonDirectiveCtrl(FormBuilderService, $scope, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.toggle = toggle;

            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }

        function toggle() {
            if (lodash.get(vm.pageData, 'fbData.settings.view_only', false)) return;
            vm.model = !vm.model;
            vm.onEventTrigger('onChange');
        }
    }
})();

(function () {
    'use strict';

    fbFieldColorPickerDirective.$inject = ['lodash'];
    fbFieldColorPickerDirectiveCtrl.$inject = ['FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldColorPicker', fbFieldColorPickerDirective);

    function fbFieldColorPickerDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldColorPickerDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldColorPicker',
            link: fbFieldColorPickerDirectiveLink
        };

        function fbFieldColorPickerDirectiveLink(scope, elem) {
            // const vm = scope.vm;
            // if (lodash.has(vm.element, 'attr.attributes')) {
            //     if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
            //         const inputElem = elem.find('input');
            //         lodash.forIn(vm.element.attr.attributes, (value, attr) => {
            //             inputElem.attr(attr, value);
            //         });
            //     }
            // }
        }
    }

    function fbFieldColorPickerDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }
    }
})();

(function () {
    'use strict';

    fbFieldCompileCtrl.$inject = ['$compile', '$scope', '$element', '$templateCache', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbFieldCompile', fbFieldCompile);

    function fbFieldCompile() {
        return {
            restrict: 'E',
            scope: {
                element: '='
            },
            controller: fbFieldCompileCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function fbFieldCompileCtrl($compile, $scope, $element, $templateCache, lodash) {
        var vm = this;
        this.$onInit = function() {
            initTemplate();
        }

        function initTemplate() {
            var template = '';

            if (lodash.has(vm.element, 'options.html')) {
                template = vm.element.options.html;
            } else {
                if (lodash.has(vm.element, 'options.templateUrl')) {
                    template = $templateCache.get(vm.element.options.templateUrl);
                }
            }

            if (!lodash.isEmpty(template)) {
                $element.html(template);
                $compile($element.contents())($scope);
            }
        }
    }
})();
(function () {
    "use strict";

    fbFieldDatatableToggleDirective.$inject = ['lodash', 'FormBuilderService'];
    angular
        .module("FormBuilder")
        .directive("fbFieldDatatableToggleManager", fbFieldDatatableToggleDirective);

    function fbFieldDatatableToggleDirective(lodash, FormBuilderService) {
        fbFieldDatatableToggleManagerDirectiveCtrl.$inject = ['$scope', 'lodash'];
        return {
            restrict: "E",
            scope: {
                element: "="
            },
            require: "ngModel",
            templateUrl: "common/libraries/formBuilder/fields/fieldDatatableToggleManager",
            link: fbFieldDatatableToggleManagerDirectiveLink,
            controller: fbFieldDatatableToggleManagerDirectiveCtrl
        };

        function fbFieldDatatableToggleManagerDirectiveLink(scope, elem, attr, ctrl) {
            scope.currentScope = {
                element: scope.element
            };

            ctrl.$render = function () {
                scope.currentScopeModel = ctrl.$modelValue;
            };

            scope.$watch("currentScopeModel", function () {
                ctrl.$setViewValue(scope.currentScopeModel);
            });
        }

        function fbFieldDatatableToggleManagerDirectiveCtrl($scope, lodash) {
            var formIdentifier = '';
            var elementIdentifier = '';
            var fbService = null;

            this.$onInit = function() {
                formIdentifier = $scope.$parent.vm.formIdentifier;
                elementIdentifier = $scope.$parent.vm.elementIdentifier;
                fbService = FormBuilderService.get(formIdentifier);

                $scope.events = {
                    hasError: hasError,
                    errorMessage: errorMessage
                };
            }

            function hasError($index) {
                return !lodash.isEmpty(
                    fbService.elementsService.getValidationRule(elementIdentifier)
                );

                // return !lodash.isEmpty(
                //     fbService.elementsService.getValidationRule(elementIdentifier + '[' + $index + ']')
                // );
            }

            function errorMessage() {
                var error = fbService.elementsService.getValidationRule(elementIdentifier);
                if (!error) {
                    return '';
                }
                return error.join(' ');

                // var error = fbService.elementsService.getValidationRule(
                //     elementIdentifier
                // );
                // var format = {};
                // if (error) {
                //     Object.keys(error).forEach(function (key) {
                //         format[key] = lodash.flatMap(error[key]).join(" ");
                //     });
                // }
                // return format;
            }
        }
    }
})();

(function () {
    'use strict';

    fbFieldDatepickerDirective.$inject = ['$timeout', 'lodash'];
    fbFieldDatepickerDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldDatepicker', fbFieldDatepickerDirective);

    function fbFieldDatepickerDirective($timeout, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldDatepicker',
            controller: fbFieldDatepickerDirectiveCtrl,
            controllerAs: 'fieldCtrl',
            bindToController: true,
            require: 'ngModel',
            link: function(scope, elem, link, ngModelCtrl) {
                var input = elem.find('input');
                if (lodash.get(scope.fieldCtrl, 'element.options.disableInput', false) === true) {
                    input.attr("autocomplete", "off");

                    input.on('click', function() {
                        if (input.find('.k-picker-wrap').hasClass('k-state-active')) {
                            scope.fieldCtrl.element.callback.close();
                        } else {
                            scope.fieldCtrl.element.callback.open();
                        }
                    })
                    $timeout(function() {
                        input.attr("readonly", "readonly");
                    });
                }

                scope.fieldCtrl.commitValue = function(value) {
                    ngModelCtrl.$setViewValue(value);
                }


                ngModelCtrl.$render = function() {
                    scope.current_model = ngModelCtrl.$viewValue;
//                    lodash.set(scope.current_model, ngModelCtrl.$viewValue);
                    if (scope.fieldCtrl.element.callback) {
                        scope.fieldCtrl.element.callback.value(scope.current_model);
                    }
                };

                ngModelCtrl.$parsers.push(function(viewValue) {
                    if (!viewValue) return null
                    if (!!scope.fieldCtrl.parse_format) {
                        return moment(viewValue).format(scope.fieldCtrl.parse_format);
                    }
                    return viewValue;
                });


            }
        };
    }

    function fbFieldDatepickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
        var fieldCtrl = this;
        var formIdentifier = '';

        this.$onInit = function() {
            fieldCtrl.current_model = '';

            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, fieldCtrl);

            fieldCtrl.onEventTrigger = fieldCtrl.pageData.eventsService.onEventTrigger.bind(fieldCtrl);
            fieldCtrl.getModelOptions = fieldCtrl.pageData.eventsService.getModelOptions.bind(fieldCtrl);

            fieldCtrl.kendo_parse_format = lodash.get(fieldCtrl.element, 'options.kendo_parse_format', 'dd/MM/yyyy');
            fieldCtrl.parse_format = lodash.get(fieldCtrl.element, 'options.parse_format', null);

            fieldCtrl.dateOptions = angular.merge({
                    format: fieldCtrl.kendo_parse_format,
                    change: function(value) {
                        fieldCtrl.commitValue(value.sender._value);
                        fieldCtrl.onEventTrigger('onChange');
                    },
                    month: {
                        empty: '<div style="color:\\#ccc;line-height: 1.833em">#= data.value #</div>'
                    }
                },
                lodash.get(fieldCtrl.element,'attr.datePickerOptions',{}),
                generateOptions()
            );
        }

        function generateOptions() {
            var option = {};
            if (lodash.has(fieldCtrl.element, 'options.max')) {
                var now = lodash.get(fieldCtrl.element, 'options.max.now');
                if (now) {
                    option.max = new Date();
                } else {
                    var maxObj = fieldCtrl.element.options.max;
                    option.max = new Date(maxObj.year, maxObj.month - 1, maxObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.min')) {
                var now = lodash.get(fieldCtrl.element, 'options.min.now');
                if (now) {
                    option.min = new Date();
                } else {
                    var minObj = fieldCtrl.element.options.min;
                    option.min = new Date(minObj.year, minObj.month - 1, minObj.day);
                }
            }

            return option;
        }

    }
})();
(function () {
    'use strict';

    fbFieldDatepicker2Directive.$inject = ['$timeout', 'lodash'];
    fbFieldDatepicker2DirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldDatepicker2', fbFieldDatepicker2Directive);

    function fbFieldDatepicker2Directive($timeout, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldDatepicker2',
            controller: fbFieldDatepicker2DirectiveCtrl,
            controllerAs: 'fieldCtrl',
            bindToController: true,
            require: 'ngModel',
            link: function(scope, elem, link, ngModelCtrl) {
                var dp_object = $(elem);
                dp_object.datepicker(scope.fieldCtrl.dateOptions);
                var block = true;

                function changeFunc(e) {
                    // if (block) return;
                    if (!e.target.value || e.target.value.length == 0) {
                        if (!block) {
                            scope.fieldCtrl.commitValue(e.target.value);
                            scope.fieldCtrl.onEventTrigger('onChange');
                        }
                        return;

                    }
                    var isValid = moment(e.target.value, scope.fieldCtrl.parse_format).isValid();
                    if (isValid) {
                        scope.fieldCtrl.commitValue(e.target.value);
                        scope.fieldCtrl.onEventTrigger('onChange');
                    } else {
                        scope.fieldCtrl.current_model = null;
                        dp_object.datepicker('update', '');
                    }
                }


                scope.fieldCtrl.clearModel = function() {
                    scope.fieldCtrl.current_model = null;
                    scope.fieldCtrl.commitValue(scope.fieldCtrl.current_model);
                    dp_object.datepicker('hide');
                }


                dp_object.on('change', changeFunc);
                //
                // dp_object.on('focusout', function(e) {
                //     dp_object.datepicker('update', e.target.value);
                // });

                scope.fieldCtrl.commitValue = function(value) {
                    ngModelCtrl.$setViewValue(value);
                }

                ngModelCtrl.$render = function() {
                    // var view_value = ngModelCtrl.$viewValue;
                    // if (!ngModelCtrl.$viewValue) {
                    //     view_value = '';
                    // }
                    // if (ngModelCtrl.$viewValue == 'Invalid date') {
                    //     scope.fieldCtrl.current_model = null;
                    // }
                    scope.fieldCtrl.current_model = ngModelCtrl.$viewValue;
                    dp_object.datepicker('setDate', scope.fieldCtrl.current_model);
                    block = false;
                };
                //
                ngModelCtrl.$formatters.push(function(modelValue) {
                    if (!modelValue) {
                        scope.fieldCtrl.commitValue('');
                        return '';
                    }
                    if (modelValue == 'Invalid date') {
                        scope.fieldCtrl.commitValue('');
                        return '';
                    }
                    var formatter_date = moment(modelValue, scope.fieldCtrl.save_format).format(scope.fieldCtrl.parse_format);
                    // block = false;
                    return formatter_date;
                    // return moment(modelValue, scope.fieldCtrl.save_format).format(scope.fieldCtrl.parse_format);
                });
                //
                ngModelCtrl.$parsers.push(function(viewValue) {
                    if (!viewValue) {
                        return null;
                    }
                    var parser_date = moment(viewValue, scope.fieldCtrl.parse_format);
                    return parser_date.format(scope.fieldCtrl.save_format); 
                //     if (!moment.isValid(parser_date.toDate())) {
                //         parser_date = '';
                //     }
                //     return parser_date;

                });
            }
        };
    }

    function fbFieldDatepicker2DirectiveCtrl(lodash, FormBuilderService, $scope) {
        var fieldCtrl = this;
        var formIdentifier = '';
        this.$onInit = function() {
            fieldCtrl.current_model = null;

            formIdentifier = $scope.$parent.vm.formIdentifier;
            fieldCtrl.is_read_only = $scope.$parent.vm.pageData.fbData.settings.view_only

            FormBuilderService.sync(formIdentifier, fieldCtrl);

            fieldCtrl.onEventTrigger = fieldCtrl.pageData.eventsService.onEventTrigger.bind(fieldCtrl);
            fieldCtrl.getModelOptions = fieldCtrl.pageData.eventsService.getModelOptions.bind(fieldCtrl);
            fieldCtrl.display_format = lodash.get(fieldCtrl.element, 'options.display_format', 'dd/mm/yyyy');
            fieldCtrl.parse_format = 'DD/mm/YYYY';
            fieldCtrl.save_format = lodash.get(fieldCtrl.element, 'options.save_format', 'YYYY-mm-DD');

            fieldCtrl.dateOptions = angular.merge({
                    format: fieldCtrl.display_format,
                    autoclose: true,
                    forceParse: false,
                    keepEmptyValues: true,
                },
                generateOptions()
            );

        }

        function generateOptions() {
            var option = {};
            if (lodash.has(fieldCtrl.element, 'options.max')) {
                var now = lodash.get(fieldCtrl.element, 'options.max.now');
                if (now) {
                    option.endDate = new Date();
                } else {
                    var maxObj = fieldCtrl.element.options.max;
                    option.endDate = new Date(maxObj.year, maxObj.month - 1, maxObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.min')) {
                var now = lodash.get(fieldCtrl.element, 'options.min.now');
                if (now) {
                    option.startDate = new Date();
                } else {
                    var minObj = fieldCtrl.element.options.min;
                    option.startDate = new Date(minObj.year, minObj.month - 1, minObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.locale')) {
                var locale = lodash.get(fieldCtrl.element, 'options.locale');
                option.language = locale;
            }

            return option;
        }

    }
})();
(function () {
	'use strict';

	fbFieldDaterangepickerDirective.$inject = ['$timeout'];
	fbFieldDaterangepickerDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
	angular
		.module('FormBuilder')
		.directive('fbFieldDaterangepicker', fbFieldDaterangepickerDirective);

	function fbFieldDaterangepickerDirective($timeout) {
		return {
			restrict: 'EA',
			scope: {
				element:'=',
				model: '='
			},
			templateUrl: 'common/libraries/formBuilder/fields/fieldDaterangepicker',
			controller: fbFieldDaterangepickerDirectiveCtrl,
			controllerAs: 'vm',
			bindToController: true,
			link: function(scope) {
			}
		};
	}

	function fbFieldDaterangepickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
		var vm = this;
		this.$onInit = function() {
			var formIdentifier = $scope.$parent.vm.formIdentifier;

			FormBuilderService.sync(formIdentifier, vm);

			vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
			vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
			vm.options = angular.merge({},
				lodash.get(vm.element,'attr.options',{})
			);
		}
	}
})();
(function () {
    'use strict';

    fbFieldDisplayOnlyFieldDirectiveCtrl.$inject = ['FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldDisplayOnly', fbFieldDisplayOnlyFieldDirective);

    function fbFieldDisplayOnlyFieldDirective() {
        return {
            restrict: "EA",
            scope: {
                element: "=",
                model: '='
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: fbFieldDisplayOnlyFieldDirectiveCtrl,
            templateUrl: 'common/libraries/formBuilder/fields/fieldDisplayOnlyField'
        };
    }

    function fbFieldDisplayOnlyFieldDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);
        }

        // vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
        // vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
    }
})();
(function () {
    'use strict';

    fbFieldDurationCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', 'GenericModel', 'ActionCommon', '$timeout', 'FbSelectService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldDuration', fbFieldDuration);

    function fbFieldDuration() {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: "=",
                eventHandler: '&'
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldDuration',
            controller: fbFieldDurationCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldDurationCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService) {
        // $scope.$watch(function() { return vm.model; }, function() { console.log('fieldSelect model', vm.model); });
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {
            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }

            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function() {
                    return vm.element.options.datasource.data;
                }, function() {
                    vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                });
            }

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        onChange: function () {
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function(selectize){
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function() {
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        }

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data:{label: value,model:formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function(res) {
                    vm.isLoading = false;
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            return model[method]({}, {data:FormBuilderService.getModel(formIdentifier)}).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function(res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();
(function () {
    'use strict';

    fbFieldEmailVerifyDirective.$inject = ['lodash'];
    fbFieldSimpleDirectiveCtrl.$inject = ['FormBuilderService', '$scope', 'GenericModel', 'lodash', '$rootScope', '$interval'];
    angular
        .module('FormBuilder')
        .directive('fbFieldEmailVerifyElement', fbFieldEmailVerifyDirective);

    function fbFieldEmailVerifyDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldSimpleDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldEmailVerify',
            link: fbFieldEmailVerifyDirectiveLink
        };

        function fbFieldEmailVerifyDirectiveLink(scope, elem) {
            const vm = scope.vm;
            if (lodash.has(vm.element, 'attr.attributes')) {
                if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
                    const inputElem = elem.find('input');
                    lodash.forIn(vm.element.attr.attributes, (value, attr) => {
                        inputElem.attr(attr, value);
                    });
                }
            }
        }
    }

    function fbFieldSimpleDirectiveCtrl(FormBuilderService, $scope, GenericModel, lodash, $rootScope, $interval) {
        var vm = this;
        var formIdentifier = '';
        var spam_protection = false;
        var start_protection_on_load = false;
        var duration = 0;

        this.$onInit = function() {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.options = lodash.get($scope.vm.pageData.currentScope.$parent.$parent, 'vm.panelState.structure.options', {});

            vm.showOtpState = lodash.get(vm.options, 'showOtpState', false);
            vm.element.loading = false;
            vm.sendOtp = sendOtp;
            vm.registerProtection = registerProtection;
            // vm.loadHasFieldError = false;
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;

            vm.expired_in = lodash.get(vm.options, 'otp_validity_mins', 0);

            lodash.set(vm.pageData.model, 'txt_otp', null);
            spam_protection = lodash.get(vm.element, 'attr.spam_protection', false);
            start_protection_on_load = lodash.get(spam_protection, 'start_on_load', false);
            duration = lodash.get(vm.options, 'last_sent_threshold', 0);
            vm.is_protected = start_protection_on_load;
            vm.protection_remaining = 0;

            if (start_protection_on_load) {
                registerProtection();
            }

            $scope.otpInput={
                size:6,
                type:"text",
                style: {
                    lineColor   : "#FFFFFF",
                    bgColor     : "#FFFFFF",
                    fontSize    : "14px",    
                },
                onDone: function(value){
                    console.log('on done :'+value);
                },
                onChange: function(value){
                    console.log('on change :'+value);
                    lodash.set(vm.pageData.model, 'txt_otp', value);
                },
            };
        }

        function showOtpWindow() {
            vm.pageData.elementsService.clearElementValidationRule(vm.element.elementIdentifier);
    
            vm.showOtpState = true;
            registerProtection();      

        }

        function registerProtection() {
            if (!!spam_protection) {
                vm.is_protected = true;
                vm.protection_remaining = duration;
                vm.protection_interval = $interval(function () {
                    if (vm.protection_remaining > 0) {
                        vm.protection_remaining = vm.protection_remaining - 1;
                    } else {
                        vm.is_protected = false;
                        $interval.cancel(vm.protection_interval);
                    }
                }, 1000);
            }
        }

        function hasFieldError(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.has(error_rules, 0, false);             
        }

        function fieldErrorMessage(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.get(error_rules, 0, '');
        }

        function sendOtp() {
            vm.element.loading = true; 
            if (lodash.has(vm.element, 'options.datasource.url')) {
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {      
                    if (res) {  
                        if (res.success) {
                            showOtpWindow();
                        }
                    }
                });
            }
        }

        function callRemoteApi() {
            vm.pageData.elementsService.clearValidationSummary(formIdentifier);
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'post');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys', null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }

            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res      
                vm.element.loading = false;
                if (res.success && res.status_code == 200) {
                    return res;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails model. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {   
                vm.element.loading = false;        
                if (res) { 
                    if (res.data.summary) {
                        vm.pageData.elementsService.setValidationSummary(formIdentifier, [res.data.summary], false);

                    }
                    else if (res.data.status_code == 422 && !res.data.summary) {
                        var error_msg = res.data.rules.txt_email_verify;
                        vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, error_msg, true);
                    }                    
                }
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails throw. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console                
                vm.element.loading = false;
                return null;
            });
            
        }
    }    
})();

(function () {
    'use strict';

    fbFieldEmploymentTypeDetails.$inject = ['lodash'];
    fbFieldEmploymentTypeDetailsCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', '$timeout', '$element', 'FbSelectService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldEmploymentTypeDetails', fbFieldEmploymentTypeDetails);

    function fbFieldEmploymentTypeDetails(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                eventHandler: '&',
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldEmploymentTypeDetails',
            controller: fbFieldEmploymentTypeDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.events = {
                    add: add,
                    remove: remove,
                    getVisibility: getVisibility,
                };

                ctrl.$render = function (viewValue) {
                    vm.model = vm.setInitialModel(ctrl.$modelValue);
                };

                 vm.commitChange = function () {
                    ctrl.$setViewValue(vm.model);

                };

                function add() {
                    vm.model.push(vm.generateDefaultModel());
                    vm.commitChange();
                }

                function remove(rowData, $index) {
                    vm.model.splice($index, 1);
                    vm.commitChange();
                }

                function getVisibility(type, field) {
                    var type_visibility_setting = lodash.get(vm.element, 'options.fields_to_hide.' + type, null);
                    if (type_visibility_setting) {
                        return !(type_visibility_setting.indexOf(field) >= 0);
                    }
                    return false;
                }
            }
        };
    }

    function fbFieldEmploymentTypeDetailsCtrl(lodash, FormBuilderService, $scope, $timeout, $element, FbSelectService) {
        var vm = this;
        var formIdentifier = '';
        var source = [];
        var elementIdentifier = '';
        var fbService = null;
        var job_grade_select_settings = null;
        var working_hours_select_settings = null;
        var additionalOptions = {};
        var additionalOptionsWorkingHours = {};
        var cdnEp = '';
        this.$onInit = function() {
            vm.selectizes = null;
            formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.model = [];
            source = lodash.get(vm, 'element.options.datasource.sel_employment_type', []);
            vm.max = source.length;

            vm.employmentTypeDs = {
            };

            elementIdentifier = $scope.$parent.vm.elementIdentifier;
            fbService = FormBuilderService.get(formIdentifier);
            FormBuilderService.sync(formIdentifier, vm);

            vm.hasError = hasError;
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;
            vm.canRemove = canRemove;

            // $scope.$watch('vm.model', function(newValue, oldValue) {
            //     console.log(newValue);
            //     vm.commitChange();
            // }, true);

            vm.single_select_settings = {
                highlight: true,
                create: false,
                labelField: 'label',
                valueField: 'value',
                maxItems: 1,
                searchField: ['label']
            };

            vm.multi_select_settings = angular.copy(vm.single_select_settings);
            vm.multi_select_settings.maxItems = null;
            job_grade_select_settings = angular.copy(vm.single_select_settings);
            working_hours_select_settings = angular.copy(vm.multi_select_settings);

            FbSelectService.initTemplateCall(lodash.get(vm.element, 'options.job_grade', {}), additionalOptions);
            FbSelectService.initTemplateCall(lodash.get(vm.element, 'options.working_hours', {}), additionalOptionsWorkingHours);
            vm.job_grade_select_settings = angular.extend(job_grade_select_settings, additionalOptions,lodash.get(vm.element, 'options.job_grade.selectize', {}));
            vm.working_hours_settings = angular.extend(working_hours_select_settings, additionalOptionsWorkingHours,lodash.get(vm.element, 'options.working_hours.selectize', {}));

            /**

             */

            cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            vm.tinymceOptions = {
                plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                menubar: false,
                toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent',
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                autoresize_min_height: 50,
                debounce: false,
                content_css: cdnEp + '/assets/css/rms-tinymce.css',
                // paste_as_text: true,
                paste_data_images: false,
                setup: function (ed) {
                    ed.on('init', function (inst) {
                        $timeout(function () {
                            var container = angular.element(inst.target.editorContainer);
                            var em = container.find('.mce-toolbar-grp');
                            container.remove('.mce-toolbar-grp');
                            container.find('.mce-edit-area').after(em);
                        });
                    });
                },
                // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
            };
            vm.employment_type_settings = angular.merge({}, vm.single_select_settings, {
                onFocus: function() {
                    var instance = this;
                    prepEmpType(instance);
                }
            });
        }

        function prepEmpType(selectizeInst) {
            var default_source = lodash.get(vm, 'element.options.datasource.sel_employment_type', []);
            var existing = vm.model.reduce(function(carry, rowData) {
                if (rowData.sel_employment_type) {
                    carry.push(rowData.sel_employment_type);
                }
                return carry;
            }, []);

            var current = selectizeInst.getValue();
            if (current) {
                lodash.pull(existing, current);
            }

            existing.map(function(_existing) {
                selectizeInst.removeOption(_existing);
            });
            default_source = lodash.filter(default_source, function(rowData) {
                var comparer = lodash.get(rowData, 'value', '').toString();
                 return existing.indexOf(comparer) < 0;
            });
            selectizeInst.addOption(default_source);
            selectizeInst.refreshOptions(false);
        }

        vm.setInitialModel = function (modelValue) {
            var result = (!modelValue) ? [] : modelValue;

            var min = lodash.get(vm, 'element.options.min', 0);
            while (result.length < min) {
                result.push(vm.generateDefaultModel());
            }
            return result;
        };

        vm.generateDefaultModel = function() {
            var _default = lodash.get(vm, 'element.options.default_value', {});
            return lodash.extend({}, _default);
        }

        vm.employmentTypeChange = function (modelIndex) {
            var employmentType = vm.model[modelIndex]['sel_employment_type'];
            var fieldsToHide = vm.element.options.fields_to_hide[employmentType];

            if (fieldsToHide.length > 0) {
                $timeout(function() {
                    vm.model[modelIndex] = lodash.omit(vm.model[modelIndex], fieldsToHide);
                });
            }
        }



        function hasError() {
            var error_rules = fbService.elementsService.getValidationRule(elementIdentifier);
            vm.error_messages = error_rules;
            return error_rules;
        }

        function hasFieldError(index, fieldname) {
            var error_rules = fbService.elementsService.getValidationRule(elementIdentifier);
            return lodash.has(error_rules, [index, fieldname].join('.'), false);
        }

        function fieldErrorMessage(index, fieldname) {
            var error_rules = fbService.elementsService.getValidationRule(elementIdentifier);
            return lodash.get(error_rules, [index, fieldname].join('.'), '');
        }

        function canRemove() {
            return vm.model.length > lodash.get(vm, 'element.options.min', 0);
        }
        //
        // function errorMessage() {
        //     var error = fbService.elementsService.getValidationRule(elementIdentifier);
        //     if (!error) {
        //         return '';
        //     }
        //     return error.join(' ');
        // }
    }
})();

(function () {
    'use strict';

    fbFieldFileDirectiveCtrl.$inject = ['$scope', '$element', 'lodash', 'FormBuilderService', 'CommonHelper'];
    angular
        .module('FormBuilder')
        .directive('fbFieldFile', fbFieldFileDirective);

    function fbFieldFileDirective() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                model: '='
            },
            templateUrl: 'common/components/file-upload',
            controller: fbFieldFileDirectiveCtrl,
            link: fbFieldFileDirectiveLink,
            controllerAs: 'vm',
            bindToController: true
        };

        function fbFieldFileDirectiveLink(scope, elem) {
            var em = elem.find('em');
            elem.remove('em');
            elem.find('.k-dropzone').prepend(em);
        }
    }

    function fbFieldFileDirectiveCtrl($scope, $element, lodash, FormBuilderService, CommonHelper) {
        var vm = this;
        var formIdentifier = '';

        this.$onInit = function () {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);

            vm.onLoadEventOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onLoad');
            console.log(vm.element.options);
            initEventOptions();
            var files = lodash.get(vm, 'model', []);
            if (lodash.isEmpty(files)) {
                files = [];
            } else {
                if (!Array.isArray(files)) {
                    files = [files];
                }
            }
            // added this to provide backward compatibility with other places other than application
            files = files.map(function (file) {
                if (!lodash.has(file, 'name')) {
                    if (lodash.has(file, 'file_name'))
                        file.name = file.file_name;
                }
                if (!lodash.has(file, 'extension')) {
                    if (lodash.has(file, 'file_ext'))
                        file.extension = file.file_ext;
                }
                return file;
            });
            vm.upload_options = {
                multiple: lodash.get(vm.onLoadEventOptions, 'multiple', false),
                async: lodash.get(vm.onLoadEventOptions, 'async', {}),
                upload: uploadEvent,
                remove: removeEvent,
                success: successEvent,
                error: errorEvent,
                files: files,
                localization: lodash.get(vm.element, 'options.localization', {})
            };
            console.log(vm.upload_options);
        }

        function initEventOptions() {
            if (lodash.has(vm.onLoadEventOptions, 'async')) {
                const formDraftId = lodash.get(vm.pageData, 'model.hid_form_draft_id', '');
                vm.onLoadEventOptions.async.removeUrl = decodeURI(vm.onLoadEventOptions.async.removeUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                if (lodash.has(vm.onLoadEventOptions.async, 'saveUrlTemplate')) {
                    vm.onLoadEventOptions.async.saveUrl = decodeURI(vm.onLoadEventOptions.async.saveUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                }
            }
        }


        function uploadEvent(e) {
            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                if (e.files[0].size > vm.onLoadEventOptions.fileSize) {
                    // var wrapper = $element.parents('label');
                    //
                    // wrapper.addClass('error');
                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 2 MB');
                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                    e.preventDefault();

                    var sizing = CommonHelper.bytesToSize(vm.onLoadEventOptions.fileSize);
                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                    $scope.$apply();
                    return false;
                }
            }

            if (lodash.has(vm.element, 'attr.sender_name')) {
                e.sender.name = vm.element.attr.sender_name;
            }
            e.data = lodash.get(vm, 'element.attr.upload_data', {});
        }


        function removeEvent(e) {
            e.sender.options.async.removeUrl = vm.onLoadEventOptions.async.removeUrl + e.files[0].file_id;
        }

        function successEvent(e) {
            switch (e.operation) {
                case "upload":
                    e.files[0].name = e.response.data.file_name;
                    e.files[0].extension = e.response.data.file_ext;
                    e.files[0].file_id = e.response.data.file_id;
                    var file_elem = $element.find('.k-file[data-uid="' + e.files[0].uid + '"] .k-filename');
                    file_elem.attr('title', e.response.data.file_name);
                    file_elem.html(e.response.data.file_name);

                    if (lodash.get(vm.element, 'options.multiple', false)) {
                        vm.model.push(e.response.data);
                    } else {
                        // vm.model = e.response.data;
                        // angular.extend(vm.model, e.response.data);
                        Object.assign(vm.model, e.response.data);
                    }

                    vm.pageData.elementsService.clearElementValidationRule(vm.element.elementIdentifier);
                    // $element.parents('.error').removeClass('error').find('.error-message').remove();
                    vm.onEventTrigger('onUploadSuccess');
                    break;
                case "remove":
                    // vm.model.forEach(function(value, key) {
                    //     delete vm.model[key];
                    // });

                    for (var propertyKey in vm.model) {
                        if (vm.model.hasOwnProperty(propertyKey)) {
                            delete vm.model[propertyKey];
                        }
                    }
                    break;
            }
        }

        function errorEvent(e) {
            //console.log(e);
            if (e.XMLHttpRequest.status == 422) {

                var rules = JSON.parse(e.XMLHttpRequest.response);
                vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, lodash.get(rules.rules, vm.element.elementIdentifier, []));
                // vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, rules.rules[vm.element.name]);
                $scope.$apply();
            }
            vm.onEventTrigger('onUploadFailure');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldHidden', fbFieldHiddenDirective);

    function fbFieldHiddenDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model: '='
            },
            template: ' <input type="hidden" ng-model="vm.model" />',
            controller: fbFieldHiddenDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldHiddenDirectiveCtrl() {

    }
})();
(function () {
    'use strict';

    fbFieldImage.$inject = ['$compile', 'lodash', '$templateRequest'];
    fbFieldImageCtrl.$inject = ['$scope', '$element', 'lodash', 'FormBuilderService', 'SodLogger', '$http', 'CommonHelper'];
    angular
        .module('FormBuilder')
        .directive('fbFieldImage', fbFieldImage);

    function fbFieldImage($compile, lodash, $templateRequest) {
        return {
            restrict: "E",
            scope: {
                element: "=",
                model: "="
            },
            templateUrl: 'common/components/image-upload/upload-wrapper',
            controller: fbFieldImageCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        function link(scope, elem) {
            //var imagePath = {'background-image': (model.default) ? model.default_file_url : model.file_url};
            var vm = scope.vm;
            elem.find('.k-upload').addClass('image-upload');
            vm.defaultProfileUrl = lodash.get(vm.element, 'options.defaultProfileUrl', "https://content.recruiterpal.com/app/assets/images/common/default.jpeg");

            $templateRequest('common/components/image-upload/image-preview').then(function (html) {
                var imgElement = angular.element(html);
                var imgElementCompiled = $compile(imgElement.contents())(scope);

                elem.find('.k-dropzone').prepend(imgElementCompiled);

                scope.$on('$destroy', function () {
                    imgElementCompiled.off();
                });
            });
        }
    }


    function fbFieldImageCtrl($scope, $element, lodash, FormBuilderService, SodLogger, $http, CommonHelper) {
        var vm = this;
        var formIdentifier = '';
        var element_name = '';
        var defaultModel = {};
        var files = {};

        this.$onInit = function() {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            element_name = lodash.get(vm.element, 'attr.upload_data.hid_file_type', vm.element.elementIdentifier);
            vm.onLoadEventOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onLoad');

            vm.removeImage = removeImage;

            defaultModel = angular.copy(vm.model);

       
        if (lodash.has(vm.model, 'default') && !vm.model.default) {
            files = vm.model;
        }

            initEventOptions();

            vm.upload_options = {
                multiple: false,
                async: lodash.get(vm.onLoadEventOptions, 'async', {}),
                upload: uploadEvent,
                remove: removeEvent,
                success: successEvent,
                error: errorEvent,
                cancel: cancelEvent,
                files: files,
                showFileList: false,
            };
        }


        function initEventOptions() {
            if (lodash.has(vm.onLoadEventOptions, 'async')) {
                const formDraftId = lodash.get(vm.pageData, 'model.hid_form_draft_id', '');
                vm.onLoadEventOptions.async.removeUrl = decodeURI(vm.onLoadEventOptions.async.removeUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                vm.onLoadEventOptions.async.saveUrl = decodeURI(vm.onLoadEventOptions.async.saveUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
            }
        }

        function uploadEvent(e) {
            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                if (e.files[0].size > vm.onLoadEventOptions.fileSize) {
                    // var wrapper = $element.parents('label');
                    //
                    // wrapper.addClass('error');
                    //
                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 1 MB');
                    //
                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                    // e.preventDefault();
                    e.preventDefault();

                    var sizing = CommonHelper.bytesToSize(vm.onLoadEventOptions.fileSize);
                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                   
                    $scope.$apply();
                    return;
                }
            }

            if (lodash.has(vm.element, 'attr.sender_name')) {
                e.sender.name = vm.element.attr.sender_name;
            }
            e.data = lodash.get(vm, 'element.attr.upload_data', {});
        }

        function cancelEvent(e) {
            SodLogger.debug('CANCEL EVENT TRIGGERED', e, this);
        }

        function removeEvent(e) {
            SodLogger.debug('REMOVE EVENT TRIGGERED', e, this);
            e.sender.options.async.removeUrl = vm.onLoadEventOptions.async.removeUrl + e.files[0].file_id;
            vm.model = defaultModel;
            $scope.$apply();
        }

        function successEvent(e) {
            if (e.operation == "upload") {
                e.files[0].file_id = e.response.data.file_id;
            }
            angular.merge(vm.model, e.response.data);
            vm.model.default = false;
            delete vm.model.remove_image;
            defaultModel = angular.copy(vm.model);
            $scope.$apply();
            $element.parents('.error').removeClass('error').find('.error-message').remove();
        }

        function errorEvent(e) {
            if (e.XMLHttpRequest.status == 422) {
                var rules = JSON.parse(e.XMLHttpRequest.response);
                vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, lodash.get(rules.rules, vm.element.elementIdentifier, []));
                $scope.$apply();
                // var eventData = {
                //     rules:  {
                //         'validate': {
                //             rules: rules.rules,
                //             summary: '',
                //             form_name: ''
                //         }
                //     },
                //     targetScope: vm.element,
                //     target: $element,
                //     event: e,
                //     model: vm.model
                // };
                // $scope.$emit('validate.file', eventData);
            }
        }

        function removeImage() {
            vm.model.file_url = null;
            vm.model.default = true;
            vm.model.remove_image = true;


            if (typeof vm.model.file_id !== typeof undefined) {
                $http({
                    method: 'delete',
                    url: vm.onLoadEventOptions.async.removeUrl + vm.model.file_id,
                });
            }


            defaultModel = angular.copy(vm.model);
            $element.find('.k-dropzone .k-upload-status').remove();
        }
    }
})();

(function () {
    'use strict';

    fbFieldInterviewMediumSelector.$inject = ['$timeout', 'lodash'];
    fbFieldInterviewMediumSelectorCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', 'GenericModel', 'ActionCommon', '$timeout', 'FbSelectService', 'RequestHelper'];
    angular
        .module('FormBuilder')
        .directive(
            'fbFieldInterviewMediumSelector', fbFieldInterviewMediumSelector);

    function fbFieldInterviewMediumSelector($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: "=",
                eventHandler: '&'
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldInterviewMediumSelector',
            controller: fbFieldInterviewMediumSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, ctrl) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    scope.toggleActive = vm.toggleActive;
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldInterviewMediumSelectorCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService,RequestHelper) {
        // $scope.$watch(function() { return vm.model; }, function() { console.log('fieldSelect model', vm.model); });
        var vm = this;
        var formIdentifier = '';
        var cdnEp = '';
        this.$onInit = function() {
            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;

            formIdentifier = $scope.$parent.vm.formIdentifier;
            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }
            
            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        });
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }

            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            }
            
            
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;
            vm.toggleActive = toggleActive;
            vm.showTextbox = showTextbox;
            vm.firstLoad = true;
            vm.toggleState = true;
            vm.selectizeMsg = '';
            cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            vm.venue_tinymceOptions = {
                plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                menubar: false,
                toolbar: 'undo redo',
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                autoresize_min_height: 50,
                debounce: false,
                content_css: cdnEp + '/assets/css/rms-tinymce.css',
                // paste_as_text: true,
                paste_data_images: false,
                setup: function (ed) {
                    ed.on('init', function (inst) {
                        $timeout(function () {
                            var container = angular.element(inst.target.editorContainer);
                            var em = container.find('.mce-toolbar-grp');
                            container.remove('.mce-toolbar-grp');
                            container.find('.mce-edit-area').after(em);
                        });
                    });
                },
                // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
            };

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        // dropdownParent: 'body',
                        // dropdownClass: 'selectize-dropdown modal-z-index',
                        // placeholder: '',
                        onChange: function(selectedValue) {
                            lodash.set(vm.element, 'attr.show_venue_box',false);
                            lodash.set(vm.element, 'attr.show_input_text',false);
                            vm.element.venue_address = null;

                            const selected = lodash.find(vm.ds, function(item) {
                                return lodash.get(item, lodash.get(vm.config, 'valueField', 'value'), null).toString() === selectedValue.toString();
                            });

                            var itemSetting = lodash.get(selected,'attr',{});
                            lodash.merge(vm.element.attr,itemSetting);
                            var itemAddress = lodash.get(selected,'venue_address',null);
                            vm.element.venue_address = itemAddress;

                            var show_checkbox = lodash.get(vm.element.attr, 'show_checkbox',false);
                            
                            lodash.merge(vm.pageData.model, {
                                'chk_generate_link_automatically':show_checkbox,
                                'txt_web_call_url':null,
                                'txt_venue':itemAddress
                            });

                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                emptyOptionLabel();
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        };

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data: {label: value, model: formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                        //     // res.push({"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')});                            
                            var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                            vm.selectize.settings.placeholder = placeholder;
                            vm.selectize.updatePlaceholder();
                        }
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys',null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }
            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }

        function emptyOptionLabel() {
            if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                if (!lodash.has(vm.element, 'options.datasource.url')) {
                    if (vm.ds.length == 0) {
                        // var obj = {"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')};
                        // vm.ds.push(obj);
                        var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                        vm.selectize.settings.placeholder = placeholder;
                        vm.selectize.updatePlaceholder();
                        vm.selectize.disable();
                    }
                }
            }
        }

        function toggleActive() {
            vm.toggleState = !vm.toggleState;
            lodash.merge(vm.pageData.model, {
                'chk_generate_link_automatically':vm.toggleState,
                'txt_web_call_url':null,
                'txt_venue':null
            });
        }

        function hasFieldError(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.has(error_rules, 0, false);
        }

        function fieldErrorMessage(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.get(error_rules, 0, '');
        }

        function showTextbox() {
            // 1. Check checkbox first.
            var showCheckbox = lodash.get(vm.element, 'attr.show_checkbox',false);

            if(showCheckbox === true && vm.toggleState === true){
                // If checkbox shows and the state is on,
                // Don't show checkbox. Return false straight away.
                return false;
            }

            // 2. Otherwise return show_input_text || show_venue_box,
            //    since I want to show text box container if any is true.
            return lodash.get(vm.element, 'attr.show_input_text', false)
                || lodash.get(vm.element, 'attr.show_venue_box', false);
        }

    }
})();
(function() {
  "use strict";

  fbLabelDirectiveCtrl.$inject = ['$scope', 'FormBuilderService', 'lodash'];
  angular.module("FormBuilder").directive("fbLabelDivNoMsg", fbLabelDirective);

  function fbLabelDirective() {
    return {
      restrict: "E",
      transclude: true,
      scope: {
        element: "=",
        elementIdentifier: '='
      },
      templateUrl: "common/libraries/formBuilder/fields/label-div-no-msg",
      controller: fbLabelDirectiveCtrl,
      controllerAs: "vm",
      bindToController: true
    };
  }

  function fbLabelDirectiveCtrl($scope, FormBuilderService, lodash) {
    var vm = this;
    var fbService = null;
    this.$onInit = function() {
      var formIdentifier = $scope.$parent.vm.formIdentifier;
      fbService = FormBuilderService.get(formIdentifier);
      vm.hasError = hasError;
    }

    function hasError() {
      return !lodash.isEmpty(
        fbService.elementsService.getValidationRule(vm.elementIdentifier)
      );
    }
  }
})();

(function () {
    'use strict';

    fbLabelDirectiveCtrl.$inject = ['$scope', 'FormBuilderService'];
    angular
        .module('FormBuilder')
        .directive('fbLabelDiv', fbLabelDirective);

    function fbLabelDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element: '=',
                elementIdentifier: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/label-div',
            controller: fbLabelDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelDirectiveCtrl($scope, FormBuilderService) {
        var vm = this;
        var fbService = null;

        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(formIdentifier);

            vm.hasError = hasError;
            vm.errorMessage = errorMessage;

        }

        function hasError() {
            return fbService.elementsService.getValidationRule(vm.elementIdentifier);
        }

        function errorMessage() {
            var error = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            if (!error) {
                return '';
            }
            return error.join(' ');
        }
    }
})();
(function () {
    'use strict';

    fbLabelDirectiveCtrl.$inject = ['$scope', 'FormBuilderService', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbLabelNoError', fbLabelDirective);

    function fbLabelDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/label-no-error',
            controller: fbLabelDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelDirectiveCtrl($scope, FormBuilderService, lodash) {
        var vm = this;
    }
})();
(function () {
    'use strict';

    fbLabelDirectiveCtrl.$inject = ['$scope', 'FormBuilderService', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbLabel', fbLabelDirective);

    function fbLabelDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element: '=',
                elementIdentifier: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/label',
            controller: fbLabelDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelDirectiveCtrl($scope, FormBuilderService, lodash) {
        var vm = this;
        var fbService = null;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(formIdentifier);

            vm.hasError = hasError;
            vm.errorMessage = errorMessage;
        }


        function hasError() {
            var validation_msg = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            // if ((vm.elementIdentifier.indexOf("file_unsigned_offer_letter") >= 0)) {
            //     console.log(validation_msg);
            // }
            return !lodash.isEmpty(validation_msg);
            // return !lodash.isEmpty(fbService.elementsService.getValidationRule(elementIdentifier));
        }

        function errorMessage() {
            var error = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            if (!error) {
                return '';
            }
            return error.join(' ');
        }
    }
})();
(function () {
    'use strict';

    fbLabelRightDirectiveCtrl.$inject = ['$scope', 'FormBuilderService'];
    angular
        .module('FormBuilder')
        .directive('fbLabelRight', fbLabelRightDirective);

    function fbLabelRightDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element:'=',
                elementIdentifier: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/labelRight',
            controller: fbLabelRightDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelRightDirectiveCtrl($scope, FormBuilderService) {
        var vm = this;
        var formIdentifier = $scope.$parent.vm.formIdentifier;
        var fbService = null;
        this.$onInit = function() {
            fbService = FormBuilderService.get(formIdentifier);

            vm.hasError = hasError;
            vm.errorMessage = errorMessage;
        }

        function hasError() {
            return fbService.elementsService.getValidationRule(vm.elementIdentifier);
        }

        function errorMessage() {
            var error = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            if (!error) {
                return '';
            }
            return error.join(' ');
        }
    }
})();
(function () {
    'use strict';

    fbLabelTextDirectiveCtrl.$inject = ['$scope', 'FormBuilderService'];
    angular
        .module('FormBuilder')
        .directive('fbLabelText', fbLabelTextDirective);

    function fbLabelTextDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element:'=',
                elementIdentifier: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/labelText',
            controller: fbLabelTextDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelTextDirectiveCtrl($scope, FormBuilderService) {
        var vm = this;
        var fbService = null;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(formIdentifier);

            vm.hasError = hasError;
            vm.errorMessage = errorMessage;
        }

        function hasError() {
            return fbService.elementsService.getValidationRule(vm.elementIdentifier);
        }

        function errorMessage() {
            var error = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            if (!error) {
                return '';
            }
            return error.join(' ');
        }
    }
})();

(function () {
    'use strict';

    fbFieldLatLongDirective.$inject = ['lodash'];
    fbFieldLatLongDirectiveCtrl.$inject = ['FormBuilderService', '$scope', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbFieldLatLong', fbFieldLatLongDirective);

    function fbFieldLatLongDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldLatLongDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldLatLong',
            link: fbFieldLatLongDirectiveLink
        };

        function fbFieldLatLongDirectiveLink(scope, elem) {

            const vm = scope.vm;
            if (lodash.has(vm.element, 'attr.attributes')) {
                if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
                    const inputElem = elem.find('input');
                    lodash.forIn(vm.element.attr.attributes, (value, attr) => {
                        inputElem.attr(attr, value);
                    });
                }
            }
        }
    }

    function fbFieldLatLongDirectiveCtrl(FormBuilderService, $scope, lodash) {
        var vm = this;


        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.getType = function() {
                switch (vm.element.type) {
                    case 'smart-text-element':
                    case 'lat-long':
                        return 'text';
                    default:
                        return vm.element.type;
                }
            };

            vm.resetLatLong = resetLatLong;
            vm.setGmapUrl = setGmapUrl;
            vm.onLatLongSearchChange = onLatLongSearchChange;
            vm.gmapQueryParams = {
                key: 'AIzaSyCPvURq8GmCmsIxyg7_CkOyhYaWvkaCNDA',
                q: 'Singapore',
            };

            vm.setGmapUrl();

            $scope.$watch('vm.model', function () {
                vm.searchModel = vm.model;
                vm.onLatLongSearchChange();
            });
        }


        function onLatLongSearchChange() {
            if (lodash.isEmpty(vm.searchModel) || vm.searchModel.trim().length === 0) return;

            vm.gmapQueryParams = Object.assign(vm.gmapQueryParams, {
                q: vm.searchModel
                    .split(' ')
                    .reduce(function (accum, justWord) {
                        return accum.concat([justWord.trim()])
                    }, [])
                    .join('+'),
            });
            vm.setGmapUrl();
            vm.model = vm.searchModel.trim();
        };

        function setGmapUrl() {
            var baseUrl = 'https://www.google.com/maps/embed/v1/place';

            var queryParams = Object.keys(vm.gmapQueryParams)
                .reduce(function (accum, queryParamKey) {
                    var queryparam = vm.gmapQueryParams[queryParamKey];
                    return accum.concat([[queryParamKey, queryparam].join('=')]);
                }, [])
                .join('&');

            vm.gmapUrl = baseUrl + '?' + queryParams;
        }

        function resetLatLong() {
            Object.assign(vm.gmapQueryParams, {
                q: 'Singapore',
            });

            vm.model = null;
            vm.searchModel = null;
            vm.setGmapUrl();

        }
    }
})();

(function () {
    'use strict';

    fbFieldRadioCheckboxDirectiveCtrl.$inject = ['FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldRadioCheckbox', fbFieldRadioCheckboxDirective);

    function fbFieldRadioCheckboxDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldRadioCheckbox',
            controller: fbFieldRadioCheckboxDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldRadioCheckboxDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;

        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }
    }
})();
(function () {
    'use strict';

    fbFieldCaptchaDirectiveCtrl.$inject = ['lodash', '$rootScope', '$timeout'];
    angular
        .module('FormBuilder')
        .directive('fbFieldCaptcha', fbFieldCaptchaDirective);

    function fbFieldCaptchaDirective() {
        return {
            restrict: "EA",
            scope: {
                element: "=",
                model: '=',
            },
            template: '<div vc-recaptcha key="vm.key" size="vm.size" badge="vm.badge" ng-model="vm.model" on-success="vm.onSuccess()" ></div>',
            controller: fbFieldCaptchaDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, elem) {
                elem.find('> div').css('margin-bottom', '1.5rem');
            }
        };
    }

    function fbFieldCaptchaDirectiveCtrl(lodash, $rootScope, $timeout) {
        var vm = this;
        this.$onInit = function() {
            if (typeof vm.element.attr.key == typeof undefined) {
                vm.key = '6Le2sg4TAAAAAGT8NZ6mp6yvFpHElFzTcIICESGC';
            } else {
                vm.key = vm.element.attr.key;
            }
            vm.size = vm.element.attr.size;
            vm.badge = vm.element.attr.badge;

            var eventOnSubmit = lodash.get(vm.element, 'attr.event', null);

            if (!!eventOnSubmit) {
                vm.onSuccess = function() {
                    $timeout(function() {
                        $rootScope.$broadcast(eventOnSubmit);
                    });
                }
            } else {
                vm.onSuccess = null;
            }

        }
    }
})();
(function () {
    'use strict';

    fbFieldSelect.$inject = ['$timeout', 'lodash'];
    fbFieldSelectCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', 'GenericModel', 'ActionCommon', '$timeout', 'FbSelectService', 'RequestHelper'];
    angular
        .module('FormBuilder')
        .directive(
            'fbFieldSelect', fbFieldSelect);

    function fbFieldSelect($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: "=",
                eventHandler: '&'
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldSelect',
            controller: fbFieldSelectCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    if (lodash.get(vm.element.options.selectize, 'emptyOptionLabel') || lodash.get(vm.element.options.selectize, 'emptyModelLabel')) {
                        elem.find('.selectize-input').css('padding-top', '5px');
                    }
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldSelectCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService,RequestHelper) {
        // $scope.$watch(function() { return vm.model; }, function() { console.log('fieldSelect model', vm.model); });
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {
            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }

            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        });
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                            emptyOptionLabel();
                            var hasDefaultModel = angular.copy(lodash.get(vm.element, 'options.selectize.hasDefaultModel', true));
                            if(!hasDefaultModel){
                                vm.model = undefined;
                                vm.selectize.items = [""];
                            }
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }

            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            }

            vm.firstLoad = true;
            vm.selectizeMsg = '';

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        // dropdownParent: 'body',
                        // dropdownClass: 'selectize-dropdown modal-z-index',
                        // placeholder: '',
                        onChange: function () {
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                emptyOptionLabel();
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        };

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data: {label: value, model: formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                        //     // res.push({"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')});                            
                            var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                            vm.selectize.settings.placeholder = placeholder;
                            vm.selectize.updatePlaceholder();
                        }
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys',null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }
            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }

        function emptyOptionLabel() {
            if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                if (!lodash.has(vm.element, 'options.datasource.url')) {        
                    if (vm.ds.length === 0) {
                        vm.selectize.settings.placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                        vm.selectize.updatePlaceholder();
                        vm.selectize.disable();
                    }else{           
                        vm.selectize.settings.placeholder = lodash.get(vm.element,'options.selectize.emptyModelLabel');
                        vm.selectize.updatePlaceholder();
                        vm.selectize.enable();
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    fbSettingFieldDirective.$inject = ['lodash', '$compile', 'CommonHelper'];
    fbSettingFieldDirectiveCtrl.$inject = ['$scope'];
    angular
        .module('FormBuilder')
        .directive('fbSettingsField', fbSettingFieldDirective);

    function fbSettingFieldDirective(lodash, $compile, CommonHelper) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                fieldType: '@',
                template: '=?',
                eventHandler: '&'
            },
            require: 'ngModel',
            controller: fbSettingFieldDirectiveCtrl,
            controllerAs: 'vm',
            link: fbSettingFieldDirectiveLink
        };

        function fbSettingFieldDirectiveLink(scope, elem, attr, ngModelCtrl) {
            scope.currentModel = {
                modelValue: null,
                settingsEnabled: false,
            };

            var subElementTemplate = CommonHelper.isEmpty(scope.template) ? '' : scope.template;

            var template = '<div class="fb-settings-field"><div><fb-field-checkbox-button element="element" model="currentModel.settingsEnabled" ></fb-field-checkbox-button></div><div>' +
                '<fb-label element="element">' +
                '<fb-' + scope.fieldType + ' element="element" options="element.options" model="currentModel.modelValue" class="field-element" event-handler="eventHandler(fieldType)" ' + subElementTemplate
                + ' ng-if="currentModel.settingsEnabled"></fb-' + scope.fieldType + '>' +
                '</fb-label>' +
                '</div></div>';

            elem.html(template);
            var cloneElement = $compile(elem.contents())(scope);
            scope.$on('$destroy', function() {
                cloneElement.off();
            });

            ngModelCtrl.$formatters.push(function(modelValue) {
                var _modelValue = modelValue.value || lodash.get(scope.element, 'options.settings_type.default.value', null);
                var _settingsEnabled = modelValue.toggle || lodash.get(scope.element, 'options.settings_type.default.toggle', false);
                return {
                    value: _modelValue,
                    toggle: _settingsEnabled,
                };
            });



            ngModelCtrl.$render = function() {
                scope.currentModel.modelValue   = ngModelCtrl.$viewValue.value;
                scope.currentModel.settingsEnabled = ngModelCtrl.$viewValue.toggle;
                // setViewValue();
            };


            scope.$watch(function() {
                return scope.currentModel.modelValue;
            }, function() {
                setViewValue();
            });

            scope.$watch(function() {
                return scope.currentModel.settingsEnabled;
            }, function() {
                setViewValue();
            });

            scope.handleToggleChange = function() {
                setViewValue();
            };

            function setViewValue() {
                ngModelCtrl.$setViewValue({
                   toggle: scope.currentModel.settingsEnabled,
                   value: scope.currentModel.modelValue,
                });
            }
        }
    }

    function fbSettingFieldDirectiveCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.elementIdentifier = $scope.$parent.vm.elementIdentifier;
        }
    }
})();

(function () {
    'use strict';

    fbFieldSignerDetails.$inject = ['$timeout', 'lodash'];
    fbFieldSignerDetailsCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSignerDetails', fbFieldSignerDetails);

    function fbFieldSignerDetails($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                eventHandler: '&'
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldSignerDetails',
            controller: fbFieldSignerDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                ctrl.$render = function () {
                    vm.model = ctrl.$viewValue;
                }

                vm.commitChange = function (index, fieldName, fieldValue) {
                    // vm.model[index].edit[fieldName] = fieldValue;
                    ctrl.$setViewValue(vm.model);
                }
            }
        };
    }

    function fbFieldSignerDetailsCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            console.log('fbFieldSignerDetails', vm.element);

            vm.getLabel = function(col_name) {
                return lodash.get(vm.element, 'options.labels.' + col_name, '');
            }
        }
    }
})();
(function () {
    'use strict';

    fbFieldSimpleDirective.$inject = ['lodash', '$timeout'];
    fbFieldSimpleDirectiveCtrl.$inject = ['FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSimple', fbFieldSimpleDirective);

    function fbFieldSimpleDirective(lodash, $timeout) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldSimpleDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldSimple',
            link: fbFieldSimpleDirectiveLink
        };

        function fbFieldSimpleDirectiveLink(scope, elem) {
            const vm = scope.vm;
            if (lodash.has(vm.element, 'attr.attributes')) {
                if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
                    const inputElem = elem.find('input');
                    lodash.forIn(vm.element.attr.attributes, (value, attr) => {
                        inputElem.attr(attr, value);
                    });
                }
            }

            vm.inputType = vm.getType();

            if (vm.element.options.is_password) {
                vm.element.attr.element_class = {
                    'pr-8': vm.element.options.is_password,
                }
            }

            vm.passwordVisible = false;
            vm.togglePasswordVisibility = function () {
                $timeout(function () {
                    vm.passwordVisible = !vm.passwordVisible;
                    if (vm.passwordVisible) {
                        vm.inputType = 'text';
                    } else {
                        vm.inputType = 'password';
                    }
                })
            }
        }
    }

    function fbFieldSimpleDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.getType = function () {
                if (vm.element.type === 'smart-text-element') {
                    return 'text';
                }
                return vm.element.type;
            }
        }
    }
})();

(function() {
  "use strict";

  fbFieldSkillsetManagerDirective.$inject = ['lodash', 'FormBuilderService'];
  angular
    .module("FormBuilder")
    .directive("fbFieldSkillsetManager", fbFieldSkillsetManagerDirective);

  function fbFieldSkillsetManagerDirective(lodash, FormBuilderService) {
    fbFieldSkillsetManagerCtrl.$inject = ['$scope', 'lodash'];
    return {
      restrict: "E",
      scope: {
        element: "="
      },
      require: "ngModel",
      templateUrl: "common/libraries/formBuilder/fields/fieldSkillsetManager",
      link: fbFieldSkillsetManagerDirectiveLink,
      controller: fbFieldSkillsetManagerCtrl
    };

    function fbFieldSkillsetManagerDirectiveLink(scope, elem, attr, ctrl) {
      scope.currentScope = {
        element: scope.element
      };

      ctrl.$render = function() {
        scope.currentScopeModel = ctrl.$modelValue;
      };

      scope.$watch("currentScopeModel", function() {
        ctrl.$setViewValue(scope.currentScopeModel);
      });
    }

    function fbFieldSkillsetManagerCtrl($scope, lodash) {
      var elementIdentifier = '';
      var fbService = null;

      this.$onInit = function() {
        var formIdentifier = $scope.$parent.vm.formIdentifier;
        elementIdentifier = $scope.$parent.vm.elementIdentifier;
        fbService = FormBuilderService.get(formIdentifier);

        $scope.events = {
          hasError: hasError,
          errorMessage: errorMessage
        };
      }

      function hasError($index) {
        return !lodash.isEmpty(
          fbService.elementsService.getValidationRule(elementIdentifier + '[' + $index + ']')
        );
      }

      function errorMessage() {
        var error = fbService.elementsService.getValidationRule(
          elementIdentifier
        );
        var format = {};
        if (error) {
          Object.keys(error).forEach(function(key) {
            format[key] = lodash.flatMap(error[key]).join(" ");
          });
        }
        return format;
      }
    }
  }
})();

(function () {
    'use strict';

    /**
     * Module to use Switchery as a directive for angular.
     * @TODO implement Switchery as a service, https://github.com/abpetkov/switchery/pull/11
     */
    uiSwitchFunc.$inject = ['$window', 'lodash'];
    angular.module('FormBuilder')
        .directive('fbFieldSwitchery', uiSwitchFunc);

    function uiSwitchFunc ($window, lodash) {
        return {
            restrict: 'AE',
            scope: {
                element: '=',
                model: '=ngModel'
            },
            controller: fbFieldFileDirectiveCtrl,
            controllerAs:'vm',
            bindToController: true,
            link: linkSwitchery,
            template: '<input type="checkbox" class="js-switch" ng-model="vm.model" />'
        };

        function linkSwitchery(scope, elem) {
            var vm = scope.vm;

            var initValue = vm.model || false;
            var options = angular.merge({}, lodash.get(vm, 'element.options', {
                className: 'switchery small',
                color: '#2d82b4'
                //secondaryColor: '#efefef'
            }));
            var switcher = new $window.Switchery(elem.children()[0], options);

            elem.prop('checked', initValue);

            scope.$on('$destroy', function() {
                switcher.destroy();
            });

            elem.on('click', '.switchery-default', function(e) {
                e.preventDefault();
            });

            elem.on('change', 'input[type=checkbox]', function() {
                vm.model = angular.element(this).prop('checked');
                scope.$apply();
            });
        }
    }

    function fbFieldFileDirectiveCtrl() {
        //var vm = this;
    }
})();

(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldTag', fbFieldTagFieldDirective);

    function fbFieldTagFieldDirective() {
        return {
            restrict: "E",
            scope: {
                element: "=",
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldTagField',
            link: function(scope, elem, attr, ctrl) {
                scope.currentScope = {
                    element: scope.element,
                };

                ctrl.$render = function() {
                    scope.currentScopeModel = ctrl.$viewValue;
                }

                scope.$watch('currentScopeModel', function() {
                   ctrl.$setViewValue(scope.currentScopeModel);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldTemplate', fbFieldTemplate);

    function fbFieldTemplate() {
        return {
            restrict: 'E',
            scope: {
                element: '='
            },
            controller: fbFieldTemplateCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: '<div ng-bind-html="vm.element.options.html | trustAsHtml"></div>'
        };
    }

    function fbFieldTemplateCtrl() {
    }
})();
(function () {
    'use strict';

    fbFieldTextfieldDirectiveCtrl.$inject = ['FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldTextfield', fbFieldTextfieldDirective);

    function fbFieldTextfieldDirective() {
        return {
            restrict: "EA",
            scope: {
                element: "=",
                model: '='
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: fbFieldTextfieldDirectiveCtrl,
            templateUrl: 'common/libraries/formBuilder/fields/fieldTextfield'
        };
    }

    function fbFieldTextfieldDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }
    }
})();
(function () {
    'use strict';

    fbFieldTimeslotpickerDirective.$inject = ['$timeout'];
    fbFieldTimeslotpickerDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldTimeslotpicker', fbFieldTimeslotpickerDirective);

    function fbFieldTimeslotpickerDirective($timeout) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldTimeslotpicker',
            controller: fbFieldTimeslotpickerDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope) {
            }
        };
    }

    function fbFieldTimeslotpickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            var timeSlotPickerOptions = lodash.get($scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.vm, 'panelState.scheduler_settings.time_slot_picker_options', {'step':15});
            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.options = angular.merge({},
                lodash.get(vm.element,'attr.options',{})
            );
            angular.merge(vm.element.options, timeSlotPickerOptions);
        };
    }
})();
(function () {
    'use strict';

    fbFieldTimepickerDirective.$inject = ['$timeout'];
    fbFieldTimepickerDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldTimepicker', fbFieldTimepickerDirective);

    function fbFieldTimepickerDirective($timeout) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldTimepicker',
            controller: fbFieldTimepickerDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope) {
            }
        };
    }

    function fbFieldTimepickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.timeOptions = angular.merge({
                    change: function() {
                        //console.log($scope.model);
                        vm.onEventTrigger('onChange');
                    }
                },
                lodash.get(vm.element,'attr.timePickerOptions',{})
            );
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldToggle', fbFieldToggleFieldDirective);

    function fbFieldToggleFieldDirective() {
        return {
            restrict: "E",
            scope: {
                element: "=",
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldToggle',
            link: function(scope, elem, attr, ctrl) {
                scope.currentScope = {
                    element: scope.element,
                };

                ctrl.$render = function() {
                    scope.currentScopeModel = ctrl.$viewValue;
                }

                scope.$watch('currentScopeModel', function() {
                   ctrl.$setViewValue(scope.currentScopeModel);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    fbFieldTwoLevelSelector.$inject = ['$timeout', 'lodash'];
    fbFieldTwoLevelSelectorCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', 'GenericModel', 'ActionCommon', '$timeout', 'FbSelectService', 'RequestHelper'];
    angular
        .module('FormBuilder')
        .directive(
            'fbFieldTwoLevelSelector', fbFieldTwoLevelSelector);

    function fbFieldTwoLevelSelector($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: "=",
                eventHandler: '&'
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldTwoLevelSelector',
            controller: fbFieldTwoLevelSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    scope.toggleActive = vm.toggleActive;
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldTwoLevelSelectorCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService,RequestHelper) {
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {
            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;

            formIdentifier = $scope.$parent.vm.formIdentifier;
            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }

            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        });
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }

            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            }
            
            
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;
            vm.toggleActive = toggleActive;
            vm.firstLoad = true;
            vm.toggleState = true;
            vm.showVisaStatus = false;
            vm.selectizeMsg = '';
            vm.visaStatus = [];   

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        onChange: function(selectedValue) {
                            var subFormElement = $scope.vm.element.elementIdentifier.split('.')[0];
                            var parameterElement = $scope.vm.element.attr.variable;
                            var parameterKey = lodash.get(lodash.get(vm.pageData.renderedElements,subFormElement), parameterElement);
                            if(selectedValue === undefined){
                                lodash.set(parameterKey,'options.datasource.data', []);
                                lodash.set(parameterKey,'options.selectize.hasDefaultModel', false);
                            }else{
                                const selected = lodash.find(vm.ds, function(item) {
                                    return lodash.get(item, lodash.get(vm.config, 'valueField', 'value'), null).toString() === selectedValue.toString();
                                });
                                
                                var dataModel = lodash.get(selected, parameterElement, []);
    
                                if(dataModel && parameterKey){
                                    lodash.set(parameterKey,'options.datasource.data', dataModel);
                                    lodash.set(parameterKey,'options.selectize.hasDefaultModel', false);
                                }
                            }
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                emptyOptionLabel();
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        };

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data: {label: value, model: formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {
            var parameterElement = $scope.vm.element.attr.variable;
            var subFormElement = $scope.vm.element.elementIdentifier.split('.')[0];
            // var subForm = lodash.get(vm.pageData.model, subFormElement);
            var selectedValue = $scope.vm.model;
            var parameterKey = lodash.get(lodash.get(vm.pageData.renderedElements,subFormElement), parameterElement);

            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');
                    res.forEach(function(v) {
                        if(v.value == selectedValue){
                            if (parameterKey && !vm.pageData.fbData.settings.view_only) {
                                lodash.set(parameterKey,'options.datasource.data', lodash.get(v, parameterElement));
                            }
                        }
                    });
    

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                        //     // res.push({"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')});                            
                            var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                            vm.selectize.settings.placeholder = placeholder;
                            vm.selectize.updatePlaceholder();
                        }
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }else{
                lodash.get(vm.element, 'options.datasource.data').forEach(function(v) {
                    if(v.value == selectedValue){
                        if (parameterKey) {
                            lodash.set(parameterKey,'options.datasource.data', lodash.get(v, parameterElement));
                        }
                    }
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys',null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }
            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }

        function emptyOptionLabel() {
            if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                if (!lodash.has(vm.element, 'options.datasource.url')) {
                    if (vm.ds.length == 0) {
                        // var obj = {"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')};
                        // vm.ds.push(obj);
                        var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                        vm.selectize.settings.placeholder = placeholder;
                        vm.selectize.updatePlaceholder();
                        vm.selectize.disable();
                    }
                }
            }
        }

        function toggleActive() {
            vm.toggleState = !vm.toggleState;
        }

        function hasFieldError() {
            return fbService.elementsService.getValidationRule(vm.elementIdentifier);
        }

        function fieldErrorMessage() {
            var error = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            if (!error) {
                return '';
            }
            return error.join(' ');
        }
    }
})();
(function () {
    'use strict';

    fbFieldWysiwyg.$inject = ['$timeout'];
    fbFieldWysiwygCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', '$timeout', '$element'];
    angular
        .module('FormBuilder')
        .directive('fbFieldWysiwyg', fbFieldWysiwyg);

    function fbFieldWysiwyg($timeout) {
        return {
            restrict: 'E',
            scope: {
                element: "=",
                model: '='
            },
            // require: ['ngModel'],
            controller: fbFieldWysiwygCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldWysiwyg',
        };
    }

    function fbFieldWysiwygCtrl(lodash, FormBuilderService, $scope, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            // const plugins = ['', ]

            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');

            vm.tinymceOptions = angular.merge(
                {},
                {
                    plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                    menubar: false,
                    toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent | alignleft aligncenter alignright alignjustify',
                    preview_styles: false,
                    resize: true,
                    statusbar: false,
                    autoresize_bottom_margin: 0,
                    autoresize_min_height: 50,
                    debounce: false,
                    // skin_url: cdnEp + '/assets/js/skins/lightgray',
                    content_css: cdnEp + '/assets/css/rms-tinymce.css',
                    // paste_as_text: true,
                    paste_data_images: false
                    // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
                },
                lodash.get(vm.element, 'options.tinymce', {}),
                {
                    setup: function (ed) {
                        vm.ed = ed;
                        ed.on('blur', function () {
                            vm.onEventTrigger('onBlur');
                        });
                        ed.on('init', function () {
                            $timeout(function () {
                                vm.pageData.currentScope.form.$setPristine();
                                vm.pageData.currentScope.form.$setUntouched();

                                $timeout(function () {
                                    var em = $element.find('.mce-toolbar-grp');
                                    $element.remove('.mce-toolbar-grp');
                                    $element.find('.mce-edit-area').after(em);
                                });
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    ed.setMode('readonly');
                                }
                            });
                        });
                        ed.on('PastePreProcess', function (e) {
                            // console.log('before');
                            // console.log(e.content);
                            var content_tmp = $("<div>");
                            content_tmp.html(e.content);
                            var s = new Sanitize(Sanitize.Config.RELAXED);
                            content_tmp.html(s.clean_node(content_tmp[0]));
                            e.content = content_tmp.html();

                            // console.log('after');
                            // console.log(e.content);
                        });
                    },
                    paste_preprocess: function (plugin, args) {
                        args.content = args.content.replace(/(<br[\s\/]*>)/g, '');

                        var pasteDataImages = lodash.get(vm.element, 'options.tinymce.paste_data_images', false);
                        if (pasteDataImages) {
                            var doc = new DOMParser().parseFromString(args.content, "text/html");

                            var toDataURL = function (url, callback) {
                                var xhr = new XMLHttpRequest();
                                xhr.onload = function () {
                                    var reader = new FileReader();
                                    reader.onloadend = function () {
                                        callback(reader.result);
                                    }
                                    reader.readAsDataURL(xhr.response);
                                };
                                xhr.open('GET', url);
                                xhr.withCredentials = "true";
                                xhr.responseType = 'blob';
                                xhr.send();

                                // function readResponseAsBlob(response) {
                                //     return response.blob();
                                // }


                                // fetch(url, {
                                //     credentials: "include",
                                //     mode: 'no-cors'
                                // }).then(readResponseAsBlob).then(function (response) {
                                //     var imgUrl = URL.createObjectURL(response);
                                //     callback(imgUrl);
                                //     console.log(response.type); // "opaque"
                                // }).catch(function (response) {
                                //     console.log(response.type); // "opaque"
                                // });


                            }

                            doc.querySelectorAll('img').forEach(function (elm) {
                                var src = elm.getAttribute('src');

                                const dataImageRegex = RegExp('^data:image/', 'ig');
                                var isBlob = dataImageRegex.test(src);
                                if (!isBlob) {
                                    toDataURL(elm.getAttribute('src'), function (result) {
                                        var content = vm.ed.getContent();
                                        var regExpSrc = new RegExp(src, 'ig');
                                        content = content.replace(regExpSrc, result);
                                        vm.ed.setContent(content);
                                    });
                                }
                            });
                        }
                    }
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbAsyncPanel', lbAsyncPanel);

    function lbAsyncPanel() {
        return {
            restrict: 'E',
            replace:true,
            scope: {
                panel:'='
            },
            controller: lbAsyncPanelCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: "common/libraries/layoutBuilder/panels/async-panel"
        };
    }
    function lbAsyncPanelCtrl() {}
})();
(function () {
    'use strict';

    lbCustomPanelDirectiveCtrl.$inject = ['$scope', '$element', '$compile'];
    angular
        .module('LayoutBuilder')
        .directive('lbCustomPanel', lbCustomPanelDirective);

    function lbCustomPanelDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                panel: "=",
                model: '=',
                content: '='
            },
            controller: lbCustomPanelDirectiveCtrl
        };
    }

    function lbCustomPanelDirectiveCtrl($scope, $element, $compile) {

        //angular.forEach(scope.panel.data.elements, function(element) {
        //    elem.append(element.html);
        //});
        this.$onInit = function() {
            $element.append($scope.panel.data.html);

            $compile($element.contents())($scope);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbDescriptionPanel', lbDescriptionPanelDirective);

    function lbDescriptionPanelDirective() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/description"
        };
    }
})();
(function () {
    'use strict';

    lbFormPanelDirectiveCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('LayoutBuilder')
        .directive('lbFormPanel', lbFormPanelDirective);

    function lbFormPanelDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                panel: "=",
                model: '=',
                content: '='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/form",
            controller:lbFormPanelDirectiveCtrl
        };
    }

    function lbFormPanelDirectiveCtrl($scope, lodash) {
        this.$onInit = function() {
            lodash.set($scope.content,'validation',{});
        }
    }
})();
(function () {
    'use strict';

    lbGridPanelDirective.$inject = ['Path', '$location', '$window'];
    angular
        .module('LayoutBuilder')
        .directive('lbGridPanel', lbGridPanelDirective);

    function lbGridPanelDirective(Path, $location, $window) {
        return {
            restrict: 'EA',
            scope: {
                panel:"="
            },
            templateUrl: 'common/libraries/layoutBuilder/panels/grid',
            compile:compileFunc
        };

        function compileFunc(){
            return {
                post: function postLink(scope, elem) {
                    elem.addClass('lb-grid-wrapper');
                    scope.resizeGrid = function() {
                        var _grid =elem.find('.k-grid');
                        if (_grid.length > 0) {
                            _grid.find(".k-grid-content").css('height','auto');
                            _grid.data('kendoGrid').resize();
                        }
                    };

                    var w = angular.element($window);
                    w.bind('resize', function () {
                        scope.resizeGrid();
                    });

                    scope.$on('$destroy', function() {
                        w.unbind('resize');
                    });
                    scope.resizeGrid();
                }
            };
        }
    }
})();
(function () {
    'use strict';

    lbInfoPanelDirectiveCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('LayoutBuilder')
        .directive('lbInfoPanel', lbInfoPanelDirective);

    function lbInfoPanelDirective() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'=',
                model:'='
            },
            templateUrl:"common/libraries/layoutBuilder/panels/info",
            controller: lbInfoPanelDirectiveCtrl
        };
    }

    function lbInfoPanelDirectiveCtrl($scope, lodash) {
        this.$onInit = function() {
            $scope.columnSize = columnSize;
            $scope.getModelVisible = getModelVisible;
            $scope.getModelValue = getModuleValue;
        }

        function columnSize(listGroup) {
            if (lodash.has(listGroup,'size')) {
                return "medium-" + listGroup.size;
            }
            return "";
        }

        function getModelVisible(element){
            if(typeof lodash.has(element,'options') === 'undefined'){
                return true;
            }
            if(typeof lodash.has(element, 'options.showIf') === 'undefined'){
                return true;
            }
            var operator = lodash.get(element, 'options.showIf.operator');
            var targetValue = lodash.get(element, 'options.showIf.value');
            var fieldIf = lodash.get(element, 'options.showIf.field','');
            var selectedValue = lodash.get($scope.model, fieldIf);
            switch (operator) {
                case 'eq':
                    return selectedValue === targetValue;
                case 'neq':
                    return selectedValue !== targetValue;
            }
            return true;
        }

        function getModuleValue(element) {
            //var value = $scope.model[element.field];
            var value = lodash.get($scope.model, element.field);

            if (angular.isArray(value)) {
                var dataTextField = lodash.get(element, 'options.dataTextField');

                if (typeof dataTextField === 'undefined') {
                    throw new Error('dataTextField must be defined');
                }

                return value.map(function (item) {
                    return item[dataTextField];
                }).join(', ');
            }

            if (typeof value === 'undefined') {
                return 'None set';
            }

            return value;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSettingsPanel', lbSettingsPanelDirective);

    function lbSettingsPanelDirective() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/settings"
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSidebarContent', lbSidebarContent);

    function lbSidebarContent() {
        return {
            restrict: 'E',
            templateUrl: 'common/libraries/layoutBuilder/panels/sidebar-content'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSidebarEntityViewPanel', lbSidebarEntityViewPanel);

    function lbSidebarEntityViewPanel() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/sidebar-entity-view",
            controller: lbSidebarEntityViewPanelCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function lbSidebarEntityViewPanelCtrl() {

    }
})();

(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSidebarWizardViewPanel', lbSidebarWizardViewPanel);

    function lbSidebarWizardViewPanel() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/sidebar-wizard-view",
            controller: lbSidebarWizardViewPanelCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function lbSidebarWizardViewPanelCtrl() {

    }
})();

(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSidebarWorkflowViewPanel', lbSidebarWorkflowViewPanel);

    function lbSidebarWorkflowViewPanel() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/sidebar-workflow-view",
            controller: lbSidebarWorkflowViewPanelCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function lbSidebarWorkflowViewPanelCtrl() {

    }
})();

(function() {
    'use strict';

    lbSideNavCtrl.$inject = ['uriActiveLinkService'];
    angular
        .module('LayoutBuilder')
        .directive('lbSidenavPanel', lbSidenavPanel);

    function lbSidenavPanel() {
        return {
            restrict: 'E',
            scope: {
                panel: '='
            },
            controller: lbSideNavCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/layoutBuilder/panels/sidenav'
        };
    }

    function lbSideNavCtrl(uriActiveLinkService) {
        var vm = this;

        this.$onInit = function() {
            vm.isNavItemActive = isNavItemActive;
        }

        function isNavItemActive(item) {
            return uriActiveLinkService(item.href) ? 'active' : '';
        }
    }
})();

(function () {
    'use strict';

    lbTabstripPanelDirective.$inject = ['lodash'];
    lbTabstripPanelDirectiveCtrl.$inject = ['$scope'];
    angular
        .module('LayoutBuilder')
        .directive('lbTabstripPanel', lbTabstripPanelDirective);

    function lbTabstripPanelDirective(lodash) {
        return {
            scope: {
                panel: '=',
                model: '='
            },
            controller: lbTabstripPanelDirectiveCtrl,
            templateUrl: "common/libraries/layoutBuilder/panels/tabstrip",
            link: lbTabstripPanelDirectiveLink
        };

        function lbTabstripPanelDirectiveLink (scope, elem) {
            var panels = [];

            angular.forEach(scope.panel.data.panels, function (val, index) {
                var visible = (function (showIf, model) {
                    if (typeof showIf === 'undefined') {
                        return true;
                    }
                    switch (showIf.operator) {
                        case 'eq':
                            return model[showIf.field] === showIf.value;
                    }
                })(val.showIf, scope.model);

                if (!visible) {
                    return;
                }

                var _html = '<lb-form-panel panel="panel.data.panels[' + index + '].panel" model="model"></lb-form-panel>';

                panels.push({
                    name: val.name,
                    panel: _html
                });
            });

            var dataSource = kendo.data.DataSource.create(panels);
            var kendoTabStripObj = elem.find('.k-tabstrip').data('kendoTabStrip');
            kendoTabStripObj.setDataSource(dataSource);
            kendoTabStripObj.select(0);

            scope.isActive = isActive;

            function isActive(panel) {
                var is_active = lodash.get(panel, 'is_active', false);
                return (is_active) ? "k-state-active" : '';
            }
        }
    }

    function lbTabstripPanelDirectiveCtrl($scope) {
        this.$onInit = function() {
            $scope.options = {
                animation:false,
                dataContentField: 'panel',
                dataTextField: 'name'
            };
        }
    }
})();

/**
 * Template panel, uses kendo template to generate view
 * receives data.template and data.model to generate html
 */
(function () {
    'use strict';

    lbTemplatePanelDirectiveCtrl.$inject = ['$scope', '$element', '$compile', 'lodash', '$sce'];
    angular
        .module('LayoutBuilder')
        .directive('lbTemplatePanel', lbTemplatePanelDirective);

    function lbTemplatePanelDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                // panel does not need scope.model and scope.content
                panel: "=",
                model: "=",
                content: '='
            },
            controller: lbTemplatePanelDirectiveCtrl
        };
    }

    function lbTemplatePanelDirectiveCtrl($scope, $element, $compile, lodash, $sce) {
        this.$onInit = function() {
            var template = lodash.get($scope, 'panel.data.template', '');
            var data = lodash.get($scope, 'panel.data.model', {});
            $scope.data = angular.copy(data);
            $element.html(template);
            $compile($element.contents())($scope);

            $scope.getOption = function (name) {
                return lodash.get($scope.panel, 'data.options.' + name, {});
            };

            $scope.trust = (type, value) => {
                return $sce.trustAs($sce[type], value);
            };
        }
    }
})();
(function () {
    'use strict';

    PanelRegistry.$inject = ['lodash'];
    angular
        .module('LayoutBuilder')
        .factory('PanelRegistry', PanelRegistry);

    function PanelRegistry(lodash) {
        let panels = {};
        return {
            register: register,
            clear: clear,
            refresh: refresh,
            get: get
        };

        function register(id, panel) {
            lodash.set(panels, id, panel);
        }

        function clear() {
            panels = {};
        }

        function refresh(id, panel) {
            lodash.set(panels, id, panel);
        }

        function get(id, path) {
            return lodash.get(panels, [id, path].join('.'), {});
        }

    }
})();
/**
 * Path Service is a wrapper that handles $location needs for the app.
 * The aim is to provide path manipulation instead of using $location directly
 */
(function () {
    'use strict';

    PathFactory.$inject = ['$location', 'lodash', '$window', '$route'];
    angular
        .module('LayoutBuilder')
        .factory('Path', PathFactory)
    ;

    function PathFactory($location, lodash, $window, $route) {
        var apiPath,
            structurePath,
            navPath = '',
            current,
            currentSplited,
            pathInfo;

        var ctrl = {
            getRelativePath: function (absPath) {
                return absPath.replace(/^(?:\/\/|[^\/]+)*\//, "/");
            },
            getPath: function (path) {
                if (typeof path == typeof []) {
                    path = path.join('/');
                }
                if (path.length < 1) {
                    path = 'index';
                }
                return path;
            },
            determinePathType: function (temp) {
                if (['new', 'edit', 'info', 'search'].indexOf(temp) > -1) {
                    return temp;
                }
                return 'id';
            },
            splitArray: function (path) {
                return path.substring(1).split('/');
            },
            decodeInteractPath: function(_interactPath) {
                var result = '',type = '';

                if (typeof _interactPath == 'string') {
                    _interactPath = _interactPath.split('/');
                }

                if (_interactPath.length == 0) {
                    return result;
                }

                switch (_interactPath.length) {
                    case 3:
                        type = this.determinePathType(_interactPath[2]);
                        result = {
                            modal: _interactPath[1],
                            tab: _interactPath[0],
                            id: _interactPath[2],
                            type: type
                        };
                        break;
                    case 2:
                        type = this.determinePathType(_interactPath[1]);
                        result = {
                            modal: _interactPath[0],
                            tab: '',
                            id: _interactPath[1],
                            type: type
                        };
                        break;
                    default:
                        //if (console) console.log('cannot determine interaction path');
                        result = "";
                }
                return result;
            },
            getParams: function(viewPath) {
                var split = viewPath.split('?');
                if (split.length < 2) {
                    return [];
                } else {
                    return split[1].split('&').map(function(paramText) {
                        var paramTextSplit = paramText.split('&');
                        var key = paramTextSplit[0];
                        var value = paramTextSplit[1] || null;
                        return { key: key, value: value };
                    });
                }
            },
            getStructurePath: function(viewPath) {
                return viewPath.split('?')[0];
            }
        };

        var PathInfo = function (splitedPath, search) {
            var viewPath, interactPath, decodedInteractPath, params, structurePath;

            var pathArr = angular.copy(splitedPath);
            if (pathArr.length < 4) {
                viewPath = pathArr.join('/');
                if (viewPath.length < 1) {
                    viewPath = 'index';
                }
                interactPath = '';
            } else {
                //var viewArr;

                //
                //if ('edit' == pathArr[3]) {
                //    viewArr = pathArr.splice(0, 4);
                //    viewPath = viewArr.join('/');
                //    interactPath = pathArr.join('/');
                //} else {
                //    viewArr = pathArr.splice(0, 3);
                //    viewPath = viewArr.join('/');
                //    interactPath = pathArr.join('/');
                //}
                viewPath = pathArr.join('/');
                interactPath = '';
            }

            decodedInteractPath = ctrl.decodeInteractPath(interactPath);
            params = ctrl.getParams(viewPath);
            structurePath = ctrl.getStructurePath(viewPath);

            return {
                viewPath: function () { return viewPath; },
                interactPath: function() { return decodedInteractPath; },
                search: function() { return search; },
                params: function() { return params; },
                structurePath: function() { return structurePath; },
            };
        };

        // Default Values, if init() is not called
        apiPath = "/";
        structurePath = "/";

        return {
            /*
             * set up Path on run
             */
            init: function (_structurePath, _apiPath) {
                apiPath = _apiPath;
                structurePath = _structurePath;
                this.change();
            },

            /*
             * Executes everything a path changes
             */
            change: function () {
                current = $location.path();
                var search = angular.copy($location.$$search);
                currentSplited = ctrl.splitArray(current);
                pathInfo = new PathInfo(currentSplited, search);
            },

            /*
             * Get Path, if index is provided, get the value of the position
             */
            get: function (position) {
                if (lodash.isNumber(position)) {
                    return currentSplited[position];
                }
                return false;
            },

            /*
             * redirect to desired destination
             */
            redirect: function (dest, searchData) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }

                $location.path(_path);
                //sodo handle clearing the param strings
                if (!searchData) searchData = [];
                $location.search(searchData);
            },

            newTab: function(dest) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }

                $window.open(_path);
            },

            newWindow: function(dest, title, options) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }


                $window.open(_path, title, options);
            },

            reload: function(dest) {
                var _path = dest;
                if (_path.indexOf('<id>') > -1) {
                    _path = _path.replace(new RegExp('<id>', 'g'), this.get(2));
                }
                $window.location.href = _path;
            },

            /*
             * redirect up one level,
             */
            up: function () {
                var _path = pathInfo.viewPath().split('/');
                _path.splice(_path.length - 1, 1);
                return "/" + _path.join('/');
            },

            /*
             * get the stucture path base on current view
             */
            getStructurePath: function () {
                return structurePath + pathInfo.viewPath();
            },

            /**
             * get the interaction path base on current view
             */
            getInteractionPath: function() {
                return pathInfo.interactPath();
            },

            /*
             * get api path given a path
             */
            getApiPath: function (path) {
                return apiPath + ctrl.getPath(path);
            },

            /**
             * set master layout data path
             * @param _p
             */
            setMasterLayoutDataPath: function(_p) {
                navPath = _p;
            },

            /**
             * get master layout data path
             * @returns {*}
             */
            getMasterLayoutDataPath: function() {
                return navPath;
            },

            /*
             * get the module portion of the parth
             */
            getModule: function () {
                return this.get(0);
            },

            /*
             * Generates a pathinfo given a path string
             * @Params path: string, if path is empty, returns pathInfo variable
             * @Returns pathInfo: object
             */
            getPathInfo: function (path) {
                if (path) {
                    path = ctrl.splitArray(ctrl.getRelativePath(path));
                    return new PathInfo(path);
                }
                return pathInfo;
            },

            /**
             * Replace uri with id
             */
            replace: function(uri, subid) {
                var _path = angular.copy(uri);
                var id = this.get(2);
                //if (typeof id == typeof undefined) {
                //    id = this.get(2);
                //}

                if (_path.indexOf('<id>') > -1 ) {
                    _path = _path.replace(new RegExp('<id>','g'), id);
                }
                if (_path.indexOf('<subid>') > -1) {
                    _path = _path.replace(new RegExp('<subid>','g'), subid);
                }
                return _path;
            },

            /**
             * Adds Tabstrip Path
             */
            selectTabstrip: function(name) {
                if (this.get(3) === false) {
                    $location.path($location.path() + '/' + name);
                } else {
                    $location.path(this.get(0) + '/' + this.get(1) + '/' + this.get(2) + '/' + name);
                }
            },

            getRelativePath: function(pathName) {
                return ctrl.getRelativePath(pathName);
            },

            paramsIsDiff: function(params1, params2) {
                if (params1.length !== params2.length) {
                    return true;
                }
                var result = params1.reduce(function(r1, p1) {
                    var p2Match = lodash.find(params2, { key: p1.key });
                    if (!p2Match) {
                        r1.push(p1);
                    }
                    if (p2Match && p2Match.value != p1.value) {
                        r1.push(p1);
                    }
                    return r1;
                }, []);

                return (result.length > 0);
            }
        };
    }
})();
(function () {
    'use strict';

    AppointmentSelectorController.$inject = ['dialogOptions', 'close', 'lodash', '$timeout', 'AppointmentSelectorConstant'];
    angular
        .module('sodAppointmentSelector')
        .controller('AppointmentSelectorController', AppointmentSelectorController);

    function AppointmentSelectorController(dialogOptions, close, lodash, $timeout, AppointmentSelectorConstant) {
        const vm = this;
        vm.show = false;
        vm.options = dialogOptions;

        vm.add = add;
        vm.STEP = AppointmentSelectorConstant.STEP;
        vm.step = vm.STEP.PARTICIPANTS;

        vm.participants = ['a', 'list', 'of', 'participants'];

        $timeout(function() {
           vm.show = true;
        });

        vm.nextStep = function() {
            switch (vm.step) {
                case vm.STEP.PARTICIPANTS: vm.step = vm.STEP.DATE_SELECTOR; break;
                case vm.STEP.DATE_SELECTOR: vm.step = vm.STEP.APPOINTMENT; break;
                default: break;
            }
        };

        vm.previousStep = function() {
            switch (vm.step) {
                case vm.STEP.APPOINTMENT: vm.step = vm.STEP.DATE_SELECTOR; break;
                case vm.STEP.DATE_SELECTOR: vm.step = vm.STEP.PARTICIPANTS; break;
                default: break;
            }
        };

        vm.dismiss = function() {
            close(false);
        };
        // Allow configuration of slots in company settings

        vm.sourcelistOptions = {
            dataSource: new kendo.data.DataSource({
                data: [
                    'a', 'b', 'c', 'd'
                ]
            })
        };

        function add(dataItem) {
            vm.participants.push(dataItem);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .constant('AppointmentSelectorConstant', {
            APPOINTMENT_SELECTOR_DIALOG_IDENTIFIER: 'document-library',
            STEP: {
                PARTICIPANTS: 1,
                DATE_SELECTOR: 2
            }
        });
})();
(function () {
    'use strict';

    actionFunc.$inject = ['DialogManager', 'AppointmentSelectorConstant', '$templateCache'];
    angular
        .module('sodAppointmentSelector')
        .factory('action-open-appointment-selector', actionFunc);

    function actionFunc(DialogManager, AppointmentSelectorConstant, $templateCache) {
        return function (options) {
            const dialogOptions = angular.merge(
                {},
                {
                    // functionality shouldn't change regardless of view. So we Hardcode the Controller
                    // Otherwise, options can override it.
                    controller: 'AppointmentSelectorController',
                    template: $templateCache.get('common/libraries/appointment-selector/appointment-selector'),
                    dialog_options: {
                        modalSize: 'medium modal-height-restrict-without-footer',
                        classes: {
                            wrapper: 'form-block'
                        },
                        list: {
                            autoBind: true
                        },
                        title: "Create an Appointment",
                        participants: {

                        },
                        availability: {

                        }
                    }
                },
                {
                    // test data. to remove
                    dialog_options: {
                        datasources: {

                        }
                    }
                },
                options
            );

            return DialogManager.init(AppointmentSelectorConstant.APPOINTMENT_SELECTOR_DIALOG_IDENTIFIER, dialogOptions);
        };
    }
})();
(function () {
    'use strict';

    sodAppointmentSelectorButtonCtrl.$inject = ['ActionManager'];
    angular
        .module('sodAppointmentSelector')
        .directive('sodAppointmentSelectorButton', sodAppointmentSelectorButton);

    const template = `
        <button type="button" class="button default" ng-click="vm.onClick()">Test</button>
    `;

    function sodAppointmentSelectorButton() {
        return {
            scope: {

            },
            template: template,
            controller: sodAppointmentSelectorButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodAppointmentSelectorButtonCtrl(ActionManager) {
        const vm = this;
        this.$onInit = function() {
            vm.onClick = onClick;
        }
        // onClick();

        function onClick() {
            console.log('hello World');
            ActionManager('open-appointment-selector', {}).then(function(result) {
                result.modal.closed.then(function(res) {
                    console.log(res);
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .directive('sodAppointmentSelectParticipant',sodAppointmentSelectParticipant);

    const template = `
        <div class="participants-wrapper">
            <div class="participants-selector-wrapper">
                <div>
                    <input type="text" placeholder="Participant Type (users, clients, candidates)" />
                </div>
                <div kendo-list-view="vm.sourceList" k-options="vm.sourcelistOptions">
                    <div k-template>
                        <div class="participant-person">
                            <div class="participant-image"></div>
                            <div class="participant-name" ng-bind="dataItem"></div>
                            <button type="button" class="button default small btn-add-participant" ng-click="vm.add(dataItem)">Add</button>
                        </div>
                    </div>
                </div>
                <div kendo-pager k-data-source="vm.sourcelistOptions.dataSource"></div>
            </div>
            <div class="selected-participants-wrapper">
                <div class="selected-participant-list">
                    <div class="selected-participant-header">Selected</div>
                    <ul>
                        <li ng-repeat="participant in vm.participants track by $index">
                            <div class="participant-image"></div>
                            <div ng-bind="participant" class="participant-name"></div><!--
                            --><div class="label default round">Interviewer</div>
                            <a ng-click="vm.remove(participant)" class="remove-participant"><i class="fa fa-times"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `;

    function sodAppointmentSelectParticipant() {
        return {
            restrict: 'E',
            controller: sodAppointmentSelectParticipantCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                getParticipants: '=?'
            },
            template: template
        };
    }

    function sodAppointmentSelectParticipantCtrl() {
        const vm = this;
        this.$onInit = function() {
            vm.getParticipants = getParticipants;
            vm.add = add;

            vm.participants = ['a', 'list', 'of', 'participants'];

            vm.sourcelistOptions = {
                dataSource: new kendo.data.DataSource({
                    data: [
                        'a', 'b', 'c', 'd'
                    ]
                })
            };
        }

        function add(dataItem) {
            vm.participants.push(dataItem);
        }

        function getParticipants() {
            return vm.participants;
        }
    }
})();
(function() {
    'use strict';

    DocumentLibraryController.$inject = ['$timeout', 'close', 'dialogOptions'];
    angular
        .module('sodDocumentLibrary')
        .controller('DocumentLibraryController', DocumentLibraryController);

    function DocumentLibraryController($timeout, close, dialogOptions) {
        const vm = this;
        vm.show = false;
        vm.options = dialogOptions;
        vm.useDocuments = useDocuments;
        vm.dismiss = dismiss;
        vm.close = close;

        $timeout(function() {
           vm.show = true;
        });

        function useDocuments() {
            close(vm.getModel());
        }

        function dismiss() {
            close(false);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .constant('DocumentLibraryConstant', {
            DOCUMENT_LIBRARY_DIALOG_IDENTIFIER: 'document-library',
            ACTION_OPEN_DOCUMENT_LIBRARY: ''
        });
})();
(function () {
    'use strict';

    sodDocumentLibraryGoogleDoc.$inject = ['$timeout', 'ActionManager'];
    angular
        .module('sodDocumentLibrary')
        .directive('sodDocumentLibraryGoogleDoc', sodDocumentLibraryGoogleDoc);

    function sodDocumentLibraryGoogleDoc($timeout, ActionManager) {
        return {
            restrict: 'E',
            controllerAs: 'vm',
            bindToController: true,
            controller: sodDocumentLibraryGoogleDocCtrl,
            scope: {
                url: '=',
                mimeType: '=',
                download: '=?',
                notifyLabel: '@?',
                refresh: '=?',
            },
            templateUrl: 'common/app/components/google-doc-viewer', //
            link: sodDocumentLibraryGoogleDocLink
        };

        function sodDocumentLibraryGoogleDocLink(scope, elem) {
            var vm = scope.vm;
            vm.show = true;
            vm.downloadFile = downloadFile;
            const imageMimeType = [
                'image/jpeg',
                'image/png',
                'image/gif'
            ];
            const pdfMimeType = [
                'application/pdf',
                // 'application/rtf',
            ];

            const docViewerElem = elem.find('.google-doc-file-viewer');

            vm.refresh = function() {
                docViewerElem.empty();
                $timeout(function() {
                    generateDom();
                })
            };

            $timeout(function () {
                generateDom();
            });

            function generateDom() {
                if (imageMimeType.indexOf(scope.vm.mimeType) >= 0) {
                    // images
                    docViewerElem.append('<div><img src="' + scope.vm.url + '" /></div>');
                } else {
                    if (pdfMimeType.indexOf(scope.vm.mimeType) >= 0) {
                        // const pdfObject = `<object type="application/pdf" data="${scope.vm.url}" width="100%" height="100%"><p>This browser does not support PDFs. Please download the PDF to view it: <a href="${scope.vm.url}">Download PDF</a>.</p></object>`;
                        // docViewerElem.append(pdfObject);
                        PDFObject.embed(scope.vm.url, docViewerElem);

                    } else {
                        const iframeDom = '<iframe src="' + scope.vm.url + '" style="width:100%; height:100%;" frameborder="0"></iframe>';
                        // const iframeDom = '<iframe src="' + scope.vm.url + '" style="width:100%; height:100%;" frameborder="0"></iframe>';
                        docViewerElem.append(iframeDom);
                    }
                }
            }

            function downloadFile() {
                ActionManager('notify', {
                    'template': vm.notifyLabel || 'Please wait while we prepare your download...',
                    'hasDelay': true,
                    'delay'   : 2000,
                    'type'    : 'success',
                    'position': 'top center'
                });
                ActionManager('download', { route: vm.download });
                // const iframeDom = docViewerElem.find('iframe')[0];
                // var idoc = iframeDom.contentDocument || iframeDom.contentWindow.document; // ie compatibility
                //
                // idoc.getSelection();
            }
        }
    }

    function sodDocumentLibraryGoogleDocCtrl() {

    }
})();
(function() {
    'use strict';

    documentLibraryImage.$inject = ['$sce'];
    angular
        .module('sodDocumentLibrary')
        .filter('documentLibraryImage', documentLibraryImage);

    function documentLibraryImage($sce) {
        return function(item) { 
            if (item.item_type === 'folder') {
                return '<div class="item-icon"><i class="fa fa-2x fa-sod-folder"></i></div>';
            }
            if (['jpg','gif', 'jpeg', 'tiff', 'png', 'svg'].indexOf(item.extension) >= 0) {
                return $sce.trustAsHtml('<div class="item-image" style="background-image:url(' + item.url + ')"></div>');
            } else {
                return '<div class="item-icon"><i class="fa fa-2x ' + item.icon + '"></i></div>';
            }
        };
    }
})();
// (function () {
//     'use strict';
//
//     angular
//         .module('sodDocumentLibrary')
//         .directive('sodDocumentLibraryPreview', sodDocumentLibraryPreview);
//
//     function sodDocumentLibraryPreview() {
//         return {
//             restrict: 'E',
//             controller: sodDocumentLibraryPreviewCtrl,
//             controllerAs: 'vm',
//             bindToController: true,
//             scope: {
//                 document: '='
//             },
//             templateUrl: ''
//         };
//     }
//
//     function sodDocumentLibraryPreviewCtrl() {
//         var vm = this;
//
//     }
// })();
(function () {
    'use strict';

    sodDocumentLibraryCtrl.$inject = ['DocumentService', 'lodash', '$scope', '$timeout', '$element', '$filter'];
    angular
        .module('sodDocumentLibrary')
        .directive('sodDocumentLibrary', sodDocumentLibrary);

    function sodDocumentLibrary() {
        return {
            restrict: 'E',
            controller: sodDocumentLibraryCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                selected: '=?',
                getModel: '=?',
                useDocumentTrigger: '&?',
                close: '=?',
            },
            templateUrl: 'common/libraries/document-library/document-library'
        };
    }

    function sodDocumentLibraryCtrl(DocumentService, lodash, $scope, $timeout, $element, $filter) {
        const vm = this;
        this.$onInit = function() {
            vm.dlNotifications = [];
            vm.crumbs = [];

            prepareUploadOptions();

            vm.useDocuments = useDocuments;
            vm.toggleSelect = toggleSelect;
            vm.isItemSelected = isItemSelected;
            vm.handleRemoveDocument = handleRemoveDocument;
            vm.getModel = getModel;
            vm.dismiss = dismiss;
            vm.removeDlNotification = removeDlNotification;
            vm.applySearch = applySearch;
            vm.changeFolder = changeFolder;

            vm.documentService = new DocumentService(vm.options);
            init();

            vm.selectData = {
                selected: (!!vm.selected) ? vm.selected : [],
                selectAllFlag: false,
                filter: [],
                isMassSelectedItems: true,
                nextStep: false
            };
        }

        function init() {
            const dsOptions = lodash.get(vm.options, 'datasources.query', null);
            if (dsOptions === null) return;
            vm.folderId = lodash.get(vm.options, 'initialFolderId', null);

            if (lodash.has(dsOptions, 'data')) {
                vm.dataSource = new kendo.data.DataSource({
                    data: dsOptions.data,
                    pageSize: 10
                });
            }
            if (!lodash.has(dsOptions, 'data')) {
                vm.dataSource = new kendo.data.DataSource({
                    transport: {
                        read: getDocuments
                    },
                    schema: {
                        data: 'rows',
                        total: 'count'
                    },
                    serverPaging: true,
                    pageSize: 20,
                });
            }
            vm.options.list.dataSource = vm.dataSource;
            vm.options.list.dataBound = listDataBound;
        }

        function listDataBound() {
            if (vm.dataSource.data().length === 0) {
                $element.find('.k-listview').html(lodash.get(vm.options, 'list.noRecords', '<h4>No Records</h4>'));
            }
        }

        function prepareUploadOptions() {
            if (!lodash.has(vm.options, 'upload.sync.saveurl') && lodash.has(vm.options, 'datasources.store')) {
                const storeDs = lodash.get(vm.options, 'datasources.store', {});
                lodash.set(vm.options, 'upload.async.saveVerb', 'POST');
                lodash.set(vm.options, 'upload.async.saveUrl', lodash.get(storeDs, 'route', ''));

                lodash.set(vm.options, 'upload.upload', handleUploadStart);
                lodash.set(vm.options, 'upload.success', handleUploadSuccess);
                lodash.set(vm.options, 'upload.progress', handleUploadProgress);
                lodash.set(vm.options, 'upload.error', handleUploadError);
                lodash.set(vm.options, 'upload.complete', handleUploadComplete);
            }
        }

        function getDocuments(readOptions) {
            // prepare filters for folder
            vm.documentService.query(readOptions.data, vm.searchText, vm.folderId || 'top').then(function(res) {
                vm.crumbs = lodash.get(res, 'crumbs', []);
                readOptions.success(res);
            }, function(err) {
                readOptions.error(err);
            })
        }

        function applySearch() {
            vm.options.list.dataSource.read(); 
        }

        function getModel() {
            return vm.selectData.selected;
        }

        function handleRemoveDocument(dataItem) {
            const removeNotification = {
                template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.removing', 'Removing...'), dataItem),
                id: dataItem.select_id,
            };
            vm.dlNotifications.push(removeNotification);
            vm.documentService.remove(dataItem.id).then(function() {
                removeDlNotification(removeNotification);
                addNotificationWithTimeout({
                    template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.removed', 'Removed...'), dataItem),
                    id: dataItem.select_id,
                });
                const index = lodash.findIndex(vm.selectData.selected, { select_id: dataItem.select_id});
                if (index >= 0) {
                    vm.selectData.selected.splice(index, 1);
                }
                vm.dataSource.read();
            }, function (err) {
                // show notification
                removeDlNotification(removeNotification);
                addNotificationWithTimeout({
                    template: 'Removed Error',
                    id: dataItem.select_id,
                });
                vm.dataSource.read();
            });
        }

        function updateDocuments() {

        }

        function useDocuments() {
            vm.loading = true;
            // trigger an event and sending the selectedData over.
            if (lodash.has(vm.options, 'trigger.use')) {
                $scope.$emit(vm.options.trigger.use);
            } else {
                vm.useDocumentTrigger();
            }
        }

        function createFolder() {

        }

        function deleteFolder() {

        }

        function handleSelection() {

        }

        function handleUploadStart(e) {
            lodash.forEach(e.files, function(file) {
                vm.dlNotifications.push({
                    template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.uploading', 'Uploading...'), file),
                    id: file.uid,
                });
                $scope.$apply();
            });
            if (lodash.has(vm.options, 'upload.attr.sender_name')) {
                e.sender.name = lodash.get(vm.options, 'upload.attr.sender_name', 'file_element');
            }
        }

        function handleUploadSuccess(e) {
            vm.folderId = lodash.get(e, 'response.data.folder_id', null);
            if (lodash.has(e, 'response.data.edit_model')) {
                vm.selectData.selected.push(lodash.get(e, 'response.data.edit_model', {}));
            }
            vm.dataSource.page(1);
            // vm.dataSource.read();
            lodash.forEach(e.files, function(file) {
                removeDlNotificationByUid(file.uid);
                $scope.$apply();
                addNotificationWithTimeout({
                    template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.uploaded', 'Uploaded...'), file),
                    id: file.uid,
                }, true);
            });
        }

        function handleUploadProgress(e) {
            console.log('upload in progress', e.percentComplete);
        }

        function handleUploadError(e) {
            var response = JSON.parse(e.XMLHttpRequest.response);

            lodash.forEach(e.files, function(file) {
                removeDlNotificationByUid(file.uid);
                $scope.$apply();
                var responseMsg = '';
                if (lodash.has(response, 'rules.file_element')) {
	                  responseMsg = response.rules.file_element.join(', ');
                }

                addNotificationWithTimeout({
                    template: responseMsg,
                    id: file.uid,
                }, true);
            });
        }

        function handleUploadComplete() {

        }


        function toggleSelect(dataItem) {
            // if dataItem.type === 'folder'
            // do something.
            if (dataItem.item_type === 'folder') {
                // vm.folderId = dataItem.id;
                changeFolder(dataItem.id);
                // vm.dataSource.read();
            } else {
                // else
                const index = lodash.findIndex(vm.selectData.selected, {select_id: dataItem.select_id});
                if (index >= 0) {
                    vm.selectData.selected.splice(index, 1);
                } else {
                    vm.selectData.selected.push(lodash.get(dataItem, 'edit_model', {}));
                }
            }
        }

        function isItemSelected(dataItem) {
            return !(lodash.find(vm.selectData.selected, { select_id: dataItem.edit_model.select_id}) === undefined);
        }

        function dismiss() {
            if (lodash.has(vm.options, 'trigger.close')) {
                $scope.$emit(vm.options.trigger.close);
            }
            if (!!vm.close) {
                vm.close(false);
            }
        }

        function removeDlNotification(notification) {
            const index = lodash.findIndex(vm.dlNotifications, notification);
            vm.dlNotifications.splice(index, 1);
        }

        function removeDlNotificationByUid(uid) {
            const index = lodash.findIndex(vm.dlNotifications, function(noti) {
               return noti.id === uid;
            });
            vm.dlNotifications.splice(index, 1);
        }

        function addNotificationWithTimeout(notification, scopeApply) {
            vm.dlNotifications.push(notification);
            if (scopeApply) { $scope.$apply(); }
            $timeout(function() {
                removeDlNotification(notification);
            }, 3000);
        }

        function changeFolder(id) {
            vm.folderId = id;
            vm.selectData.selected = [];
            vm.dataSource.page(1);
            // vm.dataSource.read();
        }
    }
})();
(function() {
    DocumentService.$inject = ['GenericModel', 'lodash'];
    angular
        .module('sodDocumentLibrary')
        .factory('DocumentService', DocumentService);

    function DocumentService(GenericModel, lodash) {
        return function(options) {
            return {
                query: query,
                remove: remove
            };

            function query(dsData, searchText, folderId) {
                let datasource = options.datasources.query.url;
                let method = lodash.get(options.datasources.query, 'method', 'query');
                const _dsData = angular.merge(
                    {},
                    dsData,
                    lodash.get(options.datasources.query, 'params' , {})
                );

                var appliedFilters = [];

                if (!!searchText) {
                    appliedFilters.push({
                        field: 'filter_search_text',
                        operator: 'contains',
                        value: searchText.toString()
                    });
                }

                var myOptions = {
                    filter:  appliedFilters,
                };

                if (myOptions.filter.length > 0) {
                    method = 'search';
                    datasource = datasource+"/filter";
                }

                var data = generateResourceOption(_dsData, myOptions, method);

                var model = new GenericModel(datasource);
                if (['query', 'get', 'getArray'].indexOf(method) >= 0) {
                    if (!!folderId) {
                        data.folderId = folderId;
                    }
                    return model[method](data).$promise;
                } else {
                    const p = {};
                    if (!!folderId) {
                        p.folderId = folderId;
                    }
                    return model[method](p, data).$promise;
                }
            }

            function remove(id) {
                const method = lodash.get(options.datasources.remove, 'method', 'delete');
                let url = options.datasources.remove.url;
                url = decodeURI(url).replace(new RegExp('<id>', 'g'), id);
                const model = new GenericModel(url);
                return model[method]().$promise;
            }
        };

        function generateResourceOption(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);
            if (method == 'search') {
                params = {'data': params};
            }
            return params;
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['DialogManager', 'DocumentLibraryConstant', '$templateCache'];
    angular
        .module('sodDocumentLibrary')
        .factory('action-open-document-library', actionFunc);

    function actionFunc(DialogManager, DocumentLibraryConstant, $templateCache) {
        return function (options) {
            const dialogOptions = angular.merge(
                {},
                {
                    // functionality shouldn't change regardless of view. So we Hardcode the Controller
                    // Otherwise, options can override it.
                    controller: 'DocumentLibraryController',
                    template: $templateCache.get('common/libraries/document-library/document-library-controller-view'),
                    // dialog_options: {
                    //     modalSize: 'large modal-height-restrict-without-footer',
                    //     classes: {
                    //         wrapper: 'form-block'
                    //     },
                    //     title: "Select Files",
                    //     "upload": {
                    //         "config": {
                    //             "multiple": true,
                    //             "showFileList": false,
                    //             "localization": {
                    //                 "select": "Upload a file",
                    //                 "dropFilesHere": "or drop files here"
                    //             }
                    //         },
                    //         "attr": {
                    //             "sender_name": "file_element"
                    //         },
                    //         "async": {
                    //             "autoUpload": true,
                    //             "batch": false,
                    //             "saveField": "file_element"
                    //         }
                    //     },
                    //     "list": {
                    //         "autoBind": true,
                    //         "noRecords": "<div class=\"list-filter-no-records\">\n    <div>\n        <img src=\"https://content.recruiterpal.com/app/assets/images/common/No_Result_Empty_State.svg\" />\n    </div>\n    <h2>No Documents Yet?</h2>\n    <div>Add a document to get started</div>\n</div>"
                    //     },
                    //     "labels": {
                    //         "uploading": {
                    //             "template": "<i class=\"fa fa-cloud-upload\"></i> Uploading - <name>"
                    //         },
                    //         "uploaded": {
                    //             "template": "<i class=\"fa fa-check success\"></i> Uploaded - <name>"
                    //         },
                    //         "removing": {
                    //             "template": "<i class=\"fa fa-trash\"></i> Removing - <name>"
                    //         },
                    //         "removed": {
                    //             "template": "<i class=\"fa fa-trash success\"></i> Removed - <name>"
                    //         }
                    //     },
                    //     "datasources": {
                    //         "query": {
                    //             "url": "api/v1/rms/document-folders/:folderId",
                    //             "method": "get"
                    //         },
                    //         "remove": {
                    //             "url": "api/v1/rms/documents/%3Cid%3E",
                    //             "method": "delete"
                    //         },
                    //         "update": {
                    //             "url": "api/v1/rms/documents/%3Cid%3E",
                    //             "method": "update"
                    //         },
                    //         "massRemove": {
                    //             "url": "api/v1/rms/documents/deactivate",
                    //             "method": "update"
                    //         },
                    //         "store": {
                    //             "route": "/api/upload/v1/rms/documents"
                    //         }
                    //     },
                    //     // "initialFolderId": "165d5aa21b164f45d254c9aa56289552124d"
                    // }
                },
                // {
                //     // test data. to remove
                //     dialog_options: {
                //         datasources: {
                //             query: {
                //                 url: '/api/v1/rms/document-folders'
                //             },
                //             remove: {
                //                 url: '/api/v1/rms/document-folders/<id>',
                //                 method: 'delete'
                //             },
                //             update: {
                //                 url: '/api/v1/rms/document-folders/<id>',
                //                 method: 'put'
                //             },
                //             massRemove: {
                //                 url: '/api/v1/rms/document-folders/',
                //                 method: 'put'
                //             }
                //         }
                //     }
                // },
                options
            );

            console.log('check upload stuff', dialogOptions);

            return DialogManager.init(DocumentLibraryConstant.DOCUMENT_LIBRARY_DIALOG_IDENTIFIER, dialogOptions);
        };
    }
})();


(function () {
    'use strict';

    documentLibraryUploadCtrl.$inject = ['lodash', '$timeout', '$element', 'CommonHelper'];
    angular
        .module('sodDocumentLibrary')
        .directive('documentLibraryUpload', documentLibraryUpload);

    function documentLibraryUpload() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
            },
            controller: documentLibraryUploadCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: '<div class="document-library-upload" ng-if="vm.uploadOptions">' +
            '<input type="file" kendo-upload="vm.uploadObj" k-options="vm.uploadOptions" ng-init="vm.quanKunDaMoYi()" />' +
            '</div>',
            link: documentLibraryUploadLink
        };

        function documentLibraryUploadLink(scope, elem) {

        }
    }

    function documentLibraryUploadCtrl(lodash, $timeout, $element, CommonHelper) {
        const vm = this;

        this.$onInit = function() {
            vm.quanKunDaMoYi = quanKunDaMoYi; // 乾坤大挪移 shifting things around.

            $timeout(function () {
                init();
                console.log('vm.options', vm.options, vm.uploadOptions);
            });

            function init() {
                vm.uploadOptions = angular.merge(
                    {},
                    vm.options,
                    lodash.get(vm.options, 'config', {}),
                    {
                        uploadEvent: function(e) {
                            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                                var fileSize = lodash.get(vm.onLoadEventOptions, 'fileSize', (1024*1024*5))
                                if (e.files[0].size > fileSize) {
                                    // var wrapper = $element.parents('label');
                                    //
                                    // wrapper.addClass('error');
                                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 2 MB');
                                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                                    e.preventDefault();

                                    var sizing =CommonHelper.bytesToSize( vm.onLoadEventOptions.fileSize);
                                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                                    $scope.$apply();
                                    return false;
                                }
                            }

                            if (lodash.has(vm.element, 'attr.sender_name')) {
                                e.sender.name = vm.element.attr.sender_name;
                            }
                            e.data = lodash.get(vm, 'element.attr.upload_data', {});
                        }
                    }
                );
            }
        }

        function quanKunDaMoYi() {
            $timeout(function () {
                var em = $element.find('.k-upload-button');
                $element.remove('.k-upload-button');
                $element.find('.k-upload').prepend(em);
            });
        }
    }
})();
(function () {
    'use strict';

    notificationCenterBadgeCtrl.$inject = ['NotificationCenterService', '$scope'];
    angular
        .module('sodNotificationCenter')
        .directive('notificationCenterBadge', notificationCenterBadge);

    function notificationCenterBadge() {
        return {
            restrict: 'E',
            controller: notificationCenterBadgeCtrl,
            controllerAs: 'nc',
            bindToController: true,
            scope: {},
            template: '<span ng-bind="nc.total" style="color:white"></span>'
        };
    }

    function notificationCenterBadgeCtrl(NotificationCenterService, $scope) {
        var nc = this;
        this.$onInit = function() {
            nc.total = NotificationCenterService.getTotal();

            $scope.$watch(
                function() { return NotificationCenterService.getUpdatedTime() },
                function() {
                    nc.total = NotificationCenterService.getTotal();
                }
            );
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('sodNotificationCenter')
        .directive('sodNotificationCenterDir', sodNotificationCenterDir);

    function sodNotificationCenterDir() {
        return {
            restrict: 'A',
            controller: sodNotificationCenterDirCtrl,
            controllerAs: 'noti',
            bindToController: true,
            scope: {}
        };
    }

    function sodNotificationCenterDirCtrl() {
        var vm = this;

    }
})();
(function () {
    'use strict';

    NotificationCenterService.$inject = ['lodash', '$interval'];
    angular
        .module('sodNotificationCenter')
        .factory('NotificationCenterService', NotificationCenterService);

    function NotificationCenterService(lodash, $interval) {
        const mem = {};
        // init();
        return {
            getTotal: getTotal,
            getData: getData,
            getUpdatedTime: getUpdatedTime,
            destroy: destroy
        };

        function init() {
            run();
            mem.intervalRef = $interval(run, 1000);
        }

        function run() {
            lodash.set(mem, 'data', {
                rows: [
                    { name: 'Test: ' + (new Date()).getTime() }
                ],
                count: Math.round(Math.random() * 10)
            });
            lodash.set(mem, 'updated', (new Date()).getTime());
        }

        function getTotal() {
            return lodash.get(mem, 'data.count', 0);
        }

        function getData() {
            return lodash.get(mem, 'data.rows', []);
        }

        function getUpdatedTime() {
            return lodash.get(mem, 'updated', null);
        }

        function destroy() {
            if (lodash.has(mem, 'intervalRef')) {
                mem.intervalRef();
            }
        }
    }
})();
(function () {
    'use strict';

    customCartItem.$inject = ['CommonHelper', 'lodash'];
    angular
        .module('sod.helper')
        .directive('customCartItem', customCartItem);

    function customCartItem(CommonHelper, lodash) {
        return {
            restrict: 'E',
            controller: customCartItemCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                item: '=',
                addToCart: '&?',
                removeFromCart: '&?',
                isActive: '&?',
            },
            templateUrl: function(tElement, tAttrs) {
                var template = lodash.get(tAttrs, 'template', '');
                if (CommonHelper.isEmpty(template)) {
                    return template;
                } else {
                    return 'common/components/cart/cart-item';
                }
            }
        };
    }

    function customCartItemCtrl() {
        var vm = this;

    }
})();
(function () {
    'use strict';

    customCart.$inject = ['lodash'];
    customCartCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('sod.helper')
        .directive('customCart', customCart);

    function customCart(lodash) {
        return {
            restrict: 'E',
            controller: customCartCtrl,
            scope: {
                options: '=?',
                addToCart: '&'
            },
            require: 'ngModel',
            templateUrl: function(tElement, tAttrs) {
                // if (lodash.has(tAttrs, 'templateName')) {
                //     return tAttrs.templateName;
                // } else {
                    return 'common/components/cart/cart';
                // }
            },
            link: function(scope, elem, attr, ctrl) {
                scope.mdlCtrl = ctrl;

                ctrl.$formatters.push(function(modelValue) {
                    if (!lodash.has(modelValue, 'selected')) {
                        modelValue.selected = [];
                    }
                   return modelValue;
                });

                ctrl.$render = function() {
                    console.log('render ran');
                    scope.model = ctrl.$viewValue;
                }
            }
        };
    }

    function customCartCtrl($scope, lodash) {
        var field_name;

        this.$onInit = function() {
            field_name = lodash.get($scope.options, 'field_to_compare', 'name');

            $scope.ctrl = {
                getTemplate: getTemplate,
                addToCart: addToCart,
                removeFromCart: removeFromCart,
                isActive: isActive,
                removeAllFromCart: removeAllFromCart,
            };
            $scope.model = null;
            init();
        }

        function init() {
            console.log('init ran');
        }

        function getTemplate(type) {
            var templateName = lodash.get($scope.options, 'templates.' + type, false);
            return (!templateName) ? '' : templateName;
        }

        function addToCart(param) {
            // $scope.model.sele
            $scope.model.selected.push(param.item);
            $scope.mdlCtrl.$setViewValue($scope.model);
        }

        function removeFromCart(param) {
            var index = lodash.findIndex($scope.model.selected, { [field_name]: param.item[field_name] });
            $scope.model.selected.splice(index, 1);
        }

        function isActive(param) {
            console.log('isActive func called');
            return (lodash.findIndex($scope.model.selected, { [field_name]: param.item[field_name] })) >= 0;
        }

        function removeAllFromCart() {
            $scope.model.selected = [];
        }

    }
})();
(function () {
    'use strict';

    tilesEditableDetail.$inject = ['ActionManager', 'lodash'];
    tilesEditableDetailCtrl.$inject = ['$scope', '$compile', '$element', 'lodash', '$templateCache'];
    angular
        .module('sod.helper')
        .directive('tilesEditableDetails', tilesEditableDetail);

    function tilesEditableDetail(ActionManager, lodash) {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                onApply: '=',
                onCancel: '=',
                // onRemove: '&?',
                validation:'=?',
                mode: '@'
            },
            require: 'ngModel',
            template: '',
            link: function(scope, elem, attr, ctrl) {
                scope.model = {};
                scope.mem = {
                    onAddAttachmentClick: onAddAttachmentClick,
                };

                ctrl.$formatters.push(function(modelValue) {
                    scope.default = angular.copy(modelValue);
                   return modelValue.edit_model;
                });

                ctrl.$parsers.push(function(viewValue) {
                    return angular.merge(scope.default, { edit_model: viewValue}) ;
                });

                ctrl.$render = function() {
                    scope.model = ctrl.$viewValue;
                };

                scope.onApply = function() {
                    ctrl.$setViewValue(scope.model);
                };

                scope.onCancel = function() {
                    scope.model = angular.copy(scope.default.edit_model);
                    ctrl.$setViewValue(scope.model);
                };

                function onAddAttachmentClick(field) {
                    const docLibOptions = lodash.get(scope, 'options.attachmentOptions', {});
                    ActionManager('open-document-library', docLibOptions).then(function(result) {
                        result.modal.closed.then(function(res) {
                            if (res !== false) {
                                // add to model
                                scope.model[field] = res;
                            }
                        });
                    });
                }
            },
            controller: tilesEditableDetailCtrl,
        };
    }

    function tilesEditableDetailCtrl($scope, $compile, $element, lodash, $templateCache) {
        var templateField = '';
        var templateUrlField = '';

        this.$onInit = function() {
            templateField = ($scope.mode === 'new') ? 'newTemplate' : 'editTemplate';
            templateUrlField = ($scope.mode === 'new') ? 'newTemplateUrl' : 'editTemplateUrl';

            initTemplate();
        }

        function initTemplate() {
            var template = '';

            if (lodash.has($scope, 'options.' + templateField)) {
                template = $scope.options[templateField];
            } else {
                if (lodash.has($scope, 'options.' + templateUrlField)) {
                    template = $templateCache.get($scope.options[templateUrlField]);
                }
            }
            $element.html(template);
            $compile($element.contents())($scope);
        }
    }
})();
(function () {
    'use strict';

    tilesEditableItemCtrl.$inject = ['$scope', '$compile', '$element', 'lodash', '$templateCache'];
    angular
        .module('sod.helper')
        .directive('tilesEditableItem', tilesEditableItem);

    function tilesEditableItem() {
        return {
            restrict: 'E',
            controller: tilesEditableItemCtrl,
            scope: {
                options: '=',
                item: '=',
                onEdit: '&',
                mode: '='
            },
            template: '',
        };
    }

    function tilesEditableItemCtrl($scope, $compile, $element, lodash, $templateCache) {
        this.$onInit = function() {
            initTemplate();

            $scope.getEnumLabel = getEnumLabel;
        }

        function initTemplate() {
            var template = '';

            if (lodash.has($scope, 'options.template')) {
                template = $scope.options.template;
            } else {
                if (lodash.has($scope, 'options.templateUrl')) {
                    template = $templateCache.get($scope.options.templateUrl);
                }
            }
            $element.html(template);
            $compile($element.contents())($scope);
        }

        function getEnumLabel(type, value) {
            return lodash.get($scope.options, 'enums.' + type + '[' + value + ']', '');
        }
    }
})();
(function () {
    'use strict';

    tilesEditable.$inject = ['lodash'];
    tilesEditableCtrl.$inject = ['$element', 'lodash', '$timeout', '$scope', '$q', 'GenericModel', 'ActionManager'];
    angular
        .module('sod.helper')
        .directive('tilesEditable', tilesEditable);

    function tilesEditable(lodash) {
        return {
            restrict: 'E',
            controller: tilesEditableCtrl,
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                options: '=',
                showList: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {
                var vm = scope.vm;
                vm.ngModelCtrl = ctrl;

                ctrl.$formatters.push(function (modelValue) {
                    if (!modelValue) {
                        modelValue = [];
                    }
                    return modelValue;
                });

                ctrl.$render = function () {
                    vm.model = ctrl.$viewValue;
                };

                // if (lodash.has(vm.options, 'events.change')) {
                //     scope.$watch(function() {
                //         return lodash.differenceWith(vm.model)
                //     })
                // }
            },
            templateUrl: function (elem, attrs) {
                return 'common/components/tiles-editable/tiles-editable';
            }
        };
    }

    function tilesEditableCtrl($element, lodash, $timeout, $scope, $q, GenericModel, ActionManager) {
        var vm = this;

        this.$onInit = function() {
            vm.actions = {
                list: [
                    {label: lodash.get(vm.options, 'labels.actions.add', 'Add'), callbackName: 'onAdd', name: 'add'},
                    {label: lodash.get(vm.options, 'labels.actions.sort', 'Sort'), callbackName: 'onSort', name: 'sort'}
                ],
                add: [
                    {
                        label: lodash.get(vm.options, 'labels.actions.apply', 'Apply'),
                        callbackName: 'onItemApply',
                        name: 'apply'
                    },
                    {
                        label: lodash.get(vm.options, 'labels.actions.cancel', 'Cancel'),
                        callbackName: 'onItemCancel',
                        name: 'cancel'
                    }
                ],
                edit: [
                    {
                        label: lodash.get(vm.options, 'labels.actions.apply', 'Apply'),
                        callbackName: 'onItemApply',
                        name: 'apply'
                    },
                    {
                        label: lodash.get(vm.options, 'labels.actions.cancel', 'Cancel'),
                        callbackName: 'onItemCancel',
                        name: 'cancel'
                    },

                    {
                        label: lodash.get(vm.options, 'labels.actions.remove', 'Remove'),
                        callbackName: 'onItemRemove',
                        name: 'remove',
                        'class': 'float-right'
                    },
                ],
                sort: [
                    {
                        label: lodash.get(vm.options, 'labels.actions.done_sorting', 'Done Sorting'),
                        callbackName: 'onSortCancel',
                        name: 'cancel'
                    }
                ],
            };
            vm.newModel = null;

            vm.selectedIndex = null;
            vm.sortable = false;
            vm.selectedActionType = 'list';


            const hide_on_active_dom = lodash.get(vm.options, 'detailOptions.hide_on_active', null);
            // hide and unhide save button
            if (hide_on_active_dom) {
                $scope.$watch(function () {
                    return vm.selectedActionType;
                }, function (newValue, oldValue) {
                    if (newValue === 'list') {
                        $(hide_on_active_dom).show();
                    } else {
                        $(hide_on_active_dom).hide();
                    }
                });
            }

            vm.sortableOptions = {
                container: $element.find('.tiles-list-wrapper'),
                start: function (e) {
                    console.log('start dragging');
                },
                end: function (e) {
                    console.log('end dragging');
                },
                handler: '.sortable-handle, .sortable-handle *',
                hint: function (elem) {
                    return elem
                        .clone().addClass(
                            lodash.concat(
                                ['sortable-hint', 'question-item-dragging'],
                                lodash.get(vm, 'options.sortable_options.hint_css_array', [])
                            ).join(' ')
                        );
                    // var hasHintTemplate = lodash.has(vm, 'options.sortable_options.hint_template');
                    // if(hasHintTemplate) {
                    //     var hintTemplate = lodash.has(vm, 'options.sortable_options.hint_template', '');
                    //     return elem.clone().html(hintTemplate);
                    // } else {
                    //     return elem.clone().addClass('sortable-hint');
                    // }
                },
                placeholder: function (elem) {
                    var placeholderElem = elem.clone();
                    var placeholderTemplate = lodash.get(vm.options, 'sortable_options.placeholder_template', '<div class="sortable-placeholder-drop-here">Drop here</div>');
                    placeholderElem.find('.tile-item').html(placeholderTemplate);
                    placeholderElem.addClass('sortable-placeholder');
                    return placeholderElem;
                },
                disabled: '.sort-disabled',
                change: function (e) {
                    if (e) {
                        var itemMoved = vm.model[e.oldIndex];
                        vm.model.splice(e.oldIndex, 1);
                        vm.model.splice(e.newIndex, 0, itemMoved);
                        $scope.$apply();
                    }
                    reorderRowIndex();
                },
            };

            vm.edit = edit;
            vm.onItemApply = onItemApply;
            vm.onItemCancel = onItemCancel;
            vm.onAdd = onAdd;
            vm.onSort = onSort;
            vm.onSortCancel = onSortCancel;
            vm.applyCallback = applyCallback;
            vm.onItemRemove = onItemRemove;
            vm.isActionAvailable = isActionAvailable;
            vm.getMode = getMode;

            vm.showList = showList;
        }

        function applyCallback(action) {
            if (typeof vm[action.callbackName] === typeof function () {
                }) {
                vm[action.callbackName]();
            }
        }

        function onAdd() {
            vm.newModel = {edit_model: {}};
            vm.selectedActionType = 'add';
        }

        function onSort() {
            vm.selectedActionType = 'sort';
            vm.sortable = true;
        }

        function onSortCancel() {
            vm.selectedActionType = 'list';
            vm.sortable = false;
        }

        function edit(item) {
            var index = lodash.findIndex(vm.model, function (_i) {
                return item.$$hashKey === _i.$$hashKey
            });
            toggleEdit(index);
        }

        function onItemApply() {
            // validate first
            var targetForm = lodash.get(vm.options, 'validationOptions.targetForm', null);
            !!targetForm && ActionManager('form-clear-validation', {formId: targetForm});
            $q.when(validate(), function (res) {
                console.log('$q.when after');
                if (typeof vm.applyItemChange === typeof function () {
                    }) {
                    vm.applyItemChange();
                }
                if (vm.selectedActionType === 'add') {
                    vm.model.push(vm.newModel);
                }
                toggleEdit(null);
            }, function (res) {
                !!targetForm && ActionManager('form-validation', {formId: targetForm}, {}, {response: res.data});
                console.log('$q.when error');
            });

        }

        function onItemCancel() {
            if (typeof vm.cancelItemChange === typeof function () {
                }) {
                vm.cancelItemChange();
            }
            toggleEdit(null);
        }

        function onItemRemove() {
            vm.model.splice(vm.selectedIndex, 1);
            toggleEdit(null);
        }

        function toggleEdit(index) {
            if (index !== null && index > -1) {
                vm.selectedIndex = index;
                vm.selectedActionType = 'edit';
            } else {
                vm.selectedIndex = null;
                vm.selectedActionType = 'list';
                vm.newModel = null;
            }
        }

        function reorderRowIndex() {
            // if (hasSortableOption()) {
            $timeout(function () {
                angular.forEach(vm.model, function (row, index) {
                    row.edit_model.order = index;
                });
            });
            // }
        }

        function isActionAvailable(action) {
            if (!lodash.has(vm.options, 'disabled_options')) {
                return true;
            }

            return !(lodash.indexOf(vm.options.disabled_options, action.name) > -1);
        }

        function validate() {
            if (lodash.has(vm.options, 'validationOptions.datasource')) {
                var data = {
                    data: (vm.selectedActionType === 'add') ? vm.newModel : vm.model[vm.selectedIndex],
                };

                var model = new GenericModel(vm.options.validationOptions.datasource.url);
                var method = lodash.get(vm.options.validationOptions.datasource, 'method', 'get');

                return model[method]({}, data).$promise;
            }
            return $timeout(function () {
                return true;
            });
        }

        function getMode() {
            return vm.selectedActionType + '-mode';
        }

        function showList() {
            onItemCancel();
            onSortCancel();
        }


    }
})();
(function () {
    'use strict';

    fbFieldFileUploadDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldUrlDirectiveCtrl.$inject = ['$scope', '$element', 'lodash', 'FormBuilderService', 'CommonHelper'];
    angular
        .module('FormBuilder')
        .directive('fbFieldFileUpload', fbFieldFileUploadDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/fileupload';

    function fbFieldFileUploadDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
            },
            require:'ngModel',
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldUrlDirectiveCtrl,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;
                vm.loaded = false;
                var em = elem.find('em');
                elem.remove('em');
                elem.find('.k-dropzone').prepend(em);

                vm.ctrl = ctrl;

                ctrl.$render = function() {
                    if (lodash.isEmpty(ctrl.$viewValue)) {
                        vm.model = {
                            answer: []
                        };
                    } else {
                        vm.model = ctrl.$viewValue;
                    }
                    vm.loaded = true;
                }
            }
        };
    }

    function fbFieldUrlDirectiveCtrl($scope, $element, lodash, FormBuilderService,CommonHelper) {
        var vm = this;

        this.$onInit = function() {$scope.vm = vm;
            vm.model = {
                answer: []
            };


            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            var formDraftId = lodash.get(vm.pageData, 'model.hid_form_draft_id', '');

            vm.onLoadEventOptions = vm.element.options.settings;
            console.log(vm.element.options);
            initEventOptions();


            var async_options = lodash.get(vm.onLoadEventOptions, 'async', {});
            async_options = lodash.extend({
                ref_draft_id: formDraftId,
            }, async_options);

            var attr_options = lodash.get(vm.onLoadEventOptions, 'attr', {

            });
            vm.upload_options = {
                multiple: lodash.get(vm.onLoadEventOptions, 'multiple', false),
                async: async_options,
                upload: uploadEvent,
                remove: removeEvent,
                success: successEvent,
                error: errorEvent,
                files: lodash.get(vm, 'model', {}),
                localization: lodash.get(vm.element, 'options.localization', {})
            };
        }


        function initEventOptions() {
            if (lodash.has(vm.onLoadEventOptions, 'async')) {
                const formDraftId = lodash.get(vm.pageData, 'model.hid_form_draft_id', '');
                vm.onLoadEventOptions.async.removeUrl = decodeURI(vm.onLoadEventOptions.async.removeUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                if (lodash.has(vm.onLoadEventOptions.async, 'saveUrlTemplate')) {
                    vm.onLoadEventOptions.async.saveUrl = decodeURI(vm.onLoadEventOptions.async.saveUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                }
            }
        }

        function uploadEvent(e) {
            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                if (e.files[0].size > vm.onLoadEventOptions.fileSize) {
                    // var wrapper = $element.parents('label');
                    //
                    // wrapper.addClass('error');
                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 2 MB');
                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                    e.preventDefault();
                    var sizing =CommonHelper.bytesToSize( vm.onLoadEventOptions.fileSize);
                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                    $scope.$apply();
                    return false;
                }
            }

            if (lodash.has(vm.element, 'attr.sender_name')) {
                e.sender.name = vm.element.attr.sender_name;
            }
            e.data = lodash.get(vm, 'element.attr.upload_data', {});
        }


        function removeEvent(e) {
            e.sender.options.async.removeUrl = vm.onLoadEventOptions.async.removeUrl + e.files[0].file_id;
        }

        function successEvent(e) {
            if (e.operation == "upload") {
                e.files[0].name = e.response.data.file_name;
                e.files[0].extension = e.response.data.file_ext;
                e.files[0].file_id = e.response.data.file_id;

                var file_elem = $element.find('.k-file[data-uid="' + e.files[0].uid + '"] .k-filename');
                file_elem.attr('title', e.response.data.file_name);
                file_elem.html(e.response.data.file_name);

                vm.model.answer.push(e.response.data.file_id);
                vm.pageData.elementsService.clearElementValidationRule(vm.element.elementIdentifier);
                // $element.parents('.error').removeClass('error').find('.error-message').remove();
                vm.onEventTrigger('onUploadSuccess');
                vm.ctrl.$setViewValue(vm.model);






            }
            if (e.operation == "remove") {
                lodash.remove(vm.model.answer, function(_item) {
                    return _item == e.files[0].file_id;
                });
                vm.ctrl.$setViewValue(vm.model);
            }
        }

        function errorEvent(e) {
            //console.log(e);
            if (e.XMLHttpRequest.status == 422) {

                var rules = JSON.parse(e.XMLHttpRequest.response);
                vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, rules.rules[vm.element.name]);
                $scope.$apply();
            }
            vm.onEventTrigger('onUploadFailure');
        }
    }
})();
(function () {
    'use strict';

    fbFieldFreetextDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldFreetextDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', '$timeout', '$element'];
    angular
        .module('FormBuilder')
        .directive('fbFieldFreetext', fbFieldFreetextDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/freetext';

    function fbFieldFreetextDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldFreetextDirectiveCtrl
        };
    }

    function fbFieldFreetextDirectiveCtrl(lodash, FormBuilderService, $scope, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');

            vm.tinymceOptions = angular.merge(
                {},
                {
                    plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                    menubar: false,
                    toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent',
                    preview_styles: false,
                    resize: true,
                    statusbar: false,
                    autoresize_bottom_margin: 0,
                    autoresize_min_height: 50,
                    debounce: false,
                    content_css: cdnEp + '/assets/css/rms-tinymce.css',
                    // paste_as_text: true,
                    paste_data_images: false
                    // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
                },
                lodash.get(vm.element, 'options.tinymce', {}),
                {
                    setup: function (ed) {
                        ed.on('blur', function () {
                            vm.onEventTrigger('onBlur');
                        });
                        ed.on('init', function () {
                            $timeout(function () {
                                vm.pageData.currentScope.form.$setPristine();
                                vm.pageData.currentScope.form.$setUntouched();

                                $timeout(function() {
                                    var em = $element.find('.mce-toolbar-grp');
                                    $element.remove('.mce-toolbar-grp');
                                    $element.find('.mce-edit-area').after(em);
                                });
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    ed.setMode('readonly');
                                }
                            });
                        });
                        ed.on('PastePreProcess', function (e) {
                            console.log(e.content);
                        });
                    },
                    paste_preprocess: function (plugin, args) {
                        args.content = args.content.replace(/(<br[\s\/]*>)/g, '');
                    }
                }
            );
        }

    }
})();
(function () {
    'use strict';

    fbFieldMultichoiceDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldMultichoiceDirectiveCtrl.$inject = ['lodash', 'FbQuestionWrapperService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldMultichoice', fbFieldMultichoiceDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/multichoice';

    function fbFieldMultichoiceDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: "=",
                model: '='
            },
            template: function(elem, attr) {
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            controller: fbFieldMultichoiceDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldMultichoiceDirectiveCtrl(lodash, FbQuestionWrapperService) {
        var vm = this;
        this.$onInit = function() {
            vm.selectable = true;
            vm.setModel = setModel;

            vm.showTextBox = function() {
                return FbQuestionWrapperService.showTextbox(vm);
            };
            vm.onBlur = function($event) {
                if (vm.showText()) {
                    FbQuestionWrapperService.onBlur(vm, $event.target);
                }
            };


            if (lodash.has(vm.element,'options.settings.showText')) {
                vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
            }
        }


        function setModel() {
            var _ans = [];
            var count = 0;
            for (var i in vm.element.options.choices) {
                if (vm.element.options.choices[i].selected) {
                    _ans.push(vm.element.options.choices[i].value);
                    count++;
                }
            }

            checkForMax(count);

            vm.model.answer = _ans;
        }

        function checkForMax(count) {
            var max_selection = lodash.get(vm.element, 'options.settings.max_selection', null);
            if (max_selection) {
                if (count >= max_selection) {
                    vm.selectable = false;
                } else {
                    vm.selectable = true;
                }
            }
        }
    }
})();
(function () {
    'use strict';

    fbFieldCheckboxDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldCheckboxDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', '$timeout', '$element'];
    angular
        .module('FormBuilder')
        .directive('fbFieldCheckboxQn', fbFieldCheckboxDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/checkbox';

    function fbFieldCheckboxDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldCheckboxDirectiveCtrl
        };
    }

    function fbFieldCheckboxDirectiveCtrl(lodash, FormBuilderService, $scope, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.setModel = setModel;
        }

        function setModel() {
            vm.model = !vm.model;
        }
    }
})();
(function () {
    'use strict';

    fbFieldDropdownQnDirective.$inject = ['$templateCache', 'lodash', '$timeout'];
    fbFieldDropdownQnDirectiveCtrl.$inject = ['lodash', 'FormBuilderService', 'FbSelectService', '$scope', '$timeout', 'GenericModel', '$element'];
    angular
        .module('FormBuilder')
        .directive('fbFieldDropdownQn', fbFieldDropdownQnDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/dropdown';

    function fbFieldDropdownQnDirective($templateCache, lodash, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldDropdownQnDirectiveCtrl,
            link: function (scope, elem) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldDropdownQnDirectiveCtrl(lodash, FormBuilderService, FbSelectService, $scope, $timeout, GenericModel, $element) {
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (lodash.has(vm.element, 'options.settings.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.settings.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        })
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.settings.datasource.data', null));
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }
            //
            // if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
            //     vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            // }

            vm.firstLoad = true;
            vm.selectizeMsg = '';

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        // dropdownParent: 'body',
                        // dropdownClass: 'selectize-dropdown modal-z-index',
                        // placeholder: '',
                        onChange: function () {
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        },
                    },
                    lodash.get(vm.element, 'options.settings.selectize', {}),
                    vm.additionalOptions
                );
        }


        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.settings.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.settings.datasource.url);
            var method = lodash.get(vm.element.options.settings.datasource, 'method', 'get');
            return model[method]({}, {data: FormBuilderService.getModel(formIdentifier)}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.settings.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.settings.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();
(function () {
    'use strict';

    fbQWrapperDirective.$inject = ['$templateCache', 'lodash'];
    fbQWrapperDirectiveCtrl.$inject = ['$scope', 'lodash', '$compile', '$templateCache', '$element'];
    angular
        .module('FormBuilder')
        .directive('fbQWrapper', fbQWrapperDirective);

    const defaultTemplate = "<div class='row up-fields up-fields-inline'>" +
        "<div class='fbc-question small-12 medium-7 columns' ng-bind-html='vm.element.options.question|lineBreakReplacement'></div>" +
        "<div class='ynq-choice small-12 medium-5 columns' >" +
        "<transclude>" +
        "<div ng-show='vm.showTextBox()'><textarea type='text' ng-model='vm.model.others' placeholder='Please provide details' ng-blur='vm.onBlur($event)'></textarea></div>" +
        "</div>" +
        '</div>';

    function fbQWrapperDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            // transclude: true,
            scope: {
                element: '=',
                model: '=',
                template: '=?'
            },
            // template: function(elem, attr) {
            //     console.log(arguments);
            //     var templateUrl = lodash.get(attr, 'template', '');
            //     if (lodash.isEmpty(templateUrl)) {
            //         return defaultTemplate;
            //     }
            //     var template = $templateCache.get(templateUrl);
            //     if (lodash.isEmpty(template)) {
            //         return defaultTemplate;
            //     }
            //     return template;
            // },
            controller: fbQWrapperDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbQWrapperDirectiveCtrl($scope, lodash, $compile, $templateCache, $element) {
        var vm = this;
        this.$onInit = function() {
            vm.onBlur = onBlur;
            vm.showTextBox = showTextbox;

            vm.textSetting = vm.element.options.settings.showText || null;

            var selectedTemplate = defaultTemplate;
            if (!lodash.isEmpty(vm.template)) {
                var temp = $templateCache.get(vm.template);
                if (!lodash.isEmpty(temp)){
                    selectedTemplate = temp;
                }
            }

            selectedTemplate = selectedTemplate.replace('<transclude>', $element.html());

            $element.html(selectedTemplate);
            var cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', ()=> {
                cloneElement.off();
            });
        }

        function showTextbox() {
            if (vm.model.answer == null) {
                return false;
            }

            var result = false;
            switch (vm.textSetting.operator) {
                case "eq":
                    result = (vm.textSetting.value == lodash.get(vm, 'model.answer', null));
                    break;
                case "notEq":
                    result = (vm.textSetting.value != lodash.get(vm, 'model.answer', null));
                    break;
                case "in":
                    if (['multichoice'].indexOf(vm.element.type) >= 0) {
                        result = false;
                        var ansArr = lodash.get(vm, 'model.answer', []);
                        for (var i in ansArr) {
                            var _ans = ansArr[i];
                            if (vm.textSetting.value.indexOf(_ans) >= 0) {
                                result = true;
                                break;
                            }
                        }

                    } else {
                        result = (vm.textSetting.value.indexOf(parseInt(lodash.get(vm, 'model.answer', -1))) != -1);
                    }
                    break;
            }
            return result;
        }

        function onBlur($event) {
            if (showTextbox() ) {
                if (!lodash.has(vm.model,'others') || lodash.get(vm.model,'others','').length == 0) {
                    angular.element($event.target).parent().addClass('error');
                    angular.element($event.target).parent().find('.error-message').remove();
                    angular.element($event.target).after('<span class="error-message">Additional details are required.</span>');
                } else {
                    angular.element($event.target).parent().removeClass('error');
                    angular.element($event.target).parent().find('.error-message').remove();
                }
            }
        }
    }
})();
(function () {
    'use strict';

    fbFieldRankchoiceDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldRankchoiceDirectiveCtrl.$inject = ['lodash', 'FbQuestionWrapperService', 'ActionManager', 'GenericModel'];
    angular
        .module('FormBuilder')
        .directive('fbFieldRankchoice', fbFieldRankchoiceDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/rankchoice';

    function fbFieldRankchoiceDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: "=",
                model: '='
            },
            template: function (elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            controller: fbFieldRankchoiceDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldRankchoiceDirectiveCtrl(lodash, FbQuestionWrapperService, ActionManager, GenericModel) {
        var vm = this;
        this.$onInit = function() {
            vm.selectable = true;
            vm.setModel = setModel;
            vm.isSelected = isSelected;
            vm.indexOfSelected = indexOfSelected;
            vm.getRankByChoice = getRankByChoice;
            vm.clearSelection = clearSelection;
            vm.setOthersModel = setOthersModel;
            vm.updateOthers = updateOthers;
            vm.model = {answer: []};
            vm.maximumSelection = '';

            init();
        }

        function init() {
            var choice_keys = lodash.get(vm.element, 'options.settings.choice_keys');

            if (lodash.has(vm.element, 'options.choices')) {
                vm.choices = angular.copy(vm.element.options.choices);
                restrictKeys(choice_keys);
                addOthers();
            }

            if (lodash.has(vm.element, 'options.settings.choice_datasource')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    vm.choices = res;
                    vm.model.choices = res.map(function (_item) {
                        return _item.value;
                    });
                    restrictKeys(choice_keys);
                });
            }
        }

        function addOthers() {
            const hasOthers = lodash.get(vm, 'element.options.settings.others', false);
            if (hasOthers) {
                vm.choices = vm.choices.concat([{value: -1, label: 'Others'}]);
            }
        }

        function restrictKeys(keys) {
            if (keys) {
                vm.choices = vm.choices.map(function (choice) {
                    var modified = {};
                    keys.forEach(function (key) {
                        modified[key] = choice[key];
                    });
                    return modified;
                });
            }
        }

        if (lodash.has(vm.element, 'options.settings.showText')) {
            vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
        }

        function setOthersModel(choice, $event) {
            const choiceValue = lodash.get(choice, 'value');
            const indexOfSelected = vm.indexOfSelected(choice);
            if (indexOfSelected >= 0) {
                // if (choiceValue < 0) {
                const elements = angular.element('#' + vm.element.name + '-value-' + choiceValue);
                const foundElement = lodash.first(elements);
                if (foundElement) {
                    return;
                }
                // }
            }
            setModel(choice, $event);

        }

        function updateOthers(choice, $event) {
            const choiceValue = lodash.get(choice, 'value');
            const answer = lodash.find(vm.model.answer, {value: choiceValue});
            if (answer) {
                answer.label = choice.label;
            }
        }

        function setModel(choice, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            var vmModelAnswer = lodash.get(vm, 'model.answer', []);
            var _ans = angular.copy(vmModelAnswer);

            const indexOfSelected = vm.indexOfSelected(choice);
            if (indexOfSelected >= 0) {
                _ans = _ans.slice(0, indexOfSelected).concat(_ans.slice(indexOfSelected + 1));
            } else {
                const isMaxed = checkForMax(_ans.length);
                if (isMaxed) {
                    var max_selection_msg = lodash.get(vm.element, 'options.settings.max_selection_msg', null);
                    ActionManager('notify', {
                        'template': max_selection_msg,
                        'hasDelay': true,
                        'delay': 2000,
                        'type': 'warning',
                        'position': 'top center'
                    });
                    return;
                }
                _ans = lodash.concat(_ans, [choice]);
                const choiceValue = lodash.get(choice, 'value');
                if (choiceValue < 0) {
                    const elements = angular.element('#' + vm.element.name + '-value-' + choiceValue);
                    const foundElement = lodash.first(elements);
                    if (foundElement) {
                        foundElement.focus();
                    }
                }
            }

            vm.model.answer = _ans;
        }

        function indexOfSelected(choice) {
            var _ans = lodash.get(vm, 'model.answer', []);
            var choiceValue = lodash.get(choice, 'value');
            return lodash.findIndex(_ans, {value: choiceValue});
        }

        function isSelected(choice) {
            return vm.indexOfSelected(choice) >= 0;
        }

        function getRankByChoice(choice) {
            const choiceValue = lodash.get(choice, 'value');
            const answer = lodash.get(vm, 'model.answer', []);
            const foundIndex = lodash.findIndex(answer, {value: choiceValue});

            if (foundIndex >= 0) {
                return foundIndex + 1;
            }

            return '#';
        }

        function clearSelection($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.choices.map(function (_choice) {
                if (_choice.value < 0) {
                    _choice.label = '';
                }
            })
            vm.model.answer = [];
        }

        function checkForMax(count) {
            var max_selection = lodash.get(vm.element, 'options.settings.max_selection', null);
            if (max_selection) {
                vm.maximumSelection = 'Maximum Selection';
                return count >= max_selection;
            }

            return false;
        }


        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.settings.choice_datasource.url);
            var method = lodash.get(vm.element.options.settings.choice_datasource, 'method', 'get');
            return model[method]({}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.settings.choice_datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.settings.choice_datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();
(function () {
    'use strict';

    fbFieldSinglechoiceDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldSinglechoiceDirectiveCtrl.$inject = ['lodash', 'FbQuestionWrapperService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSinglechoice', fbFieldSinglechoiceDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/singlechoice';

    function fbFieldSinglechoiceDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            controller: fbFieldSinglechoiceDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldSinglechoiceDirectiveCtrl(lodash, FbQuestionWrapperService) {
        var vm = this;
        this.$onInit = function() {
            vm.onChange = function() {
                return FbQuestionWrapperService.onChange(vm);
            };
            vm.showTextBox = function() {
                return FbQuestionWrapperService.showTextbox(vm);
            };
            vm.onBlur = function($event) {
                if (vm.showText()) {
                    FbQuestionWrapperService.onBlur(vm, $event.target);
                }
            };

            if (lodash.has(vm.element,'options.settings.showText')) {
                vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
            }
        }
    }
})();
(function () {
    'use strict';

    fbFieldSinglechoicedropdownDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldSinglechoicedropdownDirectiveCtrl.$inject = ['lodash', 'FbQuestionWrapperService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSinglechoicedropdown', fbFieldSinglechoicedropdownDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/singlechoicedropdown';

    function fbFieldSinglechoicedropdownDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                return $templateCache.get(defaultTemplateUrl);
            },
            controller: fbFieldSinglechoicedropdownDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldSinglechoicedropdownDirectiveCtrl(lodash, FbQuestionWrapperService) {
        var vm = this;
        this.$onInit = function() {
            vm.onChange = function() {
                return FbQuestionWrapperService.onChange(vm);
            };
            vm.showTextBox = function() {
                return FbQuestionWrapperService.showTextbox(vm);
            };
            vm.onBlur = function($event) {
                if (vm.showText()) {
                    FbQuestionWrapperService.onBlur(vm, $event.target);
                }
            };

            if (lodash.has(vm.element,'options.settings.showText')) {
                vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
            }
        };
    }
})();
(function () {
    'use strict';

    fbFieldUrlDirective.$inject = ['$templateCache', 'lodash'];
    angular
        .module('FormBuilder')
        .directive('fbFieldUrl', fbFieldUrlDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/url';

    function fbFieldUrlDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldUrlDirectiveCtrl
        };
    }

    function fbFieldUrlDirectiveCtrl() {
        //const vm = this;
    }
})();
(function () {
    'use strict';

    fbFieldYesnoDirective.$inject = ['$templateCache', 'lodash'];
    fbFieldYesnoDirectiveCtrl.$inject = ['FbQuestionWrapperService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldYesno', fbFieldYesnoDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/yesno';

    function fbFieldYesnoDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            controllerAs: 'vm',
            controller: fbFieldYesnoDirectiveCtrl,
            bindToController: true
        };
    }

    function fbFieldYesnoDirectiveCtrl(FbQuestionWrapperService) {
        var vm = this;
        this.$onInit = function() {
            vm.showTextBox = function() {
                return FbQuestionWrapperService.showTextbox(vm);
            };
            vm.onBlur = function($event) {
                if (vm.showText()) {
                    FbQuestionWrapperService.onBlur(vm, $event.target);
                }
            };
        }
    }

})();
(function () {
    'use strict';

    fbFieldSettingsButtonCtrl.$inject = ['lodash', '$element', 'FormBuilderService', '$scope'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSettingsButton', fbFieldSettingsButton);

    function fbFieldSettingsButton() {
        return {
            restrict: 'E',
            controller: fbFieldSettingsButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/settings/button',
            scope: {
                element: '=',
                model: '='
            }
        };
    }

    function fbFieldSettingsButtonCtrl(lodash, $element, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.getSpinnerColor = getSpinnerColor;
            vm.click = click;
            vm.iconClass = 'hide';
            vm.buttonClass = 'hide';
            vm.click = click;

            init();
        }

        function init() {
            getIconClass();
            getButtonClass();
        }

        function getIconClass() {
            vm.iconClass = 'fa-' + lodash.get(vm, 'element.options.button.icon', 'hide');
        }

        function getButtonClass() {
            vm.buttonClass = lodash.get(vm, 'element.options.button.class', 'hide');
        }

        function getSpinnerColor() {
            if (vm.element.options.button.class.indexOf('default') >= 0) {
                return "#888888";
            }
        }

        function click($event) {
            if  (lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                return;
            }
            vm.element.loading = true;
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event
            };

            if (lodash.has($scope, '$parent.vm.formIdentifier')) {
                vm.formIdentifier = $scope.$parent.vm.formIdentifier;
                var fbService = FormBuilderService.get(vm.formIdentifier);
                lodash.set(eventData, 'model', fbService.model || {});
                lodash.set(eventData, 'formIdentifier', vm.formIdentifier);
            }

            if (lodash.has(vm, 'element.event.click')) {
                $scope.$emit(vm.element.event.click, eventData);
            }
        }
    }
})();

(function () {
    'use strict';

    fbFieldSettingsSelectCtrl.$inject = ['lodash', 'FormBuilderService', '$scope', 'GenericModel', 'ActionCommon', 'FbSelectService', '$timeout'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSettingsSelect', fbFieldSettingsSelect);

    function fbFieldSettingsSelect() {
        return {
            restrict: 'E',
            controller: fbFieldSettingsSelectCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                element: '=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/settings/select'
        };
    }

    function fbFieldSettingsSelectCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, FbSelectService, $timeout) {
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {

            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }

            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function() {
                    return vm.element.options.datasource.data;
                }, function() {
                    vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                });
            }

            loadRemoteData();

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        placeholder: '',
                        onChange: function () {
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function(selectize){
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function() {
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {})
                );
        }

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data:{label: value,model:formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {

            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function(res) {
                    vm.ds = res;
                    vm.isLoading = false;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            return model[method]({}, {data:FormBuilderService.getModel(formIdentifier)}).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function(res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();
(function () {
    'use strict';

    fbFieldSettingsTextCtrl.$inject = ['$scope', 'FormBuilderService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSettingsText', fbFieldSettingsText);

    function fbFieldSettingsText() {
        return {
            restrict: 'E',
            controller: fbFieldSettingsTextCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                element: '=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/settings/text'
        };
    }

    function fbFieldSettingsTextCtrl($scope, FormBuilderService) {
        var vm = this;
        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.onFocus = onFocus;
            vm.onCancel = onCancel;
            vm.onSave = onSave;
            vm.element.active = false;

            FormBuilderService.sync(vm.formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }

        function onFocus() {
            vm.element.active = true;
            vm.originalModelValue = angular.copy(vm.model);
        }

        function onCancel() {
            vm.model = angular.copy(vm.originalModelValue);
            vm.originalModelValue = null;
            vm.element.active = false;
        }

        function onSave() {
            vm.onEventTrigger('onSave');
            vm.originalModelValue = null;
        }
    }
})();
(function () {
    'use strict';

    fbFieldSettingsToggleCtrl.$inject = ['$scope', 'FormBuilderService'];
    angular
        .module('FormBuilder')
        .directive('fbFieldSettingsToggle', fbFieldSettingsToggle);

    function fbFieldSettingsToggle() {
        return {
            restrict: 'E',
            controller: fbFieldSettingsToggleCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                element: '=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/settings/toggle'
        };
    }

    function fbFieldSettingsToggleCtrl($scope, FormBuilderService) {
        var vm = this;
        this.$onInit = function() {

            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
        }
    }
})();
/**
 * Copyright (c) 2010 by Gabriel Birke
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the 'Software'), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

function Sanitize(){
  var i, e, options;
  options = arguments[0] || {};
  this.config = {};
  this.config.elements = options.elements ? options.elements : [];
  this.config.attributes = options.attributes ? options.attributes : {};
  this.config.attributes[Sanitize.ALL] = this.config.attributes[Sanitize.ALL] ? this.config.attributes[Sanitize.ALL] : [];
  this.config.allow_comments = options.allow_comments ? options.allow_comments : false;
  this.allowed_elements = {};
  this.config.protocols = options.protocols ? options.protocols : {};
  this.config.add_attributes = options.add_attributes ? options.add_attributes  : {};
  this.dom = options.dom ? options.dom : document;
  for(i=0;i<this.config.elements.length;i++) {
    this.allowed_elements[this.config.elements[i]] = true;
  }
  this.config.remove_element_contents = {};
  this.config.remove_all_contents = false;
  if(options.remove_contents) {
    
    if(options.remove_contents instanceof Array) {
      for(i=0;i<options.remove_contents.length;i++) {
        this.config.remove_element_contents[options.remove_contents[i]] = true;
      }
    }
    else {
      this.config.remove_all_contents = true;
    }
  }
  this.transformers = options.transformers ? options.transformers : [];
}

Sanitize.REGEX_PROTOCOL = /^([A-Za-z0-9\+\-\.\&\;\*\s]*?)(?:\:|&*0*58|&*x0*3a)/i;

// emulate Ruby symbol with string constant
Sanitize.RELATIVE = '__RELATIVE__';
Sanitize.ALL = '__ALL__';

Sanitize.prototype.clean_node = function(container) {
  var fragment = this.dom.createDocumentFragment();
  this.current_element = fragment;
  this.whitelist_nodes = [];

  

  /**
   * Utility function to check if an element exists in an array
   */
  function _array_index(needle, haystack) {
    var i;
    for(i=0; i < haystack.length; i++) {
      if(haystack[i] == needle) 
        return i;
    }
    return -1;
  }
  
  function _merge_arrays_uniq() {
    var result = [];
    var uniq_hash = {};
    var i,j;
    for(i=0;i<arguments.length;i++) {
      if(!arguments[i] || !arguments[i].length)
        continue;
      for(j=0;j<arguments[i].length;j++) {
        if(uniq_hash[arguments[i][j]])
          continue;
        uniq_hash[arguments[i][j]] = true;
        result.push(arguments[i][j]);
      }
    }
    return result;
  }
  
  /**
   * Clean function that checks the different node types and cleans them up accordingly
   * @param elem DOM Node to clean
   */
  function _clean(elem) {
    var clone;
    switch(elem.nodeType) {
      // Element
      case 1:
        _clean_element.call(this, elem);
        break;
      // Text
      case 3:
        clone = elem.cloneNode(false);
        this.current_element.appendChild(clone);
        break;
      // Entity-Reference (normally not used)
      case 5:
        clone = elem.cloneNode(false);
        this.current_element.appendChild(clone);
        break;
      // Comment
      case 8:
        if(this.config.allow_comments) {
          clone = elem.cloneNode(false);
          this.current_element.appendChild(clone);
        }
        break;
      default:
        if (console && console.log) console.log("unknown node type", elem.nodeType);
        break;
    }
 
  }
  
  function _clean_element(elem) {
    var i, j, clone, parent_element, name, allowed_attributes, attr, attr_name, attr_node, protocols, del, attr_ok;
    var transform = _transform_element.call(this, elem);
    
    elem = transform.node;
    name = elem.nodeName.toLowerCase();
    
    // check if element itself is allowed
    parent_element = this.current_element;
    if(this.allowed_elements[name] || transform.whitelist) {
        this.current_element = this.dom.createElement(elem.nodeName);
        parent_element.appendChild(this.current_element);
        
      // clean attributes
      var attrs = this.config.attributes;
      allowed_attributes = _merge_arrays_uniq(attrs[name], attrs[Sanitize.ALL], transform.attr_whitelist);
      for(i=0;i<allowed_attributes.length;i++) {
        attr_name = allowed_attributes[i];
        attr = elem.attributes[attr_name];
        if(attr) {
            attr_ok = true;
            // Check protocol attributes for valid protocol
            if(this.config.protocols[name] && this.config.protocols[name][attr_name]) {
              protocols = this.config.protocols[name][attr_name];
              del = attr.value.toLowerCase().match(Sanitize.REGEX_PROTOCOL);
              if(del) {
                attr_ok = (_array_index(del[1], protocols) != -1);
              }
              else {
                attr_ok = (_array_index(Sanitize.RELATIVE, protocols) != -1);
              }
            }
            if(attr_ok) {
              attr_node = document.createAttribute(attr_name);
              attr_node.value = attr.value;
              this.current_element.setAttributeNode(attr_node);
            }
        }
      }
      
      // Add attributes
      if(this.config.add_attributes[name]) {
        for(attr_name in this.config.add_attributes[name]) {
          attr_node = document.createAttribute(attr_name);
          attr_node.value = this.config.add_attributes[name][attr_name];
          this.current_element.setAttributeNode(attr_node);
        }
      }
    } // End checking if element is allowed
    // If this node is in the dynamic whitelist array (built at runtime by
    // transformers), let it live with all of its attributes intact.
    else if(_array_index(elem, this.whitelist_nodes) != -1) {
      this.current_element = elem.cloneNode(true);
      // Remove child nodes, they will be sanitiazied and added by other code
      while(this.current_element.childNodes.length > 0) {
        this.current_element.removeChild(this.current_element.firstChild);
      }
      parent_element.appendChild(this.current_element);
    }

    // iterate over child nodes
    if(!this.config.remove_all_contents && !this.config.remove_element_contents[name]) {
      for(i=0;i<elem.childNodes.length;i++) {
        _clean.call(this, elem.childNodes[i]);
      }
    }
    
    // some versions of IE don't support normalize.
    if(this.current_element.normalize) {
      this.current_element.normalize();
    }
    this.current_element = parent_element;
  } // END clean_element function
  
  function _transform_element(node) {
    var output = {
      attr_whitelist:[],
      node: node,
      whitelist: false
    };
    var i, j, transform;
    for(i=0;i<this.transformers.length;i++) {
      transform = this.transformers[i]({
        allowed_elements: this.allowed_elements,
        config: this.config,
        node: node,
        node_name: node.nodeName.toLowerCase(),
        whitelist_nodes: this.whitelist_nodes,
        dom: this.dom
      });
      if (transform == null) 
        continue;
      else if(typeof transform == 'object') {
        if(transform.whitelist_nodes && transform.whitelist_nodes instanceof Array) {
          for(j=0;j<transform.whitelist_nodes.length;j++) {
            if(_array_index(transform.whitelist_nodes[j], this.whitelist_nodes) == -1) {
              this.whitelist_nodes.push(transform.whitelist_nodes[j]);
            }
          }
        }
        output.whitelist = transform.whitelist ? true : false;
        if(transform.attr_whitelist) {
          output.attr_whitelist = _merge_arrays_uniq(output.attr_whitelist, transform.attr_whitelist);
        }
        output.node = transform.node ? transform.node : output.node;
      }
      else {
        throw new Error("transformer output must be an object or null");
      }
    }
    return output;
  }
  
  
  
  for(var i=0;i<container.childNodes.length;i++) {
    _clean.call(this, container.childNodes[i]);
  }
  
  if(fragment.normalize) {
    fragment.normalize();
  }
  
  return fragment;
  
};

if ( typeof define === "function" ) {
  define( "sanitize", [], function () { return Sanitize; } );
}

Selectize.define('create_on_blur', function () {
    if (this.settings.mode !== 'multi')
        return;
    var self = this;
    this.onBlur = (function (e) {
        var original = self.onBlur;
        return function (e) {
            if (this.$control_input.val().trim() != '') {
                self.createItem(this.$control_input.val());
            }
            return original.apply(this, arguments);
        }
    })();
});
Selectize.define('infinite_scroll', function(opts) {
    var self = this;
    var options = $.extend({
        scrollRatio: 0.85,
        scrollStep: 5,
        start: 0,
        loadingTemplateClass: '_infinite_scroll_loading',
        fullyLoadedTemplateClass: '_infinite_scroll_no_more_result',
        loading_template: '<div>Loading</div>',
        fully_loaded_template: '<div>No More Result</div>'
    }, opts);
    self._state = {
        total: null,
        loading: false,
        currentQuery: '',
        previousContentHeight: 0,
    };

    var debounce = function(fn, delay) {
        var timeout;
        return function() {
            var self = this;
            var args = arguments;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                fn.apply(self, args);
            }, delay);
        };
    };

    this.setup = (function() {
        var original = self.setup;

        return function() {
            original.apply(this, arguments);
            var dropdown_content = self.$dropdown_content;
            var original_maxOptions = self.settings.maxOptions;

            self.$dropdown_content.on('scroll', function(e) {
                if (!self._state.loading) {

                    var scrollPosition = (dropdown_content.scrollTop() + dropdown_content.innerHeight()) / dropdown_content[0].scrollHeight;
                    if (scrollPosition > options.scrollRatio && (self._state.total > (options.start + options.scrollStep))) {
                        // insertLoadingDom();
                        self._state.loading = true;
                        options.start = self.settings.maxOptions;
                        self.settings.maxOptions += options.scrollStep;
                        self._state.previousContentHeight = dropdown_content[0].scrollHeight;
                        insertLoadingDom();
                        self.onSearchChange({
                            search: self._state.currentQuery,
                            skip: options.start,
                            take: options.scrollStep,
                            time: (new Date()).getTime(),
                        });
                        // self.load({skip: options.start, take: options.scrollStep});

                        // var promise = self.settings.load({skip: options.start, take: options.scrollStep});
                        // execPromise(promise);
                    }
                }
            });

            if (typeof self.setTotal !== typeof function() {}) {
                self.setTotal = function(_t) {
                    self._state.total = _t;
                };
            }

            if (typeof self.getPaginations !== typeof function() {}) {
                self.getPaginations = function() {
                    return {
                        skip: options.start,
                        take: options.scrollStep,
                    };
                };
            }

            self.on('type', function (query) {
                // debounce(function() {
                    self.settings.maxOptions = original_maxOptions;
                    options.start = 0;
                    self._state.total = 0;
                    self._state.currentQuery = query;
                    self._state.previousContentHeight = 0 ;
                    self.clearOptions();
                    self.refreshOptions(false);
                    if (query.length > 0) {
                        insertLoadingDom();
                    } else {
                        removeLoadingDom();
                    }
                    removeFullyLoadedDom();
                    self.onSearchChange({
                        search: query,
                        skip: options.start,
                        take: options.scrollStep,
                        time: (new Date()).getTime(),
                    });

                    // self.refreshOptions();
                    // self.trigger('load');
                    // options.start = 0;
                    // // removeFullyLoadedDom();
                    // // insertLoadingDom();
                    // self._state.total = 0;
                    // self.settings.maxOptions = original_maxOptions;
                    // // self.refreshOptions();
                    // var promise = self.settings.load({
                    //     search: query || '',
                    //     skip: options.start,
                    //     take: options.scrollStep,
                    // });
                    // // execPromise(promise);

                // }, 600);
            });

            self.on('load', function() {
               console.log('self.onload');
                self._state.loading = false;
                var dropdown_content = self.$dropdown_content;
                dropdown_content.scrollTop(self._state.previousContentHeight - dropdown_content.innerHeight());
                console.log(self.options);
                loadFullyLoaded();
                removeLoadingDom();
            });

            self.on('option_clear', function() {
                console.log('option clear');
                self.currentResults.items = [];
            });

            function insertLoadingDom() {
                var loadingTemplate = $('<div />').wrap('<div />');
                loadingTemplate.addClass(options.loadingTemplateClass);
                loadingTemplate.append(options.loading_template);
                self.$dropdown_content.after(loadingTemplate.parent().html());
            }

            function loadFullyLoaded() {
                if (self._state.total <=  (options.start + options.scrollStep) && self._state.total > 0) {
                    insertFullyLoadedDom();
                }
            }

            function insertFullyLoadedDom() {
                removeFullyLoadedDom();
                var loadingTemplate = $('<div />').wrap('<div />');
                loadingTemplate.addClass(options.fullyLoadedTemplateClass);
                loadingTemplate.append(options.fully_loaded_template);
                self.$dropdown_content.after(loadingTemplate.parent().html());
            }

            function removeFullyLoadedDom() {
                self.$dropdown_content.parent().find('.' + options.fullyLoadedTemplateClass).remove();
            }

            function removeLoadingDom() {
                self.$dropdown_content.parent().find('.' + options.loadingTemplateClass).remove();
            }
        };
    })();
});
/**
 * Plugin: "preserve_on_blur" (selectize.js)
 * Copyright (c) 2016 Eric M. Klingensmith
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Eric M. Klingensmith <eric.m.klingensmith@gmail.com>
 *
 * Based on methods used in restore_on_backspace plugin by Brian Reavis & contributors.
 */
 
 Selectize.define( 'preserve_on_blur', function( options ) {
    var self = this;

    options.text = options.text || function(option) {
        return option[this.settings.labelField];
    };
    
    this.onBlur = ( function( e ) {
        var original = self.onBlur;  
        
        return function( e ) {
            // Capture the current input value
            var $input = this.$control_input;
            var inputValue = $input.val();
            
            // Do the default actions
            original.apply( this, e );
            
            // Set the value back                    
            this.setTextboxValue( inputValue );
        };                                
    } )();

} );
Selectize.define('infinite_scroll', function(opts) {
    var self = this;

    self._state = {
        total: null,
        loading: false,
        previousContentHeight: 0,
    };

    this.setup = (function() {
        var original = self.setup;

        return function() {
            original.apply(this, arguments);
            var dropdown_content = self.$dropdown_content;


            self.on('type', function (query) {
                // debounce(function() {
                    self.settings.maxOptions = original_maxOptions;
                    options.start = 0;
                    self._state.currentQuery = query;
                    self._state.previousContentHeight = 0 ;
                    self.clearOptions();
                    self.refreshOptions(false);
                    if (query.length > 0) {
                        insertLoadingDom();
                    } else {
                        removeLoadingDom();
                    }
                    removeFullyLoadedDom();
                    self.onSearchChange({
                        search: query,
                        skip: options.start,
                        take: options.scrollStep,
                        time: (new Date()).getTime(),
                    });

                    // self.refreshOptions();
                    // self.trigger('load');
                    // options.start = 0;
                    // // removeFullyLoadedDom();
                    // // insertLoadingDom();
                    // self._state.total = 0;
                    // self.settings.maxOptions = original_maxOptions;
                    // // self.refreshOptions();
                    // var promise = self.settings.load({
                    //     search: query || '',
                    //     skip: options.start,
                    //     take: options.scrollStep,
                    // });
                    // // execPromise(promise);

                // }, 600);
            });

            self.on('load', function() {
               console.log('self.onload');
                self._state.loading = false;
                var dropdown_content = self.$dropdown_content;
                dropdown_content.scrollTop(self._state.previousContentHeight - dropdown_content.innerHeight());
                console.log(self.options);
                loadFullyLoaded();
                removeLoadingDom();
            });

            self.on('option_clear', function() {
                console.log('option clear');
                self.currentResults.items = [];
            });

            function insertLoadingDom() {
                var loadingTemplate = $('<div />').wrap('<div />');
                loadingTemplate.addClass(options.loadingTemplateClass);
                loadingTemplate.append(options.loading_template);
                self.$dropdown_content.after(loadingTemplate.parent().html());
            }

            function loadFullyLoaded() {
                if (self._state.total <=  (options.start + options.scrollStep) && self._state.total > 0) {
                    insertFullyLoadedDom();
                }
            }

            function insertFullyLoadedDom() {
                removeFullyLoadedDom();
                var loadingTemplate = $('<div />').wrap('<div />');
                loadingTemplate.addClass(options.fullyLoadedTemplateClass);
                loadingTemplate.append(options.fully_loaded_template);
                self.$dropdown_content.after(loadingTemplate.parent().html());
            }

            function removeFullyLoadedDom() {
                self.$dropdown_content.parent().find('.' + options.fullyLoadedTemplateClass).remove();
            }

            function removeLoadingDom() {
                self.$dropdown_content.parent().find('.' + options.loadingTemplateClass).remove();
            }
        };
    })();
});
if(!Sanitize.Config) {
  Sanitize.Config = {}
}

Sanitize.Config.BASIC = {
  elements: [
     'a', 'b', 'blockquote', 'br', 'cite', 'code', 'dd', 'dl', 'dt', 'em',
     'i', 'li', 'ol', 'p', 'pre', 'q', 'small', 'strike', 'strong', 'sub',
     'sup', 'u', 'ul'],

   attributes: {
     'a'         : ['href'],
     'blockquote': ['cite'],
     'q'         : ['cite']
   },

   add_attributes: {
     'a': {'rel': 'nofollow'}
   },

   protocols: {
     'a'         : {'href': ['ftp', 'http', 'https', 'mailto',
                                 Sanitize.RELATIVE]},
     'blockquote': {'cite': ['http', 'https', Sanitize.RELATIVE]},
     'q'         : {'cite': ['http', 'https', Sanitize.RELATIVE]}
   }
}

if(!Sanitize.Config) {
  Sanitize.Config = {}
}

Sanitize.Config.RELAXED = {
  elements: [
    'a', 'b', 'blockquote', 'br', 'caption', 'cite', 'code', 'col',
    'colgroup', 'dd', 'dl', 'dt', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'i', 'img', 'li', 'ol', 'p', 'pre', 'q', 'small', 'strike', 'strong',
    'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u',
    'ul'],

  attributes: {
    'a'         : ['href', 'title'],
    'blockquote': ['cite'],
    'col'       : ['span', 'width'],
    'colgroup'  : ['span', 'width'],
    'img'       : ['align', 'alt', 'height', 'src', 'title', 'width'],
    'ol'        : ['start', 'type'],
    'q'         : ['cite'],
    'table'     : ['summary', 'width'],
    'td'        : ['abbr', 'axis', 'colspan', 'rowspan', 'width'],
    'th'        : ['abbr', 'axis', 'colspan', 'rowspan', 'scope',
                     'width'],
    'ul'        : ['type']
  },

  protocols: {
    'a'         : {'href': ['ftp', 'http', 'https', 'mailto',
                                Sanitize.RELATIVE]},
    'blockquote': {'cite': ['http', 'https', Sanitize.RELATIVE]},
    'img'       : {'src' : ['http', 'https', Sanitize.RELATIVE]},
    'q'         : {'cite': ['http', 'https', Sanitize.RELATIVE]}
  }
}
if(!Sanitize.Config) {
  Sanitize.Config = {}
}

Sanitize.Config.RESTRICTED = {
  elements: ['b', 'em', 'i', 'strong', 'u']       
}